
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3c7f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3c7f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("815Xb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d6308ff5c29fed1$export$2e2bcd8739ae039; });
function $5d6308ff5c29fed1$export$2e2bcd8739ae039() {
    $5d6308ff5c29fed1$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d6308ff5c29fed1$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("cQNHH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("c2VSo"));

});
parcelRegister("c2VSo", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0243656f51a2fb4f$export$dca3b0875bd9a954; }, function (v) { return $0243656f51a2fb4f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0243656f51a2fb4f$export$16fa2f45be04daa8; }, function (v) { return $0243656f51a2fb4f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0243656f51a2fb4f$export$ffb0004e005737fa; }, function (v) { return $0243656f51a2fb4f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0243656f51a2fb4f$export$e2c29f18771995cb; }, function (v) { return $0243656f51a2fb4f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0243656f51a2fb4f$export$221d75b3f55bb0bd; }, function (v) { return $0243656f51a2fb4f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0243656f51a2fb4f$export$5f8d39834fd61797; }, function (v) { return $0243656f51a2fb4f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0243656f51a2fb4f$export$74bf444e3cd11ea5; }, function (v) { return $0243656f51a2fb4f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0243656f51a2fb4f$export$ae55be85d98224ed; }, function (v) { return $0243656f51a2fb4f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0243656f51a2fb4f$export$e530037191fcd5d7; }, function (v) { return $0243656f51a2fb4f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0243656f51a2fb4f$export$fd42f52fd3ae1109; }, function (v) { return $0243656f51a2fb4f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0243656f51a2fb4f$export$c8a8987d4410bf2d; }, function (v) { return $0243656f51a2fb4f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0243656f51a2fb4f$export$d38cd72104c1f0e9; }, function (v) { return $0243656f51a2fb4f$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0243656f51a2fb4f$export$7d1e3a5e95ceca43; }, function (v) { return $0243656f51a2fb4f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0243656f51a2fb4f$export$257a8862b851cb5b; }, function (v) { return $0243656f51a2fb4f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0243656f51a2fb4f$export$a8257692ac88316c; }, function (v) { return $0243656f51a2fb4f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0243656f51a2fb4f$export$488013bae63b21da; }, function (v) { return $0243656f51a2fb4f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0243656f51a2fb4f$export$7c73462e0d25e514; }, function (v) { return $0243656f51a2fb4f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0243656f51a2fb4f$export$35808ee640e87ca7; }, function (v) { return $0243656f51a2fb4f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0243656f51a2fb4f$export$fae74005e78b1a27; }, function (v) { return $0243656f51a2fb4f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0243656f51a2fb4f$export$dc8fbce3eb94dc1e; }, function (v) { return $0243656f51a2fb4f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $0243656f51a2fb4f$export$6d9c69b0de29b591; }, function (v) { return $0243656f51a2fb4f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0243656f51a2fb4f$export$d5a552a76deda3c2; }, function (v) { return $0243656f51a2fb4f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0243656f51a2fb4f$export$e5c5a5f917a5871c; }, function (v) { return $0243656f51a2fb4f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0243656f51a2fb4f$export$1538c33de8887b59; }, function (v) { return $0243656f51a2fb4f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0243656f51a2fb4f$export$13e3392192263954; }, function (v) { return $0243656f51a2fb4f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0243656f51a2fb4f$export$b8f5890fc79d6aca; }, function (v) { return $0243656f51a2fb4f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0243656f51a2fb4f$export$60241385465d0a34; }, function (v) { return $0243656f51a2fb4f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $0243656f51a2fb4f$export$83d89fbfd8236492; }, function (v) { return $0243656f51a2fb4f$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0243656f51a2fb4f$export$dca3b0875bd9a954;
var $0243656f51a2fb4f$export$16fa2f45be04daa8;
var $0243656f51a2fb4f$export$ffb0004e005737fa;
var $0243656f51a2fb4f$export$e2c29f18771995cb;
var $0243656f51a2fb4f$export$221d75b3f55bb0bd;
var $0243656f51a2fb4f$export$5f8d39834fd61797;
var $0243656f51a2fb4f$export$74bf444e3cd11ea5;
var $0243656f51a2fb4f$export$ae55be85d98224ed;
var $0243656f51a2fb4f$export$e530037191fcd5d7;
var $0243656f51a2fb4f$export$fd42f52fd3ae1109;
var $0243656f51a2fb4f$export$c8a8987d4410bf2d;
var $0243656f51a2fb4f$export$d38cd72104c1f0e9;
var $0243656f51a2fb4f$export$7d1e3a5e95ceca43;
var $0243656f51a2fb4f$export$257a8862b851cb5b;
var $0243656f51a2fb4f$export$a8257692ac88316c;
var $0243656f51a2fb4f$export$488013bae63b21da;
var $0243656f51a2fb4f$export$7c73462e0d25e514;
var $0243656f51a2fb4f$export$35808ee640e87ca7;
var $0243656f51a2fb4f$export$fae74005e78b1a27;
var $0243656f51a2fb4f$export$dc8fbce3eb94dc1e;
var $0243656f51a2fb4f$export$6d9c69b0de29b591;
var $0243656f51a2fb4f$export$d5a552a76deda3c2;
var $0243656f51a2fb4f$export$e5c5a5f917a5871c;
var $0243656f51a2fb4f$export$1538c33de8887b59;
var $0243656f51a2fb4f$export$13e3392192263954;
var $0243656f51a2fb4f$export$b8f5890fc79d6aca;
var $0243656f51a2fb4f$export$60241385465d0a34;
var $0243656f51a2fb4f$export$83d89fbfd8236492;
"use strict";

var $bDppX = parcelRequire("bDppX");
var $0243656f51a2fb4f$var$n = "function" === typeof Symbol && Symbol.for, $0243656f51a2fb4f$var$p = $0243656f51a2fb4f$var$n ? Symbol.for("react.element") : 60103, $0243656f51a2fb4f$var$q = $0243656f51a2fb4f$var$n ? Symbol.for("react.portal") : 60106, $0243656f51a2fb4f$var$r = $0243656f51a2fb4f$var$n ? Symbol.for("react.fragment") : 60107, $0243656f51a2fb4f$var$t = $0243656f51a2fb4f$var$n ? Symbol.for("react.strict_mode") : 60108, $0243656f51a2fb4f$var$u = $0243656f51a2fb4f$var$n ? Symbol.for("react.profiler") : 60114, $0243656f51a2fb4f$var$v = $0243656f51a2fb4f$var$n ? Symbol.for("react.provider") : 60109, $0243656f51a2fb4f$var$w = $0243656f51a2fb4f$var$n ? Symbol.for("react.context") : 60110, $0243656f51a2fb4f$var$x = $0243656f51a2fb4f$var$n ? Symbol.for("react.forward_ref") : 60112, $0243656f51a2fb4f$var$y = $0243656f51a2fb4f$var$n ? Symbol.for("react.suspense") : 60113, $0243656f51a2fb4f$var$z = $0243656f51a2fb4f$var$n ? Symbol.for("react.memo") : 60115, $0243656f51a2fb4f$var$A = $0243656f51a2fb4f$var$n ? Symbol.for("react.lazy") : 60116, $0243656f51a2fb4f$var$B = "function" === typeof Symbol && Symbol.iterator;
function $0243656f51a2fb4f$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0243656f51a2fb4f$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0243656f51a2fb4f$var$E = {};
function $0243656f51a2fb4f$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $0243656f51a2fb4f$var$E;
    this.updater = c || $0243656f51a2fb4f$var$D;
}
$0243656f51a2fb4f$var$F.prototype.isReactComponent = {};
$0243656f51a2fb4f$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($0243656f51a2fb4f$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0243656f51a2fb4f$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0243656f51a2fb4f$var$G() {}
$0243656f51a2fb4f$var$G.prototype = $0243656f51a2fb4f$var$F.prototype;
function $0243656f51a2fb4f$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $0243656f51a2fb4f$var$E;
    this.updater = c || $0243656f51a2fb4f$var$D;
}
var $0243656f51a2fb4f$var$I = $0243656f51a2fb4f$var$H.prototype = new $0243656f51a2fb4f$var$G;
$0243656f51a2fb4f$var$I.constructor = $0243656f51a2fb4f$var$H;
$bDppX($0243656f51a2fb4f$var$I, $0243656f51a2fb4f$var$F.prototype);
$0243656f51a2fb4f$var$I.isPureReactComponent = !0;
var $0243656f51a2fb4f$var$J = {
    current: null
}, $0243656f51a2fb4f$var$K = Object.prototype.hasOwnProperty, $0243656f51a2fb4f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0243656f51a2fb4f$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$0243656f51a2fb4f$var$K.call(b, e) && !$0243656f51a2fb4f$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $0243656f51a2fb4f$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $0243656f51a2fb4f$var$J.current
    };
}
function $0243656f51a2fb4f$var$N(a, b) {
    return {
        $$typeof: $0243656f51a2fb4f$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0243656f51a2fb4f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0243656f51a2fb4f$var$p;
}
function $0243656f51a2fb4f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0243656f51a2fb4f$var$P = /\/+/g, $0243656f51a2fb4f$var$Q = [];
function $0243656f51a2fb4f$var$R(a, b, c, e) {
    if ($0243656f51a2fb4f$var$Q.length) {
        var d = $0243656f51a2fb4f$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $0243656f51a2fb4f$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $0243656f51a2fb4f$var$Q.length && $0243656f51a2fb4f$var$Q.push(a);
}
function $0243656f51a2fb4f$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0243656f51a2fb4f$var$p:
                case $0243656f51a2fb4f$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $0243656f51a2fb4f$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $0243656f51a2fb4f$var$U(d, k);
        g += $0243656f51a2fb4f$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $0243656f51a2fb4f$var$B && a[$0243656f51a2fb4f$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $0243656f51a2fb4f$var$U(d, k++), g += $0243656f51a2fb4f$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($0243656f51a2fb4f$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $0243656f51a2fb4f$var$V(a, b, c) {
    return null == a ? 0 : $0243656f51a2fb4f$var$T(a, "", b, c);
}
function $0243656f51a2fb4f$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0243656f51a2fb4f$var$escape(a.key) : b.toString(36);
}
function $0243656f51a2fb4f$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $0243656f51a2fb4f$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $0243656f51a2fb4f$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($0243656f51a2fb4f$var$O(a) && (a = $0243656f51a2fb4f$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($0243656f51a2fb4f$var$P, "$&/") + "/") + c)), e.push(a));
}
function $0243656f51a2fb4f$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($0243656f51a2fb4f$var$P, "$&/") + "/");
    b = $0243656f51a2fb4f$var$R(b, g, e, d);
    $0243656f51a2fb4f$var$V(a, $0243656f51a2fb4f$var$aa, b);
    $0243656f51a2fb4f$var$S(b);
}
var $0243656f51a2fb4f$var$Y = {
    current: null
};
function $0243656f51a2fb4f$var$Z() {
    var a = $0243656f51a2fb4f$var$Y.current;
    if (null === a) throw Error($0243656f51a2fb4f$var$C(321));
    return a;
}
var $0243656f51a2fb4f$var$ba = {
    ReactCurrentDispatcher: $0243656f51a2fb4f$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $0243656f51a2fb4f$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $bDppX
};
$0243656f51a2fb4f$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $0243656f51a2fb4f$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $0243656f51a2fb4f$var$R(null, null, b, c);
        $0243656f51a2fb4f$var$V(a, $0243656f51a2fb4f$var$W, b);
        $0243656f51a2fb4f$var$S(b);
    },
    count: function(a) {
        return $0243656f51a2fb4f$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $0243656f51a2fb4f$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$0243656f51a2fb4f$var$O(a)) throw Error($0243656f51a2fb4f$var$C(143));
        return a;
    }
};
$0243656f51a2fb4f$export$16fa2f45be04daa8 = $0243656f51a2fb4f$var$F;
$0243656f51a2fb4f$export$ffb0004e005737fa = $0243656f51a2fb4f$var$r;
$0243656f51a2fb4f$export$e2c29f18771995cb = $0243656f51a2fb4f$var$u;
$0243656f51a2fb4f$export$221d75b3f55bb0bd = $0243656f51a2fb4f$var$H;
$0243656f51a2fb4f$export$5f8d39834fd61797 = $0243656f51a2fb4f$var$t;
$0243656f51a2fb4f$export$74bf444e3cd11ea5 = $0243656f51a2fb4f$var$y;
$0243656f51a2fb4f$export$ae55be85d98224ed = $0243656f51a2fb4f$var$ba;
$0243656f51a2fb4f$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($0243656f51a2fb4f$var$C(267, a));
    var e = $bDppX({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $0243656f51a2fb4f$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$0243656f51a2fb4f$var$K.call(b, h) && !$0243656f51a2fb4f$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $0243656f51a2fb4f$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$0243656f51a2fb4f$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $0243656f51a2fb4f$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $0243656f51a2fb4f$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$0243656f51a2fb4f$export$c8a8987d4410bf2d = $0243656f51a2fb4f$var$M;
$0243656f51a2fb4f$export$d38cd72104c1f0e9 = function(a) {
    var b = $0243656f51a2fb4f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0243656f51a2fb4f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0243656f51a2fb4f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0243656f51a2fb4f$var$x,
        render: a
    };
};
$0243656f51a2fb4f$export$a8257692ac88316c = $0243656f51a2fb4f$var$O;
$0243656f51a2fb4f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0243656f51a2fb4f$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$0243656f51a2fb4f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0243656f51a2fb4f$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0243656f51a2fb4f$export$35808ee640e87ca7 = function(a, b) {
    return $0243656f51a2fb4f$var$Z().useCallback(a, b);
};
$0243656f51a2fb4f$export$fae74005e78b1a27 = function(a, b) {
    return $0243656f51a2fb4f$var$Z().useContext(a, b);
};
$0243656f51a2fb4f$export$dc8fbce3eb94dc1e = function() {};
$0243656f51a2fb4f$export$6d9c69b0de29b591 = function(a, b) {
    return $0243656f51a2fb4f$var$Z().useEffect(a, b);
};
$0243656f51a2fb4f$export$d5a552a76deda3c2 = function(a, b, c) {
    return $0243656f51a2fb4f$var$Z().useImperativeHandle(a, b, c);
};
$0243656f51a2fb4f$export$e5c5a5f917a5871c = function(a, b) {
    return $0243656f51a2fb4f$var$Z().useLayoutEffect(a, b);
};
$0243656f51a2fb4f$export$1538c33de8887b59 = function(a, b) {
    return $0243656f51a2fb4f$var$Z().useMemo(a, b);
};
$0243656f51a2fb4f$export$13e3392192263954 = function(a, b, c) {
    return $0243656f51a2fb4f$var$Z().useReducer(a, b, c);
};
$0243656f51a2fb4f$export$b8f5890fc79d6aca = function(a) {
    return $0243656f51a2fb4f$var$Z().useRef(a);
};
$0243656f51a2fb4f$export$60241385465d0a34 = function(a) {
    return $0243656f51a2fb4f$var$Z().useState(a);
};
$0243656f51a2fb4f$export$83d89fbfd8236492 = "16.13.1";

});
parcelRegister("bDppX", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $87870da89e628224$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $87870da89e628224$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $87870da89e628224$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $87870da89e628224$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $87870da89e628224$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $87870da89e628224$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $87870da89e628224$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($87870da89e628224$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($87870da89e628224$var$getOwnPropertySymbols) {
            symbols = $87870da89e628224$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($87870da89e628224$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("1xEYC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11f8a89d85a36f13$var$ReactIs, $11f8a89d85a36f13$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("j3WDN"))();

});
parcelRegister("j3WDN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $8j5uN = parcelRequire("8j5uN");
function $de0bc8fe92a13a51$var$emptyFunction() {}
function $de0bc8fe92a13a51$var$emptyFunctionWithReset() {}
$de0bc8fe92a13a51$var$emptyFunctionWithReset.resetWarningCache = $de0bc8fe92a13a51$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8j5uN) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $de0bc8fe92a13a51$var$emptyFunctionWithReset,
        resetWarningCache: $de0bc8fe92a13a51$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8j5uN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $60c45c6b0cb44b91$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $60c45c6b0cb44b91$var$ReactPropTypesSecret;

});



parcelRegister("6WDy5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e6d666cd7a3ddf$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $2FoLs = parcelRequire("2FoLs");
function $50e6d666cd7a3ddf$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext((0, $2FoLs.default));
    return theme;
}

});
parcelRegister("2FoLs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f129ed25eb86631$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
var $1f129ed25eb86631$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext(null);
var $1f129ed25eb86631$export$2e2bcd8739ae039 = $1f129ed25eb86631$var$ThemeContext;

});


parcelRegister("dLwnG", function(module, exports) {
"use strict";
function $a058c85580ba5e0b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a058c85580ba5e0b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a058c85580ba5e0b$var$checkDCE();

module.exports = (parcelRequire("jozO0"));

});
parcelRegister("jozO0", function(module, exports) {
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $cQNHH = parcelRequire("cQNHH");

var $bDppX = parcelRequire("bDppX");

var $1MX31 = parcelRequire("1MX31");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$cQNHH) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $cQNHH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $bDppX({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $cQNHH.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $bDppX({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $bDppX({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $1MX31.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $1MX31.unstable_scheduleCallback($1MX31.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $1MX31.unstable_UserBlockingPriority, ed = $1MX31.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $bDppX({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$bDppX(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $bDppX(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $bDppX({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $bDppX({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $1MX31.unstable_runWithPriority, Jf = $1MX31.unstable_scheduleCallback, Kf = $1MX31.unstable_cancelCallback, Lf = $1MX31.unstable_requestPaint, Mf = $1MX31.unstable_now, Nf = $1MX31.unstable_getCurrentPriorityLevel, Of = $1MX31.unstable_ImmediatePriority, Pf = $1MX31.unstable_UserBlockingPriority, Qf = $1MX31.unstable_NormalPriority, Rf = $1MX31.unstable_LowPriority, Sf = $1MX31.unstable_IdlePriority, Tf = {}, Uf = $1MX31.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $bDppX({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $bDppX({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $cQNHH.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bDppX({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $bDppX({}, f, {
                    value: void 0
                });
                d = $bDppX({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $bDppX({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($bDppX({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.13.1";

});
parcelRegister("1MX31", function(module, exports) {
"use strict";

module.exports = (parcelRequire("e32xz"));

});
parcelRegister("e32xz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a3a350f95ccae46a$export$c4744153514ff05d; }, function (v) { return $a3a350f95ccae46a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a3a350f95ccae46a$export$d66a1c1c77bd778b; }, function (v) { return $a3a350f95ccae46a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a3a350f95ccae46a$export$3e506c1ccc9cc1a7; }, function (v) { return $a3a350f95ccae46a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a3a350f95ccae46a$export$e26fe2ed2fa76875; }, function (v) { return $a3a350f95ccae46a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a3a350f95ccae46a$export$502329bbf4b505b1; }, function (v) { return $a3a350f95ccae46a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a3a350f95ccae46a$export$6e3807111c4874c4; }, function (v) { return $a3a350f95ccae46a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a3a350f95ccae46a$export$c27134553091fb3a; }, function (v) { return $a3a350f95ccae46a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a3a350f95ccae46a$export$33ee1acdc04fd2a2; }, function (v) { return $a3a350f95ccae46a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a3a350f95ccae46a$export$b00a404bbd5edef2; }, function (v) { return $a3a350f95ccae46a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a3a350f95ccae46a$export$8352ce38b91d0c62; }, function (v) { return $a3a350f95ccae46a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a3a350f95ccae46a$export$d3dfb8e4810cb555; }, function (v) { return $a3a350f95ccae46a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a3a350f95ccae46a$export$839f9183b0465a69; }, function (v) { return $a3a350f95ccae46a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a3a350f95ccae46a$export$72fdf0e06517287b; }, function (v) { return $a3a350f95ccae46a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a3a350f95ccae46a$export$4b844e58a3e414b4; }, function (v) { return $a3a350f95ccae46a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a3a350f95ccae46a$export$816d2913ae6b83b1; }, function (v) { return $a3a350f95ccae46a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a3a350f95ccae46a$export$61bcfe829111a1d0; }, function (v) { return $a3a350f95ccae46a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a3a350f95ccae46a$export$7ee8c9beb337bc3f; }, function (v) { return $a3a350f95ccae46a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a3a350f95ccae46a$export$b5836b71941fa3ed; }, function (v) { return $a3a350f95ccae46a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a3a350f95ccae46a$export$cf845f2c119da08a; }, function (v) { return $a3a350f95ccae46a$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a3a350f95ccae46a$export$c4744153514ff05d;
var $a3a350f95ccae46a$export$d66a1c1c77bd778b;
var $a3a350f95ccae46a$export$3e506c1ccc9cc1a7;
var $a3a350f95ccae46a$export$e26fe2ed2fa76875;
var $a3a350f95ccae46a$export$502329bbf4b505b1;
var $a3a350f95ccae46a$export$6e3807111c4874c4;
var $a3a350f95ccae46a$export$c27134553091fb3a;
var $a3a350f95ccae46a$export$33ee1acdc04fd2a2;
var $a3a350f95ccae46a$export$b00a404bbd5edef2;
var $a3a350f95ccae46a$export$8352ce38b91d0c62;
var $a3a350f95ccae46a$export$d3dfb8e4810cb555;
var $a3a350f95ccae46a$export$839f9183b0465a69;
var $a3a350f95ccae46a$export$72fdf0e06517287b;
var $a3a350f95ccae46a$export$4b844e58a3e414b4;
var $a3a350f95ccae46a$export$816d2913ae6b83b1;
var $a3a350f95ccae46a$export$61bcfe829111a1d0;
var $a3a350f95ccae46a$export$7ee8c9beb337bc3f;
var $a3a350f95ccae46a$export$b5836b71941fa3ed;
var $a3a350f95ccae46a$export$cf845f2c119da08a;
"use strict";
var $a3a350f95ccae46a$var$f, $a3a350f95ccae46a$var$g, $a3a350f95ccae46a$var$h, $a3a350f95ccae46a$var$k, $a3a350f95ccae46a$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $a3a350f95ccae46a$var$p = null, $a3a350f95ccae46a$var$q = null, $a3a350f95ccae46a$var$t = function() {
        if (null !== $a3a350f95ccae46a$var$p) try {
            var a = $a3a350f95ccae46a$export$c4744153514ff05d();
            $a3a350f95ccae46a$var$p(!0, a);
            $a3a350f95ccae46a$var$p = null;
        } catch (b) {
            throw setTimeout($a3a350f95ccae46a$var$t, 0), b;
        }
    }, $a3a350f95ccae46a$var$u = Date.now();
    $a3a350f95ccae46a$export$c4744153514ff05d = function() {
        return Date.now() - $a3a350f95ccae46a$var$u;
    };
    $a3a350f95ccae46a$var$f = function(a) {
        null !== $a3a350f95ccae46a$var$p ? setTimeout($a3a350f95ccae46a$var$f, 0, a) : ($a3a350f95ccae46a$var$p = a, setTimeout($a3a350f95ccae46a$var$t, 0));
    };
    $a3a350f95ccae46a$var$g = function(a, b) {
        $a3a350f95ccae46a$var$q = setTimeout(a, b);
    };
    $a3a350f95ccae46a$var$h = function() {
        clearTimeout($a3a350f95ccae46a$var$q);
    };
    $a3a350f95ccae46a$var$k = function() {
        return !1;
    };
    $a3a350f95ccae46a$var$l = $a3a350f95ccae46a$export$d66a1c1c77bd778b = function() {};
} else {
    var $a3a350f95ccae46a$var$w = window.performance, $a3a350f95ccae46a$var$x = window.Date, $a3a350f95ccae46a$var$y = window.setTimeout, $a3a350f95ccae46a$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $a3a350f95ccae46a$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $a3a350f95ccae46a$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $a3a350f95ccae46a$var$w && "function" === typeof $a3a350f95ccae46a$var$w.now) $a3a350f95ccae46a$export$c4744153514ff05d = function() {
        return $a3a350f95ccae46a$var$w.now();
    };
    else {
        var $a3a350f95ccae46a$var$B = $a3a350f95ccae46a$var$x.now();
        $a3a350f95ccae46a$export$c4744153514ff05d = function() {
            return $a3a350f95ccae46a$var$x.now() - $a3a350f95ccae46a$var$B;
        };
    }
    var $a3a350f95ccae46a$var$C = !1, $a3a350f95ccae46a$var$D = null, $a3a350f95ccae46a$var$E = -1, $a3a350f95ccae46a$var$F = 5, $a3a350f95ccae46a$var$G = 0;
    $a3a350f95ccae46a$var$k = function() {
        return $a3a350f95ccae46a$export$c4744153514ff05d() >= $a3a350f95ccae46a$var$G;
    };
    $a3a350f95ccae46a$var$l = function() {};
    $a3a350f95ccae46a$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $a3a350f95ccae46a$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $a3a350f95ccae46a$var$H = new MessageChannel, $a3a350f95ccae46a$var$I = $a3a350f95ccae46a$var$H.port2;
    $a3a350f95ccae46a$var$H.port1.onmessage = function() {
        if (null !== $a3a350f95ccae46a$var$D) {
            var a = $a3a350f95ccae46a$export$c4744153514ff05d();
            $a3a350f95ccae46a$var$G = a + $a3a350f95ccae46a$var$F;
            try {
                $a3a350f95ccae46a$var$D(!0, a) ? $a3a350f95ccae46a$var$I.postMessage(null) : ($a3a350f95ccae46a$var$C = !1, $a3a350f95ccae46a$var$D = null);
            } catch (b) {
                throw $a3a350f95ccae46a$var$I.postMessage(null), b;
            }
        } else $a3a350f95ccae46a$var$C = !1;
    };
    $a3a350f95ccae46a$var$f = function(a) {
        $a3a350f95ccae46a$var$D = a;
        $a3a350f95ccae46a$var$C || ($a3a350f95ccae46a$var$C = !0, $a3a350f95ccae46a$var$I.postMessage(null));
    };
    $a3a350f95ccae46a$var$g = function(a, b) {
        $a3a350f95ccae46a$var$E = $a3a350f95ccae46a$var$y(function() {
            a($a3a350f95ccae46a$export$c4744153514ff05d());
        }, b);
    };
    $a3a350f95ccae46a$var$h = function() {
        $a3a350f95ccae46a$var$z($a3a350f95ccae46a$var$E);
        $a3a350f95ccae46a$var$E = -1;
    };
}
function $a3a350f95ccae46a$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $a3a350f95ccae46a$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a3a350f95ccae46a$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $a3a350f95ccae46a$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $a3a350f95ccae46a$var$K(n, c)) void 0 !== r && 0 > $a3a350f95ccae46a$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $a3a350f95ccae46a$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $a3a350f95ccae46a$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $a3a350f95ccae46a$var$N = [], $a3a350f95ccae46a$var$O = [], $a3a350f95ccae46a$var$P = 1, $a3a350f95ccae46a$var$Q = null, $a3a350f95ccae46a$var$R = 3, $a3a350f95ccae46a$var$S = !1, $a3a350f95ccae46a$var$T = !1, $a3a350f95ccae46a$var$U = !1;
function $a3a350f95ccae46a$var$V(a) {
    for(var b = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$O); null !== b;){
        if (null === b.callback) $a3a350f95ccae46a$var$M($a3a350f95ccae46a$var$O);
        else if (b.startTime <= a) $a3a350f95ccae46a$var$M($a3a350f95ccae46a$var$O), b.sortIndex = b.expirationTime, $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$N, b);
        else break;
        b = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$O);
    }
}
function $a3a350f95ccae46a$var$W(a) {
    $a3a350f95ccae46a$var$U = !1;
    $a3a350f95ccae46a$var$V(a);
    if (!$a3a350f95ccae46a$var$T) {
        if (null !== $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N)) $a3a350f95ccae46a$var$T = !0, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$X);
        else {
            var b = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$O);
            null !== b && $a3a350f95ccae46a$var$g($a3a350f95ccae46a$var$W, b.startTime - a);
        }
    }
}
function $a3a350f95ccae46a$var$X(a, b) {
    $a3a350f95ccae46a$var$T = !1;
    $a3a350f95ccae46a$var$U && ($a3a350f95ccae46a$var$U = !1, $a3a350f95ccae46a$var$h());
    $a3a350f95ccae46a$var$S = !0;
    var c = $a3a350f95ccae46a$var$R;
    try {
        $a3a350f95ccae46a$var$V(b);
        for($a3a350f95ccae46a$var$Q = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N); null !== $a3a350f95ccae46a$var$Q && (!($a3a350f95ccae46a$var$Q.expirationTime > b) || a && !$a3a350f95ccae46a$var$k());){
            var d = $a3a350f95ccae46a$var$Q.callback;
            if (null !== d) {
                $a3a350f95ccae46a$var$Q.callback = null;
                $a3a350f95ccae46a$var$R = $a3a350f95ccae46a$var$Q.priorityLevel;
                var e = d($a3a350f95ccae46a$var$Q.expirationTime <= b);
                b = $a3a350f95ccae46a$export$c4744153514ff05d();
                "function" === typeof e ? $a3a350f95ccae46a$var$Q.callback = e : $a3a350f95ccae46a$var$Q === $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N) && $a3a350f95ccae46a$var$M($a3a350f95ccae46a$var$N);
                $a3a350f95ccae46a$var$V(b);
            } else $a3a350f95ccae46a$var$M($a3a350f95ccae46a$var$N);
            $a3a350f95ccae46a$var$Q = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N);
        }
        if (null !== $a3a350f95ccae46a$var$Q) var m = !0;
        else {
            var n = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$O);
            null !== n && $a3a350f95ccae46a$var$g($a3a350f95ccae46a$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $a3a350f95ccae46a$var$Q = null, $a3a350f95ccae46a$var$R = c, $a3a350f95ccae46a$var$S = !1;
    }
}
function $a3a350f95ccae46a$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $a3a350f95ccae46a$var$Z = $a3a350f95ccae46a$var$l;
$a3a350f95ccae46a$export$3e506c1ccc9cc1a7 = 5;
$a3a350f95ccae46a$export$e26fe2ed2fa76875 = 1;
$a3a350f95ccae46a$export$502329bbf4b505b1 = 4;
$a3a350f95ccae46a$export$6e3807111c4874c4 = 3;
$a3a350f95ccae46a$export$c27134553091fb3a = null;
$a3a350f95ccae46a$export$33ee1acdc04fd2a2 = 2;
$a3a350f95ccae46a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a3a350f95ccae46a$export$8352ce38b91d0c62 = function() {
    $a3a350f95ccae46a$var$T || $a3a350f95ccae46a$var$S || ($a3a350f95ccae46a$var$T = !0, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$X));
};
$a3a350f95ccae46a$export$d3dfb8e4810cb555 = function() {
    return $a3a350f95ccae46a$var$R;
};
$a3a350f95ccae46a$export$839f9183b0465a69 = function() {
    return $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N);
};
$a3a350f95ccae46a$export$72fdf0e06517287b = function(a) {
    switch($a3a350f95ccae46a$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a3a350f95ccae46a$var$R;
    }
    var c = $a3a350f95ccae46a$var$R;
    $a3a350f95ccae46a$var$R = b;
    try {
        return a();
    } finally{
        $a3a350f95ccae46a$var$R = c;
    }
};
$a3a350f95ccae46a$export$4b844e58a3e414b4 = function() {};
$a3a350f95ccae46a$export$816d2913ae6b83b1 = $a3a350f95ccae46a$var$Z;
$a3a350f95ccae46a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a3a350f95ccae46a$var$R;
    $a3a350f95ccae46a$var$R = a;
    try {
        return b();
    } finally{
        $a3a350f95ccae46a$var$R = c;
    }
};
$a3a350f95ccae46a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a3a350f95ccae46a$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $a3a350f95ccae46a$var$Y(a);
    } else c = $a3a350f95ccae46a$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $a3a350f95ccae46a$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$O, a), null === $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N) && a === $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$O) && ($a3a350f95ccae46a$var$U ? $a3a350f95ccae46a$var$h() : $a3a350f95ccae46a$var$U = !0, $a3a350f95ccae46a$var$g($a3a350f95ccae46a$var$W, e - d))) : (a.sortIndex = c, $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$N, a), $a3a350f95ccae46a$var$T || $a3a350f95ccae46a$var$S || ($a3a350f95ccae46a$var$T = !0, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$X)));
    return a;
};
$a3a350f95ccae46a$export$b5836b71941fa3ed = function() {
    var a = $a3a350f95ccae46a$export$c4744153514ff05d();
    $a3a350f95ccae46a$var$V(a);
    var b = $a3a350f95ccae46a$var$L($a3a350f95ccae46a$var$N);
    return b !== $a3a350f95ccae46a$var$Q && null !== $a3a350f95ccae46a$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $a3a350f95ccae46a$var$Q.expirationTime || $a3a350f95ccae46a$var$k();
};
$a3a350f95ccae46a$export$cf845f2c119da08a = function(a) {
    var b = $a3a350f95ccae46a$var$R;
    return function() {
        var c = $a3a350f95ccae46a$var$R;
        $a3a350f95ccae46a$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a3a350f95ccae46a$var$R = c;
        }
    };
};

});




parcelRegister("iUAyZ", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_8 = [
        "navigation",
        "request",
        "process",
        "log",
        "user",
        "state",
        "error",
        "manual"
    ];
    // Array#reduce
    var _$reduce_17 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    var _$filter_12 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    var _$includes_13 = function(arr, x) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_14 = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable("toString");
    var _dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ]; // Object#keys
    var _$keys_15 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_24 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === "number" && parseInt("" + value, 10) === value && value >= min && value <= max;
        };
    }; /* removed: var _$filter_12 = require('../es-utils/filter'); */ 
    var _$listOfFunctions_25 = function(value) {
        return typeof value === "function" || _$isArray_14(value) && _$filter_12(value, function(f) {
            return typeof f === "function";
        }).length === value.length;
    };
    var _$stringWithLength_26 = function(value) {
        return typeof value === "string" && !!value.length;
    };
    var _$config_5 = {}; /* removed: var _$filter_12 = require('./lib/es-utils/filter'); */ 
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_5.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: "is required",
            validate: _$stringWithLength_26
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: "should be true|false",
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: "should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }",
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== "object" || !value) return false;
                var providedKeys = _$keys_15(value);
                var defaultKeys = _$keys_15(defaultErrorTypes()); // ensure it only has a subset of the allowed keys
                if (_$filter_12(providedKeys, function(k) {
                    return _$includes_13(defaultKeys, k);
                }).length < providedKeys.length) return false; // ensure all of the values are boolean
                if (_$filter_12(_$keys_15(value), function(k) {
                    return typeof value[k] !== "boolean";
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        endpoints: {
            defaultValue: function() {
                return {
                    notify: "https://notify.bugsnag.com",
                    sessions: "https://sessions.bugsnag.com"
                };
            },
            message: "should be an object containing endpoint URLs { notify, sessions }",
            validate: function(val) {
                return val && typeof val === "object" && // notify and sessions must always be set
                _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_12(_$keys_15(val), function(k) {
                    return !_$includes_13([
                        "notify",
                        "sessions"
                    ], k);
                }).length === 0;
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: "should be true|false",
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: "should be an array of strings",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$filter_12(value, function(f) {
                    return typeof f === "string";
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return "production";
            },
            message: "should be a string",
            validate: function(value) {
                return typeof value === "string" && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function(value) {
                return _$intRange_24(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_8;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(",") + ")",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$reduce_17(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_13(_$breadcrumbTypes_8, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || typeof value === "string";
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object with { id, email, name } properties",
            validate: function(value) {
                return value === null || value && _$reduce_17(_$keys_15(value), function(accum, key) {
                    return accum && _$includes_13([
                        "id",
                        "email",
                        "name"
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object",
            validate: function(value) {
                return typeof value === "object" && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be null or an object with methods { debug, info, warn, error }",
            validate: function(value) {
                return !value || value && _$reduce_17([
                    "debug",
                    "info",
                    "warn",
                    "error"
                ], function(accum, method) {
                    return accum && typeof value[method] === "function";
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    "password"
                ];
            },
            message: "should be an array of strings|regexes",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(s) {
                    return typeof s === "string" || s && typeof s.test === "function";
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: "should be an array of plugin objects",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(p) {
                    return p && typeof p === "object" && typeof p.load === "function";
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(feature) {
                    return feature && typeof feature === "object" && typeof feature.name === "string";
                }).length;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_11 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    var _$map_16 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_5.schema; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _$config_1 = {
        releaseStage: _$assign_11({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return "development";
                return "production";
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return "browser";
            }
        }),
        logger: _$assign_11({}, schema.logger, {
            defaultValue: function() {
                return typeof console !== "undefined" && typeof console.debug === "function" ? getPrefixedConsole() : undefined;
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_16([
            "debug",
            "info",
            "warn",
            "error"
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === "function" ? consoleMethod.bind(console, "[bugsnag]") : consoleLog.bind(console, "[bugsnag]");
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_3 = Breadcrumb;
    var _$stackframe_34 = {};
    (function(root, factory) {
        "use strict"; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
        else if (typeof _$stackframe_34 === "object") _$stackframe_34 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        "use strict";
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            "isConstructor",
            "isEval",
            "isNative",
            "isToplevel"
        ];
        var numericProps = [
            "columnNumber",
            "lineNumber"
        ];
        var stringProps = [
            "fileName",
            "functionName",
            "source"
        ];
        var arrayProps = [
            "args"
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps);
        function StackFrame(obj) {
            if (obj instanceof Object) {
                for(var i = 0; i < props.length; i++)if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
            }
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError("Eval Origin must be an Object or StackFrame");
            },
            toString: function() {
                var functionName = this.getFunctionName() || "{anonymous}";
                var args = "(" + (this.getArgs() || []).join(",") + ")";
                var fileName = this.getFileName() ? "@" + this.getFileName() : "";
                var lineNumber = _isNumber(this.getLineNumber()) ? ":" + this.getLineNumber() : "";
                var columnNumber = _isNumber(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
                return functionName + args + fileName + lineNumber + columnNumber;
            }
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$errorStackParser_31 = {};
    (function(root, factory) {
        "use strict"; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
            "stackframe"
        ], factory);
        else if (typeof _$errorStackParser_31 === "object") _$errorStackParser_31 = factory(_$stackframe_34);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        "use strict";
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error("Cannot parse given Error object");
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(":") === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ""));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, "");
                    var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "("); // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/); // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1); // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(" ") || undefined;
                    var fileName = [
                        "eval",
                        "<anonymous>"
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1");
                    if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split("\n");
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split("\n");
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split("@");
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || "";
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, "$1");
                    var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_10 = _$errorStackParser_31;
    var _$safeJsonStringify_30 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = "...";
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return "[Throws: " + (err ? err.message : "?") + "]";
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    } // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === "string" && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === "function" && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_30(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== "object") return obj;
            if (find(seen, obj)) return "[Circular]";
            seen.push(obj);
            if (typeof obj.toJSON === "function") try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_30(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat("[]")));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join(".")) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = "[REDACTED]";
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    } /* removed: var _$map_16 = require('./es-utils/map'); */ 
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== "string") return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== "string") variant = _$safeJsonStringify_30(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === "number") {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_14(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== "object") continue;
             // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    } // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_16(_$filter_12(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            }; // don't add a 'variant' property unless there's actually a value
            if (typeof variant === "string") flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === "number") {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_18 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_19 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err["opera#sourceloc"]) && typeof (err.stack || err.stacktrace || err["opera#sourceloc"]) === "string" && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_32 = __isError_32;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_32(value) {
        switch(Object.prototype.toString.call(value)){
            case "[object Error]":
                return true;
            case "[object Exception]":
                return true;
            case "[object DOMException]":
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_20 = _$isError_32; /* removed: var _$assign_11 = require('./es-utils/assign'); */ 
    var __add_22 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates; // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_22(state, section); // normalise the two supported input types into object form
        if (typeof keyOrObj === "object") updates = keyOrObj;
        if (typeof keyOrObj === "string") updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates); // exit if we don't have an updates object at this point
        if (!updates) return; // ensure a section with this name exists
        if (!state[section]) state[section] = {}; // merge the updates with the existing section
        state[section] = _$assign_11({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== "string") return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_22 = function(state, section, key) {
        if (typeof section !== "string") return; // clear an entire section
        if (!key) {
            delete state[section];
            return;
        } // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_22 = {
        add: __add_22,
        get: get,
        clear: __clear_22
    };
    var _$stackGenerator_33 = {};
    (function(root, factory) {
        "use strict"; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
            "stackframe"
        ], factory);
        else if (typeof _$stackGenerator_33 === "object") _$stackGenerator_33 = factory(_$stackframe_34);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr["arguments"]){
                    // Allow V8 optimizations
                    var args = new Array(curr["arguments"].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    }); /* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */ 
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ]; // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_18.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: "4",
                exceptions: _$map_16(this.errors, function(er) {
                    return _$assign_11({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags()
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        }; // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = "global code";
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? "global code" : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: "warning",
            severityReason: {
                type: "handledException"
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === "string" ? str : "";
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_17(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame); // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === "{}") return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    } // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip); // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_12(_$stackGenerator_33.backtrace(), function(frame) {
                return (frame.functionName || "").indexOf("StackGenerator$$") === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === "InvalidError") event.addMetadata("" + component, "non-error parameter", makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_16(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, "error cause"), error = _normaliseError2[0];
                if (error.name === "InvalidError") event.addMetadata("error cause", makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return "null";
        if (err === undefined) return "undefined";
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === "error cause" ? "was" : "received";
            if (logger) logger.warn(component + " " + verb + ' a non-error: "' + reason + '"');
            var err = new Error(component + " " + verb + ' a non-error. See "' + component + '" tab for more detail.');
            err.name = "InvalidError";
            return err;
        }; // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_20(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case "string":
            case "number":
            case "boolean":
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case "function":
                error = createAndLogInputError("function");
                internalFrames += 2;
                break;
            case "object":
                if (maybeError !== null && _$iserror_20(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? "null" : "unsupported object");
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError("nothing");
                internalFrames += 2;
        }
        if (!_$hasStack_19(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_19(e)) {
                error = e; // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    }; // default value for stacktrace.type
    Event.__type = "browserjs";
    var hasNecessaryFields = function(error) {
        return (typeof error.name === "string" || typeof error.errorClass === "string") && (typeof error.message === "string" || typeof error.errorMessage === "string");
    };
    var _$Event_6 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_7 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    }; /* removed: var _$asyncEvery_7 = require('./async-every'); */ 
    var _$callbackRunner_9 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== "function") return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event); // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === "function") return ret.then(function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                } // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_23 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_29 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_29 = require('./pad.js'); */ 
    var env = typeof window === "object" ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_28 = function fingerprint() {
        return clientId;
    }; /* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */ 
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_29(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_28(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_28;
    var _$cuid_27 = cuid; /* removed: var _$cuid_27 = require('@bugsnag/cuid'); */ 
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_27();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? "_unhandled" : "_handled"] += 1;
        };
        return Session;
    }();
    var _$Session_35 = Session; /* removed: var _$config_5 = require('./config'); */ 
    var __add_4 = _$featureFlagDelegate_18.add, __clear_4 = _$featureFlagDelegate_18.clear, __merge_4 = _$featureFlagDelegate_18.merge;
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_5.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier; // intialise opts and config
            this._config = {};
            this._schema = schema; // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            }; // plugins
            this._plugins = {}; // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {}; // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            }; // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_6;
            this.Breadcrumb = _$Breadcrumb_3;
            this.Session = _$Session_35;
            this._config = this._configure(configuration, internalPlugins);
            _$map_16(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            }); // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_4(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_4(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_4(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_17(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
                return schema;
            }, this._schema); // accumulate configuration and error messages
            var _reduce = _$reduce_17(_$keys_15(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_11(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error("No Bugsnag API Key set"); // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = "should be a string of 32 hexadecimal characters";
            } // update and elevate some options
            this._metadata = _$assign_11({}, config.metadata);
            __merge_4(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_11({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger; // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession); // finally warn about any invalid config where we fell back to the default
            if (_$keys_15(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this); // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
            return this;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_35();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_11({}, this._user); // run onSession callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.s, session, "onSession", this._logger);
            if (ignore) {
                this._logger.debug("Session not started due to onSession callback");
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_12(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_12(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_12(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === "string" ? message : "";
            type = typeof type === "string" && _$includes_13(_$breadcrumbTypes_8, type) ? type : "manual";
            metadata = typeof metadata === "object" && metadata !== null ? metadata : {}; // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_3(message, metadata, type); // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, "onBreadcrumb", this._logger);
            if (ignore) {
                this._logger.debug("Breadcrumb not attached due to onBreadcrumb callback");
                return;
            } // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_13(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_6.create(maybeError, true, undefined, "notify()", this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_11({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_11({}, event._metadata, this._metadata);
            event._user = _$assign_11({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_4(event._features, this._features, event._featuresIndex); // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn("Event not sent due to releaseStage/enabledReleaseStages configuration");
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_9(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug("Event not sent due to onError callback");
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled("error")) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, "error");
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: "userCallbackSetSeverity"
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join("\n\n"));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case "string":
            case "number":
            case "object":
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_4 = Client;
    var _$jsonPayload_21 = {}; /* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */ 
    var EVENT_REDACTION_PATHS = [
        "events.[].metaData",
        "events.[].breadcrumbs.[].metaData",
        "events.[].request"
    ];
    _$jsonPayload_21.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_30(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_30(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_21.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_30(session, null, null);
        return payload;
    };
    var _$delivery_36 = {}; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    _$delivery_36 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "notify", "4", win);
                var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error("Event failed to send");
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "sessions", "1", win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_36._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === "http:" ? endpoint.replace(/^https:/, "http:") : endpoint;
    }; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    var _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", event.apiKey || client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "4");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    var req = new win.XMLHttpRequest();
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", err);
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "1");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_38 = {
        name: "appDuration",
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_39 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var _$pad_43 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_43 = require('./pad.js'); */ 
    var __env_42 = typeof window === "object" ? window : self;
    var __globalCount_42 = 0;
    for(var __prop_42 in __env_42)if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
    var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
    var _$fingerprint_42 = function fingerprint() {
        return __clientId_42;
    }; /* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */ 
    var __c_41 = 0, __blockSize_41 = 4, __base_41 = 36, __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
    function __randomBlock_41() {
        return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
    }
    function __safeCounter_41() {
        __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
        __c_41++; // this is not subliminal
        return __c_41 - 1;
    }
    function __cuid_41() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(__base_41), // Prevent same-machine collisions.
        counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_42(), // Grab some more chars from Math.random()
        random = __randomBlock_41() + __randomBlock_41();
        return letter + timestamp + counter + print + random;
    }
    __cuid_41.fingerprint = _$fingerprint_42;
    var _$cuid_41 = __cuid_41; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    var BUGSNAG_ANONYMOUS_ID_KEY = "bugsnag-anonymous-id";
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY); // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
             /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */ 
            id = _$cuid_41();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {}
    };
    /*
 * Automatically detects browser device details
 */ var _$device_40 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? "landscape" : "portrait";
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_11({}, session.device, device); // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                }); // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_11({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_44 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_11({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    }; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    var _$session_45 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn("Session not sent due to releaseStage/enabledReleaseStages configuration");
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
             // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            } // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_46 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === "undefined") delete event._user.id;
                event._user = _$assign_11({
                    id: "[REDACTED]"
                }, event._user);
                event.request = _$assign_11({
                    clientIp: "[REDACTED]"
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: "should be true|false",
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_47 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_47.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled("log")) return;
        _$map_16(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb("Console output", _$reduce_17(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = "[Unknown value]"; // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {} // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === "[object Object]") // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf("group") === 0 ? "log" : method
                }), "log");
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_12([
        "log",
        "debug",
        "info",
        "warn",
        "error"
    ], function(method) {
        return typeof console !== "undefined" && typeof console[method] === "function";
    }); /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_48 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = ""; // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === "complete" : doc.readyState !== "loading";
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                }; // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange; // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === "interactive") {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName("script");
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml(); // simulate the raw html
                    var htmlLines = [
                        "<!-- DOC START -->"
                    ].concat(html.split("\n"));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_17(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0]; // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && frame.file.replace(/#.*$/, "") !== originalLocation.replace(/#.*$/, "")) return; // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata("script", "content", content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH)); // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true); // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_16([
                    "setTimeout",
                    "setInterval",
                    "setImmediate",
                    "requestAnimationFrame"
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0]; // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_16([
                    "EventTarget",
                    "Window",
                    "Node",
                    "ApplicationCache",
                    "AudioTrackList",
                    "ChannelMergerNode",
                    "CryptoOperation",
                    "EventSource",
                    "FileReader",
                    "HTMLUnknownElement",
                    "IDBDatabase",
                    "IDBRequest",
                    "IDBTransaction",
                    "KeyOperation",
                    "MediaController",
                    "MessagePort",
                    "ModalWindow",
                    "Notification",
                    "SVGElementInstance",
                    "Screen",
                    "TextTrack",
                    "TextTrackCue",
                    "TextTrackList",
                    "WebSocket",
                    "WebSocketWorker",
                    "Worker",
                    "XMLHttpRequest",
                    "XMLHttpRequestEventTarget",
                    "XMLHttpRequestUpload"
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, "addEventListener")) return;
                    __proxy(win[o].prototype, "addEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, "removeEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== "function") return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript(); // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script); // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        } // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === "function";
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_49 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("user")) return;
                win.addEventListener("click", function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = "[hidden]";
                        targetSelector = "[hidden]";
                        client._logger.error("Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z");
                    }
                    client.leaveBreadcrumb("UI click", {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, "user");
                }, true);
            }
        };
    };
    var trimStart = /^\s+/;
    var trimEnd = /(^|[^\s])\s+$/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || "";
        if (!text && (el.type === "submit" || el.type === "button")) text = el.value;
        text = text.replace(trimStart, "").replace(trimEnd, "$1");
        if (text.length > 140) return text.slice(0, 135) + "(...)";
        return text;
    } // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push("#" + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(" ").join(".")); // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join("");
        try {
            if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join("");
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join("");
        } // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join(""); // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join("");
        return parts.join("");
    }
    var _$navigationBreadcrumbs_50 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_50 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("navigation")) return; // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, "navigation");
                    };
                }; // simple drops – just names, no meta
                win.addEventListener("pagehide", drop("Page hidden"), true);
                win.addEventListener("pageshow", drop("Page shown"), true);
                win.addEventListener("load", drop("Page loaded"), true);
                win.document.addEventListener("DOMContentLoaded", drop("DOMContentLoaded"), true); // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener("load", function() {
                    return win.addEventListener("popstate", drop("Navigated back"), true);
                }); // hashchange has some metadata that we care about
                win.addEventListener("hashchange", function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb("Hash changed", metadata, "navigation");
                }, true); // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.replaceState) wrapHistoryFn(client, win.history, "replaceState", win);
                if (win.history.pushState) wrapHistoryFn(client, win.history, "pushState", win);
            }
        };
        return plugin;
    };
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement("A");
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win) {
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), "navigation"); // if throttle plugin is in use, reset the event sent count
            if (typeof client.resetEventCount === "function") client.resetEventCount(); // if the client is operating in auto session-mode, a new route should trigger a new session
            if (client._config.autoTrackSessions) client.startSession(); // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = "request"; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_51 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled("request")) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch(); // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!("addEventListener" in win.XMLHttpRequest.prototype)) return;
                    var nativeOpen = win.XMLHttpRequest.prototype.open; // override native open()
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        var _this = this;
                        var requestSetupKey = false;
                        var error = function() {
                            return handleXHRError(method, url);
                        };
                        var load = function() {
                            return handleXHRLoad(method, url, _this.status);
                        }; // if we have already setup listeners, it means open() was called twice, we need to remove
                        // the listeners and recreate them
                        if (requestSetupKey) {
                            this.removeEventListener("load", load);
                            this.removeEventListener("error", error);
                        } // attach load event listener
                        this.addEventListener("load", load); // attach error event listener
                        this.addEventListener("error", error);
                        requestSetupKey = true;
                        nativeOpen.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    } // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        request: method + " " + url
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb("XMLHttpRequest failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("XMLHttpRequest succeeded", metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    }
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                     // failed to contact server
                    client.leaveBreadcrumb("XMLHttpRequest error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                } // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!("fetch" in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === "object") {
                            url = urlOrRequest.url;
                            if (options && "method" in options) method = options.method;
                            else if (urlOrRequest && "method" in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && "method" in options) method = options.method;
                        }
                        if (method === undefined) method = "GET";
                        return new Promise(function(resolve, reject) {
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url);
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url);
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url) {
                    var metadata = {
                        status: response.status,
                        request: method + " " + url
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb("fetch() failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("fetch() succeeded", metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url) {
                    client.leaveBreadcrumb("fetch() error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    }; /* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */ 
    /*
 * Throttles and dedupes events
 */ var _$throttle_52 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0; // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function(val) {
                    return _$intRange_24(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_53 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    _$stripQueryString_53 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_17(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_16(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_53._strip = function(str) {
        return typeof str === "string" ? str.replace(/\?.*$/, "").replace(/#.*$/, "") : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_54 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = "window onerror";
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn("Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z");
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: "error",
                            unhandled: true,
                            severityReason: {
                                type: "unhandledException"
                            }
                        };
                        var event; // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === "object" && messageOrEvent !== null && (!url || typeof url !== "string") && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : "Error"; // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || "";
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1); // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent; // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === "function") prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    }; // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === "string") culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === "number" && String.call(n) !== "NaN";
    }; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_55 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false; // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    var event = client.Event.create(error, false, {
                        severity: "error",
                        unhandled: true,
                        severityReason: {
                            type: "unhandledPromiseRejection"
                        }
                    }, "unhandledrejection handler", 1, client._logger);
                    if (isBluebird) _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_20(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata("unhandledRejection handler", (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ("addEventListener" in win) win.addEventListener("unhandledrejection", listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    }; // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, "");
        };
    };
    var _$notifier_2 = {};
    var name = "Bugsnag JavaScript";
    var version = "7.20.0";
    var url = "https://github.com/bugsnag/bugsnag-js"; /* removed: var _$Client_4 = require('@bugsnag/core/client'); */ 
    var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1); /* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */ 
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === "string") opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                _$app_38,
                _$device_40(),
                _$context_39(),
                _$request_44(),
                _$throttle_52,
                _$session_45,
                _$clientIp_46,
                _$stripQueryString_53,
                _$onerror_54(),
                _$unhandledRejection_55(),
                _$navigationBreadcrumbs_50(),
                _$interactionBreadcrumbs_49(),
                _$networkBreadcrumbs_51(),
                _$consoleBreadcrumbs_47,
                _$inlineScriptContent_48()
            ]; // configure a client with user supplied options
            var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
                name: name,
                version: version,
                url: url
            }); // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
            bugsnag._logger.debug("Loaded!");
            bugsnag.leaveBreadcrumb("Bugsnag loaded", {}, "state");
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn("Bugsnag.start() was called more than once. Ignoring.");
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_16([
        "resetEventCount"
    ].concat(_$keys_15(_$Client_4.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_2 = Bugsnag;
    _$notifier_2.Client = _$Client_4;
    _$notifier_2.Event = _$Event_6;
    _$notifier_2.Session = _$Session_35;
    _$notifier_2.Breadcrumb = _$Breadcrumb_3; // Export a "default" property for compatibility with ESM imports
    _$notifier_2["default"] = Bugsnag;
    return _$notifier_2;
});

});

parcelRegister("hFJEF", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("269Bb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1873966958b84bde$export$2e2bcd8739ae039; });
function $1873966958b84bde$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("fsWgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b426a9fd6aa5bcb7$export$2e2bcd8739ae039; });

var $4Tov4 = parcelRequire("4Tov4");
function $b426a9fd6aa5bcb7$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $4Tov4.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("4Tov4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ff4db73cf07254$export$2e2bcd8739ae039; });
function $38ff4db73cf07254$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("gtn2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfe13a4239a95b8a$export$2e2bcd8739ae039; });
function $bfe13a4239a95b8a$export$2e2bcd8739ae039() {
    $bfe13a4239a95b8a$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfe13a4239a95b8a$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("6slzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b36185cfedf326f$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $4b36185cfedf326f$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://material-ui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("80wVS", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $5d47de89e3e59380$export$d061e26956a60b0a; });
$parcel$export(module.exports, "darken", function () { return $5d47de89e3e59380$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $5d47de89e3e59380$export$c0816ed86df316af; });
$parcel$export(module.exports, "alpha", function () { return $5d47de89e3e59380$export$58f0f39f63f3cf42; });

var $6slzQ = parcelRequire("6slzQ");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $5d47de89e3e59380$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $5d47de89e3e59380$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $5d47de89e3e59380$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $5d47de89e3e59380$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $5d47de89e3e59380$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $5d47de89e3e59380$var$intToHex(n);
    }).join(""));
}
function $5d47de89e3e59380$export$29fb7152bd3f781a(color) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $5d47de89e3e59380$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $5d47de89e3e59380$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $5d47de89e3e59380$export$677b39864803984e($5d47de89e3e59380$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $6slzQ.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $5d47de89e3e59380$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $5d47de89e3e59380$export$d061e26956a60b0a(foreground, background) {
    var lumA = $5d47de89e3e59380$export$c852d90bf7403b62(foreground);
    var lumB = $5d47de89e3e59380$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $5d47de89e3e59380$export$c852d90bf7403b62(color) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $5d47de89e3e59380$export$677b39864803984e($5d47de89e3e59380$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $5d47de89e3e59380$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $5d47de89e3e59380$export$c852d90bf7403b62(color) > 0.5 ? $5d47de89e3e59380$export$4b073707ff63303(color, coefficient) : $5d47de89e3e59380$export$c0816ed86df316af(color, coefficient);
}
var $5d47de89e3e59380$var$warnedOnce = false;
function $5d47de89e3e59380$export$cbea29d068a2e18f(color, value) {
    return $5d47de89e3e59380$export$58f0f39f63f3cf42(color, value);
}
function $5d47de89e3e59380$export$58f0f39f63f3cf42(color, value) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    value = $5d47de89e3e59380$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $5d47de89e3e59380$export$211a73f2b8c10ce4(color);
}
function $5d47de89e3e59380$export$4b073707ff63303(color, coefficient) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    coefficient = $5d47de89e3e59380$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $5d47de89e3e59380$export$211a73f2b8c10ce4(color);
}
function $5d47de89e3e59380$export$c0816ed86df316af(color, coefficient) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    coefficient = $5d47de89e3e59380$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $5d47de89e3e59380$export$211a73f2b8c10ce4(color);
}

});

parcelRegister("icOS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d410cf22e98b25f6$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $d410cf22e98b25f6$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $d410cf22e98b25f6$export$2e2bcd8739ae039 = $d410cf22e98b25f6$var$zIndex;

});

parcelRegister("7b1Lp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $539aedb282032fc2$export$2e2bcd8739ae039; });

var $gyDGU = parcelRequire("gyDGU");

var $815Xb = parcelRequire("815Xb");

var $cQNHH = parcelRequire("cQNHH");

var $ipwm3 = parcelRequire("ipwm3");

var $a6yxM = parcelRequire("a6yxM");

var $3K7R2 = parcelRequire("3K7R2");

var $6WDy5 = parcelRequire("6WDy5");

var $1krVc = parcelRequire("1krVc");

var $a4mPI = parcelRequire("a4mPI");

var $96kaR = parcelRequire("96kaR");

var $ks5BK = parcelRequire("ks5BK");
function $539aedb282032fc2$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $a6yxM.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $539aedb282032fc2$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $3K7R2.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $3K7R2.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $815Xb.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $3K7R2.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $815Xb.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $3K7R2.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $ipwm3.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $815Xb.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $a6yxM.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $539aedb282032fc2$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $539aedb282032fc2$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $3K7R2.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $3K7R2.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $539aedb282032fc2$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $539aedb282032fc2$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $ks5BK.default) : _options$defaultTheme, stylesOptions2 = (0, $gyDGU.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $96kaR.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $a4mPI.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $6WDy5.default)() || defaultTheme;
        var stylesOptions = (0, $815Xb.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext((0, $1krVc.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useRef();
        $539aedb282032fc2$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $539aedb282032fc2$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $539aedb282032fc2$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(function() {
            if (shouldUpdate.current) $539aedb282032fc2$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $539aedb282032fc2$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("gyDGU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0de9c29217d4ae1$export$2e2bcd8739ae039; });

var $jPENd = parcelRequire("jPENd");
function $c0de9c29217d4ae1$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $jPENd.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("jPENd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7026c59a0fb8b4a$export$2e2bcd8739ae039; });
function $e7026c59a0fb8b4a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("ipwm3", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $1ksDm = parcelRequire("1ksDm");

var $aGThG = parcelRequire("aGThG");

var $1UzpR = parcelRequire("1UzpR");

var $hXbED = parcelRequire("hXbED");

var $82w9t = parcelRequire("82w9t");

var $bV0Px = parcelRequire("bV0Px");

var $1sb8G = parcelRequire("1sb8G");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value, ignoreImportant) {
    if (ignoreImportant === void 0) ignoreImportant = false;
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (!ignoreImportant && value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $82w9t.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $bV0Px.default)((0, $bV0Px.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $1ksDm.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $hXbED.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $1ksDm.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $1ksDm.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $1ksDm.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $82w9t.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $1ksDm.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $1ksDm.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Get a rule.
   */ ;
    _proto.get = function get(name) {
        return this.map[name];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.map[name], data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $1ksDm.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name.
   */ ;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $1sb8G.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $hXbED.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) {
            cssValue = toCssValue(value, true);
            if (value[value.length - 1] === "!important") {
                cssRule.style.setProperty(prop, cssValue, "important");
                return true;
            }
        } // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules[index] = cssRule;
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.8.2";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $aGThG.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $1ksDm.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $1ksDm.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $1ksDm.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $1UzpR.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $1UzpR.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $hXbED.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $d673a8c732c05879$export$2e2bcd8739ae039 = index;

});
parcelRegister("1ksDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f7ddec51ea633a5$export$2e2bcd8739ae039; });
function $0f7ddec51ea633a5$export$2e2bcd8739ae039() {
    $0f7ddec51ea633a5$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f7ddec51ea633a5$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("aGThG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c88b5e9f1840927$export$2e2bcd8739ae039; });
var $7c88b5e9f1840927$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $7c88b5e9f1840927$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $7c88b5e9f1840927$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $7c88b5e9f1840927$var$_typeof(document)) === "object" && document.nodeType === 9;
var $7c88b5e9f1840927$export$2e2bcd8739ae039 = $7c88b5e9f1840927$export$4e09c449d6c407f7;

});

parcelRegister("1UzpR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16467e548dcd83b1$export$2e2bcd8739ae039; });
var $16467e548dcd83b1$var$isProduction = true;
function $16467e548dcd83b1$var$warning(condition, message) {
    if (!$16467e548dcd83b1$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $16467e548dcd83b1$export$2e2bcd8739ae039 = $16467e548dcd83b1$var$warning;

});

parcelRegister("hXbED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $035f7ff25c8ed8f0$export$2e2bcd8739ae039; });
function $035f7ff25c8ed8f0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $035f7ff25c8ed8f0$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $035f7ff25c8ed8f0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $035f7ff25c8ed8f0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("82w9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da77351594631b4$export$2e2bcd8739ae039; });

var $OlfsS = parcelRequire("OlfsS");
function $5da77351594631b4$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $OlfsS.default)(subClass, superClass);
}

});
parcelRegister("OlfsS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0975271f6cf83c70$export$2e2bcd8739ae039; });
function $0975271f6cf83c70$export$2e2bcd8739ae039(o, p) {
    $0975271f6cf83c70$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0975271f6cf83c70$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("bV0Px", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ad5a97543a4f19a$export$2e2bcd8739ae039; });
function $8ad5a97543a4f19a$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("1sb8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10f10bf588a52721$export$2e2bcd8739ae039; });
function $10f10bf588a52721$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("a6yxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b54299b87620a7$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

function $75b54299b87620a7$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $815Xb.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("3K7R2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9bc2b3c21b4faf$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $2b9bc2b3c21b4faf$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $2b9bc2b3c21b4faf$export$2e2bcd8739ae039 = $2b9bc2b3c21b4faf$var$multiKeyStore;

});

parcelRegister("1krVc", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $0f7d515dfbe6a364$export$f4de434b269fe487; });
$parcel$export(module.exports, "default", function () { return $0f7d515dfbe6a364$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

var $gyDGU = parcelRequire("gyDGU");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");


var $dCWGK = parcelRequire("dCWGK");

var $ipwm3 = parcelRequire("ipwm3");

var $iCH0W = parcelRequire("iCH0W");
var $0f7d515dfbe6a364$var$jss = (0, $ipwm3.create)((0, $iCH0W.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $0f7d515dfbe6a364$var$generateClassName = (0, $dCWGK.default)(); // Exported for test purposes
var $0f7d515dfbe6a364$export$70a8aea9ff58d1cd = new Map();
var $0f7d515dfbe6a364$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $0f7d515dfbe6a364$var$generateClassName,
    jss: $0f7d515dfbe6a364$var$jss,
    sheetsCache: null,
    sheetsManager: $0f7d515dfbe6a364$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $0f7d515dfbe6a364$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext($0f7d515dfbe6a364$var$defaultOptions);
var $0f7d515dfbe6a364$var$injectFirstNode;
function $0f7d515dfbe6a364$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $gyDGU.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext($0f7d515dfbe6a364$export$f4de434b269fe487);
    var context = (0, $815Xb.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$0f7d515dfbe6a364$var$injectFirstNode) {
            var head = document.head;
            $0f7d515dfbe6a364$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($0f7d515dfbe6a364$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $ipwm3.create)({
            plugins: (0, $iCH0W.default)().plugins,
            insertionPoint: $0f7d515dfbe6a364$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($0f7d515dfbe6a364$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("dCWGK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ebc5941a4d4dbb6$export$2e2bcd8739ae039; });

var $49sgH = parcelRequire("49sgH");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $9ebc5941a4d4dbb6$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $9ebc5941a4d4dbb6$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($9ebc5941a4d4dbb6$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $49sgH.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("49sgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $305dee35e9856e4c$export$2e2bcd8739ae039; });
var $305dee35e9856e4c$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $305dee35e9856e4c$export$2e2bcd8739ae039 = $305dee35e9856e4c$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("iCH0W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8ed24578f916d32$export$2e2bcd8739ae039; });

var $62JkZ = parcelRequire("62JkZ");

var $cyEBW = parcelRequire("cyEBW");

var $hdsV5 = parcelRequire("hdsV5");

var $3J7gu = parcelRequire("3J7gu");

var $f9Oxo = parcelRequire("f9Oxo");

var $302Yl = parcelRequire("302Yl");

var $efFhT = parcelRequire("efFhT");
function $d8ed24578f916d32$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $62JkZ.default)(),
            (0, $cyEBW.default)(),
            (0, $hdsV5.default)(),
            (0, $3J7gu.default)(),
            (0, $f9Oxo.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $302Yl.default)(),
            (0, $efFhT.default)()
        ]
    };
}

});
parcelRegister("62JkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46661918fe532c0b$export$2e2bcd8739ae039; });


var $ipwm3 = parcelRequire("ipwm3");
var $46661918fe532c0b$var$now = Date.now();
var $46661918fe532c0b$var$fnValuesNs = "fnValues" + $46661918fe532c0b$var$now;
var $46661918fe532c0b$var$fnRuleNs = "fnStyle" + ++$46661918fe532c0b$var$now;
var $46661918fe532c0b$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $ipwm3.createRule)(name, {}, options);
            rule[$46661918fe532c0b$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($46661918fe532c0b$var$fnValuesNs in rule || $46661918fe532c0b$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$46661918fe532c0b$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$46661918fe532c0b$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$46661918fe532c0b$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $46661918fe532c0b$export$2e2bcd8739ae039 = $46661918fe532c0b$var$functionPlugin;

});

parcelRegister("cyEBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92482982f55e24af$export$2e2bcd8739ae039; });

var $gRSze = parcelRequire("gRSze");

var $ipwm3 = parcelRequire("ipwm3");
var $92482982f55e24af$var$at = "@global";
var $92482982f55e24af$var$atPrefix = "@global ";
var $92482982f55e24af$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $92482982f55e24af$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $ipwm3.RuleList)((0, $gRSze.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString() {
        return this.rules.toString();
    };
    return GlobalContainerRule;
}();
var $92482982f55e24af$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $92482982f55e24af$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($92482982f55e24af$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $gRSze.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $92482982f55e24af$var$separatorRegExp = /\s*,\s*/g;
function $92482982f55e24af$var$addScope(selector, scope) {
    var parts = selector.split($92482982f55e24af$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $92482982f55e24af$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$92482982f55e24af$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $gRSze.default)({}, options, {
        selector: $92482982f55e24af$var$addScope(name, rule.selector)
    }));
    delete style[$92482982f55e24af$var$at];
}
function $92482982f55e24af$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $92482982f55e24af$var$at.length) !== $92482982f55e24af$var$at) continue;
        var selector = $92482982f55e24af$var$addScope(prop.substr($92482982f55e24af$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $gRSze.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $92482982f55e24af$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $92482982f55e24af$var$at) return new $92482982f55e24af$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $92482982f55e24af$var$atPrefix.length) === $92482982f55e24af$var$atPrefix) return new $92482982f55e24af$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $92482982f55e24af$var$handleNestedGlobalContainerRule(rule, sheet);
        $92482982f55e24af$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $92482982f55e24af$export$2e2bcd8739ae039 = $92482982f55e24af$var$jssGlobal;

});
parcelRegister("gRSze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47bec82326a2b4a$export$2e2bcd8739ae039; });
function $c47bec82326a2b4a$export$2e2bcd8739ae039() {
    $c47bec82326a2b4a$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c47bec82326a2b4a$export$2e2bcd8739ae039.apply(this, arguments);
}

});


parcelRegister("hdsV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c88a15730120666e$export$2e2bcd8739ae039; });

var $RdkRM = parcelRequire("RdkRM");

var $c88a15730120666e$var$separatorRegExp = /\s*,\s*/g;
var $c88a15730120666e$var$parentRegExp = /&/g;
var $c88a15730120666e$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $c88a15730120666e$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($c88a15730120666e$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($c88a15730120666e$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($c88a15730120666e$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $RdkRM.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $RdkRM.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($c88a15730120666e$var$refRegExp, replaceRef);
                container.addRule(selector, style[prop], (0, $RdkRM.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $c88a15730120666e$export$2e2bcd8739ae039 = $c88a15730120666e$var$jssNested;

});
parcelRegister("RdkRM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09ff4b83e25ced66$export$2e2bcd8739ae039; });
function $09ff4b83e25ced66$export$2e2bcd8739ae039() {
    $09ff4b83e25ced66$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09ff4b83e25ced66$export$2e2bcd8739ae039.apply(this, arguments);
}

});


parcelRegister("3J7gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6b35bb19b78d13$export$2e2bcd8739ae039; });

var $4UeHv = parcelRequire("4UeHv");
/**
 * Convert camel cased property names to dash separated.
 */ function $2b6b35bb19b78d13$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $4UeHv.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($2b6b35bb19b78d13$var$convertCase);
        else converted.fallbacks = $2b6b35bb19b78d13$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $2b6b35bb19b78d13$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $2b6b35bb19b78d13$var$convertCase(style[index]);
            return style;
        }
        return $2b6b35bb19b78d13$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $4UeHv.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $2b6b35bb19b78d13$export$2e2bcd8739ae039 = $2b6b35bb19b78d13$var$camelCase;

});
parcelRegister("4UeHv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3927cbaa97fc2f54$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $3927cbaa97fc2f54$var$uppercasePattern = /[A-Z]/g;
var $3927cbaa97fc2f54$var$msPattern = /^ms-/;
var $3927cbaa97fc2f54$var$cache = {};
function $3927cbaa97fc2f54$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $3927cbaa97fc2f54$var$hyphenateStyleName(name) {
    if ($3927cbaa97fc2f54$var$cache.hasOwnProperty(name)) return $3927cbaa97fc2f54$var$cache[name];
    var hName = name.replace($3927cbaa97fc2f54$var$uppercasePattern, $3927cbaa97fc2f54$var$toHyphenLower);
    return $3927cbaa97fc2f54$var$cache[name] = $3927cbaa97fc2f54$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $3927cbaa97fc2f54$export$2e2bcd8739ae039 = $3927cbaa97fc2f54$var$hyphenateStyleName;

});


parcelRegister("f9Oxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08ee6037077f5f0$export$2e2bcd8739ae039; });

var $ipwm3 = parcelRequire("ipwm3");
var $b08ee6037077f5f0$var$px = (0, $ipwm3.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $b08ee6037077f5f0$var$ms = (0, $ipwm3.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $b08ee6037077f5f0$var$percent = (0, $ipwm3.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $b08ee6037077f5f0$var$defaultUnits = {
    // Animation properties
    "animation-delay": $b08ee6037077f5f0$var$ms,
    "animation-duration": $b08ee6037077f5f0$var$ms,
    // Background properties
    "background-position": $b08ee6037077f5f0$var$px,
    "background-position-x": $b08ee6037077f5f0$var$px,
    "background-position-y": $b08ee6037077f5f0$var$px,
    "background-size": $b08ee6037077f5f0$var$px,
    // Border Properties
    border: $b08ee6037077f5f0$var$px,
    "border-bottom": $b08ee6037077f5f0$var$px,
    "border-bottom-left-radius": $b08ee6037077f5f0$var$px,
    "border-bottom-right-radius": $b08ee6037077f5f0$var$px,
    "border-bottom-width": $b08ee6037077f5f0$var$px,
    "border-left": $b08ee6037077f5f0$var$px,
    "border-left-width": $b08ee6037077f5f0$var$px,
    "border-radius": $b08ee6037077f5f0$var$px,
    "border-right": $b08ee6037077f5f0$var$px,
    "border-right-width": $b08ee6037077f5f0$var$px,
    "border-top": $b08ee6037077f5f0$var$px,
    "border-top-left-radius": $b08ee6037077f5f0$var$px,
    "border-top-right-radius": $b08ee6037077f5f0$var$px,
    "border-top-width": $b08ee6037077f5f0$var$px,
    "border-width": $b08ee6037077f5f0$var$px,
    "border-block": $b08ee6037077f5f0$var$px,
    "border-block-end": $b08ee6037077f5f0$var$px,
    "border-block-end-width": $b08ee6037077f5f0$var$px,
    "border-block-start": $b08ee6037077f5f0$var$px,
    "border-block-start-width": $b08ee6037077f5f0$var$px,
    "border-block-width": $b08ee6037077f5f0$var$px,
    "border-inline": $b08ee6037077f5f0$var$px,
    "border-inline-end": $b08ee6037077f5f0$var$px,
    "border-inline-end-width": $b08ee6037077f5f0$var$px,
    "border-inline-start": $b08ee6037077f5f0$var$px,
    "border-inline-start-width": $b08ee6037077f5f0$var$px,
    "border-inline-width": $b08ee6037077f5f0$var$px,
    "border-start-start-radius": $b08ee6037077f5f0$var$px,
    "border-start-end-radius": $b08ee6037077f5f0$var$px,
    "border-end-start-radius": $b08ee6037077f5f0$var$px,
    "border-end-end-radius": $b08ee6037077f5f0$var$px,
    // Margin properties
    margin: $b08ee6037077f5f0$var$px,
    "margin-bottom": $b08ee6037077f5f0$var$px,
    "margin-left": $b08ee6037077f5f0$var$px,
    "margin-right": $b08ee6037077f5f0$var$px,
    "margin-top": $b08ee6037077f5f0$var$px,
    "margin-block": $b08ee6037077f5f0$var$px,
    "margin-block-end": $b08ee6037077f5f0$var$px,
    "margin-block-start": $b08ee6037077f5f0$var$px,
    "margin-inline": $b08ee6037077f5f0$var$px,
    "margin-inline-end": $b08ee6037077f5f0$var$px,
    "margin-inline-start": $b08ee6037077f5f0$var$px,
    // Padding properties
    padding: $b08ee6037077f5f0$var$px,
    "padding-bottom": $b08ee6037077f5f0$var$px,
    "padding-left": $b08ee6037077f5f0$var$px,
    "padding-right": $b08ee6037077f5f0$var$px,
    "padding-top": $b08ee6037077f5f0$var$px,
    "padding-block": $b08ee6037077f5f0$var$px,
    "padding-block-end": $b08ee6037077f5f0$var$px,
    "padding-block-start": $b08ee6037077f5f0$var$px,
    "padding-inline": $b08ee6037077f5f0$var$px,
    "padding-inline-end": $b08ee6037077f5f0$var$px,
    "padding-inline-start": $b08ee6037077f5f0$var$px,
    // Mask properties
    "mask-position-x": $b08ee6037077f5f0$var$px,
    "mask-position-y": $b08ee6037077f5f0$var$px,
    "mask-size": $b08ee6037077f5f0$var$px,
    // Width and height properties
    height: $b08ee6037077f5f0$var$px,
    width: $b08ee6037077f5f0$var$px,
    "min-height": $b08ee6037077f5f0$var$px,
    "max-height": $b08ee6037077f5f0$var$px,
    "min-width": $b08ee6037077f5f0$var$px,
    "max-width": $b08ee6037077f5f0$var$px,
    // Position properties
    bottom: $b08ee6037077f5f0$var$px,
    left: $b08ee6037077f5f0$var$px,
    top: $b08ee6037077f5f0$var$px,
    right: $b08ee6037077f5f0$var$px,
    inset: $b08ee6037077f5f0$var$px,
    "inset-block": $b08ee6037077f5f0$var$px,
    "inset-block-end": $b08ee6037077f5f0$var$px,
    "inset-block-start": $b08ee6037077f5f0$var$px,
    "inset-inline": $b08ee6037077f5f0$var$px,
    "inset-inline-end": $b08ee6037077f5f0$var$px,
    "inset-inline-start": $b08ee6037077f5f0$var$px,
    // Shadow properties
    "box-shadow": $b08ee6037077f5f0$var$px,
    "text-shadow": $b08ee6037077f5f0$var$px,
    // Column properties
    "column-gap": $b08ee6037077f5f0$var$px,
    "column-rule": $b08ee6037077f5f0$var$px,
    "column-rule-width": $b08ee6037077f5f0$var$px,
    "column-width": $b08ee6037077f5f0$var$px,
    // Font and text properties
    "font-size": $b08ee6037077f5f0$var$px,
    "font-size-delta": $b08ee6037077f5f0$var$px,
    "letter-spacing": $b08ee6037077f5f0$var$px,
    "text-decoration-thickness": $b08ee6037077f5f0$var$px,
    "text-indent": $b08ee6037077f5f0$var$px,
    "text-stroke": $b08ee6037077f5f0$var$px,
    "text-stroke-width": $b08ee6037077f5f0$var$px,
    "word-spacing": $b08ee6037077f5f0$var$px,
    // Motion properties
    motion: $b08ee6037077f5f0$var$px,
    "motion-offset": $b08ee6037077f5f0$var$px,
    // Outline properties
    outline: $b08ee6037077f5f0$var$px,
    "outline-offset": $b08ee6037077f5f0$var$px,
    "outline-width": $b08ee6037077f5f0$var$px,
    // Perspective properties
    perspective: $b08ee6037077f5f0$var$px,
    "perspective-origin-x": $b08ee6037077f5f0$var$percent,
    "perspective-origin-y": $b08ee6037077f5f0$var$percent,
    // Transform properties
    "transform-origin": $b08ee6037077f5f0$var$percent,
    "transform-origin-x": $b08ee6037077f5f0$var$percent,
    "transform-origin-y": $b08ee6037077f5f0$var$percent,
    "transform-origin-z": $b08ee6037077f5f0$var$percent,
    // Transition properties
    "transition-delay": $b08ee6037077f5f0$var$ms,
    "transition-duration": $b08ee6037077f5f0$var$ms,
    // Alignment properties
    "vertical-align": $b08ee6037077f5f0$var$px,
    "flex-basis": $b08ee6037077f5f0$var$px,
    // Some random properties
    "shape-margin": $b08ee6037077f5f0$var$px,
    size: $b08ee6037077f5f0$var$px,
    gap: $b08ee6037077f5f0$var$px,
    // Grid properties
    grid: $b08ee6037077f5f0$var$px,
    "grid-gap": $b08ee6037077f5f0$var$px,
    "row-gap": $b08ee6037077f5f0$var$px,
    "grid-row-gap": $b08ee6037077f5f0$var$px,
    "grid-column-gap": $b08ee6037077f5f0$var$px,
    "grid-template-rows": $b08ee6037077f5f0$var$px,
    "grid-template-columns": $b08ee6037077f5f0$var$px,
    "grid-auto-rows": $b08ee6037077f5f0$var$px,
    "grid-auto-columns": $b08ee6037077f5f0$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $b08ee6037077f5f0$var$px,
    "box-shadow-y": $b08ee6037077f5f0$var$px,
    "box-shadow-blur": $b08ee6037077f5f0$var$px,
    "box-shadow-spread": $b08ee6037077f5f0$var$px,
    "font-line-height": $b08ee6037077f5f0$var$px,
    "text-shadow-x": $b08ee6037077f5f0$var$px,
    "text-shadow-y": $b08ee6037077f5f0$var$px,
    "text-shadow-blur": $b08ee6037077f5f0$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $b08ee6037077f5f0$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $b08ee6037077f5f0$var$units = $b08ee6037077f5f0$var$addCamelCasedVersion($b08ee6037077f5f0$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $b08ee6037077f5f0$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $b08ee6037077f5f0$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $b08ee6037077f5f0$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $b08ee6037077f5f0$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $b08ee6037077f5f0$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $b08ee6037077f5f0$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $b08ee6037077f5f0$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $b08ee6037077f5f0$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $b08ee6037077f5f0$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $b08ee6037077f5f0$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $b08ee6037077f5f0$export$2e2bcd8739ae039 = $b08ee6037077f5f0$var$defaultUnit;

});

parcelRegister("302Yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f3ad6e9ae4010b$export$2e2bcd8739ae039; });

var $9N9Yr = parcelRequire("9N9Yr");

var $ipwm3 = parcelRequire("ipwm3");
/**
 * Add vendor prefix to a property name when needed.
 */ function $22f3ad6e9ae4010b$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $9N9Yr.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $9N9Yr.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $9N9Yr.supportedValue)(supportedProp, (0, $ipwm3.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $9N9Yr.supportedValue)(prop, (0, $ipwm3.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $22f3ad6e9ae4010b$export$2e2bcd8739ae039 = $22f3ad6e9ae4010b$var$jssVendorPrefixer;

});
parcelRegister("9N9Yr", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $72106d40d165074e$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $72106d40d165074e$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $72106d40d165074e$export$511766124059c277; });

var $aGThG = parcelRequire("aGThG");

var $fYCHx = parcelRequire("fYCHx");
// Export javascript style and css style vendor prefixes.
var $72106d40d165074e$var$js = "";
var $72106d40d165074e$var$css = "";
var $72106d40d165074e$var$vendor = "";
var $72106d40d165074e$var$browser = "";
var $72106d40d165074e$var$isTouch = (0, $aGThG.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $aGThG.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $72106d40d165074e$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $72106d40d165074e$var$_document$createEleme = document.createElement("p"), $72106d40d165074e$var$style = $72106d40d165074e$var$_document$createEleme.style;
    var $72106d40d165074e$var$testProp = "Transform";
    for(var $72106d40d165074e$var$key in $72106d40d165074e$var$jsCssMap)if ($72106d40d165074e$var$key + $72106d40d165074e$var$testProp in $72106d40d165074e$var$style) {
        $72106d40d165074e$var$js = $72106d40d165074e$var$key;
        $72106d40d165074e$var$css = $72106d40d165074e$var$jsCssMap[$72106d40d165074e$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($72106d40d165074e$var$js === "Webkit" && "msHyphens" in $72106d40d165074e$var$style) {
        $72106d40d165074e$var$js = "ms";
        $72106d40d165074e$var$css = $72106d40d165074e$var$jsCssMap.ms;
        $72106d40d165074e$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($72106d40d165074e$var$js === "Webkit" && "-apple-trailing-word" in $72106d40d165074e$var$style) $72106d40d165074e$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $72106d40d165074e$export$82e9f45cca5ba907 = {
    js: $72106d40d165074e$var$js,
    css: $72106d40d165074e$var$css,
    vendor: $72106d40d165074e$var$vendor,
    browser: $72106d40d165074e$var$browser,
    isTouch: $72106d40d165074e$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $72106d40d165074e$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $72106d40d165074e$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $72106d40d165074e$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $72106d40d165074e$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit") return $72106d40d165074e$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $72106d40d165074e$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$camelize(str) {
    return str.replace($72106d40d165074e$var$regExp, $72106d40d165074e$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$pascalize(str) {
    return $72106d40d165074e$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $72106d40d165074e$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($72106d40d165074e$var$camelize(longhand) in style) return prop;
            if ($72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(longhand) in style) return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $72106d40d165074e$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.vendor === "apple" && !$72106d40d165074e$export$82e9f45cca5ba907.isTouch) return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $72106d40d165074e$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $72106d40d165074e$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $72106d40d165074e$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit" || $72106d40d165074e$export$82e9f45cca5ba907.js === "ms" && $72106d40d165074e$export$82e9f45cca5ba907.browser !== "edge") return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $72106d40d165074e$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Moz" || $72106d40d165074e$export$82e9f45cca5ba907.js === "ms" || $72106d40d165074e$export$82e9f45cca5ba907.vendor === "apple") return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $72106d40d165074e$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $72106d40d165074e$var$pascalize(prop);
            return jsProp in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $72106d40d165074e$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $72106d40d165074e$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp) in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $72106d40d165074e$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $72106d40d165074e$var$camelize(prop) in style ? prop : false;
    }
};
var $72106d40d165074e$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $72106d40d165074e$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js + pascalized in style) return $72106d40d165074e$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($72106d40d165074e$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $72106d40d165074e$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return "" + $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $72106d40d165074e$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return $72106d40d165074e$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $72106d40d165074e$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $72106d40d165074e$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $72106d40d165074e$var$propMap[prop];
        if (!newProp) return false;
        return $72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp) in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $72106d40d165074e$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $72106d40d165074e$var$propKeys = Object.keys($72106d40d165074e$var$propMap$1);
var $72106d40d165074e$var$prefixCss = function prefixCss(p) {
    return $72106d40d165074e$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $72106d40d165074e$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($72106d40d165074e$var$propKeys.indexOf(prop) > -1) {
            var newProp = $72106d40d165074e$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp) in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($72106d40d165074e$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $72106d40d165074e$var$plugins = [
    $72106d40d165074e$var$appearence,
    $72106d40d165074e$var$colorAdjust,
    $72106d40d165074e$var$mask,
    $72106d40d165074e$var$textOrientation,
    $72106d40d165074e$var$transform,
    $72106d40d165074e$var$transition,
    $72106d40d165074e$var$writingMode,
    $72106d40d165074e$var$userSelect,
    $72106d40d165074e$var$breakPropsOld,
    $72106d40d165074e$var$inlineLogicalOld,
    $72106d40d165074e$var$unprefixed,
    $72106d40d165074e$var$prefixed,
    $72106d40d165074e$var$scrollSnap,
    $72106d40d165074e$var$overscrollBehavior,
    $72106d40d165074e$var$flex2012,
    $72106d40d165074e$var$flex2009
];
var $72106d40d165074e$var$propertyDetectors = $72106d40d165074e$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $72106d40d165074e$var$noPrefill = $72106d40d165074e$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $fYCHx.default)(p.noPrefill));
    return a;
}, []);
var $72106d40d165074e$var$el;
var $72106d40d165074e$var$cache = {};
if (0, $aGThG.default) {
    $72106d40d165074e$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $72106d40d165074e$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $72106d40d165074e$var$key$1 in $72106d40d165074e$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($72106d40d165074e$var$key$1)) $72106d40d165074e$var$cache[$72106d40d165074e$var$computed[$72106d40d165074e$var$key$1]] = $72106d40d165074e$var$computed[$72106d40d165074e$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $72106d40d165074e$var$noPrefill.forEach(function(x) {
        return delete $72106d40d165074e$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $72106d40d165074e$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$72106d40d165074e$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($72106d40d165074e$var$cache[prop] != null) return $72106d40d165074e$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $72106d40d165074e$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $72106d40d165074e$var$propertyDetectors.length; i++){
        $72106d40d165074e$var$cache[prop] = $72106d40d165074e$var$propertyDetectors[i](prop, $72106d40d165074e$var$el.style, options); // Break loop, if value found.
        if ($72106d40d165074e$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $72106d40d165074e$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $72106d40d165074e$var$cache[prop];
}
var $72106d40d165074e$var$cache$1 = {};
var $72106d40d165074e$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $72106d40d165074e$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $72106d40d165074e$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $72106d40d165074e$export$ce097f82c2e4551a(p1) : ", " + $72106d40d165074e$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $aGThG.default) $72106d40d165074e$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $72106d40d165074e$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$72106d40d165074e$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($72106d40d165074e$var$cache$1[cacheKey] != null) return $72106d40d165074e$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $72106d40d165074e$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $72106d40d165074e$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($72106d40d165074e$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($72106d40d165074e$var$transPropsRegExp, $72106d40d165074e$var$prefixTransitionCallback);
    else if ($72106d40d165074e$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $72106d40d165074e$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $72106d40d165074e$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $72106d40d165074e$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($72106d40d165074e$var$el$1.style[property] === "") {
            $72106d40d165074e$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $72106d40d165074e$var$el$1.style[property] = ""; // Write current value to cache.
    $72106d40d165074e$var$cache$1[cacheKey] = prefixedValue;
    return $72106d40d165074e$var$cache$1[cacheKey];
}

});
parcelRegister("fYCHx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba1a7ae3e4bf0e26$export$2e2bcd8739ae039; });

var $8HlD9 = parcelRequire("8HlD9");

var $elYkf = parcelRequire("elYkf");

var $hvqJQ = parcelRequire("hvqJQ");

var $awOnb = parcelRequire("awOnb");
function $ba1a7ae3e4bf0e26$export$2e2bcd8739ae039(arr) {
    return (0, $8HlD9.default)(arr) || (0, $elYkf.default)(arr) || (0, $hvqJQ.default)(arr) || (0, $awOnb.default)();
}

});
parcelRegister("8HlD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65531e437642a083$export$2e2bcd8739ae039; });

var $7wbf1 = parcelRequire("7wbf1");
function $65531e437642a083$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7wbf1.default)(arr);
}

});
parcelRegister("7wbf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57943dd3d9447bb2$export$2e2bcd8739ae039; });
function $57943dd3d9447bb2$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("elYkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a731d24472956bbc$export$2e2bcd8739ae039; });
function $a731d24472956bbc$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hvqJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbea129a04028f02$export$2e2bcd8739ae039; });

var $7wbf1 = parcelRequire("7wbf1");
function $cbea129a04028f02$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7wbf1.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7wbf1.default)(o, minLen);
}

});

parcelRegister("awOnb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aa3f7903d15eb9c$export$2e2bcd8739ae039; });
function $7aa3f7903d15eb9c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("efFhT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6027e40a356f9cf$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $a6027e40a356f9cf$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $a6027e40a356f9cf$export$2e2bcd8739ae039 = $a6027e40a356f9cf$var$jssPropsSort;

});



parcelRegister("a4mPI", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $754bfd437ef97723$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $754bfd437ef97723$var$indexCounter = -1000000000;
function $754bfd437ef97723$export$a2647aa13413c947() {
    $754bfd437ef97723$var$indexCounter += 1;
    return $754bfd437ef97723$var$indexCounter;
}

});

parcelRegister("96kaR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a0452c6c6c25f78$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");
parcelRequire("ki4MK");

var $kt6Ie = parcelRequire("kt6Ie");

function $6a0452c6c6c25f78$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $815Xb.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $kt6Ie.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("ki4MK", function(module, exports) {
function $ec59335c238fe2d2$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ec59335c238fe2d2$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $ec59335c238fe2d2$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ec59335c238fe2d2$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("kt6Ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6bb90bb1e42d0a$export$2e2bcd8739ae039; });

var $9CubZ = parcelRequire("9CubZ");

var $l7JxS = parcelRequire("l7JxS");
function $ee6bb90bb1e42d0a$export$53b83ca8eaab0383(item) {
    return item && (0, $l7JxS.default)(item) === "object" && item.constructor === Object;
}
function $ee6bb90bb1e42d0a$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $9CubZ.default)({}, target) : target;
    if ($ee6bb90bb1e42d0a$export$53b83ca8eaab0383(target) && $ee6bb90bb1e42d0a$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($ee6bb90bb1e42d0a$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $ee6bb90bb1e42d0a$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("9CubZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $700f1543d9e08bb1$export$2e2bcd8739ae039; });
function $700f1543d9e08bb1$export$2e2bcd8739ae039() {
    $700f1543d9e08bb1$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $700f1543d9e08bb1$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("l7JxS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60d94cfa9f16e9d$export$2e2bcd8739ae039; });
function $f60d94cfa9f16e9d$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f60d94cfa9f16e9d$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $f60d94cfa9f16e9d$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f60d94cfa9f16e9d$export$2e2bcd8739ae039(obj);
}

});



parcelRegister("ks5BK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee3ac5c719b4f330$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $ee3ac5c719b4f330$var$noopTheme = {};
var $ee3ac5c719b4f330$export$2e2bcd8739ae039 = $ee3ac5c719b4f330$var$noopTheme;

});


parcelRegister("szrnD", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $055e1b686e8e9f5d$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $055e1b686e8e9f5d$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $055e1b686e8e9f5d$export$2e2bcd8739ae039; });

var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $aoqh7 = parcelRequire("aoqh7");

var $2KDk6 = parcelRequire("2KDk6");
function $055e1b686e8e9f5d$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $055e1b686e8e9f5d$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $cQNHH.createContext(null)) : $cQNHH.createContext(null);
var $055e1b686e8e9f5d$var$IntlConsumer = $055e1b686e8e9f5d$var$IntlContext.Consumer, $055e1b686e8e9f5d$var$IntlProvider = $055e1b686e8e9f5d$var$IntlContext.Provider;
var $055e1b686e8e9f5d$export$2881499e37b75b9a = $055e1b686e8e9f5d$var$IntlProvider;
var $055e1b686e8e9f5d$export$841858b892ce1f4c = $055e1b686e8e9f5d$var$IntlContext;
function $055e1b686e8e9f5d$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $cQNHH.createElement($055e1b686e8e9f5d$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $2KDk6.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $cQNHH.createElement(WrappedComponent, (0, $gb4K1.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($055e1b686e8e9f5d$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($aoqh7)))($cQNHH.forwardRef(function(props, ref) {
        return $cQNHH.createElement(WithIntl, (0, $gb4K1.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aoqh7)))(WithIntl, WrappedComponent);
}

});
parcelRegister("gb4K1", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $bc7159ecac4d4618$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $bc7159ecac4d4618$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $bc7159ecac4d4618$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $bc7159ecac4d4618$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $bc7159ecac4d4618$var$extendStatics = function(d, b) {
    $bc7159ecac4d4618$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bc7159ecac4d4618$var$extendStatics(d, b);
};
function $bc7159ecac4d4618$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bc7159ecac4d4618$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc7159ecac4d4618$export$18ce0697a983be9b = function() {
    $bc7159ecac4d4618$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc7159ecac4d4618$export$18ce0697a983be9b.apply(this, arguments);
};
function $bc7159ecac4d4618$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bc7159ecac4d4618$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bc7159ecac4d4618$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bc7159ecac4d4618$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bc7159ecac4d4618$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bc7159ecac4d4618$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bc7159ecac4d4618$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bc7159ecac4d4618$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bc7159ecac4d4618$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bc7159ecac4d4618$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bc7159ecac4d4618$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bc7159ecac4d4618$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bc7159ecac4d4618$export$45d3717a4c69092e(o, m, p);
}
function $bc7159ecac4d4618$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bc7159ecac4d4618$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bc7159ecac4d4618$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bc7159ecac4d4618$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bc7159ecac4d4618$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bc7159ecac4d4618$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bc7159ecac4d4618$export$10c90e4f7922046c(v) {
    return this instanceof $bc7159ecac4d4618$export$10c90e4f7922046c ? (this.v = v, this) : new $bc7159ecac4d4618$export$10c90e4f7922046c(v);
}
function $bc7159ecac4d4618$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bc7159ecac4d4618$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bc7159ecac4d4618$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bc7159ecac4d4618$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bc7159ecac4d4618$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bc7159ecac4d4618$export$19a8beecd37a4c45 === "function" ? $bc7159ecac4d4618$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bc7159ecac4d4618$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bc7159ecac4d4618$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bc7159ecac4d4618$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bc7159ecac4d4618$export$45d3717a4c69092e(result, mod, k);
    }
    $bc7159ecac4d4618$var$__setModuleDefault(result, mod);
    return result;
}
function $bc7159ecac4d4618$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bc7159ecac4d4618$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bc7159ecac4d4618$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bc7159ecac4d4618$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bc7159ecac4d4618$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bc7159ecac4d4618$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bc7159ecac4d4618$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bc7159ecac4d4618$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bc7159ecac4d4618$export$2e2bcd8739ae039 = {
    __extends: $bc7159ecac4d4618$export$a8ba968b8961cb8a,
    __assign: $bc7159ecac4d4618$export$18ce0697a983be9b,
    __rest: $bc7159ecac4d4618$export$3c9a16f847548506,
    __decorate: $bc7159ecac4d4618$export$29e00dfd3077644b,
    __param: $bc7159ecac4d4618$export$d5ad3fd78186038f,
    __metadata: $bc7159ecac4d4618$export$f1db080c865becb9,
    __awaiter: $bc7159ecac4d4618$export$1050f835b63b671e,
    __generator: $bc7159ecac4d4618$export$67ebef60e6f28a6,
    __createBinding: $bc7159ecac4d4618$export$45d3717a4c69092e,
    __exportStar: $bc7159ecac4d4618$export$f33643c0debef087,
    __values: $bc7159ecac4d4618$export$19a8beecd37a4c45,
    __read: $bc7159ecac4d4618$export$8d051b38c9118094,
    __spread: $bc7159ecac4d4618$export$afc72e2116322959,
    __spreadArrays: $bc7159ecac4d4618$export$6388937ca91ccae8,
    __spreadArray: $bc7159ecac4d4618$export$1216008129fb82ed,
    __await: $bc7159ecac4d4618$export$10c90e4f7922046c,
    __asyncGenerator: $bc7159ecac4d4618$export$e427f37a30a4de9b,
    __asyncDelegator: $bc7159ecac4d4618$export$bbd80228419bb833,
    __asyncValues: $bc7159ecac4d4618$export$e3b29a3d6162315f,
    __makeTemplateObject: $bc7159ecac4d4618$export$4fb47efe1390b86f,
    __importStar: $bc7159ecac4d4618$export$c21735bcef00d192,
    __importDefault: $bc7159ecac4d4618$export$da59b14a69baef04,
    __classPrivateFieldGet: $bc7159ecac4d4618$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bc7159ecac4d4618$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bc7159ecac4d4618$export$81fdc39f203e4e04,
    __addDisposableResource: $bc7159ecac4d4618$export$88ac25d8e944e405,
    __disposeResources: $bc7159ecac4d4618$export$8f076105dc360e92
};

});

parcelRegister("aoqh7", function(module, exports) {
"use strict";

var $4EmWC = parcelRequire("4EmWC");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $791086f2059ab2e4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $791086f2059ab2e4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $791086f2059ab2e4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $791086f2059ab2e4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $791086f2059ab2e4$var$TYPE_STATICS = {};
$791086f2059ab2e4$var$TYPE_STATICS[$4EmWC.ForwardRef] = $791086f2059ab2e4$var$FORWARD_REF_STATICS;
$791086f2059ab2e4$var$TYPE_STATICS[$4EmWC.Memo] = $791086f2059ab2e4$var$MEMO_STATICS;
function $791086f2059ab2e4$var$getStatics(component) {
    // React v16.11 and below
    if ($4EmWC.isMemo(component)) return $791086f2059ab2e4$var$MEMO_STATICS;
     // React v16.12 and above
    return $791086f2059ab2e4$var$TYPE_STATICS[component["$$typeof"]] || $791086f2059ab2e4$var$REACT_STATICS;
}
var $791086f2059ab2e4$var$defineProperty = Object.defineProperty;
var $791086f2059ab2e4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $791086f2059ab2e4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $791086f2059ab2e4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $791086f2059ab2e4$var$getPrototypeOf = Object.getPrototypeOf;
var $791086f2059ab2e4$var$objectPrototype = Object.prototype;
function $791086f2059ab2e4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($791086f2059ab2e4$var$objectPrototype) {
            var inheritedComponent = $791086f2059ab2e4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $791086f2059ab2e4$var$objectPrototype) $791086f2059ab2e4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $791086f2059ab2e4$var$getOwnPropertyNames(sourceComponent);
        if ($791086f2059ab2e4$var$getOwnPropertySymbols) keys = keys.concat($791086f2059ab2e4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $791086f2059ab2e4$var$getStatics(targetComponent);
        var sourceStatics = $791086f2059ab2e4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$791086f2059ab2e4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $791086f2059ab2e4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $791086f2059ab2e4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $791086f2059ab2e4$var$hoistNonReactStatics;

});
parcelRegister("4EmWC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aCwoi"));

});
parcelRegister("aCwoi", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $7bb694203b61db71$export$2b8d127b894957b9; }, function (v) { return $7bb694203b61db71$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $7bb694203b61db71$export$cea3a54a6425200c; }, function (v) { return $7bb694203b61db71$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $7bb694203b61db71$export$a7c73072b1a182ae; }, function (v) { return $7bb694203b61db71$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $7bb694203b61db71$export$9f27bc3417b4524d; }, function (v) { return $7bb694203b61db71$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $7bb694203b61db71$export$db77ccec0bb4ccac; }, function (v) { return $7bb694203b61db71$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $7bb694203b61db71$export$8392c0c9d3dcbd35; }, function (v) { return $7bb694203b61db71$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7bb694203b61db71$export$ffb0004e005737fa; }, function (v) { return $7bb694203b61db71$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $7bb694203b61db71$export$b624eff549462981; }, function (v) { return $7bb694203b61db71$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $7bb694203b61db71$export$7897aa7841a5380c; }, function (v) { return $7bb694203b61db71$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $7bb694203b61db71$export$602eac185826482c; }, function (v) { return $7bb694203b61db71$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $7bb694203b61db71$export$e2c29f18771995cb; }, function (v) { return $7bb694203b61db71$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7bb694203b61db71$export$5f8d39834fd61797; }, function (v) { return $7bb694203b61db71$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7bb694203b61db71$export$74bf444e3cd11ea5; }, function (v) { return $7bb694203b61db71$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $7bb694203b61db71$export$92387174baf9b227; }, function (v) { return $7bb694203b61db71$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $7bb694203b61db71$export$ec112efeb987d9c6; }, function (v) { return $7bb694203b61db71$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $7bb694203b61db71$export$b706b080d889d2c9; }, function (v) { return $7bb694203b61db71$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $7bb694203b61db71$export$5be5a87408f70ddc; }, function (v) { return $7bb694203b61db71$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $7bb694203b61db71$export$45a5e7f76e0caa8d; }, function (v) { return $7bb694203b61db71$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $7bb694203b61db71$export$455c2e768291efa6; }, function (v) { return $7bb694203b61db71$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $7bb694203b61db71$export$9522e17588c12572; }, function (v) { return $7bb694203b61db71$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $7bb694203b61db71$export$2110ac352bb060b9; }, function (v) { return $7bb694203b61db71$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $7bb694203b61db71$export$56885ab8b9c456ab; }, function (v) { return $7bb694203b61db71$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $7bb694203b61db71$export$d927fcb6adf8f9de; }, function (v) { return $7bb694203b61db71$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $7bb694203b61db71$export$b82d16f27459e05a; }, function (v) { return $7bb694203b61db71$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $7bb694203b61db71$export$522c17b4f5e123e8; }, function (v) { return $7bb694203b61db71$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $7bb694203b61db71$export$1aabd8a0274ecfd6; }, function (v) { return $7bb694203b61db71$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $7bb694203b61db71$export$9b621391a187a31a; }, function (v) { return $7bb694203b61db71$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $7bb694203b61db71$export$f5bbd400c2f4426f; }, function (v) { return $7bb694203b61db71$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7bb694203b61db71$export$2b8d127b894957b9;
var $7bb694203b61db71$export$cea3a54a6425200c;
var $7bb694203b61db71$export$a7c73072b1a182ae;
var $7bb694203b61db71$export$9f27bc3417b4524d;
var $7bb694203b61db71$export$db77ccec0bb4ccac;
var $7bb694203b61db71$export$8392c0c9d3dcbd35;
var $7bb694203b61db71$export$ffb0004e005737fa;
var $7bb694203b61db71$export$b624eff549462981;
var $7bb694203b61db71$export$7897aa7841a5380c;
var $7bb694203b61db71$export$602eac185826482c;
var $7bb694203b61db71$export$e2c29f18771995cb;
var $7bb694203b61db71$export$5f8d39834fd61797;
var $7bb694203b61db71$export$74bf444e3cd11ea5;
var $7bb694203b61db71$export$92387174baf9b227;
var $7bb694203b61db71$export$ec112efeb987d9c6;
var $7bb694203b61db71$export$b706b080d889d2c9;
var $7bb694203b61db71$export$5be5a87408f70ddc;
var $7bb694203b61db71$export$45a5e7f76e0caa8d;
var $7bb694203b61db71$export$455c2e768291efa6;
var $7bb694203b61db71$export$9522e17588c12572;
var $7bb694203b61db71$export$2110ac352bb060b9;
var $7bb694203b61db71$export$56885ab8b9c456ab;
var $7bb694203b61db71$export$d927fcb6adf8f9de;
var $7bb694203b61db71$export$b82d16f27459e05a;
var $7bb694203b61db71$export$522c17b4f5e123e8;
var $7bb694203b61db71$export$1aabd8a0274ecfd6;
var $7bb694203b61db71$export$9b621391a187a31a;
var $7bb694203b61db71$export$f5bbd400c2f4426f;
"use strict";
var $7bb694203b61db71$var$b = "function" === typeof Symbol && Symbol.for, $7bb694203b61db71$var$c = $7bb694203b61db71$var$b ? Symbol.for("react.element") : 60103, $7bb694203b61db71$var$d = $7bb694203b61db71$var$b ? Symbol.for("react.portal") : 60106, $7bb694203b61db71$var$e = $7bb694203b61db71$var$b ? Symbol.for("react.fragment") : 60107, $7bb694203b61db71$var$f = $7bb694203b61db71$var$b ? Symbol.for("react.strict_mode") : 60108, $7bb694203b61db71$var$g = $7bb694203b61db71$var$b ? Symbol.for("react.profiler") : 60114, $7bb694203b61db71$var$h = $7bb694203b61db71$var$b ? Symbol.for("react.provider") : 60109, $7bb694203b61db71$var$k = $7bb694203b61db71$var$b ? Symbol.for("react.context") : 60110, $7bb694203b61db71$var$l = $7bb694203b61db71$var$b ? Symbol.for("react.async_mode") : 60111, $7bb694203b61db71$var$m = $7bb694203b61db71$var$b ? Symbol.for("react.concurrent_mode") : 60111, $7bb694203b61db71$var$n = $7bb694203b61db71$var$b ? Symbol.for("react.forward_ref") : 60112, $7bb694203b61db71$var$p = $7bb694203b61db71$var$b ? Symbol.for("react.suspense") : 60113, $7bb694203b61db71$var$q = $7bb694203b61db71$var$b ? Symbol.for("react.suspense_list") : 60120, $7bb694203b61db71$var$r = $7bb694203b61db71$var$b ? Symbol.for("react.memo") : 60115, $7bb694203b61db71$var$t = $7bb694203b61db71$var$b ? Symbol.for("react.lazy") : 60116, $7bb694203b61db71$var$v = $7bb694203b61db71$var$b ? Symbol.for("react.block") : 60121, $7bb694203b61db71$var$w = $7bb694203b61db71$var$b ? Symbol.for("react.fundamental") : 60117, $7bb694203b61db71$var$x = $7bb694203b61db71$var$b ? Symbol.for("react.responder") : 60118, $7bb694203b61db71$var$y = $7bb694203b61db71$var$b ? Symbol.for("react.scope") : 60119;
function $7bb694203b61db71$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $7bb694203b61db71$var$c:
                switch(a = a.type, a){
                    case $7bb694203b61db71$var$l:
                    case $7bb694203b61db71$var$m:
                    case $7bb694203b61db71$var$e:
                    case $7bb694203b61db71$var$g:
                    case $7bb694203b61db71$var$f:
                    case $7bb694203b61db71$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7bb694203b61db71$var$k:
                            case $7bb694203b61db71$var$n:
                            case $7bb694203b61db71$var$t:
                            case $7bb694203b61db71$var$r:
                            case $7bb694203b61db71$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $7bb694203b61db71$var$d:
                return u;
        }
    }
}
function $7bb694203b61db71$var$A(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$m;
}
$7bb694203b61db71$export$2b8d127b894957b9 = $7bb694203b61db71$var$l;
$7bb694203b61db71$export$cea3a54a6425200c = $7bb694203b61db71$var$m;
$7bb694203b61db71$export$a7c73072b1a182ae = $7bb694203b61db71$var$k;
$7bb694203b61db71$export$9f27bc3417b4524d = $7bb694203b61db71$var$h;
$7bb694203b61db71$export$db77ccec0bb4ccac = $7bb694203b61db71$var$c;
$7bb694203b61db71$export$8392c0c9d3dcbd35 = $7bb694203b61db71$var$n;
$7bb694203b61db71$export$ffb0004e005737fa = $7bb694203b61db71$var$e;
$7bb694203b61db71$export$b624eff549462981 = $7bb694203b61db71$var$t;
$7bb694203b61db71$export$7897aa7841a5380c = $7bb694203b61db71$var$r;
$7bb694203b61db71$export$602eac185826482c = $7bb694203b61db71$var$d;
$7bb694203b61db71$export$e2c29f18771995cb = $7bb694203b61db71$var$g;
$7bb694203b61db71$export$5f8d39834fd61797 = $7bb694203b61db71$var$f;
$7bb694203b61db71$export$74bf444e3cd11ea5 = $7bb694203b61db71$var$p;
$7bb694203b61db71$export$92387174baf9b227 = function(a) {
    return $7bb694203b61db71$var$A(a) || $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$l;
};
$7bb694203b61db71$export$ec112efeb987d9c6 = $7bb694203b61db71$var$A;
$7bb694203b61db71$export$b706b080d889d2c9 = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$k;
};
$7bb694203b61db71$export$5be5a87408f70ddc = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$h;
};
$7bb694203b61db71$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7bb694203b61db71$var$c;
};
$7bb694203b61db71$export$455c2e768291efa6 = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$n;
};
$7bb694203b61db71$export$9522e17588c12572 = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$e;
};
$7bb694203b61db71$export$2110ac352bb060b9 = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$t;
};
$7bb694203b61db71$export$56885ab8b9c456ab = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$r;
};
$7bb694203b61db71$export$d927fcb6adf8f9de = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$d;
};
$7bb694203b61db71$export$b82d16f27459e05a = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$g;
};
$7bb694203b61db71$export$522c17b4f5e123e8 = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$f;
};
$7bb694203b61db71$export$1aabd8a0274ecfd6 = function(a) {
    return $7bb694203b61db71$var$z(a) === $7bb694203b61db71$var$p;
};
$7bb694203b61db71$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7bb694203b61db71$var$e || a === $7bb694203b61db71$var$m || a === $7bb694203b61db71$var$g || a === $7bb694203b61db71$var$f || a === $7bb694203b61db71$var$p || a === $7bb694203b61db71$var$q || "object" === typeof a && null !== a && (a.$$typeof === $7bb694203b61db71$var$t || a.$$typeof === $7bb694203b61db71$var$r || a.$$typeof === $7bb694203b61db71$var$h || a.$$typeof === $7bb694203b61db71$var$k || a.$$typeof === $7bb694203b61db71$var$n || a.$$typeof === $7bb694203b61db71$var$w || a.$$typeof === $7bb694203b61db71$var$x || a.$$typeof === $7bb694203b61db71$var$y || a.$$typeof === $7bb694203b61db71$var$v);
};
$7bb694203b61db71$export$f5bbd400c2f4426f = $7bb694203b61db71$var$z;

});



parcelRegister("2KDk6", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $200e617138395888$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $200e617138395888$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $200e617138395888$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $200e617138395888$export$d36bdfa510afb180; });

var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $gvCUa = parcelRequire("gvCUa");

var $5VJfG = parcelRequire("5VJfG");
function $200e617138395888$export$45c4bbf6e55bba1f(intl) {
    (0, $gvCUa.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $200e617138395888$export$b52f8d6fc0d47415 = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, (0, $5VJfG.DEFAULT_INTL_CONFIG)), {
    textComponent: $cQNHH.Fragment
});
function $200e617138395888$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($cQNHH.Children.toArray(parts));
    };
}
function $200e617138395888$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("gvCUa", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $c04db85177ba69df$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $c04db85177ba69df$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $c04db85177ba69df$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $c04db85177ba69df$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $c04db85177ba69df$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $c04db85177ba69df$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $c04db85177ba69df$export$3fae2929ed23c202(map, pl, field) {
    return $c04db85177ba69df$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $c04db85177ba69df$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $c04db85177ba69df$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $c04db85177ba69df$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $c04db85177ba69df$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $c04db85177ba69df$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("5VJfG", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $451560b32c66f622$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $451560b32c66f622$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $451560b32c66f622$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $451560b32c66f622$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $451560b32c66f622$export$4ee1db8ce44a209b; });

var $gb4K1 = parcelRequire("gb4K1");
parcelRequire("iTKsw");
var $4kwTT = parcelRequire("4kwTT");

var $bX0Gd = parcelRequire("bX0Gd");

var $dCg2n = parcelRequire("dCg2n");
function $451560b32c66f622$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $451560b32c66f622$var$defaultErrorHandler = function(error) {};
var $451560b32c66f622$var$defaultWarnHandler = function(warning) {};
var $451560b32c66f622$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $451560b32c66f622$var$defaultErrorHandler,
    onWarn: $451560b32c66f622$var$defaultWarnHandler
};
function $451560b32c66f622$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $451560b32c66f622$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $451560b32c66f622$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $451560b32c66f622$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $bX0Gd.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $451560b32c66f622$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $bX0Gd.strategies).variadic
    });
    var getNumberFormat = (0, $bX0Gd.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $451560b32c66f622$var$createFastMemoizeCache(cache.number),
        strategy: (0, $bX0Gd.strategies).variadic
    });
    var getPluralRules = (0, $bX0Gd.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $gb4K1.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $451560b32c66f622$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $bX0Gd.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $bX0Gd.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $4kwTT.IntlMessageFormat)(message, locales, overrideFormats, (0, $gb4K1.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.message),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $bX0Gd.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $bX0Gd.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.list),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getDisplayNames: (0, $bX0Gd.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $bX0Gd.strategies).variadic
        })
    };
}
function $451560b32c66f622$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $dCg2n.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("iTKsw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("8RUL4")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("8RUL4")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("9FMnG")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("4kwTT")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $4kwTT = parcelRequire("4kwTT");
parcelRequire("8RUL4");
parcelRequire("9FMnG");
var $dc2166db9278051b$export$2e2bcd8739ae039 = (0, $4kwTT.IntlMessageFormat);

});
parcelRegister("4kwTT", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $32728d0a3cb8395c$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $gb4K1 = parcelRequire("gb4K1");

var $b4svv = parcelRequire("b4svv");

var $bX0Gd = parcelRequire("bX0Gd");

var $9FMnG = parcelRequire("9FMnG");
// -- MessageFormat --------------------------------------------------------
function $32728d0a3cb8395c$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $32728d0a3cb8395c$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $32728d0a3cb8395c$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $gb4K1.__assign)({}, defaultConfig));
}
function $32728d0a3cb8395c$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $32728d0a3cb8395c$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $bX0Gd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $32728d0a3cb8395c$var$createFastMemoizeCache(cache.number),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getDateTimeFormat: (0, $bX0Gd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $32728d0a3cb8395c$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getPluralRules: (0, $bX0Gd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $32728d0a3cb8395c$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $bX0Gd.strategies).variadic
        })
    };
}
var $32728d0a3cb8395c$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $9FMnG.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $9FMnG.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $gb4K1.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $32728d0a3cb8395c$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $32728d0a3cb8395c$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b4svv.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("b4svv", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("a5i87")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("a5i87")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("a5i87")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("a5i87")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("a5i87")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("a5i87")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("a5i87")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("a5i87")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("a5i87")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("a5i87")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("a5i87")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("a5i87")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $80f62e5a8c2ca55f$export$98e6a39c04603d36; });

var $gb4K1 = parcelRequire("gb4K1");

var $iGmlb = parcelRequire("iGmlb");

var $5C8At = parcelRequire("5C8At");

var $a5i87 = parcelRequire("a5i87");
function $80f62e5a8c2ca55f$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $a5i87.isSelectElement)(el) || (0, $a5i87.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $80f62e5a8c2ca55f$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $a5i87.isNumberElement)(el) && (0, $a5i87.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $a5i87.isDateElement)(el) || (0, $a5i87.isTimeElement)(el)) && (0, $a5i87.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $a5i87.isTagElement)(el)) $80f62e5a8c2ca55f$var$pruneLocation(el.children);
    });
}
function $80f62e5a8c2ca55f$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $gb4K1.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5C8At.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $iGmlb.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $80f62e5a8c2ca55f$var$pruneLocation(result.val);
    return result.val;
}
var $80f62e5a8c2ca55f$export$d3c1bfa0f7d806e9 = (0, $5C8At.Parser);

});
parcelRegister("iGmlb", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $d99d7a9d104f8dad$export$896afd8541959ee5; });
var $d99d7a9d104f8dad$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($d99d7a9d104f8dad$export$896afd8541959ee5 || ($d99d7a9d104f8dad$export$896afd8541959ee5 = {}));

});

parcelRegister("5C8At", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $4167299d39181961$export$7acfa6ed01010e37; });

var $gb4K1 = parcelRequire("gb4K1");

var $iGmlb = parcelRequire("iGmlb");

var $a5i87 = parcelRequire("a5i87");

var $2m77C = parcelRequire("2m77C");
parcelRequire("hDzp7");
var $2WsKD = parcelRequire("2WsKD");
var $4GppD = parcelRequire("4GppD");

var $6hTU2 = parcelRequire("6hTU2");
var $4167299d39181961$var$_a;
var $4167299d39181961$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $2m77C.SPACE_SEPARATOR_REGEX).source, "*"));
var $4167299d39181961$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $2m77C.SPACE_SEPARATOR_REGEX).source, "*$"));
function $4167299d39181961$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $4167299d39181961$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $4167299d39181961$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $4167299d39181961$var$hasNativeFromEntries = !!Object.fromEntries;
var $4167299d39181961$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $4167299d39181961$var$hasTrimStart = !!String.prototype.trimStart;
var $4167299d39181961$var$hasTrimEnd = !!String.prototype.trimEnd;
var $4167299d39181961$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $4167299d39181961$var$isSafeInteger = $4167299d39181961$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $4167299d39181961$var$re = $4167299d39181961$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y = (($4167299d39181961$var$_a = $4167299d39181961$var$re.exec("a")) === null || $4167299d39181961$var$_a === void 0 ? void 0 : $4167299d39181961$var$_a[0]) === "a";
} catch (_) {
    $4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $4167299d39181961$var$startsWith = $4167299d39181961$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $4167299d39181961$var$fromCodePoint = $4167299d39181961$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $4167299d39181961$var$fromEntries = // native
$4167299d39181961$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $4167299d39181961$var$codePointAt = $4167299d39181961$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $4167299d39181961$var$trimStart = $4167299d39181961$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($4167299d39181961$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $4167299d39181961$var$trimEnd = $4167299d39181961$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($4167299d39181961$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $4167299d39181961$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $4167299d39181961$var$matchIdentifierAtIndex;
if ($4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $4167299d39181961$var$IDENTIFIER_PREFIX_RE_1 = $4167299d39181961$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $4167299d39181961$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $4167299d39181961$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $4167299d39181961$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$4167299d39181961$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $4167299d39181961$var$codePointAt(s, index);
        if (c === undefined || $4167299d39181961$var$_isWhiteSpace(c) || $4167299d39181961$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $4167299d39181961$var$fromCodePoint.apply(void 0, match);
};
var $4167299d39181961$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $a5i87.TYPE).pound,
                    location: $4167299d39181961$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $iGmlb.ErrorKind).UNMATCHED_CLOSING_TAG, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $4167299d39181961$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $a5i87.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $4167299d39181961$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$4167299d39181961$var$_isAlpha(this.char())) return this.error((0, $iGmlb.ErrorKind).INVALID_TAG, $4167299d39181961$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $iGmlb.ErrorKind).UNMATCHED_CLOSING_TAG, $4167299d39181961$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $iGmlb.ErrorKind).INVALID_TAG, $4167299d39181961$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $a5i87.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $4167299d39181961$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $iGmlb.ErrorKind).UNCLOSED_TAG, $4167299d39181961$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $iGmlb.ErrorKind).INVALID_TAG, $4167299d39181961$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $4167299d39181961$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $4167299d39181961$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $a5i87.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$4167299d39181961$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $4167299d39181961$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $4167299d39181961$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $iGmlb.ErrorKind).EMPTY_ARGUMENT, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $iGmlb.ErrorKind).MALFORMED_ARGUMENT, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $a5i87.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $iGmlb.ErrorKind).MALFORMED_ARGUMENT, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $4167299d39181961$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $4167299d39181961$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_TYPE, $4167299d39181961$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $4167299d39181961$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_STYLE, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $4167299d39181961$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $4167299d39181961$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $4167299d39181961$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $a5i87.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $iGmlb.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $6hTU2.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $a5i87.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $2WsKD.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $a5i87.TYPE).date : (0, $a5i87.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $a5i87.TYPE).number : argType === "date" ? (0, $a5i87.TYPE).date : (0, $a5i87.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $iGmlb.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $4167299d39181961$var$createLocation(typeEndPosition_1, (0, $gb4K1.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $iGmlb.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $a5i87.TYPE).select,
                        value: value,
                        options: $4167299d39181961$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $a5i87.TYPE).plural,
                        value: value,
                        options: $4167299d39181961$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $iGmlb.ErrorKind).INVALID_ARGUMENT_TYPE, $4167299d39181961$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $iGmlb.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $4167299d39181961$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $4GppD.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $iGmlb.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $a5i87.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $4GppD.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $iGmlb.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $4167299d39181961$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $iGmlb.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $iGmlb.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $iGmlb.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $iGmlb.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $iGmlb.ErrorKind).MISSING_OTHER_CLAUSE, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $4167299d39181961$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$4167299d39181961$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $4167299d39181961$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($4167299d39181961$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $4167299d39181961$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $4167299d39181961$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $4167299d39181961$var$_isAlphaOrSlash(codepoint) {
    return $4167299d39181961$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $4167299d39181961$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $4167299d39181961$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $4167299d39181961$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("a5i87", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $75786f449df6d2b2$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $75786f449df6d2b2$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $75786f449df6d2b2$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $75786f449df6d2b2$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $75786f449df6d2b2$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $75786f449df6d2b2$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $75786f449df6d2b2$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $75786f449df6d2b2$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $75786f449df6d2b2$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $75786f449df6d2b2$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $75786f449df6d2b2$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $75786f449df6d2b2$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $75786f449df6d2b2$export$7680c41f1a55f4cf; });
var $75786f449df6d2b2$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($75786f449df6d2b2$export$b87f371cbc396fcf || ($75786f449df6d2b2$export$b87f371cbc396fcf = {}));
var $75786f449df6d2b2$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($75786f449df6d2b2$export$906452485466fa53 || ($75786f449df6d2b2$export$906452485466fa53 = {}));
function $75786f449df6d2b2$export$cfa10c5697238752(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.literal;
}
function $75786f449df6d2b2$export$4f55724281bdfaf9(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.argument;
}
function $75786f449df6d2b2$export$e11187b219e191e1(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.number;
}
function $75786f449df6d2b2$export$32d811605da75f40(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.date;
}
function $75786f449df6d2b2$export$34ec46f596b1702f(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.time;
}
function $75786f449df6d2b2$export$dcfe1c11d168b5a1(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.select;
}
function $75786f449df6d2b2$export$6c796d116f0a4fbc(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.plural;
}
function $75786f449df6d2b2$export$c0ece297bdd0c082(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.pound;
}
function $75786f449df6d2b2$export$5c83de34745812b(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.tag;
}
function $75786f449df6d2b2$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $75786f449df6d2b2$export$906452485466fa53.number);
}
function $75786f449df6d2b2$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $75786f449df6d2b2$export$906452485466fa53.dateTime);
}
function $75786f449df6d2b2$export$f0ac572c1121c662(value) {
    return {
        type: $75786f449df6d2b2$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $75786f449df6d2b2$export$425e864b0ba114f1(value, style) {
    return {
        type: $75786f449df6d2b2$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("2m77C", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $1b73291d395e5a94$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $1b73291d395e5a94$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $1b73291d395e5a94$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("hDzp7", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("2WsKD")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("4GppD")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("4GppD")).parseNumberSkeletonFromString; });
parcelRequire("2WsKD");
parcelRequire("4GppD");

});
parcelRegister("2WsKD", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $22474cec4db80596$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $22474cec4db80596$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $22474cec4db80596$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($22474cec4db80596$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("4GppD", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $368ecc0b5163d758$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $368ecc0b5163d758$export$47c6f8480bda3e11; });

var $gb4K1 = parcelRequire("gb4K1");

var $8lL8v = parcelRequire("8lL8v");
function $368ecc0b5163d758$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8lL8v.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $368ecc0b5163d758$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $368ecc0b5163d758$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $368ecc0b5163d758$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $368ecc0b5163d758$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $368ecc0b5163d758$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $368ecc0b5163d758$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($368ecc0b5163d758$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $368ecc0b5163d758$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $368ecc0b5163d758$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$368ecc0b5163d758$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $368ecc0b5163d758$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $368ecc0b5163d758$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $368ecc0b5163d758$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $368ecc0b5163d758$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, all), $368ecc0b5163d758$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, all), $368ecc0b5163d758$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($368ecc0b5163d758$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($368ecc0b5163d758$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($368ecc0b5163d758$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($368ecc0b5163d758$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), $368ecc0b5163d758$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($368ecc0b5163d758$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), $368ecc0b5163d758$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $368ecc0b5163d758$var$parseSign(token.stem);
        if (signOpts) result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $368ecc0b5163d758$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8lL8v", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $6144d926f66f1e6a$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $6144d926f66f1e6a$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("6hTU2", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $493fb1c51895e6a4$export$29c5368be8904d27; });

var $eEJFp = parcelRequire("eEJFp");
function $493fb1c51895e6a4$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $493fb1c51895e6a4$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $493fb1c51895e6a4$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $eEJFp.timeData)[regionTag || ""] || (0, $eEJFp.timeData)[languageTag || ""] || (0, $eEJFp.timeData)["".concat(languageTag, "-001")] || (0, $eEJFp.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("eEJFp", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $aab8399e6b194b97$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $aab8399e6b194b97$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("bX0Gd", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $8b35bb6f41aac165$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $8b35bb6f41aac165$export$c5491a8691a23b9e; });
//
// Main
//
function $8b35bb6f41aac165$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $8b35bb6f41aac165$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8b35bb6f41aac165$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8b35bb6f41aac165$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8b35bb6f41aac165$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8b35bb6f41aac165$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8b35bb6f41aac165$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8b35bb6f41aac165$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8b35bb6f41aac165$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8b35bb6f41aac165$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8b35bb6f41aac165$var$monadic : $8b35bb6f41aac165$var$variadic;
    return $8b35bb6f41aac165$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8b35bb6f41aac165$var$strategyVariadic(fn, options) {
    return $8b35bb6f41aac165$var$assemble(fn, this, $8b35bb6f41aac165$var$variadic, options.cache.create(), options.serializer);
}
function $8b35bb6f41aac165$var$strategyMonadic(fn, options) {
    return $8b35bb6f41aac165$var$assemble(fn, this, $8b35bb6f41aac165$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8b35bb6f41aac165$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $8b35bb6f41aac165$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$8b35bb6f41aac165$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$8b35bb6f41aac165$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $8b35bb6f41aac165$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $8b35bb6f41aac165$var$ObjectWithoutPrototypeCache();
    }
};
var $8b35bb6f41aac165$export$c5491a8691a23b9e = {
    variadic: $8b35bb6f41aac165$var$strategyVariadic,
    monadic: $8b35bb6f41aac165$var$strategyMonadic
};

});

parcelRegister("9FMnG", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $70ad78ded0c32382$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $70ad78ded0c32382$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $70ad78ded0c32382$export$275d4a3bb5f66fda; });
parcelRequire("b4svv");
var $a5i87 = parcelRequire("a5i87");

var $8RUL4 = parcelRequire("8RUL4");
var $70ad78ded0c32382$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($70ad78ded0c32382$export$49694c2877b44c57 || ($70ad78ded0c32382$export$49694c2877b44c57 = {}));
function $70ad78ded0c32382$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $70ad78ded0c32382$export$49694c2877b44c57.literal || part.type !== $70ad78ded0c32382$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $70ad78ded0c32382$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $70ad78ded0c32382$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $a5i87.isLiteralElement)(els[0])) return [
        {
            type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $a5i87.isLiteralElement)(el)) {
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $a5i87.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $8RUL4.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $a5i87.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $70ad78ded0c32382$export$49694c2877b44c57.literal : $70ad78ded0c32382$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $a5i87.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $a5i87.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $a5i87.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $a5i87.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $a5i87.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $a5i87.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $a5i87.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$70ad78ded0c32382$export$df0c12a2d414a163(formatFn)) throw new (0, $8RUL4.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $70ad78ded0c32382$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $70ad78ded0c32382$export$49694c2877b44c57.literal : $70ad78ded0c32382$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $a5i87.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $8RUL4.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $70ad78ded0c32382$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $a5i87.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $8RUL4.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $8RUL4.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $70ad78ded0c32382$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $70ad78ded0c32382$var$mergeLiteral(result);
}

});
parcelRegister("8RUL4", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $674f4cfa6a43b28f$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $674f4cfa6a43b28f$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $674f4cfa6a43b28f$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $674f4cfa6a43b28f$export$8bfc137e4d23fdf0; });

var $gb4K1 = parcelRequire("gb4K1");
var $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($674f4cfa6a43b28f$export$d4e71bc0b80dc0fb || ($674f4cfa6a43b28f$export$d4e71bc0b80dc0fb = {}));
var $674f4cfa6a43b28f$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $674f4cfa6a43b28f$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($674f4cfa6a43b28f$export$7369836851cc1329);
var $674f4cfa6a43b28f$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($674f4cfa6a43b28f$export$7369836851cc1329);
var $674f4cfa6a43b28f$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($674f4cfa6a43b28f$export$7369836851cc1329);

});




parcelRegister("dCg2n", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $9e9b43ad85e9132d$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $9e9b43ad85e9132d$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $9e9b43ad85e9132d$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $9e9b43ad85e9132d$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $9e9b43ad85e9132d$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $9e9b43ad85e9132d$export$2ddcb436d0aa3688; });

var $gb4K1 = parcelRequire("gb4K1");
var $9e9b43ad85e9132d$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($9e9b43ad85e9132d$export$557d6acb76e8a244 || ($9e9b43ad85e9132d$export$557d6acb76e8a244 = {}));
var $9e9b43ad85e9132d$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $9e9b43ad85e9132d$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($9e9b43ad85e9132d$export$e3b7eee1dbc44895);
var $9e9b43ad85e9132d$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);

});




parcelRegister("8mLXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $617595e7d282f605$export$2e2bcd8739ae039; });

var $lHE6I = parcelRequire("lHE6I");

var $7b1Lp = parcelRequire("7b1Lp");

var $1GRlU = parcelRequire("1GRlU");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $617595e7d282f605$var$useStyles = (0, $7b1Lp.default)({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    white: {
        color: "white"
    }
});
function $617595e7d282f605$export$2e2bcd8739ae039({ dark: dark }) {
    const classes = $617595e7d282f605$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $lHE6I.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1GRlU)))({
            [classes.white]: !dark
        })
    }));
}
$617595e7d282f605$export$2e2bcd8739ae039.defaultProps = {
    dark: false
};

});
parcelRegister("lHE6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcccb99d67900b6d$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");


var $eyd6T = parcelRequire("eyd6T");

var $5beWR = parcelRequire("5beWR");
var $fcccb99d67900b6d$var$SIZE = 44;
var $fcccb99d67900b6d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-block"
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: "$circular-rotate 1.4s linear infinite"
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: "block" // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: "currentColor" // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px" // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        "@keyframes circular-rotate": {
            "0%": {
                // Fix IE 11 wobbly
                transformOrigin: "50% 50%"
            },
            "100%": {
                transform: "rotate(360deg)"
            }
        },
        "@keyframes circular-dash": {
            "0%": {
                strokeDasharray: "1px, 200px",
                strokeDashoffset: "0px"
            },
            "50%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-15px"
            },
            "100%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-125px"
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: "none"
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $fcccb99d67900b6d$var$CircularProgress = /*#__PURE__*/ $cQNHH.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $fsWgf.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate" || variant === "static") {
        var circumference = 2 * Math.PI * (($fcccb99d67900b6d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ $cQNHH.createElement("div", (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $5beWR.default)(color))], {
            "determinate": classes.determinate,
            "indeterminate": classes.indeterminate,
            "static": classes.static
        }[variant]),
        style: (0, $gtn2B.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $cQNHH.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($fcccb99d67900b6d$var$SIZE / 2, " ").concat($fcccb99d67900b6d$var$SIZE / 2, " ").concat($fcccb99d67900b6d$var$SIZE, " ").concat($fcccb99d67900b6d$var$SIZE)
    }, /*#__PURE__*/ $cQNHH.createElement("circle", {
        className: (0, $bKF6r.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            "determinate": classes.circleDeterminate,
            "indeterminate": classes.circleIndeterminate,
            "static": classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $fcccb99d67900b6d$var$SIZE,
        cy: $fcccb99d67900b6d$var$SIZE,
        r: ($fcccb99d67900b6d$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $fcccb99d67900b6d$export$2e2bcd8739ae039 = (0, $eyd6T.default)($fcccb99d67900b6d$export$9dd6ff9ea0189349, {
    name: "MuiCircularProgress",
    flip: false
})($fcccb99d67900b6d$var$CircularProgress);

});
parcelRegister("bKF6r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $023539494c2e2e2c$export$2e2bcd8739ae039; });
function $023539494c2e2e2c$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $023539494c2e2e2c$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $023539494c2e2e2c$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $023539494c2e2e2c$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("eyd6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97e690eb1af1eef$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $d51DM = parcelRequire("d51DM");

var $8dv03 = parcelRequire("8dv03");
function $a97e690eb1af1eef$var$withStyles(stylesOrCreator, options) {
    return (0, $d51DM.default)(stylesOrCreator, (0, $gtn2B.default)({
        defaultTheme: (0, $8dv03.default)
    }, options));
}
var $a97e690eb1af1eef$export$2e2bcd8739ae039 = $a97e690eb1af1eef$var$withStyles;

});
parcelRegister("d51DM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $985d03cef2734122$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

var $gyDGU = parcelRequire("gyDGU");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $aoqh7 = parcelRequire("aoqh7");


var $7b1Lp = parcelRequire("7b1Lp");

var $jB5O2 = parcelRequire("jB5O2");

var $6WDy5 = parcelRequire("6WDy5");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $985d03cef2734122$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $gyDGU.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $7b1Lp.default)(stylesOrCreator, (0, $815Xb.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $gyDGU.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $815Xb.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $6WDy5.default)() || defaultTheme;
                if (name) more = (0, $jB5O2.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, (0, $815Xb.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($aoqh7)))(WithStyles, Component);
        return WithStyles;
    };
};
var $985d03cef2734122$export$2e2bcd8739ae039 = $985d03cef2734122$var$withStyles;

});
parcelRegister("jB5O2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e445f9fc25a0bc01$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $e445f9fc25a0bc01$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("8dv03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fb79592c098a066$export$2e2bcd8739ae039; });

var $elwbS = parcelRequire("elwbS");
var $5fb79592c098a066$var$defaultTheme = (0, $elwbS.default)();
var $5fb79592c098a066$export$2e2bcd8739ae039 = $5fb79592c098a066$var$defaultTheme;

});
parcelRegister("elwbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a71bff40f023b26e$export$2e2bcd8739ae039; });
parcelRequire("269Bb");

var $fsWgf = parcelRequire("fsWgf");

var $kt6Ie = parcelRequire("kt6Ie");

var $lkMpL = parcelRequire("lkMpL");

var $4GONF = parcelRequire("4GONF");

var $adeGL = parcelRequire("adeGL");

var $b3xjG = parcelRequire("b3xjG");

var $b07Va = parcelRequire("b07Va");

var $K4Wzh = parcelRequire("K4Wzh");

var $lzf3y = parcelRequire("lzf3y");

var $ijxDf = parcelRequire("ijxDf");

var $icOS8 = parcelRequire("icOS8");
function $a71bff40f023b26e$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $fsWgf.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $adeGL.default)(paletteInput);
    var breakpoints = (0, $lkMpL.default)(breakpointsInput);
    var spacing = (0, $lzf3y.default)(spacingInput);
    var muiTheme = (0, $kt6Ie.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $4GONF.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $b07Va.default),
        typography: (0, $b3xjG.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $K4Wzh.default),
        transitions: (0, $ijxDf.default),
        zIndex: (0, $icOS8.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $kt6Ie.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $a71bff40f023b26e$var$warnedOnce = false;
function $a71bff40f023b26e$export$c469355549431d9b() {
    return $a71bff40f023b26e$var$createTheme.apply(void 0, arguments);
}
var $a71bff40f023b26e$export$2e2bcd8739ae039 = $a71bff40f023b26e$var$createTheme;

});
parcelRegister("lkMpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $040214bb4e643271$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");
var $040214bb4e643271$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $040214bb4e643271$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $fsWgf.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $040214bb4e643271$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$040214bb4e643271$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $040214bb4e643271$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $040214bb4e643271$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $040214bb4e643271$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$040214bb4e643271$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$040214bb4e643271$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $gtn2B.default)({
        keys: $040214bb4e643271$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("4GONF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36a27d805a478ecd$export$2e2bcd8739ae039; });

var $269Bb = parcelRequire("269Bb");

var $gtn2B = parcelRequire("gtn2B");
function $36a27d805a478ecd$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $gtn2B.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $gtn2B.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $269Bb.default)({}, breakpoints.up("sm"), (0, $gtn2B.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $269Bb.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $269Bb.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("adeGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f6832225758e88$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $kt6Ie = parcelRequire("kt6Ie");
var $6slzQ = parcelRequire("6slzQ");

var $9TCcK = parcelRequire("9TCcK");

var $051CJ = parcelRequire("051CJ");

var $NZaiv = parcelRequire("NZaiv");

var $9VDdv = parcelRequire("9VDdv");

var $fdcrk = parcelRequire("fdcrk");

var $iujT5 = parcelRequire("iujT5");

var $hz3ne = parcelRequire("hz3ne");

var $ecMVT = parcelRequire("ecMVT");

var $80wVS = parcelRequire("80wVS");
var $76f6832225758e88$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $9TCcK.default).white,
        default: (0, $051CJ.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $76f6832225758e88$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $9TCcK.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $051CJ.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $9TCcK.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $76f6832225758e88$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $80wVS.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $80wVS.darken)(intent.main, tonalOffsetDark);
    }
}
function $76f6832225758e88$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $NZaiv.default)[300],
        main: (0, $NZaiv.default)[500],
        dark: (0, $NZaiv.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $9VDdv.default).A200,
        main: (0, $9VDdv.default).A400,
        dark: (0, $9VDdv.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $fdcrk.default)[300],
        main: (0, $fdcrk.default)[500],
        dark: (0, $fdcrk.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $iujT5.default)[300],
        main: (0, $iujT5.default)[500],
        dark: (0, $iujT5.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $hz3ne.default)[300],
        main: (0, $hz3ne.default)[500],
        dark: (0, $hz3ne.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $ecMVT.default)[300],
        main: (0, $ecMVT.default)[500],
        dark: (0, $ecMVT.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $fsWgf.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $80wVS.getContrastRatio)(background, $76f6832225758e88$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $76f6832225758e88$export$55ce6f3a06c59543.text.primary : $76f6832225758e88$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $gtn2B.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $6slzQ.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $6slzQ.default)(5, JSON.stringify(color.main)));
        $76f6832225758e88$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $76f6832225758e88$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $76f6832225758e88$export$55ce6f3a06c59543,
        light: $76f6832225758e88$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $kt6Ie.default)((0, $gtn2B.default)({
        // A collection of common colors.
        common: (0, $9TCcK.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $051CJ.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("9TCcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7346e2bda4197486$export$2e2bcd8739ae039; });
var $7346e2bda4197486$var$common = {
    black: "#000",
    white: "#fff"
};
var $7346e2bda4197486$export$2e2bcd8739ae039 = $7346e2bda4197486$var$common;

});

parcelRegister("051CJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f1ba29dcdc9761$export$2e2bcd8739ae039; });
var $00f1ba29dcdc9761$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $00f1ba29dcdc9761$export$2e2bcd8739ae039 = $00f1ba29dcdc9761$var$grey;

});

parcelRegister("NZaiv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $096405d4ab423029$export$2e2bcd8739ae039; });
var $096405d4ab423029$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $096405d4ab423029$export$2e2bcd8739ae039 = $096405d4ab423029$var$indigo;

});

parcelRegister("9VDdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a7db8f43fcc9e3$export$2e2bcd8739ae039; });
var $73a7db8f43fcc9e3$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $73a7db8f43fcc9e3$export$2e2bcd8739ae039 = $73a7db8f43fcc9e3$var$pink;

});

parcelRegister("fdcrk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b131b82f87dc9910$export$2e2bcd8739ae039; });
var $b131b82f87dc9910$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $b131b82f87dc9910$export$2e2bcd8739ae039 = $b131b82f87dc9910$var$red;

});

parcelRegister("iujT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d75a749302b9f0b3$export$2e2bcd8739ae039; });
var $d75a749302b9f0b3$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $d75a749302b9f0b3$export$2e2bcd8739ae039 = $d75a749302b9f0b3$var$orange;

});

parcelRegister("hz3ne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc9852826ea8b595$export$2e2bcd8739ae039; });
var $cc9852826ea8b595$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $cc9852826ea8b595$export$2e2bcd8739ae039 = $cc9852826ea8b595$var$blue;

});

parcelRegister("ecMVT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a57824b5225a5ddf$export$2e2bcd8739ae039; });
var $a57824b5225a5ddf$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a57824b5225a5ddf$export$2e2bcd8739ae039 = $a57824b5225a5ddf$var$green;

});


parcelRegister("b3xjG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80c9d1759486e639$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $kt6Ie = parcelRequire("kt6Ie");
function $80c9d1759486e639$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $80c9d1759486e639$var$warnedOnce = false;
function $80c9d1759486e639$var$roundWithDeprecationWarning(value) {
    return $80c9d1759486e639$var$round(value);
}
var $80c9d1759486e639$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $80c9d1759486e639$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $80c9d1759486e639$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $80c9d1759486e639$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $fsWgf.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $gtn2B.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $80c9d1759486e639$var$defaultFontFamily ? {
            letterSpacing: "".concat($80c9d1759486e639$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $80c9d1759486e639$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $80c9d1759486e639$var$caseAllCaps)
    };
    return (0, $kt6Ie.default)((0, $gtn2B.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $80c9d1759486e639$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("b07Va", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8025d6c1e5036b25$export$2e2bcd8739ae039; });
var $8025d6c1e5036b25$var$shadowKeyUmbraOpacity = 0.2;
var $8025d6c1e5036b25$var$shadowKeyPenumbraOpacity = 0.14;
var $8025d6c1e5036b25$var$shadowAmbientShadowOpacity = 0.12;
function $8025d6c1e5036b25$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($8025d6c1e5036b25$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($8025d6c1e5036b25$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($8025d6c1e5036b25$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $8025d6c1e5036b25$var$shadows = [
    "none",
    $8025d6c1e5036b25$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8025d6c1e5036b25$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8025d6c1e5036b25$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8025d6c1e5036b25$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8025d6c1e5036b25$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8025d6c1e5036b25$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8025d6c1e5036b25$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8025d6c1e5036b25$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8025d6c1e5036b25$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8025d6c1e5036b25$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8025d6c1e5036b25$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8025d6c1e5036b25$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8025d6c1e5036b25$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8025d6c1e5036b25$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8025d6c1e5036b25$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8025d6c1e5036b25$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8025d6c1e5036b25$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8025d6c1e5036b25$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8025d6c1e5036b25$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8025d6c1e5036b25$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8025d6c1e5036b25$export$2e2bcd8739ae039 = $8025d6c1e5036b25$var$shadows;

});

parcelRegister("K4Wzh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a821b2a29d41fe$export$2e2bcd8739ae039; });
var $08a821b2a29d41fe$var$shape = {
    borderRadius: 4
};
var $08a821b2a29d41fe$export$2e2bcd8739ae039 = $08a821b2a29d41fe$var$shape;

});

parcelRegister("lzf3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb388bb65aa1abcc$export$2e2bcd8739ae039; });

var $9SGLk = parcelRequire("9SGLk");
var $fb388bb65aa1abcc$var$warnOnce;
function $fb388bb65aa1abcc$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $9SGLk.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("9SGLk", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $731a53edb0f4ac6e$export$1def6f833384e3d1; });

var $gz0Kt = parcelRequire("gz0Kt");


var $3fJgA = parcelRequire("3fJgA");

var $5DANl = parcelRequire("5DANl");

var $kXi0m = parcelRequire("kXi0m");
var $731a53edb0f4ac6e$var$properties = {
    m: "margin",
    p: "padding"
};
var $731a53edb0f4ac6e$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $731a53edb0f4ac6e$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $731a53edb0f4ac6e$var$getCssProperties = (0, $kXi0m.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($731a53edb0f4ac6e$var$aliases[prop]) prop = $731a53edb0f4ac6e$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $gz0Kt.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $731a53edb0f4ac6e$var$properties[a];
    var direction = $731a53edb0f4ac6e$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $731a53edb0f4ac6e$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $731a53edb0f4ac6e$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $731a53edb0f4ac6e$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $731a53edb0f4ac6e$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $731a53edb0f4ac6e$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $731a53edb0f4ac6e$var$spacing(props) {
    var theme = props.theme;
    var transformer = $731a53edb0f4ac6e$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($731a53edb0f4ac6e$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $731a53edb0f4ac6e$var$getCssProperties(prop);
        var styleFromPropValue = $731a53edb0f4ac6e$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $3fJgA.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $5DANl.default), {});
}
$731a53edb0f4ac6e$var$spacing.propTypes = {};
$731a53edb0f4ac6e$var$spacing.filterProps = $731a53edb0f4ac6e$var$spacingKeys;
var $731a53edb0f4ac6e$export$2e2bcd8739ae039 = $731a53edb0f4ac6e$var$spacing;

});
parcelRegister("gz0Kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0f07ee6dc52cafe$export$2e2bcd8739ae039; });

var $g8eN4 = parcelRequire("g8eN4");

var $7GVqY = parcelRequire("7GVqY");

var $ckYPN = parcelRequire("ckYPN");

var $ez4um = parcelRequire("ez4um");
function $c0f07ee6dc52cafe$export$2e2bcd8739ae039(arr, i) {
    return (0, $g8eN4.default)(arr) || (0, $7GVqY.default)(arr, i) || (0, $ckYPN.default)(arr, i) || (0, $ez4um.default)();
}

});
parcelRegister("g8eN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe8ddc18fa78d73$export$2e2bcd8739ae039; });
function $bbe8ddc18fa78d73$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("7GVqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599901dc822f2782$export$2e2bcd8739ae039; });
function $599901dc822f2782$export$2e2bcd8739ae039(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("ckYPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fb68ac233b05c9d$export$2e2bcd8739ae039; });

var $2tQb7 = parcelRequire("2tQb7");
function $8fb68ac233b05c9d$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2tQb7.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2tQb7.default)(o, minLen);
}

});
parcelRegister("2tQb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ce6c3b6a66b7b6f$export$2e2bcd8739ae039; });
function $1ce6c3b6a66b7b6f$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("ez4um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9a7d0f305bd9213$export$2e2bcd8739ae039; });
function $a9a7d0f305bd9213$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3fJgA", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $25e5e2c6bba237bf$export$88347efdb2e19abd; });

var $5vwUL = parcelRequire("5vwUL");

var $d9u0Q = parcelRequire("d9u0Q");

var $geaQ7 = parcelRequire("geaQ7");
parcelRequire("1xEYC");

var $5DANl = parcelRequire("5DANl");
// For instance with the first breakpoint xs: [xs, sm[.
var $25e5e2c6bba237bf$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $25e5e2c6bba237bf$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($25e5e2c6bba237bf$var$values[key], "px)");
    }
};
function $25e5e2c6bba237bf$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $25e5e2c6bba237bf$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $geaQ7.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $25e5e2c6bba237bf$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $25e5e2c6bba237bf$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $25e5e2c6bba237bf$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $d9u0Q.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $5DANl.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $5vwUL.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $25e5e2c6bba237bf$export$2e2bcd8739ae039 = $25e5e2c6bba237bf$var$breakpoints;

});
parcelRegister("5vwUL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40296128f0b1ffa4$export$2e2bcd8739ae039; });

var $5ROPm = parcelRequire("5ROPm");

var $8e7xG = parcelRequire("8e7xG");

var $ckYPN = parcelRequire("ckYPN");

var $l8uy1 = parcelRequire("l8uy1");
function $40296128f0b1ffa4$export$2e2bcd8739ae039(arr) {
    return (0, $5ROPm.default)(arr) || (0, $8e7xG.default)(arr) || (0, $ckYPN.default)(arr) || (0, $l8uy1.default)();
}

});
parcelRegister("5ROPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4459543e84e5ccb9$export$2e2bcd8739ae039; });

var $2tQb7 = parcelRequire("2tQb7");
function $4459543e84e5ccb9$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $2tQb7.default)(arr);
}

});

parcelRegister("8e7xG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd57b4ca072ed95$export$2e2bcd8739ae039; });
function $5fd57b4ca072ed95$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("l8uy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6320a7fd1550648$export$2e2bcd8739ae039; });
function $f6320a7fd1550648$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("d9u0Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9933657f497b2faa$export$2e2bcd8739ae039; });
function $9933657f497b2faa$export$2e2bcd8739ae039() {
    $9933657f497b2faa$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9933657f497b2faa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("geaQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd065cada0a9ba14$export$2e2bcd8739ae039; });
function $bd065cada0a9ba14$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bd065cada0a9ba14$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $bd065cada0a9ba14$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bd065cada0a9ba14$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("5DANl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ad22f171612a8a$export$2e2bcd8739ae039; });

var $kt6Ie = parcelRequire("kt6Ie");
function $41ad22f171612a8a$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $kt6Ie.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $41ad22f171612a8a$export$2e2bcd8739ae039 = $41ad22f171612a8a$var$merge;

});


parcelRegister("kXi0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41748bc89937e63$export$2e2bcd8739ae039; });
function $f41748bc89937e63$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("ijxDf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d55416f5c7eecff1$export$2e2bcd8739ae039; });

var $fsWgf = parcelRequire("fsWgf");
var $d55416f5c7eecff1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $d55416f5c7eecff1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $d55416f5c7eecff1$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $d55416f5c7eecff1$export$2e2bcd8739ae039 = {
    easing: $d55416f5c7eecff1$export$24c5ac7c37452e7d,
    duration: $d55416f5c7eecff1$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $d55416f5c7eecff1$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $d55416f5c7eecff1$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $fsWgf.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $d55416f5c7eecff1$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $d55416f5c7eecff1$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});




parcelRegister("5beWR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c599346d9c42cf8$export$2e2bcd8739ae039; });

var $6slzQ = parcelRequire("6slzQ");
function $3c599346d9c42cf8$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $6slzQ.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("1GRlU", function(module, exports) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === "object") {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("8u8eZ", function(module, exports) {

var $1xEYC = parcelRequire("1xEYC");
const $62d784828f63e593$export$7e927f89b22caf2c = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    formatMessage: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func.isRequired
});
const $62d784828f63e593$export$1d69e636f1b32562 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    inlineText: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    key: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired
}));
const $62d784828f63e593$export$9bc1f4057b1b7043 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    description: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired,
    items: $62d784828f63e593$export$1d69e636f1b32562,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape(),
    question: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired
});
const $62d784828f63e593$export$aaf0649dab15c9f5 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    questions: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).arrayOf($62d784828f63e593$export$9bc1f4057b1b7043).isRequired
});
const $62d784828f63e593$export$3084229670219754 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    subText: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
});
const $62d784828f63e593$export$e4ca1b6fd62441ab = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    completed: $62d784828f63e593$export$3084229670219754,
    eligibl: $62d784828f63e593$export$3084229670219754,
    ineligible: $62d784828f63e593$export$3084229670219754,
    leave: $62d784828f63e593$export$3084229670219754,
    welcome: $62d784828f63e593$export$3084229670219754
});
var $62d784828f63e593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC)));

});


parcelRegister("7YYXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cfd6c9aeb364ae4$export$2e2bcd8739ae039; });

var $fsWgf = parcelRequire("fsWgf");

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $80wVS = parcelRequire("80wVS");

var $6apHB = parcelRequire("6apHB");

var $5beWR = parcelRequire("5beWR");
var $5cfd6c9aeb364ae4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $gtn2B.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $80wVS.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $80wVS.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $80wVS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $80wVS.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $80wVS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $5cfd6c9aeb364ae4$var$Button = /*#__PURE__*/ $cQNHH.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $fsWgf.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $cQNHH.createElement("span", {
        className: (0, $bKF6r.default)(classes.startIcon, classes["iconSize".concat((0, $5beWR.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $cQNHH.createElement("span", {
        className: (0, $bKF6r.default)(classes.endIcon, classes["iconSize".concat((0, $5beWR.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $cQNHH.createElement((0, $6apHB.default), (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $5beWR.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $5beWR.default)(size))],
            classes["size".concat((0, $5beWR.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $bKF6r.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $cQNHH.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $5cfd6c9aeb364ae4$export$2e2bcd8739ae039 = (0, $eyd6T.default)($5cfd6c9aeb364ae4$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($5cfd6c9aeb364ae4$var$Button);

});
parcelRegister("6apHB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d79d2fb924a37f$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $dLwnG = parcelRequire("dLwnG");

var $bKF6r = parcelRequire("bKF6r");


var $ge6Tz = parcelRequire("ge6Tz");

var $3uSqW = parcelRequire("3uSqW");


var $eyd6T = parcelRequire("eyd6T");

var $9fjCj = parcelRequire("9fjCj");

var $iqfQ6 = parcelRequire("iqfQ6");
var $47d79d2fb924a37f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $47d79d2fb924a37f$var$ButtonBase = /*#__PURE__*/ $cQNHH.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $fsWgf.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $cQNHH.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $dLwnG.findDOMNode(buttonRef.current);
    }
    var rippleRef = $cQNHH.useRef(null);
    var _React$useState = $cQNHH.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $9fjCj.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $cQNHH.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $cQNHH.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $3uSqW.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $3uSqW.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $cQNHH.useRef(false);
    var handleKeyDown = (0, $3uSqW.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $3uSqW.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $ge6Tz.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $ge6Tz.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $ge6Tz.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $cQNHH.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $cQNHH.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $cQNHH.createElement(ComponentProp, (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $cQNHH.createElement((0, $iqfQ6.default), (0, $gtn2B.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $47d79d2fb924a37f$export$2e2bcd8739ae039 = (0, $eyd6T.default)($47d79d2fb924a37f$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($47d79d2fb924a37f$var$ButtonBase);

});
parcelRegister("ge6Tz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd034d6561620cdc$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $dNhy6 = parcelRequire("dNhy6");
function $bd034d6561620cdc$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $cQNHH.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $dNhy6.default)(refA, refValue);
            (0, $dNhy6.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("dNhy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ad76dbd8c041a0$export$2e2bcd8739ae039; });
// TODO v5: consider to make it private
function $a0ad76dbd8c041a0$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("3uSqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28be65d3ec97a86f$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
var $28be65d3ec97a86f$var$useEnhancedEffect = typeof window !== "undefined" ? $cQNHH.useLayoutEffect : $cQNHH.useEffect;
function $28be65d3ec97a86f$export$2e2bcd8739ae039(fn) {
    var ref = $cQNHH.useRef(fn);
    $28be65d3ec97a86f$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $cQNHH.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("9fjCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bb4bb481cb61c23$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $cQNHH = parcelRequire("cQNHH");

var $dLwnG = parcelRequire("dLwnG");
var $6bb4bb481cb61c23$var$hadKeyboardEvent = true;
var $6bb4bb481cb61c23$var$hadFocusVisibleRecently = false;
var $6bb4bb481cb61c23$var$hadFocusVisibleRecentlyTimeout = null;
var $6bb4bb481cb61c23$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $6bb4bb481cb61c23$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $6bb4bb481cb61c23$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $6bb4bb481cb61c23$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $6bb4bb481cb61c23$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $6bb4bb481cb61c23$var$handlePointerDown() {
    $6bb4bb481cb61c23$var$hadKeyboardEvent = false;
}
function $6bb4bb481cb61c23$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($6bb4bb481cb61c23$var$hadFocusVisibleRecently) $6bb4bb481cb61c23$var$hadKeyboardEvent = true;
    }
}
function $6bb4bb481cb61c23$var$prepare(doc) {
    doc.addEventListener("keydown", $6bb4bb481cb61c23$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $6bb4bb481cb61c23$var$handleVisibilityChange, true);
}
function $6bb4bb481cb61c23$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $6bb4bb481cb61c23$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $6bb4bb481cb61c23$var$handleVisibilityChange, true);
}
function $6bb4bb481cb61c23$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $6bb4bb481cb61c23$var$hadKeyboardEvent || $6bb4bb481cb61c23$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $6bb4bb481cb61c23$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $6bb4bb481cb61c23$var$hadFocusVisibleRecently = true;
    window.clearTimeout($6bb4bb481cb61c23$var$hadFocusVisibleRecentlyTimeout);
    $6bb4bb481cb61c23$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $6bb4bb481cb61c23$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $6bb4bb481cb61c23$export$2e2bcd8739ae039() {
    var ref = $cQNHH.useCallback(function(instance) {
        var node = $dLwnG.findDOMNode(instance);
        if (node != null) $6bb4bb481cb61c23$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $6bb4bb481cb61c23$var$isFocusVisible,
        onBlurVisible: $6bb4bb481cb61c23$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("iqfQ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d696f110982781b3$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $6YeMW = parcelRequire("6YeMW");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $c4T9R = parcelRequire("c4T9R");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $2tdAk = parcelRequire("2tdAk");
var $d696f110982781b3$var$DURATION = 550;
var $d696f110982781b3$export$95d0c9356b2231a3 = 80;
var $d696f110982781b3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($d696f110982781b3$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($d696f110982781b3$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $d696f110982781b3$var$TouchRipple = /*#__PURE__*/ $cQNHH.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $fsWgf.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $cQNHH.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $cQNHH.useRef(0);
    var rippleCallback = $cQNHH.useRef(null);
    $cQNHH.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $cQNHH.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $cQNHH.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $cQNHH.useRef(null);
    var container = $cQNHH.useRef(null);
    $cQNHH.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $cQNHH.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $6YeMW.default)(oldRipples), [
                /*#__PURE__*/ $cQNHH.createElement((0, $2tdAk.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $d696f110982781b3$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $cQNHH.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $d696f110982781b3$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $cQNHH.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $cQNHH.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $cQNHH.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $cQNHH.createElement("span", (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $cQNHH.createElement((0, $c4T9R.default), {
        component: null,
        exit: true
    }, ripples));
});
var $d696f110982781b3$export$2e2bcd8739ae039 = (0, $eyd6T.default)($d696f110982781b3$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $cQNHH.memo($d696f110982781b3$var$TouchRipple));

});
parcelRegister("6YeMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $014f4991f4d0f092$export$2e2bcd8739ae039; });

var $knZSh = parcelRequire("knZSh");

var $k5BsA = parcelRequire("k5BsA");

var $baMhu = parcelRequire("baMhu");

var $bnRQJ = parcelRequire("bnRQJ");
function $014f4991f4d0f092$export$2e2bcd8739ae039(arr) {
    return (0, $knZSh.default)(arr) || (0, $k5BsA.default)(arr) || (0, $baMhu.default)(arr) || (0, $bnRQJ.default)();
}

});
parcelRegister("knZSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed75f39b613f9081$export$2e2bcd8739ae039; });

var $gpw9Q = parcelRequire("gpw9Q");
function $ed75f39b613f9081$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $gpw9Q.default)(arr);
}

});
parcelRegister("gpw9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf27ed05ce04d7f9$export$2e2bcd8739ae039; });
function $bf27ed05ce04d7f9$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("k5BsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea01551684783848$export$2e2bcd8739ae039; });
function $ea01551684783848$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("baMhu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8226147f2fa55264$export$2e2bcd8739ae039; });

var $gpw9Q = parcelRequire("gpw9Q");
function $8226147f2fa55264$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gpw9Q.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gpw9Q.default)(o, minLen);
}

});

parcelRegister("bnRQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $849b9d1829ec10aa$export$2e2bcd8739ae039; });
function $849b9d1829ec10aa$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("c4T9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb0a4fa412dae56$export$2e2bcd8739ae039; });

var $6lOdG = parcelRequire("6lOdG");

var $i6zBg = parcelRequire("i6zBg");

var $b7QTH = parcelRequire("b7QTH");

var $8hqNG = parcelRequire("8hqNG");
parcelRequire("1xEYC");

var $cQNHH = parcelRequire("cQNHH");

var $bjgr0 = parcelRequire("bjgr0");

var $6ig0S = parcelRequire("6ig0S");
var $8cb0a4fa412dae56$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8cb0a4fa412dae56$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $8cb0a4fa412dae56$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $8hqNG.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $b7QTH.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $6ig0S.getInitialChildMapping)(nextProps, handleExited) : (0, $6ig0S.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $6ig0S.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $i6zBg.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $6lOdG.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $8cb0a4fa412dae56$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $bjgr0.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $bjgr0.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
$8cb0a4fa412dae56$var$TransitionGroup.propTypes = {};
$8cb0a4fa412dae56$var$TransitionGroup.defaultProps = $8cb0a4fa412dae56$var$defaultProps;
var $8cb0a4fa412dae56$export$2e2bcd8739ae039 = $8cb0a4fa412dae56$var$TransitionGroup;

});
parcelRegister("6lOdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fba8cdda0d58ac$export$2e2bcd8739ae039; });
function $49fba8cdda0d58ac$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("i6zBg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2e466f1eaa47316$export$2e2bcd8739ae039; });
function $d2e466f1eaa47316$export$2e2bcd8739ae039() {
    $d2e466f1eaa47316$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2e466f1eaa47316$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("b7QTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8199617eadd0ac5d$export$2e2bcd8739ae039; });
function $8199617eadd0ac5d$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("8hqNG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6074b33ab09718d9$export$2e2bcd8739ae039; });
function $6074b33ab09718d9$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRegister("bjgr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83be37a334a682ab$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
var $83be37a334a682ab$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext(null);

});

parcelRegister("6ig0S", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $4950d85fc708fe19$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $4950d85fc708fe19$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $4950d85fc708fe19$export$36fd1af28d383ec0; });

var $cQNHH = parcelRequire("cQNHH");
function $4950d85fc708fe19$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $cQNHH.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $cQNHH.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $4950d85fc708fe19$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $4950d85fc708fe19$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $4950d85fc708fe19$export$fa71e2345c31d7a2(props, onExited) {
    return $4950d85fc708fe19$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $cQNHH.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $4950d85fc708fe19$var$getProp(child, "appear", props),
            enter: $4950d85fc708fe19$var$getProp(child, "enter", props),
            exit: $4950d85fc708fe19$var$getProp(child, "exit", props)
        });
    });
}
function $4950d85fc708fe19$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $4950d85fc708fe19$export$bbc8a025727ea824(nextProps.children);
    var children = $4950d85fc708fe19$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $cQNHH.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $cQNHH.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $cQNHH.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $4950d85fc708fe19$var$getProp(child, "exit", nextProps),
            enter: $4950d85fc708fe19$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $cQNHH.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $cQNHH.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $cQNHH.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $4950d85fc708fe19$var$getProp(child, "exit", nextProps),
            enter: $4950d85fc708fe19$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("2tdAk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cc8d3df6a1dfa78$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $3uSqW = parcelRequire("3uSqW");
var $1cc8d3df6a1dfa78$var$useEnhancedEffect = typeof window === "undefined" ? $cQNHH.useEffect : $cQNHH.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $1cc8d3df6a1dfa78$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $cQNHH.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $bKF6r.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $bKF6r.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $3uSqW.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $1cc8d3df6a1dfa78$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $cQNHH.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $cQNHH.createElement("span", {
        className: childClassName
    }));
}
var $1cc8d3df6a1dfa78$export$2e2bcd8739ae039 = $1cc8d3df6a1dfa78$var$Ripple;

});




parcelRegister("kV13H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3a9f3bdcc3e49ef$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $4uhmr = parcelRequire("4uhmr");

var $2KDk6 = parcelRequire("2KDk6");
function $f3a9f3bdcc3e49ef$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $gb4K1.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $gb4K1.__rest)(nextProps, [
        "values"
    ]);
    return (0, $2KDk6.shallowEqual)(nextValues, values) && (0, $2KDk6.shallowEqual)(otherProps, nextOtherProps);
}
function $f3a9f3bdcc3e49ef$var$FormattedMessage(props) {
    var intl = (0, $4uhmr.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $cQNHH.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $cQNHH.createElement(Component, null, $cQNHH.Children.toArray(nodes));
    return $cQNHH.createElement($cQNHH.Fragment, null, nodes);
}
$f3a9f3bdcc3e49ef$var$FormattedMessage.displayName = "FormattedMessage";
var $f3a9f3bdcc3e49ef$var$MemoizedFormattedMessage = $cQNHH.memo($f3a9f3bdcc3e49ef$var$FormattedMessage, $f3a9f3bdcc3e49ef$var$areEqual);
$f3a9f3bdcc3e49ef$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $f3a9f3bdcc3e49ef$export$2e2bcd8739ae039 = $f3a9f3bdcc3e49ef$var$MemoizedFormattedMessage;

});
parcelRegister("4uhmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34476e4abdeb83b0$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $szrnD = parcelRequire("szrnD");

var $2KDk6 = parcelRequire("2KDk6");
function $34476e4abdeb83b0$export$2e2bcd8739ae039() {
    var intl = $cQNHH.useContext((0, $szrnD.Context));
    (0, $2KDk6.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("1YSJM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1715dab906eefb27$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
function $1715dab906eefb27$export$2e2bcd8739ae039({ noFocus: noFocus, ref: outsideRef } = {}) {
    const [refState, setRefState] = (0, $cQNHH.useState)(null);
    const setRef = (ref)=>{
        setRefState(ref);
        if (typeof outsideRef === "function") outsideRef(ref);
        else if (typeof outsideRef === "object") // eslint-disable-next-line no-param-reassign
        outsideRef.current = ref;
    };
    (0, $cQNHH.useEffect)(()=>{
        if (!refState || noFocus) return;
        refState.focus();
    }, [
        refState
    ]);
    return {
        ref: setRef,
        tabIndex: "-1",
        style: {
            outline: "none"
        }
    };
}

});

parcelRegister("jge0r", function(module, exports) {

$parcel$export(module.exports, "userMetrics", function () { return $e05a604081b2ade4$export$914b7abbe5f6a98d; });
/* eslint-disable import/prefer-default-export */ 
var $eAAXH = parcelRequire("eAAXH");
// The value should either be replaced as late as possible for production builds
// or, during development, using environment variables (.env or docker env)
const $e05a604081b2ade4$var$MIXPANEL_TOKEN = "____MIXPANEL_TOKEN____";
// We decide if we should log to console or to MixPanel based on if token was configured
const $e05a604081b2ade4$var$isMixPanelConfigured = !$e05a604081b2ade4$var$MIXPANEL_TOKEN.includes("____");
if (!$e05a604081b2ade4$var$isMixPanelConfigured) console.warn("\uD83C\uDF6F Development mode: Environment variable MIXPANEL_TOKEN is not defined/replaced.");
(0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).init($e05a604081b2ade4$var$MIXPANEL_TOKEN);
const $e05a604081b2ade4$export$914b7abbe5f6a98d = {
    identify: (id)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).identify(id);
        else console.log("Mixpanel - identify:", id);
    },
    alias: (id)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).alias(id);
        else console.log("Mixpanel - alias:", id);
    },
    track: (name, props)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).track(name, props);
        else console.log("Mixpanel - track:", name, props);
    },
    people: {
        set: (props)=>{
            if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).people.set(props);
            else console.log("Mixpanel - people:", props);
        }
    },
    register: (props)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).register(props);
        else console.log("Mixpanel - register:", props);
    },
    register_once: (props)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).register_once(props);
        else console.log("Mixpanel - register once:", props);
    }
};

});
parcelRegister("eAAXH", function(module, exports) {
"use strict";
var $a9f1195cdd0a4fb0$var$Config = {
    DEBUG: false,
    LIB_VERSION: "2.45.0"
};
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $a9f1195cdd0a4fb0$var$window$1;
if (typeof window === "undefined") {
    var $a9f1195cdd0a4fb0$var$loc = {
        hostname: ""
    };
    $a9f1195cdd0a4fb0$var$window$1 = {
        navigator: {
            userAgent: ""
        },
        document: {
            location: $a9f1195cdd0a4fb0$var$loc,
            referrer: ""
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $a9f1195cdd0a4fb0$var$loc
    };
} else $a9f1195cdd0a4fb0$var$window$1 = window;
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $a9f1195cdd0a4fb0$var$ArrayProto = Array.prototype;
var $a9f1195cdd0a4fb0$var$FuncProto = Function.prototype;
var $a9f1195cdd0a4fb0$var$ObjProto = Object.prototype;
var $a9f1195cdd0a4fb0$var$slice = $a9f1195cdd0a4fb0$var$ArrayProto.slice;
var $a9f1195cdd0a4fb0$var$toString = $a9f1195cdd0a4fb0$var$ObjProto.toString;
var $a9f1195cdd0a4fb0$var$hasOwnProperty = $a9f1195cdd0a4fb0$var$ObjProto.hasOwnProperty;
var $a9f1195cdd0a4fb0$var$windowConsole = $a9f1195cdd0a4fb0$var$window$1.console;
var $a9f1195cdd0a4fb0$var$navigator = $a9f1195cdd0a4fb0$var$window$1.navigator;
var $a9f1195cdd0a4fb0$var$document$1 = $a9f1195cdd0a4fb0$var$window$1.document;
var $a9f1195cdd0a4fb0$var$windowOpera = $a9f1195cdd0a4fb0$var$window$1.opera;
var $a9f1195cdd0a4fb0$var$screen = $a9f1195cdd0a4fb0$var$window$1.screen;
var $a9f1195cdd0a4fb0$var$userAgent = $a9f1195cdd0a4fb0$var$navigator.userAgent;
var $a9f1195cdd0a4fb0$var$nativeBind = $a9f1195cdd0a4fb0$var$FuncProto.bind;
var $a9f1195cdd0a4fb0$var$nativeForEach = $a9f1195cdd0a4fb0$var$ArrayProto.forEach;
var $a9f1195cdd0a4fb0$var$nativeIndexOf = $a9f1195cdd0a4fb0$var$ArrayProto.indexOf;
var $a9f1195cdd0a4fb0$var$nativeMap = $a9f1195cdd0a4fb0$var$ArrayProto.map;
var $a9f1195cdd0a4fb0$var$nativeIsArray = Array.isArray;
var $a9f1195cdd0a4fb0$var$breaker = {};
var $a9f1195cdd0a4fb0$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
};
// Console override
var $a9f1195cdd0a4fb0$var$console = {
    /** @type {function(...*)} */ log: function() {
        if ($a9f1195cdd0a4fb0$var$Config.DEBUG && !$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) try {
            $a9f1195cdd0a4fb0$var$windowConsole.log.apply($a9f1195cdd0a4fb0$var$windowConsole, arguments);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.each(arguments, function(arg) {
                $a9f1195cdd0a4fb0$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($a9f1195cdd0a4fb0$var$Config.DEBUG && !$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) {
            var args = [
                "Mixpanel warning:"
            ].concat($a9f1195cdd0a4fb0$var$_.toArray(arguments));
            try {
                $a9f1195cdd0a4fb0$var$windowConsole.warn.apply($a9f1195cdd0a4fb0$var$windowConsole, args);
            } catch (err) {
                $a9f1195cdd0a4fb0$var$_.each(args, function(arg) {
                    $a9f1195cdd0a4fb0$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($a9f1195cdd0a4fb0$var$Config.DEBUG && !$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($a9f1195cdd0a4fb0$var$_.toArray(arguments));
            try {
                $a9f1195cdd0a4fb0$var$windowConsole.error.apply($a9f1195cdd0a4fb0$var$windowConsole, args);
            } catch (err) {
                $a9f1195cdd0a4fb0$var$_.each(args, function(arg) {
                    $a9f1195cdd0a4fb0$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($a9f1195cdd0a4fb0$var$_.toArray(arguments));
            try {
                $a9f1195cdd0a4fb0$var$windowConsole.error.apply($a9f1195cdd0a4fb0$var$windowConsole, args);
            } catch (err) {
                $a9f1195cdd0a4fb0$var$_.each(args, function(arg) {
                    $a9f1195cdd0a4fb0$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $a9f1195cdd0a4fb0$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = "[" + prefix + "] " + arguments[0];
        return func.apply($a9f1195cdd0a4fb0$var$console, arguments);
    };
};
var $a9f1195cdd0a4fb0$var$console_with_prefix = function(prefix) {
    return {
        log: $a9f1195cdd0a4fb0$var$log_func_with_prefix($a9f1195cdd0a4fb0$var$console.log, prefix),
        error: $a9f1195cdd0a4fb0$var$log_func_with_prefix($a9f1195cdd0a4fb0$var$console.error, prefix),
        critical: $a9f1195cdd0a4fb0$var$log_func_with_prefix($a9f1195cdd0a4fb0$var$console.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$a9f1195cdd0a4fb0$var$_.bind = function(func, context) {
    var args, bound;
    if ($a9f1195cdd0a4fb0$var$nativeBind && func.bind === $a9f1195cdd0a4fb0$var$nativeBind) return $a9f1195cdd0a4fb0$var$nativeBind.apply(func, $a9f1195cdd0a4fb0$var$slice.call(arguments, 1));
    if (!$a9f1195cdd0a4fb0$var$_.isFunction(func)) throw new TypeError();
    args = $a9f1195cdd0a4fb0$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($a9f1195cdd0a4fb0$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($a9f1195cdd0a4fb0$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $a9f1195cdd0a4fb0$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($a9f1195cdd0a4fb0$var$nativeForEach && obj.forEach === $a9f1195cdd0a4fb0$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $a9f1195cdd0a4fb0$var$breaker) return;
    }
    else {
        for(var key in obj)if ($a9f1195cdd0a4fb0$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $a9f1195cdd0a4fb0$var$breaker) return;
        }
    }
};
$a9f1195cdd0a4fb0$var$_.extend = function(obj) {
    $a9f1195cdd0a4fb0$var$_.each($a9f1195cdd0a4fb0$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$a9f1195cdd0a4fb0$var$_.isArray = $a9f1195cdd0a4fb0$var$nativeIsArray || function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) === "[object Array]";
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$a9f1195cdd0a4fb0$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$a9f1195cdd0a4fb0$var$_.isArguments = function(obj) {
    return !!(obj && $a9f1195cdd0a4fb0$var$hasOwnProperty.call(obj, "callee"));
};
$a9f1195cdd0a4fb0$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($a9f1195cdd0a4fb0$var$_.isArray(iterable)) return $a9f1195cdd0a4fb0$var$slice.call(iterable);
    if ($a9f1195cdd0a4fb0$var$_.isArguments(iterable)) return $a9f1195cdd0a4fb0$var$slice.call(iterable);
    return $a9f1195cdd0a4fb0$var$_.values(iterable);
};
$a9f1195cdd0a4fb0$var$_.map = function(arr, callback, context) {
    if ($a9f1195cdd0a4fb0$var$nativeMap && arr.map === $a9f1195cdd0a4fb0$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $a9f1195cdd0a4fb0$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$a9f1195cdd0a4fb0$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $a9f1195cdd0a4fb0$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$a9f1195cdd0a4fb0$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $a9f1195cdd0a4fb0$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$a9f1195cdd0a4fb0$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($a9f1195cdd0a4fb0$var$nativeIndexOf && obj.indexOf === $a9f1195cdd0a4fb0$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $a9f1195cdd0a4fb0$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $a9f1195cdd0a4fb0$var$breaker;
    });
    return found;
};
$a9f1195cdd0a4fb0$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$a9f1195cdd0a4fb0$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$a9f1195cdd0a4fb0$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$a9f1195cdd0a4fb0$var$_.isArray(obj);
};
$a9f1195cdd0a4fb0$var$_.isEmptyObject = function(obj) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(obj)) {
        for(var key in obj){
            if ($a9f1195cdd0a4fb0$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$a9f1195cdd0a4fb0$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$a9f1195cdd0a4fb0$var$_.isString = function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) == "[object String]";
};
$a9f1195cdd0a4fb0$var$_.isDate = function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) == "[object Date]";
};
$a9f1195cdd0a4fb0$var$_.isNumber = function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) == "[object Number]";
};
$a9f1195cdd0a4fb0$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$a9f1195cdd0a4fb0$var$_.encodeDates = function(obj) {
    $a9f1195cdd0a4fb0$var$_.each(obj, function(v, k) {
        if ($a9f1195cdd0a4fb0$var$_.isDate(v)) obj[k] = $a9f1195cdd0a4fb0$var$_.formatDate(v);
        else if ($a9f1195cdd0a4fb0$var$_.isObject(v)) obj[k] = $a9f1195cdd0a4fb0$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$a9f1195cdd0a4fb0$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$a9f1195cdd0a4fb0$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? "0" + n : n;
    }
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
};
$a9f1195cdd0a4fb0$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $a9f1195cdd0a4fb0$var$_.each(p, function(v, k) {
        if ($a9f1195cdd0a4fb0$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $a9f1195cdd0a4fb0$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === "string") ret = obj.slice(0, length);
    else if ($a9f1195cdd0a4fb0$var$_.isArray(obj)) {
        ret = [];
        $a9f1195cdd0a4fb0$var$_.each(obj, function(val) {
            ret.push($a9f1195cdd0a4fb0$var$_.truncate(val, length));
        });
    } else if ($a9f1195cdd0a4fb0$var$_.isObject(obj)) {
        ret = {};
        $a9f1195cdd0a4fb0$var$_.each(obj, function(val, key) {
            ret[key] = $a9f1195cdd0a4fb0$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$a9f1195cdd0a4fb0$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = "";
            var indent = "    ";
            var i = 0; // The loop counter.
            var k = ""; // The member key.
            var v = ""; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case "string":
                    return quote(value);
                case "number":
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                case "null":
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case "object":
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return "null";
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($a9f1195cdd0a4fb0$var$toString.apply(value) === "[object Array]") {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($a9f1195cdd0a4fb0$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? "{}" : gap ? "{" + partial.join(",") + "" + mind + "}" : "{" + partial.join(",") + "}";
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $a9f1195cdd0a4fb0$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        "b": "\b",
        "f": "\f",
        "n": "\n",
        "r": "\r",
        "t": "	"
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === "\\") {
                next();
                if (ch === "u") {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === "string") string += escapee[ch];
                else break;
            } else string += ch;
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        return result;
    };
}();
$a9f1195cdd0a4fb0$var$_.base64Encode = function(data) {
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
    if (!data) return data;
    data = $a9f1195cdd0a4fb0$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join("");
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + "==";
            break;
        case 2:
            enc = enc.slice(0, -1) + "=";
            break;
    }
    return enc;
};
$a9f1195cdd0a4fb0$var$_.utf8Encode = function(string) {
    string = (string + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var utftext = "", start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$a9f1195cdd0a4fb0$var$_.UUID = function() {
    // Time/ticks information
    // 1*new Date() is a cross browser version of Date.now()
    var T = function() {
        var d = 1 * new Date(), i = 0;
        // this while loop figures how many browser ticks go by
        // before 1*new Date() returns a new number, ie the amount
        // of ticks that go by per millisecond
        while(d == 1 * new Date())i++;
        return d.toString(16) + i.toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace(".", "");
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $a9f1195cdd0a4fb0$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($a9f1195cdd0a4fb0$var$screen.height * $a9f1195cdd0a4fb0$var$screen.width).toString(16);
        return T() + "-" + R() + "-" + UA() + "-" + se + "-" + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $a9f1195cdd0a4fb0$var$BLOCKED_UA_STRS = [
    "ahrefsbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "facebookexternal",
    "petalbot",
    "pinterest",
    "screaming frog",
    "yahoo! slurp",
    "yandexbot",
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
];
$a9f1195cdd0a4fb0$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $a9f1195cdd0a4fb0$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($a9f1195cdd0a4fb0$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $a9f1195cdd0a4fb0$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(arg_separator)) arg_separator = "&";
    $a9f1195cdd0a4fb0$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + "=" + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$a9f1195cdd0a4fb0$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== "string" && results[1].length) return "";
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$console.error("Skipping decoding for malformed query param: " + result);
        }
        return result.replace(/\+/g, " ");
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$a9f1195cdd0a4fb0$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + "=";
        var ca = $a9f1195cdd0a4fb0$var$document$1.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $a9f1195cdd0a4fb0$var$_.JSONDecode($a9f1195cdd0a4fb0$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $a9f1195cdd0a4fb0$var$extract_domain($a9f1195cdd0a4fb0$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        $a9f1195cdd0a4fb0$var$document$1.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $a9f1195cdd0a4fb0$var$extract_domain($a9f1195cdd0a4fb0$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        var new_cookie_val = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
        $a9f1195cdd0a4fb0$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $a9f1195cdd0a4fb0$var$_.cookie.set(name, "", -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $a9f1195cdd0a4fb0$var$_localStorageSupported = null;
var $a9f1195cdd0a4fb0$var$localStorageSupported = function(storage, forceCheck) {
    if ($a9f1195cdd0a4fb0$var$_localStorageSupported !== null && !forceCheck) return $a9f1195cdd0a4fb0$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = "__mplss_" + $a9f1195cdd0a4fb0$var$cheap_guid(8), val = "xyz";
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $a9f1195cdd0a4fb0$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$a9f1195cdd0a4fb0$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $a9f1195cdd0a4fb0$var$localStorageSupported(null, force_check);
        if (!supported) $a9f1195cdd0a4fb0$var$console.error("localStorage unsupported; falling back to cookie store");
        return supported;
    },
    error: function(msg) {
        $a9f1195cdd0a4fb0$var$console.error("localStorage error: " + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $a9f1195cdd0a4fb0$var$_.JSONDecode($a9f1195cdd0a4fb0$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.localStorage.error(err);
        }
    }
};
$a9f1195cdd0a4fb0$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $a9f1195cdd0a4fb0$var$console.error("No valid element provided to register_event");
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = "on" + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($a9f1195cdd0a4fb0$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $a9f1195cdd0a4fb0$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$a9f1195cdd0a4fb0$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName("*");
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = " " + selector + " ";
        return (" " + elem.className + " ").replace(bad_whitespace, " ").indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$a9f1195cdd0a4fb0$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(" ");
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $a9f1195cdd0a4fb0$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, "").replace(/\s+$/, "");
            if (token.indexOf("#") > -1) {
                // Token is an ID selector
                bits = token.split("#");
                tagName = bits[0];
                var id = bits[1];
                var element = $a9f1195cdd0a4fb0$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf(".") > -1) {
                // Token contains a class selector
                bits = token.split(".");
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = "*";
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $a9f1195cdd0a4fb0$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($a9f1195cdd0a4fb0$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = "*";
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case "=":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case "~":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("\\b" + attrValue + "\\b"));
                        };
                        break;
                    case "|":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("^" + attrValue + "-?"));
                        };
                        break;
                    case "^":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case "$":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case "*":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($a9f1195cdd0a4fb0$var$_.isElement(query)) return [
            query
        ];
        else if ($a9f1195cdd0a4fb0$var$_.isObject(query) && !$a9f1195cdd0a4fb0$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
$a9f1195cdd0a4fb0$var$_.info = {
    campaignParams: function() {
        var campaign_keywords = "utm_source utm_medium utm_campaign utm_content utm_term".split(" "), kw = "", params = {};
        $a9f1195cdd0a4fb0$var$_.each(campaign_keywords, function(kwkey) {
            kw = $a9f1195cdd0a4fb0$var$_.getQueryParam($a9f1195cdd0a4fb0$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
        });
        return params;
    },
    searchEngine: function(referrer) {
        if (referrer.search("https?://(.*)google.([^/?]*)") === 0) return "google";
        else if (referrer.search("https?://(.*)bing.com") === 0) return "bing";
        else if (referrer.search("https?://(.*)yahoo.com") === 0) return "yahoo";
        else if (referrer.search("https?://(.*)duckduckgo.com") === 0) return "duckduckgo";
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $a9f1195cdd0a4fb0$var$_.info.searchEngine(referrer), param = search != "yahoo" ? "q" : "p", ret = {};
        if (search !== null) {
            ret["$search_engine"] = search;
            var keyword = $a9f1195cdd0a4fb0$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret["mp_keyword"] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ""; // vendor is undefined for at least IE9
        if (opera || $a9f1195cdd0a4fb0$var$_.includes(user_agent, " OPR/")) {
            if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Mini")) return "Opera Mini";
            return "Opera";
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "IEMobile") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
        return "Samsung Internet";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Edge") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "Edg/")) return "Microsoft Edge";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "FBIOS")) return "Facebook Mobile";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Chrome")) return "Chrome";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "CriOS")) return "Chrome iOS";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "UCWEB") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "UCBrowser")) return "UC Browser";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "FxiOS")) return "Firefox iOS";
        else if ($a9f1195cdd0a4fb0$var$_.includes(vendor, "Apple")) {
            if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Mobile")) return "Mobile Safari";
            return "Safari";
        } else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Android")) return "Android Mobile";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Konqueror")) return "Konqueror";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Firefox")) return "Firefox";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "MSIE") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "Trident/")) return "Internet Explorer";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Gecko")) return "Mozilla";
        else return "";
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $a9f1195cdd0a4fb0$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
            "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
            "Chrome": /Chrome\/(\d+(\.\d+)?)/,
            "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
            "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            "Safari": /Version\/(\d+(\.\d+)?)/,
            "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
            "Opera": /(Opera|OPR)\/(\d+(\.\d+)?)/,
            "Firefox": /Firefox\/(\d+(\.\d+)?)/,
            "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
            "Konqueror": /Konqueror:(\d+(\.\d+)?)/,
            "BlackBerry": /BlackBerry (\d+(\.\d+)?)/,
            "Android Mobile": /android\s(\d+(\.\d+)?)/,
            "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
            "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
            "Mozilla": /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $a9f1195cdd0a4fb0$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
            return "Windows";
        } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
        else if (/Android/.test(a)) return "Android";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
        else if (/Mac/i.test(a)) return "Mac OS X";
        else if (/Linux/.test(a)) return "Linux";
        else if (/CrOS/.test(a)) return "Chrome OS";
        else return "";
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
        else if (/iPad/.test(user_agent)) return "iPad";
        else if (/iPod/.test(user_agent)) return "iPod Touch";
        else if (/iPhone/.test(user_agent)) return "iPhone";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if (/Android/.test(user_agent)) return "Android";
        else return "";
    },
    referringDomain: function(referrer) {
        var split = referrer.split("/");
        if (split.length >= 3) return split[2];
        return "";
    },
    properties: function() {
        return $a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$_.strip_empty_properties({
            "$os": $a9f1195cdd0a4fb0$var$_.info.os(),
            "$browser": $a9f1195cdd0a4fb0$var$_.info.browser($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera),
            "$referrer": $a9f1195cdd0a4fb0$var$document$1.referrer,
            "$referring_domain": $a9f1195cdd0a4fb0$var$_.info.referringDomain($a9f1195cdd0a4fb0$var$document$1.referrer),
            "$device": $a9f1195cdd0a4fb0$var$_.info.device($a9f1195cdd0a4fb0$var$userAgent)
        }), {
            "$current_url": $a9f1195cdd0a4fb0$var$window$1.location.href,
            "$browser_version": $a9f1195cdd0a4fb0$var$_.info.browserVersion($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera),
            "$screen_height": $a9f1195cdd0a4fb0$var$screen.height,
            "$screen_width": $a9f1195cdd0a4fb0$var$screen.width,
            "mp_lib": "web",
            "$lib_version": $a9f1195cdd0a4fb0$var$Config.LIB_VERSION,
            "$insert_id": $a9f1195cdd0a4fb0$var$cheap_guid(),
            "time": $a9f1195cdd0a4fb0$var$_.timestamp() / 1000 // epoch time in seconds
        });
    },
    people_properties: function() {
        return $a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$_.strip_empty_properties({
            "$os": $a9f1195cdd0a4fb0$var$_.info.os(),
            "$browser": $a9f1195cdd0a4fb0$var$_.info.browser($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera)
        }), {
            "$browser_version": $a9f1195cdd0a4fb0$var$_.info.browserVersion($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera)
        });
    },
    pageviewInfo: function(page) {
        return $a9f1195cdd0a4fb0$var$_.strip_empty_properties({
            "mp_page": page,
            "mp_referrer": $a9f1195cdd0a4fb0$var$document$1.referrer,
            "mp_browser": $a9f1195cdd0a4fb0$var$_.info.browser($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera),
            "mp_platform": $a9f1195cdd0a4fb0$var$_.info.os()
        });
    }
};
var $a9f1195cdd0a4fb0$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $a9f1195cdd0a4fb0$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $a9f1195cdd0a4fb0$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $a9f1195cdd0a4fb0$var$extract_domain = function(hostname) {
    var domain_regex = $a9f1195cdd0a4fb0$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split(".");
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === "com" || tld === "org") domain_regex = $a9f1195cdd0a4fb0$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : "";
};
var $a9f1195cdd0a4fb0$var$JSONStringify = null;
var $a9f1195cdd0a4fb0$var$JSONParse = null;
if (typeof JSON !== "undefined") {
    $a9f1195cdd0a4fb0$var$JSONStringify = JSON.stringify;
    $a9f1195cdd0a4fb0$var$JSONParse = JSON.parse;
}
$a9f1195cdd0a4fb0$var$JSONStringify = $a9f1195cdd0a4fb0$var$JSONStringify || $a9f1195cdd0a4fb0$var$_.JSONEncode;
$a9f1195cdd0a4fb0$var$JSONParse = $a9f1195cdd0a4fb0$var$JSONParse || $a9f1195cdd0a4fb0$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$a9f1195cdd0a4fb0$var$_["toArray"] = $a9f1195cdd0a4fb0$var$_.toArray;
$a9f1195cdd0a4fb0$var$_["isObject"] = $a9f1195cdd0a4fb0$var$_.isObject;
$a9f1195cdd0a4fb0$var$_["JSONEncode"] = $a9f1195cdd0a4fb0$var$_.JSONEncode;
$a9f1195cdd0a4fb0$var$_["JSONDecode"] = $a9f1195cdd0a4fb0$var$_.JSONDecode;
$a9f1195cdd0a4fb0$var$_["isBlockedUA"] = $a9f1195cdd0a4fb0$var$_.isBlockedUA;
$a9f1195cdd0a4fb0$var$_["isEmptyObject"] = $a9f1195cdd0a4fb0$var$_.isEmptyObject;
$a9f1195cdd0a4fb0$var$_["info"] = $a9f1195cdd0a4fb0$var$_.info;
$a9f1195cdd0a4fb0$var$_["info"]["device"] = $a9f1195cdd0a4fb0$var$_.info.device;
$a9f1195cdd0a4fb0$var$_["info"]["browser"] = $a9f1195cdd0a4fb0$var$_.info.browser;
$a9f1195cdd0a4fb0$var$_["info"]["browserVersion"] = $a9f1195cdd0a4fb0$var$_.info.browserVersion;
$a9f1195cdd0a4fb0$var$_["info"]["properties"] = $a9f1195cdd0a4fb0$var$_.info.properties;
/**
 * DomTracker Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$DomTracker = function() {};
// interface
$a9f1195cdd0a4fb0$var$DomTracker.prototype.create_properties = function() {};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.event_handler = function() {};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.after_track_handler = function() {};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $a9f1195cdd0a4fb0$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $a9f1195cdd0a4fb0$var$_.dom_query(query);
    if (elements.length === 0) {
        $a9f1195cdd0a4fb0$var$console.error("The DOM query (" + query + ") returned 0 elements");
        return;
    }
    $a9f1195cdd0a4fb0$var$_.each(elements, function(element) {
        $a9f1195cdd0a4fb0$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config("track_links_timeout");
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $a9f1195cdd0a4fb0$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === "function") props = properties(element);
    else props = $a9f1195cdd0a4fb0$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $a9f1195cdd0a4fb0$var$LinkTracker = function() {
    this.override_event = "click";
};
$a9f1195cdd0a4fb0$var$_.inherit($a9f1195cdd0a4fb0$var$LinkTracker, $a9f1195cdd0a4fb0$var$DomTracker);
$a9f1195cdd0a4fb0$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $a9f1195cdd0a4fb0$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props["url"] = element.href;
    return props;
};
$a9f1195cdd0a4fb0$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === "_blank";
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$a9f1195cdd0a4fb0$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $a9f1195cdd0a4fb0$var$FormTracker = function() {
    this.override_event = "submit";
};
$a9f1195cdd0a4fb0$var$_.inherit($a9f1195cdd0a4fb0$var$FormTracker, $a9f1195cdd0a4fb0$var$DomTracker);
$a9f1195cdd0a4fb0$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$a9f1195cdd0a4fb0$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
// eslint-disable-line camelcase
var $a9f1195cdd0a4fb0$var$logger$2 = $a9f1195cdd0a4fb0$var$console_with_prefix("lock");
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$a9f1195cdd0a4fb0$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== "function") {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + "|" + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ":X";
    var keyY = key + ":Y";
    var keyZ = key + ":Z";
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $a9f1195cdd0a4fb0$var$logger$2.error("Timeout waiting for mutex on " + key + "; clearing lock. [" + i + "]");
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$a9f1195cdd0a4fb0$var$localStorageSupported(storage, true)) throw new Error("localStorage support dropped while acquiring lock");
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, "1");
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($a9f1195cdd0a4fb0$var$localStorageSupported(storage, true)) loop();
        else throw new Error("localStorage support check failed");
    } catch (err) {
        reportError(err);
    }
};
// eslint-disable-line camelcase
var $a9f1195cdd0a4fb0$var$logger$1 = $a9f1195cdd0a4fb0$var$console_with_prefix("batch");
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $a9f1195cdd0a4fb0$var$_.bind($a9f1195cdd0a4fb0$var$logger$1.error, $a9f1195cdd0a4fb0$var$logger$1);
    this.lock = new $a9f1195cdd0a4fb0$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        "id": $a9f1195cdd0a4fb0$var$cheap_guid(),
        "flushAfter": new Date().getTime() + flushInterval * 2,
        "payload": item
    };
    this.lock.withLock($a9f1195cdd0a4fb0$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError("Error enqueueing item", item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $a9f1195cdd0a4fb0$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $a9f1195cdd0a4fb0$var$_.each(batch, function(item) {
                idsInBatch[item["id"]] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item["flushAfter"] && !idsInBatch[item["id"]]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $a9f1195cdd0a4fb0$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $a9f1195cdd0a4fb0$var$_.each(items, function(item) {
        if (item["id"] && !idSet[item["id"]]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $a9f1195cdd0a4fb0$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $a9f1195cdd0a4fb0$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    var removeFromStorage = $a9f1195cdd0a4fb0$var$_.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $a9f1195cdd0a4fb0$var$filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);
            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item["id"] && !!idSet[item["id"]]) {
                        this.reportError("Item not removed from storage");
                        return false;
                    }
                }
            }
        } catch (err) {
            this.reportError("Error removing items", ids);
            succeeded = false;
        }
        return succeeded;
    }, this);
    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) cb(succeeded);
    }, $a9f1195cdd0a4fb0$var$_.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError("Error acquiring storage lock", err);
        if (!$a9f1195cdd0a4fb0$var$localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
            // entirely.
            try {
                this.storage.removeItem(this.storageKey);
            } catch (err) {
                this.reportError("Error clearing queue", err);
            }
        }
        if (cb) cb(succeeded);
    }, this), this.pid);
};
// internal helper for RequestQueue.updatePayloads
var $a9f1195cdd0a4fb0$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $a9f1195cdd0a4fb0$var$_.each(existingItems, function(item) {
        var id = item["id"];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item["payload"] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $a9f1195cdd0a4fb0$var$updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock($a9f1195cdd0a4fb0$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $a9f1195cdd0a4fb0$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError("Error updating items", itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $a9f1195cdd0a4fb0$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $a9f1195cdd0a4fb0$var$JSONParse(storageEntry);
            if (!$a9f1195cdd0a4fb0$var$_.isArray(storageEntry)) {
                this.reportError("Invalid storage entry:", storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError("Error retrieving queue", err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $a9f1195cdd0a4fb0$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError("Error saving queue", err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};
// eslint-disable-line camelcase
// maximum interval between request retries after exponential backoff
var $a9f1195cdd0a4fb0$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $a9f1195cdd0a4fb0$var$logger = $a9f1195cdd0a4fb0$var$console_with_prefix("batch");
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $a9f1195cdd0a4fb0$var$RequestQueue(storageKey, {
        errorReporter: $a9f1195cdd0a4fb0$var$_.bind(this.reportError, this),
        storage: options.storage
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig["batch_size"];
    this.flushInterval = this.libConfig["batch_flush_interval_ms"];
    this.stopped = !this.libConfig["batch_autostart"];
    this.consecutiveRemovalFailures = 0;
};
/**
 * Add one item to queue.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig["batch_size"];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig["batch_flush_interval_ms"]);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($a9f1195cdd0a4fb0$var$_.bind(this.flush, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $a9f1195cdd0a4fb0$var$logger.log("Flush: Request already in progress");
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig["batch_request_timeout_ms"];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        $a9f1195cdd0a4fb0$var$_.each(batch, function(item) {
            var payload = item["payload"];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) dataForRequest.push(payload);
            transformedItems[item["id"]] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $a9f1195cdd0a4fb0$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($a9f1195cdd0a4fb0$var$_.isObject(res) && res.error === "timeout" && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError("Network timeout; retrying");
                    this.flush();
                } else if ($a9f1195cdd0a4fb0$var$_.isObject(res) && res.xhr_req && (res.xhr_req["status"] >= 500 || res.xhr_req["status"] === 429 || res.error === "timeout")) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req["responseHeaders"];
                    if (headers) {
                        var retryAfter = headers["Retry-After"];
                        if (retryAfter) retryMS = parseInt(retryAfter, 10) * 1000 || retryMS;
                    }
                    retryMS = Math.min($a9f1195cdd0a4fb0$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError("Error; retry in " + retryMS + " ms");
                    this.scheduleFlush(retryMS);
                } else if ($a9f1195cdd0a4fb0$var$_.isObject(res) && res.xhr_req && res.xhr_req["status"] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError("413 response; reducing batch size to " + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError("Single-event request too large; dropping", batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) this.queue.removeItemsByID($a9f1195cdd0a4fb0$var$_.map(batch, function(item) {
                    return item["id"];
                }), $a9f1195cdd0a4fb0$var$_.bind(function(succeeded) {
                    if (succeeded) {
                        this.consecutiveRemovalFailures = 0;
                        this.flush(); // handle next batch if the queue isn't empty
                    } else {
                        this.reportError("Failed to remove items from queue");
                        if (++this.consecutiveRemovalFailures > 5) {
                            this.reportError("Too many queue failures; disabling batching system.");
                            this.stopAllBatching();
                        } else this.resetFlush();
                    }
                }, this));
            } catch (err) {
                this.reportError("Error handling API response", err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: "POST",
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = "sendBeacon";
        $a9f1195cdd0a4fb0$var$logger.log("MIXPANEL REQUEST:", dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError("Error flushing request queue", err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $a9f1195cdd0a4fb0$var$logger.error.apply($a9f1195cdd0a4fb0$var$logger.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $a9f1195cdd0a4fb0$var$logger.error(err);
    }
};
/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $a9f1195cdd0a4fb0$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = "__mp_opt_in_out_";
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$optIn(token, options) {
    $a9f1195cdd0a4fb0$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$optOut(token, options) {
    $a9f1195cdd0a4fb0$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $a9f1195cdd0a4fb0$var$hasOptedIn(token, options) {
    return $a9f1195cdd0a4fb0$var$_getStorageValue(token, options) === "1";
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $a9f1195cdd0a4fb0$var$hasOptedOut(token, options) {
    if ($a9f1195cdd0a4fb0$var$_hasDoNotTrackFlagOn(options)) {
        $a9f1195cdd0a4fb0$var$console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $a9f1195cdd0a4fb0$var$_getStorageValue(token, options) === "0";
    if (optedOut) $a9f1195cdd0a4fb0$var$console.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.");
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(method) {
    return $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(method) {
    return $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(method) {
    return $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$clearOptInOut(token, options) {
    options = options || {};
    $a9f1195cdd0a4fb0$var$_getStorage(options).remove($a9f1195cdd0a4fb0$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $a9f1195cdd0a4fb0$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === "localStorage" ? $a9f1195cdd0a4fb0$var$_.localStorage : $a9f1195cdd0a4fb0$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $a9f1195cdd0a4fb0$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $a9f1195cdd0a4fb0$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $a9f1195cdd0a4fb0$var$_getStorageValue(token, options) {
    return $a9f1195cdd0a4fb0$var$_getStorage(options).get($a9f1195cdd0a4fb0$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $a9f1195cdd0a4fb0$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win = options && options.window || $a9f1195cdd0a4fb0$var$window$1;
    var nav = win["navigator"] || {};
    var hasDntOn = false;
    $a9f1195cdd0a4fb0$var$_.each([
        nav["doNotTrack"],
        nav["msDoNotTrack"],
        win["doNotTrack"]
    ], function(dntValue) {
        if ($a9f1195cdd0a4fb0$var$_.includes([
            true,
            1,
            "1",
            "yes"
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$_optInOut(optValue, token, options) {
    if (!$a9f1195cdd0a4fb0$var$_.isString(token) || !token.length) {
        $a9f1195cdd0a4fb0$var$console.error("gdpr." + (optValue ? "optIn" : "optOut") + " called with an invalid token");
        return;
    }
    options = options || {};
    $a9f1195cdd0a4fb0$var$_getStorage(options).set($a9f1195cdd0a4fb0$var$_getStorageKey(token, options), optValue ? 1 : 0, $a9f1195cdd0a4fb0$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || "$opt_in", options.trackProperties, {
        "send_immediately": true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, "token");
            var ignoreDnt = getConfigValue.call(this, "ignore_dnt");
            var persistenceType = getConfigValue.call(this, "opt_out_tracking_persistence_type");
            var persistencePrefix = getConfigValue.call(this, "opt_out_tracking_cookie_prefix");
            var win = getConfigValue.call(this, "window"); // used to override window during browser tests
            if (token) optedOut = $a9f1195cdd0a4fb0$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $a9f1195cdd0a4fb0$var$console.error("Unexpected error when checking tracking opt-out status: " + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === "function") callback(0);
        return;
    };
}
/** @const */ var $a9f1195cdd0a4fb0$var$SET_ACTION = "$set";
/** @const */ var $a9f1195cdd0a4fb0$var$SET_ONCE_ACTION = "$set_once";
/** @const */ var $a9f1195cdd0a4fb0$var$UNSET_ACTION = "$unset";
/** @const */ var $a9f1195cdd0a4fb0$var$ADD_ACTION = "$add";
/** @const */ var $a9f1195cdd0a4fb0$var$APPEND_ACTION = "$append";
/** @const */ var $a9f1195cdd0a4fb0$var$UNION_ACTION = "$union";
/** @const */ var $a9f1195cdd0a4fb0$var$REMOVE_ACTION = "$remove";
/** @const */ var $a9f1195cdd0a4fb0$var$DELETE_ACTION = "$delete";
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $a9f1195cdd0a4fb0$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) $a9f1195cdd0a4fb0$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$a9f1195cdd0a4fb0$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$a9f1195cdd0a4fb0$var$_.isArray(prop)) prop = [
            prop
        ];
        $a9f1195cdd0a4fb0$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$a9f1195cdd0a4fb0$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) $a9f1195cdd0a4fb0$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$a9f1195cdd0a4fb0$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) $a9f1195cdd0a4fb0$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $a9f1195cdd0a4fb0$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $a9f1195cdd0a4fb0$var$_.isArray(values) ? values : [
            values
        ];
        data[$a9f1195cdd0a4fb0$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) $a9f1195cdd0a4fb0$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$a9f1195cdd0a4fb0$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) $a9f1195cdd0a4fb0$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$a9f1195cdd0a4fb0$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$a9f1195cdd0a4fb0$var$DELETE_ACTION] = "";
        return data;
    }
};
/**
 * Mixpanel Group Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelGroup = function() {};
$a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$MixpanelGroup.prototype, $a9f1195cdd0a4fb0$var$apiActions);
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set_once = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.unset = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.union = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["delete"] = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.remove = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data["$group_key"] = this._group_key;
    data["$group_id"] = this._group_id;
    data["$token"] = this._get_config("token");
    var date_encoded_data = $a9f1195cdd0a4fb0$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: "groups",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/groups/",
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === "$group_key" || prop === "$group_id";
};
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
// MixpanelGroup Exports
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["remove"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.remove;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["set"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["set_once"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set_once;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["union"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.union;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["unset"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.unset;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["toString"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.toString;
/**
 * Mixpanel People Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelPeople = function() {};
$a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$MixpanelPeople.prototype, $a9f1195cdd0a4fb0$var$apiActions);
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config("save_referrer")) this._mixpanel["persistence"].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$a9f1195cdd0a4fb0$var$SET_ACTION] = $a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$_.info.people_properties(), this._mixpanel["persistence"].get_referrer_info(), data[$a9f1195cdd0a4fb0$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set_once = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.unset = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.increment = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) {
        $a9f1195cdd0a4fb0$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $a9f1195cdd0a4fb0$var$console.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($a9f1195cdd0a4fb0$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$a9f1195cdd0a4fb0$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.append = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.remove = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.union = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
* Record that you have charged the current user a certain amount
* of money. Charges recorded with track_charge() will appear in the
* Mixpanel revenue report.
*
* ### Usage:
*
*     // charge a user $50
*     mixpanel.people.track_charge(50);
*
*     // charge a user $30.50 on the 2nd of january
*     mixpanel.people.track_charge(30.50, {
*         '$time': new Date('jan 1 2012')
*     });
*
* @param {Number} amount The amount of money charged to the current user
* @param {Object} [properties] An associative array of properties associated with the charge
* @param {Function} [callback] If provided, the callback will be called when the server responds
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.track_charge = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$a9f1195cdd0a4fb0$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $a9f1195cdd0a4fb0$var$console.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
            return;
        }
    }
    return this.append("$transactions", $a9f1195cdd0a4fb0$var$_.extend({
        "$amount": amount
    }, properties), callback);
});
/*
* Permanently clear all revenue report transactions from the
* current user's people analytics profile.
*
* ### Usage:
*
*     mixpanel.people.clear_charges();
*
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set("$transactions", [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $a9f1195cdd0a4fb0$var$console.error("mixpanel.people.delete_user() requires you to call identify() first");
        return;
    }
    var data = {
        "$delete": this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + ".people";
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data["$token"] = this._get_config("token");
    data["$distinct_id"] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property("$device_id");
    var user_id = this._mixpanel.get_property("$user_id");
    var had_persisted_distinct_id = this._mixpanel.get_property("$had_persisted_distinct_id");
    if (device_id) data["$device_id"] = device_id;
    if (user_id) data["$user_id"] = user_id;
    if (had_persisted_distinct_id) data["$had_persisted_distinct_id"] = had_persisted_distinct_id;
    var date_encoded_data = $a9f1195cdd0a4fb0$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$a9f1195cdd0a4fb0$var$_.isUndefined(callback)) {
            if (this._get_config("verbose")) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $a9f1195cdd0a4fb0$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: "people",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/engage/",
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($a9f1195cdd0a4fb0$var$SET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$SET_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$UNSET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$ADD_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$ADD_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$APPEND_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$REMOVE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$UNION_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$UNION_ACTION, data);
    else $a9f1195cdd0a4fb0$var$console.error("Invalid call to _enqueue():", data);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $a9f1195cdd0a4fb0$var$_.extend({}, this._mixpanel["persistence"]._get_queue(action));
    var action_params = queued_data;
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(queued_data) && $a9f1195cdd0a4fb0$var$_.isObject(queued_data) && !$a9f1195cdd0a4fb0$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel["persistence"]._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue(action, queued_data);
            if (!$a9f1195cdd0a4fb0$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    var $append_queue = this._mixpanel["persistence"]._get_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION);
    var $remove_queue = this._mixpanel["persistence"]._get_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $a9f1195cdd0a4fb0$var$_.keys(queue);
    });
    this._flush_one_queue($a9f1195cdd0a4fb0$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined($append_queue) && $a9f1195cdd0a4fb0$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, $append_item);
            if (!$a9f1195cdd0a4fb0$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_item = $append_queue.pop();
            if (!$a9f1195cdd0a4fb0$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
        // Save the shortened append queue
        _this._mixpanel["persistence"].save();
    }
    // same for $remove
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined($remove_queue) && $a9f1195cdd0a4fb0$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION, $remove_item);
            if (!$a9f1195cdd0a4fb0$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_item = $remove_queue.pop();
            if (!$a9f1195cdd0a4fb0$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
        _this._mixpanel["persistence"].save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === "$distinct_id" || prop === "$token" || prop === "$device_id" || prop === "$user_id" || prop === "$had_persisted_distinct_id";
};
// MixpanelPeople Exports
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["set"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["set_once"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set_once;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["unset"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.unset;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["increment"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.increment;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["append"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.append;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["remove"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.remove;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["union"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.union;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["track_charge"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.track_charge;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["clear_charges"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.clear_charges;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["delete_user"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.delete_user;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["toString"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.toString;
/*
 * Constants
 */ /** @const */ var $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY = "__mps";
/** @const */ var $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY = "__mpso";
/** @const */ var $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY = "__mpus";
/** @const */ var $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY = "__mpa";
/** @const */ var $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY = "__mpap";
/** @const */ var $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY = "__mpr";
/** @const */ var $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY = "__mpu";
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $a9f1195cdd0a4fb0$var$PEOPLE_DISTINCT_ID_KEY = "$people_distinct_id";
/** @const */ var $a9f1195cdd0a4fb0$var$ALIAS_ID_KEY = "__alias";
/** @const */ var $a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY = "__timers";
/** @const */ var $a9f1195cdd0a4fb0$var$RESERVED_PROPERTIES = [
    $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$PEOPLE_DISTINCT_ID_KEY,
    $a9f1195cdd0a4fb0$var$ALIAS_ID_KEY,
    $a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelPersistence = function(config) {
    this["props"] = {};
    this.campaign_params_saved = false;
    if (config["persistence_name"]) this.name = "mp_" + config["persistence_name"];
    else this.name = "mp_" + config["token"] + "_mixpanel";
    var storage_type = config["persistence"];
    if (storage_type !== "cookie" && storage_type !== "localStorage") {
        $a9f1195cdd0a4fb0$var$console.critical("Unknown persistence type " + storage_type + "; falling back to cookie");
        storage_type = config["persistence"] = "cookie";
    }
    if (storage_type === "localStorage" && $a9f1195cdd0a4fb0$var$_.localStorage.is_supported()) this.storage = $a9f1195cdd0a4fb0$var$_.localStorage;
    else this.storage = $a9f1195cdd0a4fb0$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    // Filter out reserved properties
    $a9f1195cdd0a4fb0$var$_.each(this["props"], function(v, k) {
        if (!$a9f1195cdd0a4fb0$var$_.include($a9f1195cdd0a4fb0$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this["props"] = $a9f1195cdd0a4fb0$var$_.extend({}, entry);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config["upgrade"], old_cookie_name, old_cookie;
    if (upgrade_from_old_lib) {
        old_cookie_name = "mp_super_properties";
        // Case where they had a custom cookie name before.
        if (typeof upgrade_from_old_lib === "string") old_cookie_name = upgrade_from_old_lib;
        old_cookie = this.storage.parse(old_cookie_name);
        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);
        if (old_cookie) this["props"] = $a9f1195cdd0a4fb0$var$_.extend(this["props"], old_cookie["all"], old_cookie["events"]);
    }
    if (!config["cookie_name"] && config["name"] !== "mixpanel") {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = "mp_" + config["token"] + "_" + config["name"];
        old_cookie = this.storage.parse(old_cookie_name);
        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);
            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }
    if (this.storage === $a9f1195cdd0a4fb0$var$_.localStorage) {
        old_cookie = $a9f1195cdd0a4fb0$var$_.cookie.parse(this.name);
        $a9f1195cdd0a4fb0$var$_.cookie.remove(this.name);
        $a9f1195cdd0a4fb0$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $a9f1195cdd0a4fb0$var$_.JSONEncode(this["props"]), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this["props"] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(props)) {
        if (typeof default_value === "undefined") default_value = "None";
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        $a9f1195cdd0a4fb0$var$_.each(props, function(val, prop) {
            if (!this["props"].hasOwnProperty(prop) || this["props"][prop] === default_value) this["props"][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(props)) {
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        $a9f1195cdd0a4fb0$var$_.extend(this["props"], props);
        this.save();
        return true;
    }
    return false;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.unregister = function(prop) {
    if (prop in this["props"]) {
        delete this["props"][prop];
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_campaign_params = function() {
    if (!this.campaign_params_saved) {
        this.register_once($a9f1195cdd0a4fb0$var$_.info.campaignParams());
        this.campaign_params_saved = true;
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($a9f1195cdd0a4fb0$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        "$initial_referrer": referrer || "$direct",
        "$initial_referring_domain": $a9f1195cdd0a4fb0$var$_.info.referringDomain(referrer) || "$direct"
    }, "");
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $a9f1195cdd0a4fb0$var$_.strip_empty_properties({
        "$initial_referrer": this["props"]["$initial_referrer"],
        "$initial_referring_domain": this["props"]["$initial_referring_domain"]
    });
};
// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.safe_merge = function(props) {
    $a9f1195cdd0a4fb0$var$_.each(this["props"], function(val, prop) {
        if (!(prop in props)) props[prop] = val;
    });
    return props;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config["cookie_expiration"];
    this.set_disabled(config["disable_persistence"]);
    this.set_cookie_domain(config["cookie_domain"]);
    this.set_cross_site(config["cross_site_cookie"]);
    this.set_cross_subdomain(config["cross_subdomain_cookie"]);
    this.set_secure(config["secure_cookie"]);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$SET_ACTION), set_once_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION), add_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$ADD_ACTION), union_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$UNION_ACTION), remove_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, []);
    if (q_key === $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $a9f1195cdd0a4fb0$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $a9f1195cdd0a4fb0$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY) $a9f1195cdd0a4fb0$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $a9f1195cdd0a4fb0$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $a9f1195cdd0a4fb0$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY) {
        $a9f1195cdd0a4fb0$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY) {
        $a9f1195cdd0a4fb0$var$_.each(q_data, function(v, k) {
            if ($a9f1195cdd0a4fb0$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    }
    $a9f1195cdd0a4fb0$var$console.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):");
    $a9f1195cdd0a4fb0$var$console.log(data);
    this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this._get_queue(queue);
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(q)) {
        $a9f1195cdd0a4fb0$var$_.each(data, function(v, k) {
            if (queue === $a9f1195cdd0a4fb0$var$APPEND_ACTION || queue === $a9f1195cdd0a4fb0$var$REMOVE_ACTION) // list actions: only remove if both k+v match
            // e.g. remove should not override append in a case like
            // append({foo: 'bar'}); remove({foo: 'qux'})
            $a9f1195cdd0a4fb0$var$_.each(q, function(queued_action) {
                if (queued_action[k] === v) delete queued_action[k];
            });
            else delete q[k];
        }, this);
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $a9f1195cdd0a4fb0$var$SET_ACTION) return $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$SET_ONCE_ACTION) return $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$UNSET_ACTION) return $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$ADD_ACTION) return $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$APPEND_ACTION) return $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$REMOVE_ACTION) return $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$UNION_ACTION) return $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY;
    else $a9f1195cdd0a4fb0$var$console.error("Invalid queue:", queue);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._get_queue = function(queue) {
    return this["props"][this._get_queue_key(queue)];
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $a9f1195cdd0a4fb0$var$_.isUndefined(default_val) ? {} : default_val;
    return this["props"][key] || (this["props"][key] = default_val);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(timestamp)) {
        delete this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $a9f1195cdd0a4fb0$var$init_type; // MODULE or SNIPPET loader
var $a9f1195cdd0a4fb0$var$mixpanel_master; // main mixpanel instance / object
var $a9f1195cdd0a4fb0$var$INIT_MODULE = 0;
var $a9f1195cdd0a4fb0$var$INIT_SNIPPET = 1;
var $a9f1195cdd0a4fb0$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $a9f1195cdd0a4fb0$var$NOOP_FUNC = function() {};
/** @const */ var $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME = "mixpanel";
/** @const */ var $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_BASE64 = "base64";
/** @const */ var $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_JSON = "json";
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $a9f1195cdd0a4fb0$var$USE_XHR = $a9f1195cdd0a4fb0$var$window$1.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $a9f1195cdd0a4fb0$var$ENQUEUE_REQUESTS = !$a9f1195cdd0a4fb0$var$USE_XHR && $a9f1195cdd0a4fb0$var$userAgent.indexOf("MSIE") === -1 && $a9f1195cdd0a4fb0$var$userAgent.indexOf("Mozilla") === -1;
// save reference to navigator.sendBeacon so it can be minified
var $a9f1195cdd0a4fb0$var$sendBeacon = null;
if ($a9f1195cdd0a4fb0$var$navigator["sendBeacon"]) $a9f1195cdd0a4fb0$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $a9f1195cdd0a4fb0$var$navigator["sendBeacon"].apply($a9f1195cdd0a4fb0$var$navigator, arguments);
};
/*
 * Module-level globals
 */ var $a9f1195cdd0a4fb0$var$DEFAULT_CONFIG = {
    "api_host": "https://api-js.mixpanel.com",
    "api_method": "POST",
    "api_transport": "XHR",
    "api_payload_format": $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_BASE64,
    "app_host": "https://mixpanel.com",
    "cdn": "https://cdn.mxpnl.com",
    "cross_site_cookie": false,
    "cross_subdomain_cookie": true,
    "error_reporter": $a9f1195cdd0a4fb0$var$NOOP_FUNC,
    "persistence": "cookie",
    "persistence_name": "",
    "cookie_domain": "",
    "cookie_name": "",
    "loaded": $a9f1195cdd0a4fb0$var$NOOP_FUNC,
    "store_google": true,
    "save_referrer": true,
    "test": false,
    "verbose": false,
    "img": false,
    "debug": false,
    "track_links_timeout": 300,
    "cookie_expiration": 365,
    "upgrade": false,
    "disable_persistence": false,
    "disable_cookie": false,
    "secure_cookie": false,
    "ip": true,
    "opt_out_tracking_by_default": false,
    "opt_out_persistence_by_default": false,
    "opt_out_tracking_persistence_type": "localStorage",
    "opt_out_tracking_cookie_prefix": null,
    "property_blacklist": [],
    "xhr_headers": {},
    "ignore_dnt": false,
    "batch_requests": true,
    "batch_size": 50,
    "batch_flush_interval_ms": 5000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true,
    "hooks": {}
};
var $a9f1195cdd0a4fb0$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $a9f1195cdd0a4fb0$var$create_mplib = function(token, config, name) {
    var instance, target = name === $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME ? $a9f1195cdd0a4fb0$var$mixpanel_master : $a9f1195cdd0a4fb0$var$mixpanel_master[name];
    if (target && $a9f1195cdd0a4fb0$var$init_type === $a9f1195cdd0a4fb0$var$INIT_MODULE) instance = target;
    else {
        if (target && !$a9f1195cdd0a4fb0$var$_.isArray(target)) {
            $a9f1195cdd0a4fb0$var$console.error("You have already initialized " + name);
            return;
        }
        instance = new $a9f1195cdd0a4fb0$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance["people"] = new $a9f1195cdd0a4fb0$var$MixpanelPeople();
    instance["people"]._init(instance);
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $a9f1195cdd0a4fb0$var$Config.DEBUG = $a9f1195cdd0a4fb0$var$Config.DEBUG || instance.get_config("debug");
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(target) && $a9f1195cdd0a4fb0$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance["people"], target["people"]);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(name)) {
        this.report_error("You must name your new library: init(token, config, name)");
        return;
    }
    if (name === $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME) {
        this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
        return;
    }
    var instance = $a9f1195cdd0a4fb0$var$create_mplib(token, config, name);
    $a9f1195cdd0a4fb0$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this["__loaded"] = true;
    this["config"] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!("api_payload_format" in config)) {
        var api_host = config["api_host"] || $a9f1195cdd0a4fb0$var$DEFAULT_CONFIG["api_host"];
        if (api_host.match(/\.mixpanel\.com$/)) variable_features["api_payload_format"] = $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$DEFAULT_CONFIG, variable_features, config, {
        "name": name,
        "token": token,
        "callback_fn": (name === $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME ? name : $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME + "." + name) + "._jsc"
    }));
    this["_jsc"] = $a9f1195cdd0a4fb0$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        "disable_all_events": false,
        "identify_called": false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config("batch_requests");
    if (this._batch_requests) {
        if (!$a9f1195cdd0a4fb0$var$_.localStorage.is_supported(true) || !$a9f1195cdd0a4fb0$var$USE_XHR) {
            this._batch_requests = false;
            $a9f1195cdd0a4fb0$var$console.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
        } else {
            this.init_batchers();
            if ($a9f1195cdd0a4fb0$var$sendBeacon && $a9f1195cdd0a4fb0$var$window$1.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $a9f1195cdd0a4fb0$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $a9f1195cdd0a4fb0$var$window$1.addEventListener("pagehide", function(ev) {
                    if (ev["persisted"]) flush_on_unload();
                });
                $a9f1195cdd0a4fb0$var$window$1.addEventListener("visibilitychange", function() {
                    if ($a9f1195cdd0a4fb0$var$document$1["visibilityState"] === "hidden") flush_on_unload();
                });
            }
        }
    }
    this["persistence"] = this["cookie"] = new $a9f1195cdd0a4fb0$var$MixpanelPersistence(this["config"]);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $a9f1195cdd0a4fb0$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        "distinct_id": uuid,
        "$device_id": uuid
    }, "");
};
// Private methods
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._loaded = function() {
    this.get_config("loaded")(this);
    this._set_default_superprops();
};
// update persistence with info on referrer, UTM params, etc
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._set_default_superprops = function() {
    this["persistence"].update_search_keyword($a9f1195cdd0a4fb0$var$document$1.referrer);
    if (this.get_config("store_google")) this["persistence"].update_campaign_params();
    if (this.get_config("save_referrer")) this["persistence"].update_referrer_info($a9f1195cdd0a4fb0$var$document$1.referrer);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._dom_loaded = function() {
    $a9f1195cdd0a4fb0$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $a9f1195cdd0a4fb0$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config("img")) {
        this.report_error("You can't use DOM tracking functions with img = true.");
        return false;
    }
    if (!$a9f1195cdd0a4fb0$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(callback)) return null;
    if ($a9f1195cdd0a4fb0$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this["_jsc"];
        var randomized_cb = "" + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config("callback_fn") + "[" + randomized_cb + "]";
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($a9f1195cdd0a4fb0$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config("api_method"),
        transport: this.get_config("api_transport"),
        verbose: this.get_config("verbose")
    };
    var body_data = null;
    if (!callback && ($a9f1195cdd0a4fb0$var$_.isFunction(options) || typeof options === "string")) {
        callback = options;
        options = null;
    }
    options = $a9f1195cdd0a4fb0$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$a9f1195cdd0a4fb0$var$USE_XHR) options.method = "GET";
    var use_post = options.method === "POST";
    var use_sendBeacon = $a9f1195cdd0a4fb0$var$sendBeacon && use_post && options.transport.toLowerCase() === "sendbeacon";
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data["verbose"]) verbose_mode = true;
    if (this.get_config("test")) data["test"] = 1;
    if (verbose_mode) data["verbose"] = 1;
    if (this.get_config("img")) data["img"] = 1;
    if (!$a9f1195cdd0a4fb0$var$USE_XHR) {
        if (callback) data["callback"] = callback;
        else if (verbose_mode || this.get_config("test")) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data["callback"] = "(function(){})";
    }
    data["ip"] = this.get_config("ip") ? 1 : 0;
    data["_"] = new Date().getTime().toString();
    if (use_post) {
        body_data = "data=" + encodeURIComponent(data["data"]);
        delete data["data"];
    }
    url += "?" + $a9f1195cdd0a4fb0$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ("img" in data) {
        var img = $a9f1195cdd0a4fb0$var$document$1.createElement("img");
        img.src = url;
        $a9f1195cdd0a4fb0$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $a9f1195cdd0a4fb0$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($a9f1195cdd0a4fb0$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config("xhr_headers");
        if (use_post) headers["Content-Type"] = "application/x-www-form-urlencoded";
        $a9f1195cdd0a4fb0$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== "undefined") {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $a9f1195cdd0a4fb0$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = "timeout";
                    else error = "Bad HTTP status: " + req.status + " " + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) callback({
                            status: 0,
                            error: error,
                            xhr_req: req
                        });
                        else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $a9f1195cdd0a4fb0$var$document$1.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $a9f1195cdd0a4fb0$var$document$1.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $a9f1195cdd0a4fb0$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($a9f1195cdd0a4fb0$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === "function") item.call(this);
            else if ($a9f1195cdd0a4fb0$var$_.isArray(item) && fn_name === "alias") alias_calls.push(item);
            else if ($a9f1195cdd0a4fb0$var$_.isArray(item) && fn_name.indexOf("track") !== -1 && typeof this[fn_name] === "function") tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $a9f1195cdd0a4fb0$var$_.each(calls, function(item) {
            if ($a9f1195cdd0a4fb0$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $a9f1195cdd0a4fb0$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.init_batchers = function() {
    var token = this.get_config("token");
    if (!this.are_batchers_initialized()) {
        var batcher_for = $a9f1195cdd0a4fb0$var$_.bind(function(attrs) {
            return new $a9f1195cdd0a4fb0$var$RequestBatcher("__mpq_" + token + attrs.queue_suffix, {
                libConfig: this["config"],
                sendRequestFunc: $a9f1195cdd0a4fb0$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config("api_host") + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $a9f1195cdd0a4fb0$var$_.bind(function(item) {
                    return this._run_hook("before_send_" + attrs.type, item);
                }, this),
                errorReporter: this.get_config("error_reporter"),
                stopAllBatchingFunc: $a9f1195cdd0a4fb0$var$_.bind(this.stop_batch_senders, this)
            });
        }, this);
        this.request_batchers = {
            events: batcher_for({
                type: "events",
                endpoint: "/track/",
                queue_suffix: "_ev"
            }),
            people: batcher_for({
                type: "people",
                endpoint: "/engage/",
                queue_suffix: "_pp"
            }),
            groups: batcher_for({
                type: "groups",
                endpoint: "/groups/",
                queue_suffix: "_gr"
            })
        };
    }
    if (this.get_config("batch_autostart")) this.start_batch_senders();
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.start_batch_senders = function() {
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === "undefined") this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $a9f1195cdd0a4fb0$var$_.JSONEncode(data);
    if (this.get_config("api_payload_format") === $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_BASE64) encoded_data = $a9f1195cdd0a4fb0$var$_.base64Encode(encoded_data);
    return {
        "data": encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $a9f1195cdd0a4fb0$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $a9f1195cdd0a4fb0$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $a9f1195cdd0a4fb0$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook("before_send_" + options.type, truncated_data);
        if (truncated_data) {
            $a9f1195cdd0a4fb0$var$console.log("MIXPANEL REQUEST:");
            $a9f1195cdd0a4fb0$var$console.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === "function") {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options["transport"]; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options["send_immediately"];
    if (typeof callback !== "function") callback = $a9f1195cdd0a4fb0$var$NOOP_FUNC;
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.track");
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = properties || {};
    properties["token"] = this.get_config("token");
    // set $duration if time_event was previously called for this event
    var start_timestamp = this["persistence"].remove_event_timer(event_name);
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties["$duration"] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$_.info.properties(), this["persistence"].properties(), this.unpersisted_superprops, properties);
    var property_blacklist = this.get_config("property_blacklist");
    if ($a9f1195cdd0a4fb0$var$_.isArray(property_blacklist)) $a9f1195cdd0a4fb0$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error("Invalid value for property_blacklist config: " + property_blacklist);
    var data = {
        "event": event_name,
        "properties": properties
    };
    var ret = this._track_or_batch({
        type: "events",
        data: data,
        endpoint: this.get_config("api_host") + "/track/",
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_group = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$a9f1195cdd0a4fb0$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this["people"].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.add_group = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    if (old_values === undefined) {
        var prop = {};
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        this.register(prop);
    }
    return this["people"].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.remove_group = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this["people"].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_with_groups = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $a9f1195cdd0a4fb0$var$_.extend({}, properties || {});
    $a9f1195cdd0a4fb0$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + "_" + JSON.stringify(group_id);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $a9f1195cdd0a4fb0$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track mp_page_view event. This is now ignored by the server.
 *
 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
 * @deprecated
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_pageview = function(page) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(page)) page = $a9f1195cdd0a4fb0$var$document$1.location.href;
    this.track("mp_page_view", $a9f1195cdd0a4fb0$var$_.info.pageviewInfo(page));
};
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $a9f1195cdd0a4fb0$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $a9f1195cdd0a4fb0$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.time_event");
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this["persistence"].set_event_timer(event_name, new Date().getTime());
};
var $a9f1195cdd0a4fb0$var$REGISTER_DEFAULTS = {
    "persistent": true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $a9f1195cdd0a4fb0$var$options_for_register = function(days_or_options) {
    var options;
    if ($a9f1195cdd0a4fb0$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$a9f1195cdd0a4fb0$var$_.isUndefined(days_or_options)) options = {
        "days": days_or_options
    };
    else options = {};
    return $a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $a9f1195cdd0a4fb0$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register(props, options["days"]);
    else $a9f1195cdd0a4fb0$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $a9f1195cdd0a4fb0$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register_once(props, default_value, options["days"]);
    else {
        if (typeof default_value === "undefined") default_value = "None";
        $a9f1195cdd0a4fb0$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $a9f1195cdd0a4fb0$var$options_for_register(options);
    if (options["persistent"]) this["persistence"].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    this.register({
        "$user_id": new_distinct_id
    });
    if (!this.get_property("$device_id")) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            "$had_persisted_distinct_id": true,
            "$device_id": device_id
        }, "");
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($a9f1195cdd0a4fb0$var$ALIAS_ID_KEY)) {
        this.unregister($a9f1195cdd0a4fb0$var$ALIAS_ID_KEY);
        this.register({
            "distinct_id": new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this["people"]._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track("$identify", {
        "distinct_id": new_distinct_id,
        "$anon_distinct_id": previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.reset = function() {
    this["persistence"].clear();
    this._flags.identify_called = false;
    var uuid = $a9f1195cdd0a4fb0$var$_.UUID();
    this.register_once({
        "distinct_id": uuid,
        "$device_id": uuid
    }, "");
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property("distinct_id");
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($a9f1195cdd0a4fb0$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error("Attempting to create alias for existing People user - aborting.");
        return -2;
    }
    var _this = this;
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($a9f1195cdd0a4fb0$var$ALIAS_ID_KEY, alias);
        return this.track("$create_alias", {
            "alias": alias,
            "distinct_id": original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error("alias matches current distinct_id - skipping api call.");
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single("mp_name_tag", name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // turn on request-batching/queueing/retry
 *       batch_requests: false,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_config = function(config) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(config)) {
        $a9f1195cdd0a4fb0$var$_.extend(this["config"], config);
        var new_batch_size = config["batch_size"];
        if (new_batch_size) $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config("persistence_name")) this["config"]["persistence_name"] = this["config"]["cookie_name"];
        if (!this.get_config("disable_persistence")) this["config"]["disable_persistence"] = this["config"]["disable_cookie"];
        if (this["persistence"]) this["persistence"].update_config(this["config"]);
        $a9f1195cdd0a4fb0$var$Config.DEBUG = $a9f1195cdd0a4fb0$var$Config.DEBUG || this.get_config("debug");
    }
};
/**
 * returns the current config object for the library.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this["config"][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this["config"]["hooks"][hook_name] || $a9f1195cdd0a4fb0$var$IDENTITY_FUNC).apply(this, $a9f1195cdd0a4fb0$var$slice.call(arguments, 1));
    if (typeof ret === "undefined") {
        this.report_error(hook_name + " hook did not return a value");
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this["persistence"]["props"][property_name];
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config("name");
    if (name !== $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME) name = $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME + "." + name;
    return name;
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $a9f1195cdd0a4fb0$var$_.isBlockedUA($a9f1195cdd0a4fb0$var$userAgent) || this._flags.disable_all_events || $a9f1195cdd0a4fb0$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $a9f1195cdd0a4fb0$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            "persistence_type": "cookie"
        })) this.opt_in_tracking({
            "enable_persistence": false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            "persistence_type": "cookie"
        })) this.opt_out_tracking({
            "clear_persistence": false
        });
        this.clear_opt_in_out_tracking({
            "persistence_type": "cookie",
            "enable_persistence": false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        "clear_persistence": true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || $a9f1195cdd0a4fb0$var$_.cookie.get("mp_optout"))) {
        $a9f1195cdd0a4fb0$var$_.cookie.remove("mp_optout");
        this.opt_out_tracking({
            "clear_persistence": this.get_config("opt_out_persistence_by_default")
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options["clear_persistence"]) disabled = true;
    else if (options && options["enable_persistence"]) disabled = false;
    else return;
    if (!this.get_config("disable_persistence") && this["persistence"].disabled !== disabled) this["persistence"].set_disabled(disabled);
    if (disabled) $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
        batcher.clear();
    });
};
// call a base gdpr function after constructing the appropriate token and options args
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "track": $a9f1195cdd0a4fb0$var$_.bind(this.track, this),
        "persistence_type": this.get_config("opt_out_tracking_persistence_type"),
        "cookie_prefix": this.get_config("opt_out_tracking_cookie_prefix"),
        "cookie_expiration": this.get_config("cookie_expiration"),
        "cross_site_cookie": this.get_config("cross_site_cookie"),
        "cross_subdomain_cookie": this.get_config("cross_subdomain_cookie"),
        "cookie_domain": this.get_config("cookie_domain"),
        "secure_cookie": this.get_config("secure_cookie"),
        "ignore_dnt": this.get_config("ignore_dnt")
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$a9f1195cdd0a4fb0$var$_.localStorage.is_supported()) options["persistence_type"] = "cookie";
    return func(this.get_config("token"), {
        track: options["track"],
        trackEventName: options["track_event_name"],
        trackProperties: options["track_properties"],
        persistenceType: options["persistence_type"],
        persistencePrefix: options["cookie_prefix"],
        cookieDomain: options["cookie_domain"],
        cookieExpiration: options["cookie_expiration"],
        crossSiteCookie: options["cross_site_cookie"],
        crossSubdomainCookie: options["cross_subdomain_cookie"],
        secureCookie: options["secure_cookie"],
        ignoreDnt: options["ignore_dnt"]
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($a9f1195cdd0a4fb0$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "clear_persistence": true,
        "delete_user": true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options["delete_user"] && this["people"] && this["people"]._identify_called()) {
        this["people"].delete_user();
        this["people"].clear_charges();
    }
    this._gdpr_call_func($a9f1195cdd0a4fb0$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($a9f1195cdd0a4fb0$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($a9f1195cdd0a4fb0$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($a9f1195cdd0a4fb0$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $a9f1195cdd0a4fb0$var$console.error.apply($a9f1195cdd0a4fb0$var$console.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $a9f1195cdd0a4fb0$var$console.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["init"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.init;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["reset"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.reset;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["disable"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.disable;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["time_event"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.time_event;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_links"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_links;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_forms"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_forms;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_pageview"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_pageview;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["register"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["register_once"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register_once;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["unregister"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.unregister;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["identify"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.identify;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["alias"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.alias;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["name_tag"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.name_tag;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["set_config"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_config;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_config"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_config;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_property"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_property;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_distinct_id"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_distinct_id;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["toString"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.toString;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["opt_out_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_out_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["opt_in_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_in_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["has_opted_out_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_out_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["has_opted_in_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_in_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["clear_opt_in_out_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["set_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["add_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.add_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["remove_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.remove_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_with_groups"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_with_groups;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["start_batch_senders"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.start_batch_senders;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["stop_batch_senders"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.stop_batch_senders;
// MixpanelPersistence Exports
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["properties"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.properties;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["update_search_keyword"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_search_keyword;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["update_referrer_info"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_referrer_info;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["get_cross_subdomain"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.get_cross_subdomain;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["clear"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.clear;
var $a9f1195cdd0a4fb0$var$instances = {};
var $a9f1195cdd0a4fb0$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $a9f1195cdd0a4fb0$var$_.each($a9f1195cdd0a4fb0$var$instances, function(instance, name) {
        if (name !== $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME) $a9f1195cdd0a4fb0$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $a9f1195cdd0a4fb0$var$mixpanel_master["_"] = $a9f1195cdd0a4fb0$var$_;
};
var $a9f1195cdd0a4fb0$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $a9f1195cdd0a4fb0$var$mixpanel_master["init"] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$a9f1195cdd0a4fb0$var$mixpanel_master[name]) {
                $a9f1195cdd0a4fb0$var$mixpanel_master[name] = $a9f1195cdd0a4fb0$var$instances[name] = $a9f1195cdd0a4fb0$var$create_mplib(token, config, name);
                $a9f1195cdd0a4fb0$var$mixpanel_master[name]._loaded();
            }
            return $a9f1195cdd0a4fb0$var$mixpanel_master[name];
        } else {
            var instance = $a9f1195cdd0a4fb0$var$mixpanel_master;
            if ($a9f1195cdd0a4fb0$var$instances[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $a9f1195cdd0a4fb0$var$instances[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $a9f1195cdd0a4fb0$var$create_mplib(token, config, $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $a9f1195cdd0a4fb0$var$instances[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $a9f1195cdd0a4fb0$var$mixpanel_master = instance;
            if ($a9f1195cdd0a4fb0$var$init_type === $a9f1195cdd0a4fb0$var$INIT_SNIPPET) $a9f1195cdd0a4fb0$var$window$1[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME] = $a9f1195cdd0a4fb0$var$mixpanel_master;
            $a9f1195cdd0a4fb0$var$extend_mp();
        }
    };
};
var $a9f1195cdd0a4fb0$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $a9f1195cdd0a4fb0$var$DOM_LOADED = true;
        $a9f1195cdd0a4fb0$var$ENQUEUE_REQUESTS = false;
        $a9f1195cdd0a4fb0$var$_.each($a9f1195cdd0a4fb0$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $a9f1195cdd0a4fb0$var$document$1.documentElement.doScroll("left");
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($a9f1195cdd0a4fb0$var$document$1.addEventListener) {
        if ($a9f1195cdd0a4fb0$var$document$1.readyState === "complete") // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $a9f1195cdd0a4fb0$var$document$1.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
    } else if ($a9f1195cdd0a4fb0$var$document$1.attachEvent) {
        // IE
        $a9f1195cdd0a4fb0$var$document$1.attachEvent("onreadystatechange", dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $a9f1195cdd0a4fb0$var$window$1.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($a9f1195cdd0a4fb0$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $a9f1195cdd0a4fb0$var$_.register_event($a9f1195cdd0a4fb0$var$window$1, "load", dom_loaded_handler, true);
};
function $a9f1195cdd0a4fb0$var$init_as_module() {
    $a9f1195cdd0a4fb0$var$init_type = $a9f1195cdd0a4fb0$var$INIT_MODULE;
    $a9f1195cdd0a4fb0$var$mixpanel_master = new $a9f1195cdd0a4fb0$var$MixpanelLib();
    $a9f1195cdd0a4fb0$var$override_mp_init_func();
    $a9f1195cdd0a4fb0$var$mixpanel_master["init"]();
    $a9f1195cdd0a4fb0$var$add_dom_loaded_handler();
    return $a9f1195cdd0a4fb0$var$mixpanel_master;
}
var $a9f1195cdd0a4fb0$var$mixpanel = $a9f1195cdd0a4fb0$var$init_as_module();
module.exports = $a9f1195cdd0a4fb0$var$mixpanel;

});


parcelRegister("h5HRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c714eca6b62784f4$export$2e2bcd8739ae039; });

var $RP8BZ = parcelRequire("RP8BZ");
var $c714eca6b62784f4$export$2e2bcd8739ae039 = (0, $RP8BZ.default);

});
parcelRegister("RP8BZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1c9e45e781f34f$export$2e2bcd8739ae039; });

var $ikATC = parcelRequire("ikATC");
var $co7DE = parcelRequire("co7DE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $fsuNT = parcelRequire("fsuNT");

var $bv9EC = parcelRequire("bv9EC");

var $1irrc = parcelRequire("1irrc");

var $kvHhM = parcelRequire("kvHhM");
const $0a1c9e45e781f34f$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        listItem: {
            fontFamily: theme.typography.fontFamily
        }
    }));
function $0a1c9e45e781f34f$var$MdLink({ href: href, ...props }) {
    const target = href.startsWith("mailto:") ? "" : "_blank";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ikATC.default), {
        href: href,
        rel: "noopener noreferrer",
        target: target,
        ...props
    });
}
$0a1c9e45e781f34f$var$MdLink.defaultProps = {
    href: undefined
};
function $0a1c9e45e781f34f$var$Markdown({ children: children, remarkReactComponents: remarkReactComponents, extend: extend, tags: tags }) {
    const classes = $0a1c9e45e781f34f$var$useStyles();
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($fsuNT)))().use((0, (/*@__PURE__*/$parcel$interopDefault($bv9EC))), {
        remarkReactComponents: remarkReactComponents || {
            h1: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), props),
            h2: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h2",
                    ...props
                }),
            h3: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h3",
                    ...props
                }),
            h4: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h4",
                    ...props
                }),
            h5: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h5",
                    ...props
                }),
            h6: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h6",
                    ...props
                }),
            p: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), props),
            a: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($0a1c9e45e781f34f$var$MdLink, props),
            li: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("li", {
                    ...props,
                    className: classes.listItem
                }),
            ...extend
        }
    }).processSync((0, (/*@__PURE__*/$parcel$interopDefault($1irrc)))(children, tags)).contents));
}
$0a1c9e45e781f34f$var$Markdown.defaultProps = {
    extend: undefined,
    remarkReactComponents: undefined,
    tags: {}
};
var $0a1c9e45e781f34f$export$2e2bcd8739ae039 = $0a1c9e45e781f34f$var$Markdown;

});
parcelRegister("ikATC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d586b70d67f5b7de$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $5beWR = parcelRequire("5beWR");

var $eyd6T = parcelRequire("eyd6T");


var $9fjCj = parcelRequire("9fjCj");

var $ge6Tz = parcelRequire("ge6Tz");

var $co7DE = parcelRequire("co7DE");
var $d586b70d67f5b7de$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: "none"
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: "underline"
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$focusVisible": {
            outline: "auto"
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $d586b70d67f5b7de$var$Link = /*#__PURE__*/ $cQNHH.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "a" : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? "hover" : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? "inherit" : _props$variant, other = (0, $fsWgf.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $9fjCj.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $cQNHH.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $ge6Tz.default)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $cQNHH.createElement((0, $co7DE.default), (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, classes["underline".concat((0, $5beWR.default)(underline))], className, focusVisible && classes.focusVisible, component === "button" && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $d586b70d67f5b7de$export$2e2bcd8739ae039 = (0, $eyd6T.default)($d586b70d67f5b7de$export$9dd6ff9ea0189349, {
    name: "MuiLink"
})($d586b70d67f5b7de$var$Link);

});
parcelRegister("co7DE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $904da6c53ca8b7ec$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $5beWR = parcelRequire("5beWR");
var $904da6c53ca8b7ec$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $904da6c53ca8b7ec$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $904da6c53ca8b7ec$var$Typography = /*#__PURE__*/ $cQNHH.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $904da6c53ca8b7ec$var$defaultVariantMapping : _props$variantMapping, other = (0, $fsWgf.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $904da6c53ca8b7ec$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $cQNHH.createElement(Component, (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $5beWR.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $5beWR.default)(align))], display !== "initial" && classes["display".concat((0, $5beWR.default)(display))]),
        ref: ref
    }, other));
});
var $904da6c53ca8b7ec$export$2e2bcd8739ae039 = (0, $eyd6T.default)($904da6c53ca8b7ec$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($904da6c53ca8b7ec$var$Typography);

});


parcelRegister("fsuNT", function(module, exports) {
"use strict";

var $al4fO = parcelRequire("al4fO");

var $PZETB = parcelRequire("PZETB");

var $h6gi9 = parcelRequire("h6gi9");
module.exports = $al4fO().use($PZETB).use($h6gi9).freeze();

});
parcelRegister("al4fO", function(module, exports) {
"use strict";

var $fxuRr = parcelRequire("fxuRr");

var $bZMx7 = parcelRequire("bZMx7");

var $vpVay = parcelRequire("vpVay");

var $7SpAC = parcelRequire("7SpAC");

var $f0IPP = parcelRequire("f0IPP");
// Expose a frozen processor.
module.exports = $786f2a4b21dab975$var$unified().freeze();
var $786f2a4b21dab975$var$slice = [].slice;
var $786f2a4b21dab975$var$own = {}.hasOwnProperty;
// Process pipeline.
var $786f2a4b21dab975$var$pipeline = $7SpAC().use($786f2a4b21dab975$var$pipelineParse).use($786f2a4b21dab975$var$pipelineRun).use($786f2a4b21dab975$var$pipelineStringify);
function $786f2a4b21dab975$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $786f2a4b21dab975$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(err, tree, file) {
        if (err) next(err);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $786f2a4b21dab975$var$pipelineStringify(p, ctx) {
    ctx.file.contents = p.stringify(ctx.tree, ctx.file);
}
// Function to create the first processor.
function $786f2a4b21dab975$var$unified() {
    var attachers = [];
    var transformers = $7SpAC();
    var namespace = {};
    var frozen = false;
    var freezeIndex = -1;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $786f2a4b21dab975$var$unified();
        var length = attachers.length;
        var index = -1;
        while(++index < length)destination.use.apply(null, attachers[index]);
        destination.data($fxuRr(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var plugin;
        var options;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            plugin = values[0];
            options = values[1];
            transformer = null;
            if (options === false) continue;
            if (options === true) values[1] = undefined;
            transformer = plugin.apply(processor, values.slice(1));
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $786f2a4b21dab975$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $786f2a4b21dab975$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $786f2a4b21dab975$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $786f2a4b21dab975$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin.apply(null, arguments);
        else if (typeof value === "object") {
            if ("length" in value) addList(value);
            else addPreset(value);
        } else throw new Error("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = $fxuRr(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $fxuRr(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if ("length" in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error("Expected usable value, not `" + value + "`");
        }
        function addList(plugins) {
            var length;
            var index;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === "object" && "length" in plugins) {
                length = plugins.length;
                index = -1;
                while(++index < length)add(plugins[index]);
            } else throw new Error("Expected a list of plugins, not `" + plugins + "`");
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($f0IPP(entry[1]) && $f0IPP(value)) value = $fxuRr(entry[1], value);
                entry[1] = value;
            } else attachers.push($786f2a4b21dab975$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var length = attachers.length;
        var index = -1;
        var entry;
        while(++index < length){
            entry = attachers[index];
            if (entry[0] === plugin) return entry;
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $vpVay(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $786f2a4b21dab975$var$assertParser("parse", Parser);
        if ($786f2a4b21dab975$var$newable(Parser, "parse")) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $786f2a4b21dab975$var$assertNode(node);
        freeze();
        if (!cb && typeof file === "function") {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $vpVay(file), done);
            function done(err, tree, file) {
                tree = tree || node;
                if (err) reject(err);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var complete = false;
        var result;
        run(node, file, done);
        $786f2a4b21dab975$var$assertDone("runSync", "run", complete);
        return result;
        function done(err, tree) {
            complete = true;
            $bZMx7(err);
            result = tree;
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $vpVay(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $786f2a4b21dab975$var$assertCompiler("stringify", Compiler);
        $786f2a4b21dab975$var$assertNode(node);
        if ($786f2a4b21dab975$var$newable(Compiler, "compile")) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $786f2a4b21dab975$var$assertParser("process", processor.Parser);
        $786f2a4b21dab975$var$assertCompiler("process", processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $vpVay(doc);
            $786f2a4b21dab975$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(err) {
                if (err) reject(err);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var complete = false;
        var file;
        freeze();
        $786f2a4b21dab975$var$assertParser("processSync", processor.Parser);
        $786f2a4b21dab975$var$assertCompiler("processSync", processor.Compiler);
        file = $vpVay(doc);
        process(file, done);
        $786f2a4b21dab975$var$assertDone("processSync", "process", complete);
        return file;
        function done(err) {
            complete = true;
            $bZMx7(err);
        }
    }
}
// Check if `value` is a constructor.
function $786f2a4b21dab975$var$newable(value, name) {
    return typeof value === "function" && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($786f2a4b21dab975$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $786f2a4b21dab975$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $786f2a4b21dab975$var$assertParser(name, Parser) {
    if (typeof Parser !== "function") throw new Error("Cannot `" + name + "` without `Parser`");
}
// Assert a compiler is available.
function $786f2a4b21dab975$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== "function") throw new Error("Cannot `" + name + "` without `Compiler`");
}
// Assert the processor is not frozen.
function $786f2a4b21dab975$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot invoke `" + name + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.");
}
// Assert `node` is a unist node.
function $786f2a4b21dab975$var$assertNode(node) {
    if (!node || typeof node.type !== "string") throw new Error("Expected node, got `" + node + "`");
}
// Assert that `complete` is `true`.
function $786f2a4b21dab975$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}

});
parcelRegister("fxuRr", function(module, exports) {
"use strict";
var $b501e06b6b651fe4$var$hasOwn = Object.prototype.hasOwnProperty;
var $b501e06b6b651fe4$var$toStr = Object.prototype.toString;
var $b501e06b6b651fe4$var$defineProperty = Object.defineProperty;
var $b501e06b6b651fe4$var$gOPD = Object.getOwnPropertyDescriptor;
var $b501e06b6b651fe4$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $b501e06b6b651fe4$var$toStr.call(arr) === "[object Array]";
};
var $b501e06b6b651fe4$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $b501e06b6b651fe4$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $b501e06b6b651fe4$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $b501e06b6b651fe4$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $b501e06b6b651fe4$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $b501e06b6b651fe4$var$setProperty = function setProperty(target, options) {
    if ($b501e06b6b651fe4$var$defineProperty && options.name === "__proto__") $b501e06b6b651fe4$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $b501e06b6b651fe4$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$b501e06b6b651fe4$var$hasOwn.call(obj, name)) return void 0;
        else if ($b501e06b6b651fe4$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $b501e06b6b651fe4$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $b501e06b6b651fe4$var$getProperty(target, name);
            copy = $b501e06b6b651fe4$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($b501e06b6b651fe4$var$isPlainObject(copy) || (copyIsArray = $b501e06b6b651fe4$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $b501e06b6b651fe4$var$isArray(src) ? src : [];
                    } else clone = src && $b501e06b6b651fe4$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $b501e06b6b651fe4$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $b501e06b6b651fe4$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("bZMx7", function(module, exports) {
"use strict";
module.exports = $8bbb09eaf06aca0c$var$bail;
function $8bbb09eaf06aca0c$var$bail(err) {
    if (err) throw err;
}

});

parcelRegister("vpVay", function(module, exports) {
"use strict";

var $bPuwV = parcelRequire("bPuwV");

var $fwwoB = parcelRequire("fwwoB");
module.exports = $fwwoB;
var $05e700c0aeb742be$var$proto = $fwwoB.prototype;
$05e700c0aeb742be$var$proto.message = $05e700c0aeb742be$var$message;
$05e700c0aeb742be$var$proto.info = $05e700c0aeb742be$var$info;
$05e700c0aeb742be$var$proto.fail = $05e700c0aeb742be$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $05e700c0aeb742be$var$message(reason, position, origin) {
    var filePath = this.path;
    var message = new $bPuwV(reason, position, origin);
    if (filePath) {
        message.name = filePath + ":" + message.name;
        message.file = filePath;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $05e700c0aeb742be$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $05e700c0aeb742be$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("bPuwV", function(module, exports) {
"use strict";

var $eG7dw = parcelRequire("eG7dw");
module.exports = $89cc23c5335e372f$var$VMessage;
// Inherit from `Error#`.
function $89cc23c5335e372f$var$VMessagePrototype() {}
$89cc23c5335e372f$var$VMessagePrototype.prototype = Error.prototype;
$89cc23c5335e372f$var$VMessage.prototype = new $89cc23c5335e372f$var$VMessagePrototype();
// Message properties.
var $89cc23c5335e372f$var$proto = $89cc23c5335e372f$var$VMessage.prototype;
$89cc23c5335e372f$var$proto.file = "";
$89cc23c5335e372f$var$proto.name = "";
$89cc23c5335e372f$var$proto.reason = "";
$89cc23c5335e372f$var$proto.message = "";
$89cc23c5335e372f$var$proto.stack = "";
$89cc23c5335e372f$var$proto.fatal = null;
$89cc23c5335e372f$var$proto.column = null;
$89cc23c5335e372f$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $89cc23c5335e372f$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === "string") {
        origin = position;
        position = null;
    }
    parts = $89cc23c5335e372f$var$parseOrigin(origin);
    range = $eG7dw(position) || "1:1";
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $89cc23c5335e372f$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === "string") {
        index = origin.indexOf(":");
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("eG7dw", function(module, exports) {
"use strict";
var $aafa9619e0b09949$var$own = {}.hasOwnProperty;
module.exports = $aafa9619e0b09949$var$stringify;
function $aafa9619e0b09949$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ($aafa9619e0b09949$var$own.call(value, "position") || $aafa9619e0b09949$var$own.call(value, "type")) return $aafa9619e0b09949$var$position(value.position);
    // Position.
    if ($aafa9619e0b09949$var$own.call(value, "start") || $aafa9619e0b09949$var$own.call(value, "end")) return $aafa9619e0b09949$var$position(value);
    // Point.
    if ($aafa9619e0b09949$var$own.call(value, "line") || $aafa9619e0b09949$var$own.call(value, "column")) return $aafa9619e0b09949$var$point(value);
    // ?
    return "";
}
function $aafa9619e0b09949$var$point(point) {
    if (!point || typeof point !== "object") point = {};
    return $aafa9619e0b09949$var$index(point.line) + ":" + $aafa9619e0b09949$var$index(point.column);
}
function $aafa9619e0b09949$var$position(pos) {
    if (!pos || typeof pos !== "object") pos = {};
    return $aafa9619e0b09949$var$point(pos.start) + "-" + $aafa9619e0b09949$var$point(pos.end);
}
function $aafa9619e0b09949$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("fwwoB", function(module, exports) {

var $7dgut = parcelRequire("7dgut");
"use strict";

var $iOurU = parcelRequire("iOurU");

var $1gN1A = parcelRequire("1gN1A");

var $3eCyv = parcelRequire("3eCyv");
module.exports = $b4d2f94dffc020b9$var$VFile;
var $b4d2f94dffc020b9$var$own = {}.hasOwnProperty;
var $b4d2f94dffc020b9$var$proto = $b4d2f94dffc020b9$var$VFile.prototype;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $b4d2f94dffc020b9$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
$b4d2f94dffc020b9$var$proto.toString = $b4d2f94dffc020b9$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "path", {
    get: $b4d2f94dffc020b9$var$getPath,
    set: $b4d2f94dffc020b9$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "dirname", {
    get: $b4d2f94dffc020b9$var$getDirname,
    set: $b4d2f94dffc020b9$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "basename", {
    get: $b4d2f94dffc020b9$var$getBasename,
    set: $b4d2f94dffc020b9$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "extname", {
    get: $b4d2f94dffc020b9$var$getExtname,
    set: $b4d2f94dffc020b9$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "stem", {
    get: $b4d2f94dffc020b9$var$getStem,
    set: $b4d2f94dffc020b9$var$setStem
});
// Construct a new file.
function $b4d2f94dffc020b9$var$VFile(options) {
    var prop;
    var index;
    var length;
    if (!options) options = {};
    else if (typeof options === "string" || $3eCyv(options)) options = {
        contents: options
    };
    else if ("message" in options && "messages" in options) return options;
    if (!(this instanceof $b4d2f94dffc020b9$var$VFile)) return new $b4d2f94dffc020b9$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $7dgut.cwd();
    // Set path related properties in the correct order.
    index = -1;
    length = $b4d2f94dffc020b9$var$order.length;
    while(++index < length){
        prop = $b4d2f94dffc020b9$var$order[index];
        if ($b4d2f94dffc020b9$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($b4d2f94dffc020b9$var$order.indexOf(prop) === -1) this[prop] = options[prop];
}
function $b4d2f94dffc020b9$var$getPath() {
    return this.history[this.history.length - 1];
}
function $b4d2f94dffc020b9$var$setPath(path) {
    $b4d2f94dffc020b9$var$assertNonEmpty(path, "path");
    if (path !== this.path) this.history.push(path);
}
function $b4d2f94dffc020b9$var$getDirname() {
    return typeof this.path === "string" ? $iOurU.dirname(this.path) : undefined;
}
function $b4d2f94dffc020b9$var$setDirname(dirname) {
    $b4d2f94dffc020b9$var$assertPath(this.path, "dirname");
    this.path = $iOurU.join(dirname || "", this.basename);
}
function $b4d2f94dffc020b9$var$getBasename() {
    return typeof this.path === "string" ? $iOurU.basename(this.path) : undefined;
}
function $b4d2f94dffc020b9$var$setBasename(basename) {
    $b4d2f94dffc020b9$var$assertNonEmpty(basename, "basename");
    $b4d2f94dffc020b9$var$assertPart(basename, "basename");
    this.path = $iOurU.join(this.dirname || "", basename);
}
function $b4d2f94dffc020b9$var$getExtname() {
    return typeof this.path === "string" ? $iOurU.extname(this.path) : undefined;
}
function $b4d2f94dffc020b9$var$setExtname(extname) {
    var ext = extname || "";
    $b4d2f94dffc020b9$var$assertPart(ext, "extname");
    $b4d2f94dffc020b9$var$assertPath(this.path, "extname");
    if (ext) {
        if (ext.charAt(0) !== ".") throw new Error("`extname` must start with `.`");
        if (ext.indexOf(".", 1) !== -1) throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = $1gN1A(this.path, ext);
}
function $b4d2f94dffc020b9$var$getStem() {
    return typeof this.path === "string" ? $iOurU.basename(this.path, this.extname) : undefined;
}
function $b4d2f94dffc020b9$var$setStem(stem) {
    $b4d2f94dffc020b9$var$assertNonEmpty(stem, "stem");
    $b4d2f94dffc020b9$var$assertPart(stem, "stem");
    this.path = $iOurU.join(this.dirname || "", stem + (this.extname || ""));
}
// Get the value of the file.
function $b4d2f94dffc020b9$var$toString(encoding) {
    var value = this.contents || "";
    return $3eCyv(value) ? value.toString(encoding) : String(value);
}
// Assert that `part` is not a path (i.e., does not contain `path.sep`).
function $b4d2f94dffc020b9$var$assertPart(part, name) {
    if (part.indexOf($iOurU.sep) !== -1) throw new Error("`" + name + "` cannot be a path: did not expect `" + $iOurU.sep + "`");
}
// Assert that `part` is not empty.
function $b4d2f94dffc020b9$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
// Assert `path` exists.
function $b4d2f94dffc020b9$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}

});
parcelRegister("7dgut", function(module, exports) {
// shim for using process in browser
var $540689f746aefe05$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $540689f746aefe05$var$cachedSetTimeout;
var $540689f746aefe05$var$cachedClearTimeout;
function $540689f746aefe05$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $540689f746aefe05$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        else $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    } catch (e) {
        $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        else $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    } catch (e) {
        $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    }
})();
function $540689f746aefe05$var$runTimeout(fun) {
    if ($540689f746aefe05$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedSetTimeout === $540689f746aefe05$var$defaultSetTimout || !$540689f746aefe05$var$cachedSetTimeout) && setTimeout) {
        $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $540689f746aefe05$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $540689f746aefe05$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $540689f746aefe05$var$runClearTimeout(marker) {
    if ($540689f746aefe05$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedClearTimeout === $540689f746aefe05$var$defaultClearTimeout || !$540689f746aefe05$var$cachedClearTimeout) && clearTimeout) {
        $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $540689f746aefe05$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $540689f746aefe05$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $540689f746aefe05$var$queue = [];
var $540689f746aefe05$var$draining = false;
var $540689f746aefe05$var$currentQueue;
var $540689f746aefe05$var$queueIndex = -1;
function $540689f746aefe05$var$cleanUpNextTick() {
    if (!$540689f746aefe05$var$draining || !$540689f746aefe05$var$currentQueue) return;
    $540689f746aefe05$var$draining = false;
    if ($540689f746aefe05$var$currentQueue.length) $540689f746aefe05$var$queue = $540689f746aefe05$var$currentQueue.concat($540689f746aefe05$var$queue);
    else $540689f746aefe05$var$queueIndex = -1;
    if ($540689f746aefe05$var$queue.length) $540689f746aefe05$var$drainQueue();
}
function $540689f746aefe05$var$drainQueue() {
    if ($540689f746aefe05$var$draining) return;
    var timeout = $540689f746aefe05$var$runTimeout($540689f746aefe05$var$cleanUpNextTick);
    $540689f746aefe05$var$draining = true;
    var len = $540689f746aefe05$var$queue.length;
    while(len){
        $540689f746aefe05$var$currentQueue = $540689f746aefe05$var$queue;
        $540689f746aefe05$var$queue = [];
        while(++$540689f746aefe05$var$queueIndex < len)if ($540689f746aefe05$var$currentQueue) $540689f746aefe05$var$currentQueue[$540689f746aefe05$var$queueIndex].run();
        $540689f746aefe05$var$queueIndex = -1;
        len = $540689f746aefe05$var$queue.length;
    }
    $540689f746aefe05$var$currentQueue = null;
    $540689f746aefe05$var$draining = false;
    $540689f746aefe05$var$runClearTimeout(timeout);
}
$540689f746aefe05$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $540689f746aefe05$var$queue.push(new $540689f746aefe05$var$Item(fun, args));
    if ($540689f746aefe05$var$queue.length === 1 && !$540689f746aefe05$var$draining) $540689f746aefe05$var$runTimeout($540689f746aefe05$var$drainQueue);
};
// v8 likes predictible objects
function $540689f746aefe05$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$540689f746aefe05$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$540689f746aefe05$var$process.title = "browser";
$540689f746aefe05$var$process.browser = true;
$540689f746aefe05$var$process.env = {};
$540689f746aefe05$var$process.argv = [];
$540689f746aefe05$var$process.version = ""; // empty string to avoid regexp issues
$540689f746aefe05$var$process.versions = {};
function $540689f746aefe05$var$noop() {}
$540689f746aefe05$var$process.on = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.addListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.once = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.off = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeAllListeners = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.emit = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependOnceListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.listeners = function(name) {
    return [];
};
$540689f746aefe05$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$540689f746aefe05$var$process.cwd = function() {
    return "/";
};
$540689f746aefe05$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$540689f746aefe05$var$process.umask = function() {
    return 0;
};

});

parcelRegister("iOurU", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $7dgut = parcelRequire("7dgut");
"use strict";
function $db24840fa9c68a9a$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $db24840fa9c68a9a$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $db24840fa9c68a9a$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $db24840fa9c68a9a$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $7dgut.cwd();
                path = cwd;
            }
            $db24840fa9c68a9a$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $db24840fa9c68a9a$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $db24840fa9c68a9a$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $db24840fa9c68a9a$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $db24840fa9c68a9a$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $db24840fa9c68a9a$var$assertPath(from);
        $db24840fa9c68a9a$var$assertPath(to);
        if (from === to) return "";
        from = $db24840fa9c68a9a$var$posix.resolve(from);
        to = $db24840fa9c68a9a$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $db24840fa9c68a9a$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $db24840fa9c68a9a$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$db24840fa9c68a9a$var$posix.posix = $db24840fa9c68a9a$var$posix;
module.exports = $db24840fa9c68a9a$var$posix;

});

parcelRegister("1gN1A", function(module, exports) {
"use strict";

var $iOurU = parcelRequire("iOurU");
function $0ecd5055f547f8a4$var$replaceExt(npath, ext) {
    if (typeof npath !== "string") return npath;
    if (npath.length === 0) return npath;
    var nFileName = $iOurU.basename(npath, $iOurU.extname(npath)) + ext;
    return $iOurU.join($iOurU.dirname(npath), nFileName);
}
module.exports = $0ecd5055f547f8a4$var$replaceExt;

});

parcelRegister("3eCyv", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});



parcelRegister("7SpAC", function(module, exports) {
"use strict";

var $ihG1m = parcelRequire("ihG1m");
module.exports = $017adc9937679e2f$var$trough;
$017adc9937679e2f$var$trough.wrap = $ihG1m;
var $017adc9937679e2f$var$slice = [].slice;
// Create new middleware.
function $017adc9937679e2f$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $017adc9937679e2f$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== "function") throw new Error("Expected function as last argument, not " + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $017adc9937679e2f$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $ihG1m(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== "function") throw new Error("Expected `fn` to be a function, not " + fn);
        fns.push(fn);
        return middleware;
    }
}

});
parcelRegister("ihG1m", function(module, exports) {
"use strict";
var $d4fa68fd2733e2cf$var$slice = [].slice;
module.exports = $d4fa68fd2733e2cf$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $d4fa68fd2733e2cf$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $d4fa68fd2733e2cf$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}

});


parcelRegister("f0IPP", function(module, exports) {
"use strict";
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

});


parcelRegister("PZETB", function(module, exports) {
"use strict";

var $4HYGy = parcelRequire("4HYGy");

var $36bRz = parcelRequire("36bRz");

var $G7B4J = parcelRequire("G7B4J");
module.exports = $09c497a69dbc7da5$var$parse;
$09c497a69dbc7da5$var$parse.Parser = $G7B4J;
function $09c497a69dbc7da5$var$parse(options) {
    var settings = this.data("settings");
    var Local = $4HYGy($G7B4J);
    Local.prototype.options = $36bRz(Local.prototype.options, settings, options);
    this.Parser = Local;
}

});
parcelRegister("4HYGy", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $7Q4w4 = parcelRequire("7Q4w4");
module.exports = $36da4070a7384296$var$unherit;
// Create a custom constructor which can be modified without affecting the
// original class.
function $36da4070a7384296$var$unherit(Super) {
    var result;
    var key;
    var value;
    $7Q4w4(Of, Super);
    $7Q4w4(From, Of);
    // Clone values.
    result = Of.prototype;
    for(key in result){
        value = result[key];
        if (value && typeof value === "object") result[key] = "concat" in value ? value.concat() : $36bRz(value);
    }
    return Of;
    // Constructor accepting a single argument, which itself is an `arguments`
    // object.
    function From(parameters) {
        return Super.apply(this, parameters);
    }
    // Constructor accepting variadic arguments.
    function Of() {
        if (!(this instanceof Of)) return new From(arguments);
        return Super.apply(this, arguments);
    }
}

});
parcelRegister("36bRz", function(module, exports) {
module.exports = $241b2260c1f9890b$var$extend;
var $241b2260c1f9890b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $241b2260c1f9890b$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($241b2260c1f9890b$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("7Q4w4", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("G7B4J", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $2Na8b = parcelRequire("2Na8b");

var $etX82 = parcelRequire("etX82");

var $gVaw4 = parcelRequire("gVaw4");

var $RwGFz = parcelRequire("RwGFz");

var $9H32T = parcelRequire("9H32T");
module.exports = $07e9d0f66f1e1b4a$var$Parser;
function $07e9d0f66f1e1b4a$var$Parser(doc, file) {
    this.file = file;
    this.offset = {};
    this.options = $36bRz(this.options);
    this.setOptions({});
    this.inList = false;
    this.inBlock = false;
    this.inLink = false;
    this.atStart = true;
    this.toOffset = $etX82(file).toOffset;
    this.unescape = $gVaw4(this, "escape");
    this.decode = $RwGFz(this);
}
var $07e9d0f66f1e1b4a$var$proto = $07e9d0f66f1e1b4a$var$Parser.prototype;

// Expose core.
$07e9d0f66f1e1b4a$var$proto.setOptions = (parcelRequire("8A1yv"));

$07e9d0f66f1e1b4a$var$proto.parse = (parcelRequire("gVkoZ"));

// Expose `defaults`.
$07e9d0f66f1e1b4a$var$proto.options = (parcelRequire("2WaU5"));
// Enter and exit helpers.
$07e9d0f66f1e1b4a$var$proto.exitStart = $2Na8b("atStart", true);
$07e9d0f66f1e1b4a$var$proto.enterList = $2Na8b("inList", false);
$07e9d0f66f1e1b4a$var$proto.enterLink = $2Na8b("inLink", false);
$07e9d0f66f1e1b4a$var$proto.enterBlock = $2Na8b("inBlock", false);
// Nodes that can interupt a paragraph:
//
// ```markdown
// A paragraph, followed by a thematic break.
// ___
// ```
//
// In the above example, the thematic break “interupts” the paragraph.
$07e9d0f66f1e1b4a$var$proto.interruptParagraph = [
    [
        "thematicBreak"
    ],
    [
        "atxHeading"
    ],
    [
        "fencedCode"
    ],
    [
        "blockquote"
    ],
    [
        "html"
    ],
    [
        "setextHeading",
        {
            commonmark: false
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
// Nodes that can interupt a list:
//
// ```markdown
// - One
// ___
// ```
//
// In the above example, the thematic break “interupts” the list.
$07e9d0f66f1e1b4a$var$proto.interruptList = [
    [
        "atxHeading",
        {
            pedantic: false
        }
    ],
    [
        "fencedCode",
        {
            pedantic: false
        }
    ],
    [
        "thematicBreak",
        {
            pedantic: false
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
// Nodes that can interupt a blockquote:
//
// ```markdown
// > A paragraph.
// ___
// ```
//
// In the above example, the thematic break “interupts” the blockquote.
$07e9d0f66f1e1b4a$var$proto.interruptBlockquote = [
    [
        "indentedCode",
        {
            commonmark: true
        }
    ],
    [
        "fencedCode",
        {
            commonmark: true
        }
    ],
    [
        "atxHeading",
        {
            commonmark: true
        }
    ],
    [
        "setextHeading",
        {
            commonmark: true
        }
    ],
    [
        "thematicBreak",
        {
            commonmark: true
        }
    ],
    [
        "html",
        {
            commonmark: true
        }
    ],
    [
        "list",
        {
            commonmark: true
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];













// Handlers.
$07e9d0f66f1e1b4a$var$proto.blockTokenizers = {
    newline: (parcelRequire("eWCwV")),
    indentedCode: (parcelRequire("g5BkQ")),
    fencedCode: (parcelRequire("8jp8K")),
    blockquote: (parcelRequire("hFW9g")),
    atxHeading: (parcelRequire("2Y1RE")),
    thematicBreak: (parcelRequire("5GZmu")),
    list: (parcelRequire("gMkLN")),
    setextHeading: (parcelRequire("6gCu0")),
    html: (parcelRequire("8EbVz")),
    footnote: (parcelRequire("lRbMn")),
    definition: (parcelRequire("gv9fx")),
    table: (parcelRequire("04Igv")),
    paragraph: (parcelRequire("hfuIQ"))
};












$07e9d0f66f1e1b4a$var$proto.inlineTokenizers = {
    escape: (parcelRequire("fG8Jf")),
    autoLink: (parcelRequire("40HEA")),
    url: (parcelRequire("cXItb")),
    html: (parcelRequire("76c2Q")),
    link: (parcelRequire("4bxc4")),
    reference: (parcelRequire("7Wiug")),
    strong: (parcelRequire("fmNrr")),
    emphasis: (parcelRequire("7yt0a")),
    deletion: (parcelRequire("8NqmE")),
    code: (parcelRequire("kcJCs")),
    break: (parcelRequire("5HxXI")),
    text: (parcelRequire("6Wwq4"))
};
// Expose precedence.
$07e9d0f66f1e1b4a$var$proto.blockMethods = $07e9d0f66f1e1b4a$var$keys($07e9d0f66f1e1b4a$var$proto.blockTokenizers);
$07e9d0f66f1e1b4a$var$proto.inlineMethods = $07e9d0f66f1e1b4a$var$keys($07e9d0f66f1e1b4a$var$proto.inlineTokenizers);
// Tokenizers.
$07e9d0f66f1e1b4a$var$proto.tokenizeBlock = $9H32T("block");
$07e9d0f66f1e1b4a$var$proto.tokenizeInline = $9H32T("inline");
$07e9d0f66f1e1b4a$var$proto.tokenizeFactory = $9H32T;
// Get all keys in `value`.
function $07e9d0f66f1e1b4a$var$keys(value) {
    var result = [];
    var key;
    for(key in value)result.push(key);
    return result;
}

});
parcelRegister("2Na8b", function(module, exports) {
"use strict";
module.exports = $2088042db98445c3$var$factory;
// Construct a state `toggler`: a function which inverses `property` in context
// based on its current value.
// The by `toggler` returned function restores that value.
function $2088042db98445c3$var$factory(key, state, ctx) {
    return enter;
    function enter() {
        var context = ctx || this;
        var current = context[key];
        context[key] = !state;
        return exit;
        function exit() {
            context[key] = current;
        }
    }
}

});

parcelRegister("etX82", function(module, exports) {
"use strict";
module.exports = $a8b1a3d64223ebef$var$factory;
function $a8b1a3d64223ebef$var$factory(file) {
    var contents = $a8b1a3d64223ebef$var$indices(String(file));
    return {
        toPosition: $a8b1a3d64223ebef$var$offsetToPositionFactory(contents),
        toOffset: $a8b1a3d64223ebef$var$positionToOffsetFactory(contents)
    };
}
// Factory to get the line and column-based `position` for `offset` in the bound
// indices.
function $a8b1a3d64223ebef$var$offsetToPositionFactory(indices) {
    return offsetToPosition;
    // Get the line and column-based `position` for `offset` in the bound indices.
    function offsetToPosition(offset) {
        var index = -1;
        var length = indices.length;
        if (offset < 0) return {};
        while(++index < length){
            if (indices[index] > offset) return {
                line: index + 1,
                column: offset - (indices[index - 1] || 0) + 1,
                offset: offset
            };
        }
        return {};
    }
}
// Factory to get the `offset` for a line and column-based `position` in the
// bound indices.
function $a8b1a3d64223ebef$var$positionToOffsetFactory(indices) {
    return positionToOffset;
    // Get the `offset` for a line and column-based `position` in the bound
    // indices.
    function positionToOffset(position) {
        var line = position && position.line;
        var column = position && position.column;
        if (!isNaN(line) && !isNaN(column) && line - 1 in indices) return (indices[line - 2] || 0) + column - 1 || 0;
        return -1;
    }
}
// Get indices of line-breaks in `value`.
function $a8b1a3d64223ebef$var$indices(value) {
    var result = [];
    var index = value.indexOf("\n");
    while(index !== -1){
        result.push(index + 1);
        index = value.indexOf("\n", index + 1);
    }
    result.push(value.length + 1);
    return result;
}

});

parcelRegister("gVaw4", function(module, exports) {
"use strict";
module.exports = $c51a20857cab52c5$var$factory;
var $c51a20857cab52c5$var$backslash = "\\";
// Factory to de-escape a value, based on a list at `key` in `ctx`.
function $c51a20857cab52c5$var$factory(ctx, key) {
    return unescape;
    // De-escape a string using the expression at `key` in `ctx`.
    function unescape(value) {
        var prev = 0;
        var index = value.indexOf($c51a20857cab52c5$var$backslash);
        var escape = ctx[key];
        var queue = [];
        var character;
        while(index !== -1){
            queue.push(value.slice(prev, index));
            prev = index + 1;
            character = value.charAt(prev);
            // If the following character is not a valid escape, add the slash.
            if (!character || escape.indexOf(character) === -1) queue.push($c51a20857cab52c5$var$backslash);
            index = value.indexOf($c51a20857cab52c5$var$backslash, prev + 1);
        }
        queue.push(value.slice(prev));
        return queue.join("");
    }
}

});

parcelRegister("RwGFz", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $eUIxU = parcelRequire("eUIxU");
module.exports = $0a0e4e5a2f4c08fc$var$factory;
// Factory to create an entity decoder.
function $0a0e4e5a2f4c08fc$var$factory(ctx) {
    decoder.raw = decodeRaw;
    return decoder;
    // Normalize `position` to add an `indent`.
    function normalize(position) {
        var offsets = ctx.offset;
        var line = position.line;
        var result = [];
        while(++line){
            if (!(line in offsets)) break;
            result.push((offsets[line] || 0) + 1);
        }
        return {
            start: position,
            indent: result
        };
    }
    // Decode `value` (at `position`) into text-nodes.
    function decoder(value, position, handler) {
        $eUIxU(value, {
            position: normalize(position),
            warning: handleWarning,
            text: handler,
            reference: handler,
            textContext: ctx,
            referenceContext: ctx
        });
    }
    // Decode `value` (at `position`) into a string.
    function decodeRaw(value, position, options) {
        return $eUIxU(value, $36bRz(options, {
            position: normalize(position),
            warning: handleWarning
        }));
    }
    // Handle a warning.
    // See <https://github.com/wooorm/parse-entities> for the warnings.
    function handleWarning(reason, position, code) {
        if (code !== 3) ctx.file.message(reason, position);
    }
}

});
parcelRegister("eUIxU", function(module, exports) {
"use strict";

var $9PlhL = parcelRequire("9PlhL");

var $i3t4F = parcelRequire("i3t4F");

var $35IlD = parcelRequire("35IlD");

var $6lhfp = parcelRequire("6lhfp");

var $a278X = parcelRequire("a278X");

var $5IZQE = parcelRequire("5IZQE");
module.exports = $adb8d98d7e693dfc$var$parseEntities;
var $adb8d98d7e693dfc$var$own = {}.hasOwnProperty;
var $adb8d98d7e693dfc$var$fromCharCode = String.fromCharCode;
var $adb8d98d7e693dfc$var$noop = Function.prototype;
// Default settings.
var $adb8d98d7e693dfc$var$defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var $adb8d98d7e693dfc$var$tab = 9 // '\t'
;
var $adb8d98d7e693dfc$var$lineFeed = 10 // '\n'
;
var $adb8d98d7e693dfc$var$formFeed = 12 //  '\f'
;
var $adb8d98d7e693dfc$var$space = 32 // ' '
;
var $adb8d98d7e693dfc$var$ampersand = 38 //  '&'
;
var $adb8d98d7e693dfc$var$semicolon = 59 //  ';'
;
var $adb8d98d7e693dfc$var$lessThan = 60 //  '<'
;
var $adb8d98d7e693dfc$var$equalsTo = 61 //  '='
;
var $adb8d98d7e693dfc$var$numberSign = 35 //  '#'
;
var $adb8d98d7e693dfc$var$uppercaseX = 88 //  'X'
;
var $adb8d98d7e693dfc$var$lowercaseX = 120 //  'x'
;
var $adb8d98d7e693dfc$var$replacementCharacter = 65533 // '�'
;
// Reference types.
var $adb8d98d7e693dfc$var$name = "named";
var $adb8d98d7e693dfc$var$hexa = "hexadecimal";
var $adb8d98d7e693dfc$var$deci = "decimal";
// Map of bases.
var $adb8d98d7e693dfc$var$bases = {};
$adb8d98d7e693dfc$var$bases[$adb8d98d7e693dfc$var$hexa] = 16;
$adb8d98d7e693dfc$var$bases[$adb8d98d7e693dfc$var$deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var $adb8d98d7e693dfc$var$tests = {};
$adb8d98d7e693dfc$var$tests[$adb8d98d7e693dfc$var$name] = $a278X;
$adb8d98d7e693dfc$var$tests[$adb8d98d7e693dfc$var$deci] = $35IlD;
$adb8d98d7e693dfc$var$tests[$adb8d98d7e693dfc$var$hexa] = $6lhfp;
// Warning types.
var $adb8d98d7e693dfc$var$namedNotTerminated = 1;
var $adb8d98d7e693dfc$var$numericNotTerminated = 2;
var $adb8d98d7e693dfc$var$namedEmpty = 3;
var $adb8d98d7e693dfc$var$numericEmpty = 4;
var $adb8d98d7e693dfc$var$namedUnknown = 5;
var $adb8d98d7e693dfc$var$numericDisallowed = 6;
var $adb8d98d7e693dfc$var$numericProhibited = 7;
// Warning messages.
var $adb8d98d7e693dfc$var$messages = {};
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$namedNotTerminated] = "Named character references must be terminated by a semicolon";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericNotTerminated] = "Numeric character references must be terminated by a semicolon";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$namedEmpty] = "Named character references cannot be empty";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericEmpty] = "Numeric character references cannot be empty";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$namedUnknown] = "Named character references must be known";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericDisallowed] = "Numeric character references cannot be disallowed";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
// Wrap to ensure clean parameters are given to `parse`.
function $adb8d98d7e693dfc$var$parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in $adb8d98d7e693dfc$var$defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? $adb8d98d7e693dfc$var$defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return $adb8d98d7e693dfc$var$parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function $adb8d98d7e693dfc$var$parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = "";
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === "string") additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : $adb8d98d7e693dfc$var$noop;
    // Ensure the algorithm walks over the first character and the end (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === $adb8d98d7e693dfc$var$lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === $adb8d98d7e693dfc$var$ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === $adb8d98d7e693dfc$var$tab || following === $adb8d98d7e693dfc$var$lineFeed || following === $adb8d98d7e693dfc$var$formFeed || following === $adb8d98d7e693dfc$var$space || following === $adb8d98d7e693dfc$var$ampersand || following === $adb8d98d7e693dfc$var$lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += $adb8d98d7e693dfc$var$fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === $adb8d98d7e693dfc$var$numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === $adb8d98d7e693dfc$var$uppercaseX || following === $adb8d98d7e693dfc$var$lowercaseX) {
                    // ASCII hex digits.
                    type = $adb8d98d7e693dfc$var$hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = $adb8d98d7e693dfc$var$deci;
            } else // Named entity.
            type = $adb8d98d7e693dfc$var$name;
            entityCharacters = "";
            entity = "";
            characters = "";
            test = $adb8d98d7e693dfc$var$tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += $adb8d98d7e693dfc$var$fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === $adb8d98d7e693dfc$var$name && $adb8d98d7e693dfc$var$own.call($9PlhL, characters)) {
                    entityCharacters = characters;
                    entity = $9PlhL[characters];
                }
            }
            terminated = value.charCodeAt(end) === $adb8d98d7e693dfc$var$semicolon;
            if (terminated) {
                end++;
                namedEntity = type === $adb8d98d7e693dfc$var$name ? $5IZQE(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== $adb8d98d7e693dfc$var$name) warning($adb8d98d7e693dfc$var$numericEmpty, diff);
            } else if (type === $adb8d98d7e693dfc$var$name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning($adb8d98d7e693dfc$var$namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? $adb8d98d7e693dfc$var$namedNotTerminated : $adb8d98d7e693dfc$var$namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === $adb8d98d7e693dfc$var$equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if ($a278X(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning($adb8d98d7e693dfc$var$numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, $adb8d98d7e693dfc$var$bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if ($adb8d98d7e693dfc$var$prohibited(reference)) {
                    warning($adb8d98d7e693dfc$var$numericProhibited, diff);
                    reference = $adb8d98d7e693dfc$var$fromCharCode($adb8d98d7e693dfc$var$replacementCharacter);
                } else if (reference in $i3t4F) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning($adb8d98d7e693dfc$var$numericDisallowed, diff);
                    reference = $i3t4F[reference];
                } else {
                    // Parse the number.
                    output = "";
                    // Trigger a warning when the parsed number should not be used.
                    if ($adb8d98d7e693dfc$var$disallowed(reference)) warning($adb8d98d7e693dfc$var$numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += $adb8d98d7e693dfc$var$fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + $adb8d98d7e693dfc$var$fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += $adb8d98d7e693dfc$var$fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes, and any possible warnings.
    return result.join("");
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, $adb8d98d7e693dfc$var$messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = "";
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function $adb8d98d7e693dfc$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function $adb8d98d7e693dfc$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}

});
parcelRegister("9PlhL", function(module, exports) {
module.exports = JSON.parse('{"AElig":"\xc6","AMP":"&","Aacute":"\xc1","Acirc":"\xc2","Agrave":"\xc0","Aring":"\xc5","Atilde":"\xc3","Auml":"\xc4","COPY":"\xa9","Ccedil":"\xc7","ETH":"\xd0","Eacute":"\xc9","Ecirc":"\xca","Egrave":"\xc8","Euml":"\xcb","GT":">","Iacute":"\xcd","Icirc":"\xce","Igrave":"\xcc","Iuml":"\xcf","LT":"<","Ntilde":"\xd1","Oacute":"\xd3","Ocirc":"\xd4","Ograve":"\xd2","Oslash":"\xd8","Otilde":"\xd5","Ouml":"\xd6","QUOT":"\\"","REG":"\xae","THORN":"\xde","Uacute":"\xda","Ucirc":"\xdb","Ugrave":"\xd9","Uuml":"\xdc","Yacute":"\xdd","aacute":"\xe1","acirc":"\xe2","acute":"\xb4","aelig":"\xe6","agrave":"\xe0","amp":"&","aring":"\xe5","atilde":"\xe3","auml":"\xe4","brvbar":"\xa6","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","eacute":"\xe9","ecirc":"\xea","egrave":"\xe8","eth":"\xf0","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","iacute":"\xed","icirc":"\xee","iexcl":"\xa1","igrave":"\xec","iquest":"\xbf","iuml":"\xef","laquo":"\xab","lt":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","ntilde":"\xf1","oacute":"\xf3","ocirc":"\xf4","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","oslash":"\xf8","otilde":"\xf5","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","raquo":"\xbb","reg":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","thorn":"\xfe","times":"\xd7","uacute":"\xfa","ucirc":"\xfb","ugrave":"\xf9","uml":"\xa8","uuml":"\xfc","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

});

parcelRegister("i3t4F", function(module, exports) {
module.exports = JSON.parse('{"0":"\uFFFD","128":"\u20AC","130":"\u201A","131":"\u0192","132":"\u201E","133":"\u2026","134":"\u2020","135":"\u2021","136":"\u02C6","137":"\u2030","138":"\u0160","139":"\u2039","140":"\u0152","142":"\u017D","145":"\u2018","146":"\u2019","147":"\u201C","148":"\u201D","149":"\u2022","150":"\u2013","151":"\u2014","152":"\u02DC","153":"\u2122","154":"\u0161","155":"\u203A","156":"\u0153","158":"\u017E","159":"\u0178"}');

});

parcelRegister("35IlD", function(module, exports) {
"use strict";
module.exports = $24043d495cb6d5f6$var$decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function $24043d495cb6d5f6$var$decimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}

});

parcelRegister("6lhfp", function(module, exports) {
"use strict";
module.exports = $49e215413186b63c$var$hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function $49e215413186b63c$var$hexadecimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}

});

parcelRegister("a278X", function(module, exports) {
"use strict";

var $aDCQv = parcelRequire("aDCQv");

var $35IlD = parcelRequire("35IlD");
module.exports = $74dfa1d6cc46cebe$var$alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function $74dfa1d6cc46cebe$var$alphanumerical(character) {
    return $aDCQv(character) || $35IlD(character);
}

});
parcelRegister("aDCQv", function(module, exports) {
"use strict";
module.exports = $7bebade65d61c65b$var$alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function $7bebade65d61c65b$var$alphabetical(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}

});


parcelRegister("5IZQE", function(module, exports) {
"use strict";
/* eslint-env browser */ var $42b1099a2e98ac5c$var$el;
var $42b1099a2e98ac5c$var$semicolon = 59 //  ';'
;
module.exports = $42b1099a2e98ac5c$var$decodeEntity;
function $42b1099a2e98ac5c$var$decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    $42b1099a2e98ac5c$var$el = $42b1099a2e98ac5c$var$el || document.createElement("i");
    $42b1099a2e98ac5c$var$el.innerHTML = entity;
    char = $42b1099a2e98ac5c$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $42b1099a2e98ac5c$var$semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});



parcelRegister("9H32T", function(module, exports) {
"use strict";
module.exports = $70ea7e0776c16e6e$var$factory;
// Construct a tokenizer.  This creates both `tokenizeInline` and `tokenizeBlock`.
function $70ea7e0776c16e6e$var$factory(type) {
    return tokenize;
    // Tokenizer for a bound `type`.
    function tokenize(value, location) {
        var self = this;
        var offset = self.offset;
        var tokens = [];
        var methods = self[type + "Methods"];
        var tokenizers = self[type + "Tokenizers"];
        var line = location.line;
        var column = location.column;
        var index;
        var length;
        var method;
        var name;
        var matched;
        var valueLength;
        // Trim white space only lines.
        if (!value) return tokens;
        // Expose on `eat`.
        eat.now = now;
        eat.file = self.file;
        // Sync initial offset.
        updatePosition("");
        // Iterate over `value`, and iterate over all tokenizers.  When one eats
        // something, re-iterate with the remaining value.  If no tokenizer eats,
        // something failed (should not happen) and an exception is thrown.
        while(value){
            index = -1;
            length = methods.length;
            matched = false;
            while(++index < length){
                name = methods[index];
                method = tokenizers[name];
                if (method && /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) && (!method.notInList || !self.inList) && (!method.notInBlock || !self.inBlock) && (!method.notInLink || !self.inLink)) {
                    valueLength = value.length;
                    method.apply(self, [
                        eat,
                        value
                    ]);
                    matched = valueLength !== value.length;
                    if (matched) break;
                }
            }
            /* istanbul ignore if */ if (!matched) self.file.fail(new Error("Infinite loop"), eat.now());
        }
        self.eof = now();
        return tokens;
        // Update line, column, and offset based on `value`.
        function updatePosition(subvalue) {
            var lastIndex = -1;
            var index = subvalue.indexOf("\n");
            while(index !== -1){
                line++;
                lastIndex = index;
                index = subvalue.indexOf("\n", index + 1);
            }
            if (lastIndex === -1) column += subvalue.length;
            else column = subvalue.length - lastIndex;
            if (line in offset) {
                if (lastIndex !== -1) column += offset[line];
                else if (column <= offset[line]) column = offset[line] + 1;
            }
        }
        // Get offset.  Called before the first character is eaten to retrieve the
        // range’s offsets.
        function getOffset() {
            var indentation = [];
            var pos = line + 1;
            // Done.  Called when the last character is eaten to retrieve the range’s
            // offsets.
            return function() {
                var last = line + 1;
                while(pos < last){
                    indentation.push((offset[pos] || 0) + 1);
                    pos++;
                }
                return indentation;
            };
        }
        // Get the current position.
        function now() {
            var pos = {
                line: line,
                column: column
            };
            pos.offset = self.toOffset(pos);
            return pos;
        }
        // Store position information for a node.
        function Position(start) {
            this.start = start;
            this.end = now();
        }
        // Throw when a value is incorrectly eaten.  This shouldn’t happen but will
        // throw on new, incorrect rules.
        function validateEat(subvalue) {
            /* istanbul ignore if */ if (value.slice(0, subvalue.length) !== subvalue) // Capture stack-trace.
            self.file.fail(new Error("Incorrectly eaten value: please report this warning on https://git.io/vg5Ft"), now());
        }
        // Mark position and patch `node.position`.
        function position() {
            var before = now();
            return update;
            // Add the position to a node.
            function update(node, indent) {
                var prev = node.position;
                var start = prev ? prev.start : before;
                var combined = [];
                var n = prev && prev.end.line;
                var l = before.line;
                node.position = new Position(start);
                // If there was already a `position`, this node was merged.  Fixing
                // `start` wasn’t hard, but the indent is different.  Especially
                // because some information, the indent between `n` and `l` wasn’t
                // tracked.  Luckily, that space is (should be?) empty, so we can
                // safely check for it now.
                if (prev && indent && prev.indent) {
                    combined = prev.indent;
                    if (n < l) {
                        while(++n < l)combined.push((offset[n] || 0) + 1);
                        combined.push(before.column);
                    }
                    indent = combined.concat(indent);
                }
                node.position.indent = indent || [];
                return node;
            }
        }
        // Add `node` to `parent`s children or to `tokens`.  Performs merges where
        // possible.
        function add(node, parent) {
            var children = parent ? parent.children : tokens;
            var prev = children[children.length - 1];
            var fn;
            if (prev && node.type === prev.type && (node.type === "text" || node.type === "blockquote") && $70ea7e0776c16e6e$var$mergeable(prev) && $70ea7e0776c16e6e$var$mergeable(node)) {
                fn = node.type === "text" ? $70ea7e0776c16e6e$var$mergeText : $70ea7e0776c16e6e$var$mergeBlockquote;
                node = fn.call(self, prev, node);
            }
            if (node !== prev) children.push(node);
            if (self.atStart && tokens.length !== 0) self.exitStart();
            return node;
        }
        // Remove `subvalue` from `value`.  `subvalue` must be at the start of
        // `value`.
        function eat(subvalue) {
            var indent = getOffset();
            var pos = position();
            var current = now();
            validateEat(subvalue);
            apply.reset = reset;
            reset.test = test;
            apply.test = test;
            value = value.slice(subvalue.length);
            updatePosition(subvalue);
            indent = indent();
            return apply;
            // Add the given arguments, add `position` to the returned node, and
            // return the node.
            function apply(node, parent) {
                return pos(add(pos(node), parent), indent);
            }
            // Functions just like apply, but resets the content: the line and
            // column are reversed, and the eaten value is re-added.   This is
            // useful for nodes with a single type of content, such as lists and
            // tables.  See `apply` above for what parameters are expected.
            function reset() {
                var node = apply.apply(null, arguments);
                line = current.line;
                column = current.column;
                value = subvalue + value;
                return node;
            }
            // Test the position, after eating, and reverse to a not-eaten state.
            function test() {
                var result = pos({});
                line = current.line;
                column = current.column;
                value = subvalue + value;
                return result.position;
            }
        }
    }
}
// Check whether a node is mergeable with adjacent nodes.
function $70ea7e0776c16e6e$var$mergeable(node) {
    var start;
    var end;
    if (node.type !== "text" || !node.position) return true;
    start = node.position.start;
    end = node.position.end;
    // Only merge nodes which occupy the same size as their `value`.
    return start.line !== end.line || end.column - start.column === node.value.length;
}
// Merge two text nodes: `node` into `prev`.
function $70ea7e0776c16e6e$var$mergeText(prev, node) {
    prev.value += node.value;
    return prev;
}
// Merge two blockquotes: `node` into `prev`, unless in CommonMark or gfm modes.
function $70ea7e0776c16e6e$var$mergeBlockquote(prev, node) {
    if (this.options.commonmark || this.options.gfm) return node;
    prev.children = prev.children.concat(node.children);
    return prev;
}

});

parcelRegister("8A1yv", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $6lv3b = parcelRequire("6lv3b");

var $2WaU5 = parcelRequire("2WaU5");
module.exports = $63f2e4671f235175$var$setOptions;
function $63f2e4671f235175$var$setOptions(options) {
    var self = this;
    var current = self.options;
    var key;
    var value;
    if (options == null) options = {};
    else if (typeof options === "object") options = $36bRz(options);
    else throw new Error("Invalid value `" + options + "` for setting `options`");
    for(key in $2WaU5){
        value = options[key];
        if (value == null) value = current[key];
        if (key !== "blocks" && typeof value !== "boolean" || key === "blocks" && typeof value !== "object") throw new Error("Invalid value `" + value + "` for setting `options." + key + "`");
        options[key] = value;
    }
    self.options = options;
    self.escape = $6lv3b(options);
    return self;
}

});
parcelRegister("6lv3b", function(module, exports) {
"use strict";
module.exports = $49ecca349270a938$var$escapes;
var $49ecca349270a938$var$defaults = [
    "\\",
    "`",
    "*",
    "{",
    "}",
    "[",
    "]",
    "(",
    ")",
    "#",
    "+",
    "-",
    ".",
    "!",
    "_",
    ">"
];
var $49ecca349270a938$var$gfm = $49ecca349270a938$var$defaults.concat([
    "~",
    "|"
]);
var $49ecca349270a938$var$commonmark = $49ecca349270a938$var$gfm.concat([
    "\n",
    '"',
    "$",
    "%",
    "&",
    "'",
    ",",
    "/",
    ":",
    ";",
    "<",
    "=",
    "?",
    "@",
    "^"
]);
$49ecca349270a938$var$escapes.default = $49ecca349270a938$var$defaults;
$49ecca349270a938$var$escapes.gfm = $49ecca349270a938$var$gfm;
$49ecca349270a938$var$escapes.commonmark = $49ecca349270a938$var$commonmark;
// Get markdown escapes.
function $49ecca349270a938$var$escapes(options) {
    var settings = options || {};
    if (settings.commonmark) return $49ecca349270a938$var$commonmark;
    return settings.gfm ? $49ecca349270a938$var$gfm : $49ecca349270a938$var$defaults;
}

});

parcelRegister("2WaU5", function(module, exports) {
"use strict";

module.exports = {
    position: true,
    gfm: true,
    commonmark: false,
    footnotes: false,
    pedantic: false,
    blocks: (parcelRequire("7FKxk"))
};

});
parcelRegister("7FKxk", function(module, exports) {
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "meta",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "pre",
    "section",
    "source",
    "title",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});



parcelRegister("gVkoZ", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $k54iK = parcelRequire("k54iK");
module.exports = $c521cba1cfa0f111$var$parse;
var $c521cba1cfa0f111$var$lineFeed = "\n";
var $c521cba1cfa0f111$var$lineBreaksExpression = /\r\n|\r/g;
// Parse the bound file.
function $c521cba1cfa0f111$var$parse() {
    var self = this;
    var value = String(self.file);
    var start = {
        line: 1,
        column: 1,
        offset: 0
    };
    var content = $36bRz(start);
    var node;
    // Clean non-unix newlines: `\r\n` and `\r` are all changed to `\n`.
    // This should not affect positional information.
    value = value.replace($c521cba1cfa0f111$var$lineBreaksExpression, $c521cba1cfa0f111$var$lineFeed);
    // BOM.
    if (value.charCodeAt(0) === 0xfeff) {
        value = value.slice(1);
        content.column++;
        content.offset++;
    }
    node = {
        type: "root",
        children: self.tokenizeBlock(value, content),
        position: {
            start: start,
            end: self.eof || $36bRz(start)
        }
    };
    if (!self.options.position) $k54iK(node, true);
    return node;
}

});
parcelRegister("k54iK", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
module.exports = $e9e79c6ff1696951$var$removePosition;
function $e9e79c6ff1696951$var$removePosition(node, force) {
    $KDBsL(node, force ? $e9e79c6ff1696951$var$hard : $e9e79c6ff1696951$var$soft);
    return node;
}
function $e9e79c6ff1696951$var$hard(node) {
    delete node.position;
}
function $e9e79c6ff1696951$var$soft(node) {
    node.position = undefined;
}

});
parcelRegister("KDBsL", function(module, exports) {
"use strict";
module.exports = $08c3045f17a63617$var$visit;

var $5yqcV = parcelRequire("5yqcV");
var $08c3045f17a63617$var$CONTINUE = $5yqcV.CONTINUE;
var $08c3045f17a63617$var$SKIP = $5yqcV.SKIP;
var $08c3045f17a63617$var$EXIT = $5yqcV.EXIT;
$08c3045f17a63617$var$visit.CONTINUE = $08c3045f17a63617$var$CONTINUE;
$08c3045f17a63617$var$visit.SKIP = $08c3045f17a63617$var$SKIP;
$08c3045f17a63617$var$visit.EXIT = $08c3045f17a63617$var$EXIT;
function $08c3045f17a63617$var$visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $5yqcV(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("5yqcV", function(module, exports) {
"use strict";
module.exports = $40b474fa08467108$var$visitParents;

var $3AImh = parcelRequire("3AImh");
var $40b474fa08467108$var$CONTINUE = true;
var $40b474fa08467108$var$SKIP = "skip";
var $40b474fa08467108$var$EXIT = false;
$40b474fa08467108$var$visitParents.CONTINUE = $40b474fa08467108$var$CONTINUE;
$40b474fa08467108$var$visitParents.SKIP = $40b474fa08467108$var$SKIP;
$40b474fa08467108$var$visitParents.EXIT = $40b474fa08467108$var$EXIT;
function $40b474fa08467108$var$visitParents(tree, test, visitor, reverse) {
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $3AImh(test);
    one(tree, null, []);
    // Visit a single node.
    function one(node, index, parents) {
        var result = [];
        var subresult;
        if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = $40b474fa08467108$var$toResult(visitor(node, parents));
            if (result[0] === $40b474fa08467108$var$EXIT) return result;
        }
        if (node.children && result[0] !== $40b474fa08467108$var$SKIP) {
            subresult = $40b474fa08467108$var$toResult(all(node.children, parents.concat(node)));
            return subresult[0] === $40b474fa08467108$var$EXIT ? subresult : result;
        }
        return result;
    }
    // Visit children in `parent`.
    function all(children, parents) {
        var min = -1;
        var step = reverse ? -1 : 1;
        var index = (reverse ? children.length : min) + step;
        var result;
        while(index > min && index < children.length){
            result = one(children[index], index, parents);
            if (result[0] === $40b474fa08467108$var$EXIT) return result;
            index = typeof result[1] === "number" ? result[1] : index + step;
        }
    }
}
function $40b474fa08467108$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $40b474fa08467108$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("3AImh", function(module, exports) {
"use strict";
module.exports = $29d72484875d47da$var$convert;
function $29d72484875d47da$var$convert(test) {
    if (typeof test === "string") return $29d72484875d47da$var$typeFactory(test);
    if (test === null || test === undefined) return $29d72484875d47da$var$ok;
    if (typeof test === "object") return ("length" in test ? $29d72484875d47da$var$anyFactory : $29d72484875d47da$var$matchesFactory)(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
function $29d72484875d47da$var$convertAll(tests) {
    var results = [];
    var length = tests.length;
    var index = -1;
    while(++index < length)results[index] = $29d72484875d47da$var$convert(tests[index]);
    return results;
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $29d72484875d47da$var$matchesFactory(test) {
    return matches;
    function matches(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $29d72484875d47da$var$anyFactory(tests) {
    var checks = $29d72484875d47da$var$convertAll(tests);
    var length = checks.length;
    return matches;
    function matches() {
        var index = -1;
        while(++index < length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $29d72484875d47da$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $29d72484875d47da$var$ok() {
    return true;
}

});





parcelRegister("eWCwV", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");
module.exports = $ae145ebbbe9cda62$var$newline;
var $ae145ebbbe9cda62$var$lineFeed = "\n";
function $ae145ebbbe9cda62$var$newline(eat, value, silent) {
    var character = value.charAt(0);
    var length;
    var subvalue;
    var queue;
    var index;
    if (character !== $ae145ebbbe9cda62$var$lineFeed) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    index = 1;
    length = value.length;
    subvalue = character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        queue += character;
        if (character === $ae145ebbbe9cda62$var$lineFeed) {
            subvalue += queue;
            queue = "";
        }
        index++;
    }
    eat(subvalue);
}

});
parcelRegister("kZNgz", function(module, exports) {
"use strict";
module.exports = $f48fb86a79611e98$var$whitespace;
var $f48fb86a79611e98$var$fromCode = String.fromCharCode;
var $f48fb86a79611e98$var$re = /\s/;
// Check if the given character code, or the character code at the first
// character, is a whitespace character.
function $f48fb86a79611e98$var$whitespace(character) {
    return $f48fb86a79611e98$var$re.test(typeof character === "number" ? $f48fb86a79611e98$var$fromCode(character) : character.charAt(0));
}

});


parcelRegister("g5BkQ", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");

var $5H7vD = parcelRequire("5H7vD");
module.exports = $bb6a12f5361d4ec6$var$indentedCode;
var $bb6a12f5361d4ec6$var$lineFeed = "\n";
var $bb6a12f5361d4ec6$var$tab = "	";
var $bb6a12f5361d4ec6$var$space = " ";
var $bb6a12f5361d4ec6$var$tabSize = 4;
var $bb6a12f5361d4ec6$var$codeIndent = $j6axH($bb6a12f5361d4ec6$var$space, $bb6a12f5361d4ec6$var$tabSize);
function $bb6a12f5361d4ec6$var$indentedCode(eat, value, silent) {
    var index = -1;
    var length = value.length;
    var subvalue = "";
    var content = "";
    var subvalueQueue = "";
    var contentQueue = "";
    var character;
    var blankQueue;
    var indent;
    while(++index < length){
        character = value.charAt(index);
        if (indent) {
            indent = false;
            subvalue += subvalueQueue;
            content += contentQueue;
            subvalueQueue = "";
            contentQueue = "";
            if (character === $bb6a12f5361d4ec6$var$lineFeed) {
                subvalueQueue = character;
                contentQueue = character;
            } else {
                subvalue += character;
                content += character;
                while(++index < length){
                    character = value.charAt(index);
                    if (!character || character === $bb6a12f5361d4ec6$var$lineFeed) {
                        contentQueue = character;
                        subvalueQueue = character;
                        break;
                    }
                    subvalue += character;
                    content += character;
                }
            }
        } else if (character === $bb6a12f5361d4ec6$var$space && value.charAt(index + 1) === character && value.charAt(index + 2) === character && value.charAt(index + 3) === character) {
            subvalueQueue += $bb6a12f5361d4ec6$var$codeIndent;
            index += 3;
            indent = true;
        } else if (character === $bb6a12f5361d4ec6$var$tab) {
            subvalueQueue += character;
            indent = true;
        } else {
            blankQueue = "";
            while(character === $bb6a12f5361d4ec6$var$tab || character === $bb6a12f5361d4ec6$var$space){
                blankQueue += character;
                character = value.charAt(++index);
            }
            if (character !== $bb6a12f5361d4ec6$var$lineFeed) break;
            subvalueQueue += blankQueue + character;
            contentQueue += character;
        }
    }
    if (content) {
        if (silent) return true;
        return eat(subvalue)({
            type: "code",
            lang: null,
            meta: null,
            value: $5H7vD(content)
        });
    }
}

});
parcelRegister("j6axH", function(module, exports) {
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
/**
 * Results cache
 */ var $de76c169196a1fdc$var$res = "";
var $de76c169196a1fdc$var$cache;
/**
 * Expose `repeat`
 */ module.exports = $de76c169196a1fdc$var$repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function $de76c169196a1fdc$var$repeat(str, num) {
    if (typeof str !== "string") throw new TypeError("expected a string");
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if ($de76c169196a1fdc$var$cache !== str || typeof $de76c169196a1fdc$var$cache === "undefined") {
        $de76c169196a1fdc$var$cache = str;
        $de76c169196a1fdc$var$res = "";
    } else if ($de76c169196a1fdc$var$res.length >= max) return $de76c169196a1fdc$var$res.substr(0, max);
    while(max > $de76c169196a1fdc$var$res.length && num > 1){
        if (num & 1) $de76c169196a1fdc$var$res += str;
        num >>= 1;
        str += str;
    }
    $de76c169196a1fdc$var$res += str;
    $de76c169196a1fdc$var$res = $de76c169196a1fdc$var$res.substr(0, max);
    return $de76c169196a1fdc$var$res;
}

});

parcelRegister("5H7vD", function(module, exports) {
"use strict";
module.exports = $4256cb184abd9807$var$trimTrailingLines;
var $4256cb184abd9807$var$line = "\n";
// Remove final newline characters from `value`.
function $4256cb184abd9807$var$trimTrailingLines(value) {
    var val = String(value);
    var index = val.length;
    while(val.charAt(--index) === $4256cb184abd9807$var$line);
    return val.slice(0, index + 1);
}

});


parcelRegister("8jp8K", function(module, exports) {
"use strict";
module.exports = $018fcccbdc17e6da$var$fencedCode;
var $018fcccbdc17e6da$var$lineFeed = "\n";
var $018fcccbdc17e6da$var$tab = "	";
var $018fcccbdc17e6da$var$space = " ";
var $018fcccbdc17e6da$var$tilde = "~";
var $018fcccbdc17e6da$var$graveAccent = "`";
var $018fcccbdc17e6da$var$minFenceCount = 3;
var $018fcccbdc17e6da$var$tabSize = 4;
function $018fcccbdc17e6da$var$fencedCode(eat, value, silent) {
    var self = this;
    var gfm = self.options.gfm;
    var length = value.length + 1;
    var index = 0;
    var subvalue = "";
    var fenceCount;
    var marker;
    var character;
    var flag;
    var lang;
    var meta;
    var queue;
    var content;
    var exdentedContent;
    var closing;
    var exdentedClosing;
    var indent;
    var now;
    if (!gfm) return;
    // Eat initial spacing.
    while(index < length){
        character = value.charAt(index);
        if (character !== $018fcccbdc17e6da$var$space && character !== $018fcccbdc17e6da$var$tab) break;
        subvalue += character;
        index++;
    }
    indent = index;
    // Eat the fence.
    character = value.charAt(index);
    if (character !== $018fcccbdc17e6da$var$tilde && character !== $018fcccbdc17e6da$var$graveAccent) return;
    index++;
    marker = character;
    fenceCount = 1;
    subvalue += character;
    while(index < length){
        character = value.charAt(index);
        if (character !== marker) break;
        subvalue += character;
        fenceCount++;
        index++;
    }
    if (fenceCount < $018fcccbdc17e6da$var$minFenceCount) return;
    // Eat spacing before flag.
    while(index < length){
        character = value.charAt(index);
        if (character !== $018fcccbdc17e6da$var$space && character !== $018fcccbdc17e6da$var$tab) break;
        subvalue += character;
        index++;
    }
    // Eat flag.
    flag = "";
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $018fcccbdc17e6da$var$lineFeed || marker === $018fcccbdc17e6da$var$graveAccent && character === marker) break;
        if (character === $018fcccbdc17e6da$var$space || character === $018fcccbdc17e6da$var$tab) queue += character;
        else {
            flag += queue + character;
            queue = "";
        }
        index++;
    }
    character = value.charAt(index);
    if (character && character !== $018fcccbdc17e6da$var$lineFeed) return;
    if (silent) return true;
    now = eat.now();
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += flag;
    flag = self.decode.raw(self.unescape(flag), now);
    if (queue) subvalue += queue;
    queue = "";
    closing = "";
    exdentedClosing = "";
    content = "";
    exdentedContent = "";
    var skip = true;
    // Eat content.
    while(index < length){
        character = value.charAt(index);
        content += closing;
        exdentedContent += exdentedClosing;
        closing = "";
        exdentedClosing = "";
        if (character !== $018fcccbdc17e6da$var$lineFeed) {
            content += character;
            exdentedClosing += character;
            index++;
            continue;
        }
        // The first line feed is ignored. Others aren’t.
        if (skip) {
            subvalue += character;
            skip = false;
        } else {
            closing += character;
            exdentedClosing += character;
        }
        queue = "";
        index++;
        while(index < length){
            character = value.charAt(index);
            if (character !== $018fcccbdc17e6da$var$space) break;
            queue += character;
            index++;
        }
        closing += queue;
        exdentedClosing += queue.slice(indent);
        if (queue.length >= $018fcccbdc17e6da$var$tabSize) continue;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character !== marker) break;
            queue += character;
            index++;
        }
        closing += queue;
        exdentedClosing += queue;
        if (queue.length < fenceCount) continue;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character !== $018fcccbdc17e6da$var$space && character !== $018fcccbdc17e6da$var$tab) break;
            closing += character;
            exdentedClosing += character;
            index++;
        }
        if (!character || character === $018fcccbdc17e6da$var$lineFeed) break;
    }
    subvalue += content + closing;
    // Get lang and meta from the flag.
    index = -1;
    length = flag.length;
    while(++index < length){
        character = flag.charAt(index);
        if (character === $018fcccbdc17e6da$var$space || character === $018fcccbdc17e6da$var$tab) {
            if (!lang) lang = flag.slice(0, index);
        } else if (lang) {
            meta = flag.slice(index);
            break;
        }
    }
    return eat(subvalue)({
        type: "code",
        lang: lang || flag || null,
        meta: meta || null,
        value: exdentedContent
    });
}

});

parcelRegister("hFW9g", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $hIMnZ = parcelRequire("hIMnZ");
module.exports = $cde35f147e4145a8$var$blockquote;
var $cde35f147e4145a8$var$lineFeed = "\n";
var $cde35f147e4145a8$var$tab = "	";
var $cde35f147e4145a8$var$space = " ";
var $cde35f147e4145a8$var$greaterThan = ">";
function $cde35f147e4145a8$var$blockquote(eat, value, silent) {
    var self = this;
    var offsets = self.offset;
    var tokenizers = self.blockTokenizers;
    var interruptors = self.interruptBlockquote;
    var now = eat.now();
    var currentLine = now.line;
    var length = value.length;
    var values = [];
    var contents = [];
    var indents = [];
    var add;
    var index = 0;
    var character;
    var rest;
    var nextIndex;
    var content;
    var line;
    var startIndex;
    var prefixed;
    var exit;
    while(index < length){
        character = value.charAt(index);
        if (character !== $cde35f147e4145a8$var$space && character !== $cde35f147e4145a8$var$tab) break;
        index++;
    }
    if (value.charAt(index) !== $cde35f147e4145a8$var$greaterThan) return;
    if (silent) return true;
    index = 0;
    while(index < length){
        nextIndex = value.indexOf($cde35f147e4145a8$var$lineFeed, index);
        startIndex = index;
        prefixed = false;
        if (nextIndex === -1) nextIndex = length;
        while(index < length){
            character = value.charAt(index);
            if (character !== $cde35f147e4145a8$var$space && character !== $cde35f147e4145a8$var$tab) break;
            index++;
        }
        if (value.charAt(index) === $cde35f147e4145a8$var$greaterThan) {
            index++;
            prefixed = true;
            if (value.charAt(index) === $cde35f147e4145a8$var$space) index++;
        } else index = startIndex;
        content = value.slice(index, nextIndex);
        if (!prefixed && !$2Lc6r(content)) {
            index = startIndex;
            break;
        }
        if (!prefixed) {
            rest = value.slice(index);
            // Check if the following code contains a possible block.
            if ($hIMnZ(interruptors, tokenizers, self, [
                eat,
                rest,
                true
            ])) break;
        }
        line = startIndex === index ? content : value.slice(startIndex, nextIndex);
        indents.push(index - startIndex);
        values.push(line);
        contents.push(content);
        index = nextIndex + 1;
    }
    index = -1;
    length = indents.length;
    add = eat(values.join($cde35f147e4145a8$var$lineFeed));
    while(++index < length){
        offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
        currentLine++;
    }
    exit = self.enterBlock();
    contents = self.tokenizeBlock(contents.join($cde35f147e4145a8$var$lineFeed), now);
    exit();
    return add({
        type: "blockquote",
        children: contents
    });
}

});
parcelRegister("2Lc6r", function(module, exports) {
exports = module.exports = trim;
function trim(str) {
    return str.replace(/^\s*|\s*$/g, "");
}
exports.left = function(str) {
    return str.replace(/^\s*/, "");
};
exports.right = function(str) {
    return str.replace(/\s*$/, "");
};

});

parcelRegister("hIMnZ", function(module, exports) {
"use strict";
module.exports = $ce6c1424c6567c8c$var$interrupt;
function $ce6c1424c6567c8c$var$interrupt(interruptors, tokenizers, ctx, params) {
    var length = interruptors.length;
    var index = -1;
    var interruptor;
    var config;
    while(++index < length){
        interruptor = interruptors[index];
        config = interruptor[1] || {};
        if (config.pedantic !== undefined && config.pedantic !== ctx.options.pedantic) continue;
        if (config.commonmark !== undefined && config.commonmark !== ctx.options.commonmark) continue;
        if (tokenizers[interruptor[0]].apply(ctx, params)) return true;
    }
    return false;
}

});


parcelRegister("2Y1RE", function(module, exports) {
"use strict";
module.exports = $2292a1942d04c20a$var$atxHeading;
var $2292a1942d04c20a$var$lineFeed = "\n";
var $2292a1942d04c20a$var$tab = "	";
var $2292a1942d04c20a$var$space = " ";
var $2292a1942d04c20a$var$numberSign = "#";
var $2292a1942d04c20a$var$maxFenceCount = 6;
function $2292a1942d04c20a$var$atxHeading(eat, value, silent) {
    var self = this;
    var pedantic = self.options.pedantic;
    var length = value.length + 1;
    var index = -1;
    var now = eat.now();
    var subvalue = "";
    var content = "";
    var character;
    var queue;
    var depth;
    // Eat initial spacing.
    while(++index < length){
        character = value.charAt(index);
        if (character !== $2292a1942d04c20a$var$space && character !== $2292a1942d04c20a$var$tab) {
            index--;
            break;
        }
        subvalue += character;
    }
    // Eat hashes.
    depth = 0;
    while(++index <= length){
        character = value.charAt(index);
        if (character !== $2292a1942d04c20a$var$numberSign) {
            index--;
            break;
        }
        subvalue += character;
        depth++;
    }
    if (depth > $2292a1942d04c20a$var$maxFenceCount) return;
    if (!depth || !pedantic && value.charAt(index + 1) === $2292a1942d04c20a$var$numberSign) return;
    length = value.length + 1;
    // Eat intermediate white-space.
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character !== $2292a1942d04c20a$var$space && character !== $2292a1942d04c20a$var$tab) {
            index--;
            break;
        }
        queue += character;
    }
    // Exit when not in pedantic mode without spacing.
    if (!pedantic && queue.length === 0 && character && character !== $2292a1942d04c20a$var$lineFeed) return;
    if (silent) return true;
    // Eat content.
    subvalue += queue;
    queue = "";
    content = "";
    while(++index < length){
        character = value.charAt(index);
        if (!character || character === $2292a1942d04c20a$var$lineFeed) break;
        if (character !== $2292a1942d04c20a$var$space && character !== $2292a1942d04c20a$var$tab && character !== $2292a1942d04c20a$var$numberSign) {
            content += queue + character;
            queue = "";
            continue;
        }
        while(character === $2292a1942d04c20a$var$space || character === $2292a1942d04c20a$var$tab){
            queue += character;
            character = value.charAt(++index);
        }
        // `#` without a queue is part of the content.
        if (!pedantic && content && !queue && character === $2292a1942d04c20a$var$numberSign) {
            content += character;
            continue;
        }
        while(character === $2292a1942d04c20a$var$numberSign){
            queue += character;
            character = value.charAt(++index);
        }
        while(character === $2292a1942d04c20a$var$space || character === $2292a1942d04c20a$var$tab){
            queue += character;
            character = value.charAt(++index);
        }
        index--;
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += content + queue;
    return eat(subvalue)({
        type: "heading",
        depth: depth,
        children: self.tokenizeInline(content, now)
    });
}

});

parcelRegister("5GZmu", function(module, exports) {
"use strict";
module.exports = $4250792c50fd3b00$var$thematicBreak;
var $4250792c50fd3b00$var$tab = "	";
var $4250792c50fd3b00$var$lineFeed = "\n";
var $4250792c50fd3b00$var$space = " ";
var $4250792c50fd3b00$var$asterisk = "*";
var $4250792c50fd3b00$var$dash = "-";
var $4250792c50fd3b00$var$underscore = "_";
var $4250792c50fd3b00$var$maxCount = 3;
function $4250792c50fd3b00$var$thematicBreak(eat, value, silent) {
    var index = -1;
    var length = value.length + 1;
    var subvalue = "";
    var character;
    var marker;
    var markerCount;
    var queue;
    while(++index < length){
        character = value.charAt(index);
        if (character !== $4250792c50fd3b00$var$tab && character !== $4250792c50fd3b00$var$space) break;
        subvalue += character;
    }
    if (character !== $4250792c50fd3b00$var$asterisk && character !== $4250792c50fd3b00$var$dash && character !== $4250792c50fd3b00$var$underscore) return;
    marker = character;
    subvalue += character;
    markerCount = 1;
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character === marker) {
            markerCount++;
            subvalue += queue + marker;
            queue = "";
        } else if (character === $4250792c50fd3b00$var$space) queue += character;
        else if (markerCount >= $4250792c50fd3b00$var$maxCount && (!character || character === $4250792c50fd3b00$var$lineFeed)) {
            subvalue += queue;
            if (silent) return true;
            return eat(subvalue)({
                type: "thematicBreak"
            });
        } else return;
    }
}

});

parcelRegister("gMkLN", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $j6axH = parcelRequire("j6axH");

var $35IlD = parcelRequire("35IlD");

var $4EdzQ = parcelRequire("4EdzQ");

var $gi4CN = parcelRequire("gi4CN");

var $hIMnZ = parcelRequire("hIMnZ");
module.exports = $c3713d7ce0443654$var$list;
var $c3713d7ce0443654$var$asterisk = "*";
var $c3713d7ce0443654$var$underscore = "_";
var $c3713d7ce0443654$var$plusSign = "+";
var $c3713d7ce0443654$var$dash = "-";
var $c3713d7ce0443654$var$dot = ".";
var $c3713d7ce0443654$var$space = " ";
var $c3713d7ce0443654$var$lineFeed = "\n";
var $c3713d7ce0443654$var$tab = "	";
var $c3713d7ce0443654$var$rightParenthesis = ")";
var $c3713d7ce0443654$var$lowercaseX = "x";
var $c3713d7ce0443654$var$tabSize = 4;
var $c3713d7ce0443654$var$looseListItemExpression = /\n\n(?!\s*$)/;
var $c3713d7ce0443654$var$taskItemExpression = /^\[([ \t]|x|X)][ \t]/;
var $c3713d7ce0443654$var$bulletExpression = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
var $c3713d7ce0443654$var$pedanticBulletExpression = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
var $c3713d7ce0443654$var$initialIndentExpression = /^( {1,4}|\t)?/gm;
function $c3713d7ce0443654$var$list(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var pedantic = self.options.pedantic;
    var tokenizers = self.blockTokenizers;
    var interuptors = self.interruptList;
    var index = 0;
    var length = value.length;
    var start = null;
    var size = 0;
    var queue;
    var ordered;
    var character;
    var marker;
    var nextIndex;
    var startIndex;
    var prefixed;
    var currentMarker;
    var content;
    var line;
    var prevEmpty;
    var empty;
    var items;
    var allLines;
    var emptyLines;
    var item;
    var enterTop;
    var exitBlockquote;
    var spread = false;
    var node;
    var now;
    var end;
    var indented;
    while(index < length){
        character = value.charAt(index);
        if (character === $c3713d7ce0443654$var$tab) size += $c3713d7ce0443654$var$tabSize - size % $c3713d7ce0443654$var$tabSize;
        else if (character === $c3713d7ce0443654$var$space) size++;
        else break;
        index++;
    }
    if (size >= $c3713d7ce0443654$var$tabSize) return;
    character = value.charAt(index);
    if (character === $c3713d7ce0443654$var$asterisk || character === $c3713d7ce0443654$var$plusSign || character === $c3713d7ce0443654$var$dash) {
        marker = character;
        ordered = false;
    } else {
        ordered = true;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (!$35IlD(character)) break;
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (!queue || !(character === $c3713d7ce0443654$var$dot || commonmark && character === $c3713d7ce0443654$var$rightParenthesis)) return;
        start = parseInt(queue, 10);
        marker = character;
    }
    character = value.charAt(++index);
    if (character !== $c3713d7ce0443654$var$space && character !== $c3713d7ce0443654$var$tab && (pedantic || character !== $c3713d7ce0443654$var$lineFeed && character !== "")) return;
    if (silent) return true;
    index = 0;
    items = [];
    allLines = [];
    emptyLines = [];
    while(index < length){
        nextIndex = value.indexOf($c3713d7ce0443654$var$lineFeed, index);
        startIndex = index;
        prefixed = false;
        indented = false;
        if (nextIndex === -1) nextIndex = length;
        end = index + $c3713d7ce0443654$var$tabSize;
        size = 0;
        while(index < length){
            character = value.charAt(index);
            if (character === $c3713d7ce0443654$var$tab) size += $c3713d7ce0443654$var$tabSize - size % $c3713d7ce0443654$var$tabSize;
            else if (character === $c3713d7ce0443654$var$space) size++;
            else break;
            index++;
        }
        if (size >= $c3713d7ce0443654$var$tabSize) indented = true;
        if (item && size >= item.indent) indented = true;
        character = value.charAt(index);
        currentMarker = null;
        if (!indented) {
            if (character === $c3713d7ce0443654$var$asterisk || character === $c3713d7ce0443654$var$plusSign || character === $c3713d7ce0443654$var$dash) {
                currentMarker = character;
                index++;
                size++;
            } else {
                queue = "";
                while(index < length){
                    character = value.charAt(index);
                    if (!$35IlD(character)) break;
                    queue += character;
                    index++;
                }
                character = value.charAt(index);
                index++;
                if (queue && (character === $c3713d7ce0443654$var$dot || commonmark && character === $c3713d7ce0443654$var$rightParenthesis)) {
                    currentMarker = character;
                    size += queue.length + 1;
                }
            }
            if (currentMarker) {
                character = value.charAt(index);
                if (character === $c3713d7ce0443654$var$tab) {
                    size += $c3713d7ce0443654$var$tabSize - size % $c3713d7ce0443654$var$tabSize;
                    index++;
                } else if (character === $c3713d7ce0443654$var$space) {
                    end = index + $c3713d7ce0443654$var$tabSize;
                    while(index < end){
                        if (value.charAt(index) !== $c3713d7ce0443654$var$space) break;
                        index++;
                        size++;
                    }
                    if (index === end && value.charAt(index) === $c3713d7ce0443654$var$space) {
                        index -= $c3713d7ce0443654$var$tabSize - 1;
                        size -= $c3713d7ce0443654$var$tabSize - 1;
                    }
                } else if (character !== $c3713d7ce0443654$var$lineFeed && character !== "") currentMarker = null;
            }
        }
        if (currentMarker) {
            if (!pedantic && marker !== currentMarker) break;
            prefixed = true;
        } else {
            if (!commonmark && !indented && value.charAt(startIndex) === $c3713d7ce0443654$var$space) indented = true;
            else if (commonmark && item) indented = size >= item.indent || size > $c3713d7ce0443654$var$tabSize;
            prefixed = false;
            index = startIndex;
        }
        line = value.slice(startIndex, nextIndex);
        content = startIndex === index ? line : value.slice(index, nextIndex);
        if (currentMarker === $c3713d7ce0443654$var$asterisk || currentMarker === $c3713d7ce0443654$var$underscore || currentMarker === $c3713d7ce0443654$var$dash) {
            if (tokenizers.thematicBreak.call(self, eat, line, true)) break;
        }
        prevEmpty = empty;
        empty = !prefixed && !$2Lc6r(content).length;
        if (indented && item) {
            item.value = item.value.concat(emptyLines, line);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        } else if (prefixed) {
            if (emptyLines.length !== 0) {
                spread = true;
                item.value.push("");
                item.trail = emptyLines.concat();
            }
            item = {
                value: [
                    line
                ],
                indent: size,
                trail: []
            };
            items.push(item);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        } else if (empty) {
            if (prevEmpty && !commonmark) break;
            emptyLines.push(line);
        } else {
            if (prevEmpty) break;
            if ($hIMnZ(interuptors, tokenizers, self, [
                eat,
                line,
                true
            ])) break;
            item.value = item.value.concat(emptyLines, line);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        }
        index = nextIndex + 1;
    }
    node = eat(allLines.join($c3713d7ce0443654$var$lineFeed)).reset({
        type: "list",
        ordered: ordered,
        start: start,
        spread: spread,
        children: []
    });
    enterTop = self.enterList();
    exitBlockquote = self.enterBlock();
    index = -1;
    length = items.length;
    while(++index < length){
        item = items[index].value.join($c3713d7ce0443654$var$lineFeed);
        now = eat.now();
        eat(item)($c3713d7ce0443654$var$listItem(self, item, now), node);
        item = items[index].trail.join($c3713d7ce0443654$var$lineFeed);
        if (index !== length - 1) item += $c3713d7ce0443654$var$lineFeed;
        eat(item);
    }
    enterTop();
    exitBlockquote();
    return node;
}
function $c3713d7ce0443654$var$listItem(ctx, value, position) {
    var offsets = ctx.offset;
    var fn = ctx.options.pedantic ? $c3713d7ce0443654$var$pedanticListItem : $c3713d7ce0443654$var$normalListItem;
    var checked = null;
    var task;
    var indent;
    value = fn.apply(null, arguments);
    if (ctx.options.gfm) {
        task = value.match($c3713d7ce0443654$var$taskItemExpression);
        if (task) {
            indent = task[0].length;
            checked = task[1].toLowerCase() === $c3713d7ce0443654$var$lowercaseX;
            offsets[position.line] += indent;
            value = value.slice(indent);
        }
    }
    return {
        type: "listItem",
        spread: $c3713d7ce0443654$var$looseListItemExpression.test(value),
        checked: checked,
        children: ctx.tokenizeBlock(value, position)
    };
}
// Create a list-item using overly simple mechanics.
function $c3713d7ce0443654$var$pedanticListItem(ctx, value, position) {
    var offsets = ctx.offset;
    var line = position.line;
    // Remove the list-item’s bullet.
    value = value.replace($c3713d7ce0443654$var$pedanticBulletExpression, replacer);
    // The initial line was also matched by the below, so we reset the `line`.
    line = position.line;
    return value.replace($c3713d7ce0443654$var$initialIndentExpression, replacer);
    // A simple replacer which removed all matches, and adds their length to
    // `offset`.
    function replacer($0) {
        offsets[line] = (offsets[line] || 0) + $0.length;
        line++;
        return "";
    }
}
// Create a list-item using sane mechanics.
function $c3713d7ce0443654$var$normalListItem(ctx, value, position) {
    var offsets = ctx.offset;
    var line = position.line;
    var max;
    var bullet;
    var rest;
    var lines;
    var trimmedLines;
    var index;
    var length;
    // Remove the list-item’s bullet.
    value = value.replace($c3713d7ce0443654$var$bulletExpression, replacer);
    lines = value.split($c3713d7ce0443654$var$lineFeed);
    trimmedLines = $gi4CN(value, $4EdzQ(max).indent).split($c3713d7ce0443654$var$lineFeed);
    // We replaced the initial bullet with something else above, which was used
    // to trick `removeIndentation` into removing some more characters when
    // possible.  However, that could result in the initial line to be stripped
    // more than it should be.
    trimmedLines[0] = rest;
    offsets[line] = (offsets[line] || 0) + bullet.length;
    line++;
    index = 0;
    length = lines.length;
    while(++index < length){
        offsets[line] = (offsets[line] || 0) + lines[index].length - trimmedLines[index].length;
        line++;
    }
    return trimmedLines.join($c3713d7ce0443654$var$lineFeed);
    /* eslint-disable-next-line max-params */ function replacer($0, $1, $2, $3, $4) {
        bullet = $1 + $2 + $3;
        rest = $4;
        // Make sure that the first nine numbered list items can indent with an
        // extra space.  That is, when the bullet did not receive an extra final
        // space.
        if (Number($2) < 10 && bullet.length % 2 === 1) $2 = $c3713d7ce0443654$var$space + $2;
        max = $1 + $j6axH($c3713d7ce0443654$var$space, $2.length) + $3;
        return max + rest;
    }
}

});
parcelRegister("4EdzQ", function(module, exports) {
"use strict";
module.exports = $36256dfe6a4cc2e6$var$indentation;
var $36256dfe6a4cc2e6$var$tab = "	";
var $36256dfe6a4cc2e6$var$space = " ";
var $36256dfe6a4cc2e6$var$spaceSize = 1;
var $36256dfe6a4cc2e6$var$tabSize = 4;
// Gets indentation information for a line.
function $36256dfe6a4cc2e6$var$indentation(value) {
    var index = 0;
    var indent = 0;
    var character = value.charAt(index);
    var stops = {};
    var size;
    while(character === $36256dfe6a4cc2e6$var$tab || character === $36256dfe6a4cc2e6$var$space){
        size = character === $36256dfe6a4cc2e6$var$tab ? $36256dfe6a4cc2e6$var$tabSize : $36256dfe6a4cc2e6$var$spaceSize;
        indent += size;
        if (size > 1) indent = Math.floor(indent / size) * size;
        stops[indent] = index;
        character = value.charAt(++index);
    }
    return {
        indent: indent,
        stops: stops
    };
}

});

parcelRegister("gi4CN", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $j6axH = parcelRequire("j6axH");

var $4EdzQ = parcelRequire("4EdzQ");
module.exports = $bdc1ea2b9c465561$var$indentation;
var $bdc1ea2b9c465561$var$tab = "	";
var $bdc1ea2b9c465561$var$lineFeed = "\n";
var $bdc1ea2b9c465561$var$space = " ";
var $bdc1ea2b9c465561$var$exclamationMark = "!";
// Remove the minimum indent from every line in `value`.  Supports both tab,
// spaced, and mixed indentation (as well as possible).
function $bdc1ea2b9c465561$var$indentation(value, maximum) {
    var values = value.split($bdc1ea2b9c465561$var$lineFeed);
    var position = values.length + 1;
    var minIndent = Infinity;
    var matrix = [];
    var index;
    var indentation;
    var stops;
    var padding;
    values.unshift($j6axH($bdc1ea2b9c465561$var$space, maximum) + $bdc1ea2b9c465561$var$exclamationMark);
    while(position--){
        indentation = $4EdzQ(values[position]);
        matrix[position] = indentation.stops;
        if ($2Lc6r(values[position]).length === 0) continue;
        if (indentation.indent) {
            if (indentation.indent > 0 && indentation.indent < minIndent) minIndent = indentation.indent;
        } else {
            minIndent = Infinity;
            break;
        }
    }
    if (minIndent !== Infinity) {
        position = values.length;
        while(position--){
            stops = matrix[position];
            index = minIndent;
            while(index && !(index in stops))index--;
            if ($2Lc6r(values[position]).length !== 0 && minIndent && index !== minIndent) padding = $bdc1ea2b9c465561$var$tab;
            else padding = "";
            values[position] = padding + values[position].slice(index in stops ? stops[index] + 1 : 0);
        }
    }
    values.shift();
    return values.join($bdc1ea2b9c465561$var$lineFeed);
}

});


parcelRegister("6gCu0", function(module, exports) {
"use strict";
module.exports = $490216a0d03d17d9$var$setextHeading;
var $490216a0d03d17d9$var$lineFeed = "\n";
var $490216a0d03d17d9$var$tab = "	";
var $490216a0d03d17d9$var$space = " ";
var $490216a0d03d17d9$var$equalsTo = "=";
var $490216a0d03d17d9$var$dash = "-";
var $490216a0d03d17d9$var$maxIndent = 3;
var $490216a0d03d17d9$var$equalsToDepth = 1;
var $490216a0d03d17d9$var$dashDepth = 2;
function $490216a0d03d17d9$var$setextHeading(eat, value, silent) {
    var self = this;
    var now = eat.now();
    var length = value.length;
    var index = -1;
    var subvalue = "";
    var content;
    var queue;
    var character;
    var marker;
    var depth;
    // Eat initial indentation.
    while(++index < length){
        character = value.charAt(index);
        if (character !== $490216a0d03d17d9$var$space || index >= $490216a0d03d17d9$var$maxIndent) {
            index--;
            break;
        }
        subvalue += character;
    }
    // Eat content.
    content = "";
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character === $490216a0d03d17d9$var$lineFeed) {
            index--;
            break;
        }
        if (character === $490216a0d03d17d9$var$space || character === $490216a0d03d17d9$var$tab) queue += character;
        else {
            content += queue + character;
            queue = "";
        }
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += content + queue;
    // Ensure the content is followed by a newline and a valid marker.
    character = value.charAt(++index);
    marker = value.charAt(++index);
    if (character !== $490216a0d03d17d9$var$lineFeed || marker !== $490216a0d03d17d9$var$equalsTo && marker !== $490216a0d03d17d9$var$dash) return;
    subvalue += character;
    // Eat Setext-line.
    queue = marker;
    depth = marker === $490216a0d03d17d9$var$equalsTo ? $490216a0d03d17d9$var$equalsToDepth : $490216a0d03d17d9$var$dashDepth;
    while(++index < length){
        character = value.charAt(index);
        if (character !== marker) {
            if (character !== $490216a0d03d17d9$var$lineFeed) return;
            index--;
            break;
        }
        queue += character;
    }
    if (silent) return true;
    return eat(subvalue + queue)({
        type: "heading",
        depth: depth,
        children: self.tokenizeInline(content, now)
    });
}

});

parcelRegister("8EbVz", function(module, exports) {
"use strict";

var $irnv4 = parcelRequire("irnv4");
var $64bb4fbd32af98c8$require$openCloseTag = $irnv4.openCloseTag;
module.exports = $64bb4fbd32af98c8$var$blockHtml;
var $64bb4fbd32af98c8$var$tab = "	";
var $64bb4fbd32af98c8$var$space = " ";
var $64bb4fbd32af98c8$var$lineFeed = "\n";
var $64bb4fbd32af98c8$var$lessThan = "<";
var $64bb4fbd32af98c8$var$rawOpenExpression = /^<(script|pre|style)(?=(\s|>|$))/i;
var $64bb4fbd32af98c8$var$rawCloseExpression = /<\/(script|pre|style)>/i;
var $64bb4fbd32af98c8$var$commentOpenExpression = /^<!--/;
var $64bb4fbd32af98c8$var$commentCloseExpression = /-->/;
var $64bb4fbd32af98c8$var$instructionOpenExpression = /^<\?/;
var $64bb4fbd32af98c8$var$instructionCloseExpression = /\?>/;
var $64bb4fbd32af98c8$var$directiveOpenExpression = /^<![A-Za-z]/;
var $64bb4fbd32af98c8$var$directiveCloseExpression = />/;
var $64bb4fbd32af98c8$var$cdataOpenExpression = /^<!\[CDATA\[/;
var $64bb4fbd32af98c8$var$cdataCloseExpression = /\]\]>/;
var $64bb4fbd32af98c8$var$elementCloseExpression = /^$/;
var $64bb4fbd32af98c8$var$otherElementOpenExpression = new RegExp($64bb4fbd32af98c8$require$openCloseTag.source + "\\s*$");
function $64bb4fbd32af98c8$var$blockHtml(eat, value, silent) {
    var self = this;
    var blocks = self.options.blocks.join("|");
    var elementOpenExpression = new RegExp("^</?(" + blocks + ")(?=(\\s|/?>|$))", "i");
    var length = value.length;
    var index = 0;
    var next;
    var line;
    var offset;
    var character;
    var count;
    var sequence;
    var subvalue;
    var sequences = [
        [
            $64bb4fbd32af98c8$var$rawOpenExpression,
            $64bb4fbd32af98c8$var$rawCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$commentOpenExpression,
            $64bb4fbd32af98c8$var$commentCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$instructionOpenExpression,
            $64bb4fbd32af98c8$var$instructionCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$directiveOpenExpression,
            $64bb4fbd32af98c8$var$directiveCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$cdataOpenExpression,
            $64bb4fbd32af98c8$var$cdataCloseExpression,
            true
        ],
        [
            elementOpenExpression,
            $64bb4fbd32af98c8$var$elementCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$otherElementOpenExpression,
            $64bb4fbd32af98c8$var$elementCloseExpression,
            false
        ]
    ];
    // Eat initial spacing.
    while(index < length){
        character = value.charAt(index);
        if (character !== $64bb4fbd32af98c8$var$tab && character !== $64bb4fbd32af98c8$var$space) break;
        index++;
    }
    if (value.charAt(index) !== $64bb4fbd32af98c8$var$lessThan) return;
    next = value.indexOf($64bb4fbd32af98c8$var$lineFeed, index + 1);
    next = next === -1 ? length : next;
    line = value.slice(index, next);
    offset = -1;
    count = sequences.length;
    while(++offset < count)if (sequences[offset][0].test(line)) {
        sequence = sequences[offset];
        break;
    }
    if (!sequence) return;
    if (silent) return sequence[2];
    index = next;
    if (!sequence[1].test(line)) while(index < length){
        next = value.indexOf($64bb4fbd32af98c8$var$lineFeed, index + 1);
        next = next === -1 ? length : next;
        line = value.slice(index + 1, next);
        if (sequence[1].test(line)) {
            if (line) index = next;
            break;
        }
        index = next;
    }
    subvalue = value.slice(0, index);
    return eat(subvalue)({
        type: "html",
        value: subvalue
    });
}

});
parcelRegister("irnv4", function(module, exports) {

$parcel$export(module.exports, "openCloseTag", function () { return $d6ccfa4616af940f$export$a33a5d2984e0051b; }, function (v) { return $d6ccfa4616af940f$export$a33a5d2984e0051b = v; });
$parcel$export(module.exports, "tag", function () { return $d6ccfa4616af940f$export$2b067c6666111485; }, function (v) { return $d6ccfa4616af940f$export$2b067c6666111485 = v; });
var $d6ccfa4616af940f$export$a33a5d2984e0051b;
var $d6ccfa4616af940f$export$2b067c6666111485;
"use strict";
var $d6ccfa4616af940f$var$attributeName = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $d6ccfa4616af940f$var$unquoted = "[^\"'=<>`\\u0000-\\u0020]+";
var $d6ccfa4616af940f$var$singleQuoted = "'[^']*'";
var $d6ccfa4616af940f$var$doubleQuoted = '"[^"]*"';
var $d6ccfa4616af940f$var$attributeValue = "(?:" + $d6ccfa4616af940f$var$unquoted + "|" + $d6ccfa4616af940f$var$singleQuoted + "|" + $d6ccfa4616af940f$var$doubleQuoted + ")";
var $d6ccfa4616af940f$var$attribute = "(?:\\s+" + $d6ccfa4616af940f$var$attributeName + "(?:\\s*=\\s*" + $d6ccfa4616af940f$var$attributeValue + ")?)";
var $d6ccfa4616af940f$var$openTag = "<[A-Za-z][A-Za-z0-9\\-]*" + $d6ccfa4616af940f$var$attribute + "*\\s*\\/?>";
var $d6ccfa4616af940f$var$closeTag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $d6ccfa4616af940f$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $d6ccfa4616af940f$var$processing = "<[?].*?[?]>";
var $d6ccfa4616af940f$var$declaration = "<![A-Za-z]+\\s+[^>]*>";
var $d6ccfa4616af940f$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
$d6ccfa4616af940f$export$a33a5d2984e0051b = new RegExp("^(?:" + $d6ccfa4616af940f$var$openTag + "|" + $d6ccfa4616af940f$var$closeTag + ")");
$d6ccfa4616af940f$export$2b067c6666111485 = new RegExp("^(?:" + $d6ccfa4616af940f$var$openTag + "|" + $d6ccfa4616af940f$var$closeTag + "|" + $d6ccfa4616af940f$var$comment + "|" + $d6ccfa4616af940f$var$processing + "|" + $d6ccfa4616af940f$var$declaration + "|" + $d6ccfa4616af940f$var$cdata + ")");

});


parcelRegister("lRbMn", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $jmqbX = parcelRequire("jmqbX");
module.exports = $fe97af50c71cf6df$var$footnoteDefinition;
$fe97af50c71cf6df$var$footnoteDefinition.notInList = true;
$fe97af50c71cf6df$var$footnoteDefinition.notInBlock = true;
var $fe97af50c71cf6df$var$backslash = "\\";
var $fe97af50c71cf6df$var$lineFeed = "\n";
var $fe97af50c71cf6df$var$tab = "	";
var $fe97af50c71cf6df$var$space = " ";
var $fe97af50c71cf6df$var$leftSquareBracket = "[";
var $fe97af50c71cf6df$var$rightSquareBracket = "]";
var $fe97af50c71cf6df$var$caret = "^";
var $fe97af50c71cf6df$var$colon = ":";
var $fe97af50c71cf6df$var$EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
function $fe97af50c71cf6df$var$footnoteDefinition(eat, value, silent) {
    var self = this;
    var offsets = self.offset;
    var index;
    var length;
    var subvalue;
    var now;
    var currentLine;
    var content;
    var queue;
    var subqueue;
    var character;
    var identifier;
    var add;
    var exit;
    if (!self.options.footnotes) return;
    index = 0;
    length = value.length;
    subvalue = "";
    now = eat.now();
    currentLine = now.line;
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        subvalue += character;
        index++;
    }
    if (value.charAt(index) !== $fe97af50c71cf6df$var$leftSquareBracket || value.charAt(index + 1) !== $fe97af50c71cf6df$var$caret) return;
    subvalue += $fe97af50c71cf6df$var$leftSquareBracket + $fe97af50c71cf6df$var$caret;
    index = subvalue.length;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $fe97af50c71cf6df$var$rightSquareBracket) break;
        else if (character === $fe97af50c71cf6df$var$backslash) {
            queue += character;
            index++;
            character = value.charAt(index);
        }
        queue += character;
        index++;
    }
    if (!queue || value.charAt(index) !== $fe97af50c71cf6df$var$rightSquareBracket || value.charAt(index + 1) !== $fe97af50c71cf6df$var$colon) return;
    if (silent) return true;
    identifier = queue;
    subvalue += queue + $fe97af50c71cf6df$var$rightSquareBracket + $fe97af50c71cf6df$var$colon;
    index = subvalue.length;
    while(index < length){
        character = value.charAt(index);
        if (character !== $fe97af50c71cf6df$var$tab && character !== $fe97af50c71cf6df$var$space) break;
        subvalue += character;
        index++;
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    queue = "";
    content = "";
    subqueue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $fe97af50c71cf6df$var$lineFeed) {
            subqueue = character;
            index++;
            while(index < length){
                character = value.charAt(index);
                if (character !== $fe97af50c71cf6df$var$lineFeed) break;
                subqueue += character;
                index++;
            }
            queue += subqueue;
            subqueue = "";
            while(index < length){
                character = value.charAt(index);
                if (character !== $fe97af50c71cf6df$var$space) break;
                subqueue += character;
                index++;
            }
            if (subqueue.length === 0) break;
            queue += subqueue;
        }
        if (queue) {
            content += queue;
            queue = "";
        }
        content += character;
        index++;
    }
    subvalue += content;
    content = content.replace($fe97af50c71cf6df$var$EXPRESSION_INITIAL_TAB, function(line) {
        offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
        currentLine++;
        return "";
    });
    add = eat(subvalue);
    exit = self.enterBlock();
    content = self.tokenizeBlock(content, now);
    exit();
    return add({
        type: "footnoteDefinition",
        identifier: $jmqbX(identifier),
        label: identifier,
        children: content
    });
}

});
parcelRegister("jmqbX", function(module, exports) {
"use strict";

var $lcAVc = parcelRequire("lcAVc");
module.exports = $e184638aaf360d75$var$normalize;
// Normalize an identifier.  Collapses multiple white space characters into a
// single space, and removes casing.
function $e184638aaf360d75$var$normalize(value) {
    return $lcAVc(value).toLowerCase();
}

});
parcelRegister("lcAVc", function(module, exports) {
"use strict";
module.exports = $f6f75bd2ad2cfe0a$var$collapse;
// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function $f6f75bd2ad2cfe0a$var$collapse(value) {
    return String(value).replace(/\s+/g, " ");
}

});



parcelRegister("gv9fx", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $jmqbX = parcelRequire("jmqbX");
module.exports = $c036b75b867a35f9$var$definition;
var $c036b75b867a35f9$var$quotationMark = '"';
var $c036b75b867a35f9$var$apostrophe = "'";
var $c036b75b867a35f9$var$backslash = "\\";
var $c036b75b867a35f9$var$lineFeed = "\n";
var $c036b75b867a35f9$var$tab = "	";
var $c036b75b867a35f9$var$space = " ";
var $c036b75b867a35f9$var$leftSquareBracket = "[";
var $c036b75b867a35f9$var$rightSquareBracket = "]";
var $c036b75b867a35f9$var$leftParenthesis = "(";
var $c036b75b867a35f9$var$rightParenthesis = ")";
var $c036b75b867a35f9$var$colon = ":";
var $c036b75b867a35f9$var$lessThan = "<";
var $c036b75b867a35f9$var$greaterThan = ">";
function $c036b75b867a35f9$var$definition(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var index = 0;
    var length = value.length;
    var subvalue = "";
    var beforeURL;
    var beforeTitle;
    var queue;
    var character;
    var test;
    var identifier;
    var url;
    var title;
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$space && character !== $c036b75b867a35f9$var$tab) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    if (character !== $c036b75b867a35f9$var$leftSquareBracket) return;
    index++;
    subvalue += character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $c036b75b867a35f9$var$rightSquareBracket) break;
        else if (character === $c036b75b867a35f9$var$backslash) {
            queue += character;
            index++;
            character = value.charAt(index);
        }
        queue += character;
        index++;
    }
    if (!queue || value.charAt(index) !== $c036b75b867a35f9$var$rightSquareBracket || value.charAt(index + 1) !== $c036b75b867a35f9$var$colon) return;
    identifier = queue;
    subvalue += queue + $c036b75b867a35f9$var$rightSquareBracket + $c036b75b867a35f9$var$colon;
    index = subvalue.length;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$tab && character !== $c036b75b867a35f9$var$space && character !== $c036b75b867a35f9$var$lineFeed) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    queue = "";
    beforeURL = subvalue;
    if (character === $c036b75b867a35f9$var$lessThan) {
        index++;
        while(index < length){
            character = value.charAt(index);
            if (!$c036b75b867a35f9$var$isEnclosedURLCharacter(character)) break;
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (character === $c036b75b867a35f9$var$isEnclosedURLCharacter.delimiter) {
            subvalue += $c036b75b867a35f9$var$lessThan + queue + character;
            index++;
        } else {
            if (commonmark) return;
            index -= queue.length + 1;
            queue = "";
        }
    }
    if (!queue) {
        while(index < length){
            character = value.charAt(index);
            if (!$c036b75b867a35f9$var$isUnclosedURLCharacter(character)) break;
            queue += character;
            index++;
        }
        subvalue += queue;
    }
    if (!queue) return;
    url = queue;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$tab && character !== $c036b75b867a35f9$var$space && character !== $c036b75b867a35f9$var$lineFeed) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    test = null;
    if (character === $c036b75b867a35f9$var$quotationMark) test = $c036b75b867a35f9$var$quotationMark;
    else if (character === $c036b75b867a35f9$var$apostrophe) test = $c036b75b867a35f9$var$apostrophe;
    else if (character === $c036b75b867a35f9$var$leftParenthesis) test = $c036b75b867a35f9$var$rightParenthesis;
    if (!test) {
        queue = "";
        index = subvalue.length;
    } else if (queue) {
        subvalue += queue + character;
        index = subvalue.length;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character === test) break;
            if (character === $c036b75b867a35f9$var$lineFeed) {
                index++;
                character = value.charAt(index);
                if (character === $c036b75b867a35f9$var$lineFeed || character === test) return;
                queue += $c036b75b867a35f9$var$lineFeed;
            }
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (character !== test) return;
        beforeTitle = subvalue;
        subvalue += queue + character;
        index++;
        title = queue;
        queue = "";
    } else return;
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$tab && character !== $c036b75b867a35f9$var$space) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    if (!character || character === $c036b75b867a35f9$var$lineFeed) {
        if (silent) return true;
        beforeURL = eat(beforeURL).test().end;
        url = self.decode.raw(self.unescape(url), beforeURL, {
            nonTerminated: false
        });
        if (title) {
            beforeTitle = eat(beforeTitle).test().end;
            title = self.decode.raw(self.unescape(title), beforeTitle);
        }
        return eat(subvalue)({
            type: "definition",
            identifier: $jmqbX(identifier),
            label: identifier,
            title: title || null,
            url: url
        });
    }
}
// Check if `character` can be inside an enclosed URI.
function $c036b75b867a35f9$var$isEnclosedURLCharacter(character) {
    return character !== $c036b75b867a35f9$var$greaterThan && character !== $c036b75b867a35f9$var$leftSquareBracket && character !== $c036b75b867a35f9$var$rightSquareBracket;
}
$c036b75b867a35f9$var$isEnclosedURLCharacter.delimiter = $c036b75b867a35f9$var$greaterThan;
// Check if `character` can be inside an unclosed URI.
function $c036b75b867a35f9$var$isUnclosedURLCharacter(character) {
    return character !== $c036b75b867a35f9$var$leftSquareBracket && character !== $c036b75b867a35f9$var$rightSquareBracket && !$kZNgz(character);
}

});

parcelRegister("04Igv", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");
module.exports = $00e2b6037037da29$var$table;
var $00e2b6037037da29$var$tab = "	";
var $00e2b6037037da29$var$lineFeed = "\n";
var $00e2b6037037da29$var$space = " ";
var $00e2b6037037da29$var$dash = "-";
var $00e2b6037037da29$var$colon = ":";
var $00e2b6037037da29$var$backslash = "\\";
var $00e2b6037037da29$var$verticalBar = "|";
var $00e2b6037037da29$var$minColumns = 1;
var $00e2b6037037da29$var$minRows = 2;
var $00e2b6037037da29$var$left = "left";
var $00e2b6037037da29$var$center = "center";
var $00e2b6037037da29$var$right = "right";
function $00e2b6037037da29$var$table(eat, value, silent) {
    var self = this;
    var index;
    var alignments;
    var alignment;
    var subvalue;
    var row;
    var length;
    var lines;
    var queue;
    var character;
    var hasDash;
    var align;
    var cell;
    var preamble;
    var now;
    var position;
    var lineCount;
    var line;
    var rows;
    var table;
    var lineIndex;
    var pipeIndex;
    var first;
    // Exit when not in gfm-mode.
    if (!self.options.gfm) return;
    // Get the rows.
    // Detecting tables soon is hard, so there are some checks for performance
    // here, such as the minimum number of rows, and allowed characters in the
    // alignment row.
    index = 0;
    lineCount = 0;
    length = value.length + 1;
    lines = [];
    while(index < length){
        lineIndex = value.indexOf($00e2b6037037da29$var$lineFeed, index);
        pipeIndex = value.indexOf($00e2b6037037da29$var$verticalBar, index + 1);
        if (lineIndex === -1) lineIndex = value.length;
        if (pipeIndex === -1 || pipeIndex > lineIndex) {
            if (lineCount < $00e2b6037037da29$var$minRows) return;
            break;
        }
        lines.push(value.slice(index, lineIndex));
        lineCount++;
        index = lineIndex + 1;
    }
    // Parse the alignment row.
    subvalue = lines.join($00e2b6037037da29$var$lineFeed);
    alignments = lines.splice(1, 1)[0] || [];
    index = 0;
    length = alignments.length;
    lineCount--;
    alignment = false;
    align = [];
    while(index < length){
        character = alignments.charAt(index);
        if (character === $00e2b6037037da29$var$verticalBar) {
            hasDash = null;
            if (alignment === false) {
                if (first === false) return;
            } else {
                align.push(alignment);
                alignment = false;
            }
            first = false;
        } else if (character === $00e2b6037037da29$var$dash) {
            hasDash = true;
            alignment = alignment || null;
        } else if (character === $00e2b6037037da29$var$colon) {
            if (alignment === $00e2b6037037da29$var$left) alignment = $00e2b6037037da29$var$center;
            else if (hasDash && alignment === null) alignment = $00e2b6037037da29$var$right;
            else alignment = $00e2b6037037da29$var$left;
        } else if (!$kZNgz(character)) return;
        index++;
    }
    if (alignment !== false) align.push(alignment);
    // Exit when without enough columns.
    if (align.length < $00e2b6037037da29$var$minColumns) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    // Parse the rows.
    position = -1;
    rows = [];
    table = eat(subvalue).reset({
        type: "table",
        align: align,
        children: rows
    });
    while(++position < lineCount){
        line = lines[position];
        row = {
            type: "tableRow",
            children: []
        };
        // Eat a newline character when this is not the first row.
        if (position) eat($00e2b6037037da29$var$lineFeed);
        // Eat the row.
        eat(line).reset(row, table);
        length = line.length + 1;
        index = 0;
        queue = "";
        cell = "";
        preamble = true;
        while(index < length){
            character = line.charAt(index);
            if (character === $00e2b6037037da29$var$tab || character === $00e2b6037037da29$var$space) {
                if (cell) queue += character;
                else eat(character);
                index++;
                continue;
            }
            if (character === "" || character === $00e2b6037037da29$var$verticalBar) {
                if (preamble) eat(character);
                else {
                    if ((cell || character) && !preamble) {
                        subvalue = cell;
                        if (queue.length > 1) {
                            if (character) {
                                subvalue += queue.slice(0, queue.length - 1);
                                queue = queue.charAt(queue.length - 1);
                            } else {
                                subvalue += queue;
                                queue = "";
                            }
                        }
                        now = eat.now();
                        eat(subvalue)({
                            type: "tableCell",
                            children: self.tokenizeInline(cell, now)
                        }, row);
                    }
                    eat(queue + character);
                    queue = "";
                    cell = "";
                }
            } else {
                if (queue) {
                    cell += queue;
                    queue = "";
                }
                cell += character;
                if (character === $00e2b6037037da29$var$backslash && index !== length - 2) {
                    cell += line.charAt(index + 1);
                    index++;
                }
            }
            preamble = false;
            index++;
        }
        // Eat the alignment row.
        if (!position) eat($00e2b6037037da29$var$lineFeed + alignments);
    }
    return table;
}

});

parcelRegister("hfuIQ", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $35IlD = parcelRequire("35IlD");

var $5H7vD = parcelRequire("5H7vD");

var $hIMnZ = parcelRequire("hIMnZ");
module.exports = $c8ebab3365122f53$var$paragraph;
var $c8ebab3365122f53$var$tab = "	";
var $c8ebab3365122f53$var$lineFeed = "\n";
var $c8ebab3365122f53$var$space = " ";
var $c8ebab3365122f53$var$tabSize = 4;
// Tokenise paragraph.
function $c8ebab3365122f53$var$paragraph(eat, value, silent) {
    var self = this;
    var settings = self.options;
    var commonmark = settings.commonmark;
    var gfm = settings.gfm;
    var tokenizers = self.blockTokenizers;
    var interruptors = self.interruptParagraph;
    var index = value.indexOf($c8ebab3365122f53$var$lineFeed);
    var length = value.length;
    var position;
    var subvalue;
    var character;
    var size;
    var now;
    while(index < length){
        // Eat everything if there’s no following newline.
        if (index === -1) {
            index = length;
            break;
        }
        // Stop if the next character is NEWLINE.
        if (value.charAt(index + 1) === $c8ebab3365122f53$var$lineFeed) break;
        // In commonmark-mode, following indented lines are part of the paragraph.
        if (commonmark) {
            size = 0;
            position = index + 1;
            while(position < length){
                character = value.charAt(position);
                if (character === $c8ebab3365122f53$var$tab) {
                    size = $c8ebab3365122f53$var$tabSize;
                    break;
                } else if (character === $c8ebab3365122f53$var$space) size++;
                else break;
                position++;
            }
            if (size >= $c8ebab3365122f53$var$tabSize && character !== $c8ebab3365122f53$var$lineFeed) {
                index = value.indexOf($c8ebab3365122f53$var$lineFeed, index + 1);
                continue;
            }
        }
        subvalue = value.slice(index + 1);
        // Check if the following code contains a possible block.
        if ($hIMnZ(interruptors, tokenizers, self, [
            eat,
            subvalue,
            true
        ])) break;
        // Break if the following line starts a list, when already in a list, or
        // when in commonmark, or when in gfm mode and the bullet is *not* numeric.
        if (tokenizers.list.call(self, eat, subvalue, true) && (self.inList || commonmark || gfm && !$35IlD($2Lc6r.left(subvalue).charAt(0)))) break;
        position = index;
        index = value.indexOf($c8ebab3365122f53$var$lineFeed, index + 1);
        if (index !== -1 && $2Lc6r(value.slice(position, index)) === "") {
            index = position;
            break;
        }
    }
    subvalue = value.slice(0, index);
    if ($2Lc6r(subvalue) === "") {
        eat(subvalue);
        return null;
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    now = eat.now();
    subvalue = $5H7vD(subvalue);
    return eat(subvalue)({
        type: "paragraph",
        children: self.tokenizeInline(subvalue, now)
    });
}

});

parcelRegister("fG8Jf", function(module, exports) {
"use strict";

var $i6Cnu = parcelRequire("i6Cnu");
module.exports = $b6a18ca0d6d7ad52$var$escape;
$b6a18ca0d6d7ad52$var$escape.locator = $i6Cnu;
var $b6a18ca0d6d7ad52$var$lineFeed = "\n";
var $b6a18ca0d6d7ad52$var$backslash = "\\";
function $b6a18ca0d6d7ad52$var$escape(eat, value, silent) {
    var self = this;
    var character;
    var node;
    if (value.charAt(0) === $b6a18ca0d6d7ad52$var$backslash) {
        character = value.charAt(1);
        if (self.escape.indexOf(character) !== -1) {
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            if (character === $b6a18ca0d6d7ad52$var$lineFeed) node = {
                type: "break"
            };
            else node = {
                type: "text",
                value: character
            };
            return eat($b6a18ca0d6d7ad52$var$backslash + character)(node);
        }
    }
}

});
parcelRegister("i6Cnu", function(module, exports) {
"use strict";
module.exports = $d2e68e981f5ef606$var$locate;
function $d2e68e981f5ef606$var$locate(value, fromIndex) {
    return value.indexOf("\\", fromIndex);
}

});


parcelRegister("40HEA", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $eUIxU = parcelRequire("eUIxU");

var $2utui = parcelRequire("2utui");
module.exports = $2eb9063277fa9ae9$var$autoLink;
$2eb9063277fa9ae9$var$autoLink.locator = $2utui;
$2eb9063277fa9ae9$var$autoLink.notInLink = true;
var $2eb9063277fa9ae9$var$lessThan = "<";
var $2eb9063277fa9ae9$var$greaterThan = ">";
var $2eb9063277fa9ae9$var$atSign = "@";
var $2eb9063277fa9ae9$var$slash = "/";
var $2eb9063277fa9ae9$var$mailto = "mailto:";
var $2eb9063277fa9ae9$var$mailtoLength = $2eb9063277fa9ae9$var$mailto.length;
function $2eb9063277fa9ae9$var$autoLink(eat, value, silent) {
    var self = this;
    var subvalue = "";
    var length = value.length;
    var index = 0;
    var queue = "";
    var hasAtCharacter = false;
    var link = "";
    var character;
    var now;
    var content;
    var tokenizers;
    var exit;
    if (value.charAt(0) !== $2eb9063277fa9ae9$var$lessThan) return;
    index++;
    subvalue = $2eb9063277fa9ae9$var$lessThan;
    while(index < length){
        character = value.charAt(index);
        if ($kZNgz(character) || character === $2eb9063277fa9ae9$var$greaterThan || character === $2eb9063277fa9ae9$var$atSign || character === ":" && value.charAt(index + 1) === $2eb9063277fa9ae9$var$slash) break;
        queue += character;
        index++;
    }
    if (!queue) return;
    link += queue;
    queue = "";
    character = value.charAt(index);
    link += character;
    index++;
    if (character === $2eb9063277fa9ae9$var$atSign) hasAtCharacter = true;
    else {
        if (character !== ":" || value.charAt(index + 1) !== $2eb9063277fa9ae9$var$slash) return;
        link += $2eb9063277fa9ae9$var$slash;
        index++;
    }
    while(index < length){
        character = value.charAt(index);
        if ($kZNgz(character) || character === $2eb9063277fa9ae9$var$greaterThan) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    if (!queue || character !== $2eb9063277fa9ae9$var$greaterThan) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    link += queue;
    content = link;
    subvalue += link + character;
    now = eat.now();
    now.column++;
    now.offset++;
    if (hasAtCharacter) {
        if (link.slice(0, $2eb9063277fa9ae9$var$mailtoLength).toLowerCase() === $2eb9063277fa9ae9$var$mailto) {
            content = content.slice($2eb9063277fa9ae9$var$mailtoLength);
            now.column += $2eb9063277fa9ae9$var$mailtoLength;
            now.offset += $2eb9063277fa9ae9$var$mailtoLength;
        } else link = $2eb9063277fa9ae9$var$mailto + link;
    }
    // Temporarily remove all tokenizers except text in autolinks.
    tokenizers = self.inlineTokenizers;
    self.inlineTokenizers = {
        text: tokenizers.text
    };
    exit = self.enterLink();
    content = self.tokenizeInline(content, now);
    self.inlineTokenizers = tokenizers;
    exit();
    return eat(subvalue)({
        type: "link",
        title: null,
        url: $eUIxU(link, {
            nonTerminated: false
        }),
        children: content
    });
}

});
parcelRegister("2utui", function(module, exports) {
"use strict";
module.exports = $1d0541bad92d2f9c$var$locate;
function $1d0541bad92d2f9c$var$locate(value, fromIndex) {
    return value.indexOf("<", fromIndex);
}

});


parcelRegister("cXItb", function(module, exports) {
"use strict";

var $eUIxU = parcelRequire("eUIxU");

var $kZNgz = parcelRequire("kZNgz");

var $5PG7O = parcelRequire("5PG7O");
module.exports = $96fd7d785cdb864e$var$url;
$96fd7d785cdb864e$var$url.locator = $5PG7O;
$96fd7d785cdb864e$var$url.notInLink = true;
var $96fd7d785cdb864e$var$quotationMark = '"';
var $96fd7d785cdb864e$var$apostrophe = "'";
var $96fd7d785cdb864e$var$leftParenthesis = "(";
var $96fd7d785cdb864e$var$rightParenthesis = ")";
var $96fd7d785cdb864e$var$comma = ",";
var $96fd7d785cdb864e$var$dot = ".";
var $96fd7d785cdb864e$var$colon = ":";
var $96fd7d785cdb864e$var$semicolon = ";";
var $96fd7d785cdb864e$var$lessThan = "<";
var $96fd7d785cdb864e$var$atSign = "@";
var $96fd7d785cdb864e$var$leftSquareBracket = "[";
var $96fd7d785cdb864e$var$rightSquareBracket = "]";
var $96fd7d785cdb864e$var$http = "http://";
var $96fd7d785cdb864e$var$https = "https://";
var $96fd7d785cdb864e$var$mailto = "mailto:";
var $96fd7d785cdb864e$var$protocols = [
    $96fd7d785cdb864e$var$http,
    $96fd7d785cdb864e$var$https,
    $96fd7d785cdb864e$var$mailto
];
var $96fd7d785cdb864e$var$protocolsLength = $96fd7d785cdb864e$var$protocols.length;
function $96fd7d785cdb864e$var$url(eat, value, silent) {
    var self = this;
    var subvalue;
    var content;
    var character;
    var index;
    var position;
    var protocol;
    var match;
    var length;
    var queue;
    var parenCount;
    var nextCharacter;
    var tokenizers;
    var exit;
    if (!self.options.gfm) return;
    subvalue = "";
    index = -1;
    while(++index < $96fd7d785cdb864e$var$protocolsLength){
        protocol = $96fd7d785cdb864e$var$protocols[index];
        match = value.slice(0, protocol.length);
        if (match.toLowerCase() === protocol) {
            subvalue = match;
            break;
        }
    }
    if (!subvalue) return;
    index = subvalue.length;
    length = value.length;
    queue = "";
    parenCount = 0;
    while(index < length){
        character = value.charAt(index);
        if ($kZNgz(character) || character === $96fd7d785cdb864e$var$lessThan) break;
        if (character === $96fd7d785cdb864e$var$dot || character === $96fd7d785cdb864e$var$comma || character === $96fd7d785cdb864e$var$colon || character === $96fd7d785cdb864e$var$semicolon || character === $96fd7d785cdb864e$var$quotationMark || character === $96fd7d785cdb864e$var$apostrophe || character === $96fd7d785cdb864e$var$rightParenthesis || character === $96fd7d785cdb864e$var$rightSquareBracket) {
            nextCharacter = value.charAt(index + 1);
            if (!nextCharacter || $kZNgz(nextCharacter)) break;
        }
        if (character === $96fd7d785cdb864e$var$leftParenthesis || character === $96fd7d785cdb864e$var$leftSquareBracket) parenCount++;
        if (character === $96fd7d785cdb864e$var$rightParenthesis || character === $96fd7d785cdb864e$var$rightSquareBracket) {
            parenCount--;
            if (parenCount < 0) break;
        }
        queue += character;
        index++;
    }
    if (!queue) return;
    subvalue += queue;
    content = subvalue;
    if (protocol === $96fd7d785cdb864e$var$mailto) {
        position = queue.indexOf($96fd7d785cdb864e$var$atSign);
        if (position === -1 || position === length - 1) return;
        content = content.slice($96fd7d785cdb864e$var$mailto.length);
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    exit = self.enterLink();
    // Temporarily remove all tokenizers except text in url.
    tokenizers = self.inlineTokenizers;
    self.inlineTokenizers = {
        text: tokenizers.text
    };
    content = self.tokenizeInline(content, eat.now());
    self.inlineTokenizers = tokenizers;
    exit();
    return eat(subvalue)({
        type: "link",
        title: null,
        url: $eUIxU(subvalue, {
            nonTerminated: false
        }),
        children: content
    });
}

});
parcelRegister("5PG7O", function(module, exports) {
"use strict";
module.exports = $43f26451b4436772$var$locate;
var $43f26451b4436772$var$protocols = [
    "https://",
    "http://",
    "mailto:"
];
function $43f26451b4436772$var$locate(value, fromIndex) {
    var length = $43f26451b4436772$var$protocols.length;
    var index = -1;
    var min = -1;
    var position;
    if (!this.options.gfm) return -1;
    while(++index < length){
        position = value.indexOf($43f26451b4436772$var$protocols[index], fromIndex);
        if (position !== -1 && (position < min || min === -1)) min = position;
    }
    return min;
}

});


parcelRegister("76c2Q", function(module, exports) {
"use strict";

var $aDCQv = parcelRequire("aDCQv");

var $2utui = parcelRequire("2utui");

var $irnv4 = parcelRequire("irnv4");
var $52b26fd260680e73$require$tag = $irnv4.tag;
module.exports = $52b26fd260680e73$var$inlineHTML;
$52b26fd260680e73$var$inlineHTML.locator = $2utui;
var $52b26fd260680e73$var$lessThan = "<";
var $52b26fd260680e73$var$questionMark = "?";
var $52b26fd260680e73$var$exclamationMark = "!";
var $52b26fd260680e73$var$slash = "/";
var $52b26fd260680e73$var$htmlLinkOpenExpression = /^<a /i;
var $52b26fd260680e73$var$htmlLinkCloseExpression = /^<\/a>/i;
function $52b26fd260680e73$var$inlineHTML(eat, value, silent) {
    var self = this;
    var length = value.length;
    var character;
    var subvalue;
    if (value.charAt(0) !== $52b26fd260680e73$var$lessThan || length < 3) return;
    character = value.charAt(1);
    if (!$aDCQv(character) && character !== $52b26fd260680e73$var$questionMark && character !== $52b26fd260680e73$var$exclamationMark && character !== $52b26fd260680e73$var$slash) return;
    subvalue = value.match($52b26fd260680e73$require$tag);
    if (!subvalue) return;
    /* istanbul ignore if - not used yet. */ if (silent) return true;
    subvalue = subvalue[0];
    if (!self.inLink && $52b26fd260680e73$var$htmlLinkOpenExpression.test(subvalue)) self.inLink = true;
    else if (self.inLink && $52b26fd260680e73$var$htmlLinkCloseExpression.test(subvalue)) self.inLink = false;
    return eat(subvalue)({
        type: "html",
        value: subvalue
    });
}

});

parcelRegister("4bxc4", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $79FXg = parcelRequire("79FXg");
module.exports = $30c1f0114b4bfd47$var$link;
$30c1f0114b4bfd47$var$link.locator = $79FXg;
var $30c1f0114b4bfd47$var$lineFeed = "\n";
var $30c1f0114b4bfd47$var$exclamationMark = "!";
var $30c1f0114b4bfd47$var$quotationMark = '"';
var $30c1f0114b4bfd47$var$apostrophe = "'";
var $30c1f0114b4bfd47$var$leftParenthesis = "(";
var $30c1f0114b4bfd47$var$rightParenthesis = ")";
var $30c1f0114b4bfd47$var$lessThan = "<";
var $30c1f0114b4bfd47$var$greaterThan = ">";
var $30c1f0114b4bfd47$var$leftSquareBracket = "[";
var $30c1f0114b4bfd47$var$backslash = "\\";
var $30c1f0114b4bfd47$var$rightSquareBracket = "]";
var $30c1f0114b4bfd47$var$graveAccent = "`";
function $30c1f0114b4bfd47$var$link(eat, value, silent) {
    var self = this;
    var subvalue = "";
    var index = 0;
    var character = value.charAt(0);
    var pedantic = self.options.pedantic;
    var commonmark = self.options.commonmark;
    var gfm = self.options.gfm;
    var closed;
    var count;
    var opening;
    var beforeURL;
    var beforeTitle;
    var subqueue;
    var hasMarker;
    var isImage;
    var content;
    var marker;
    var length;
    var title;
    var depth;
    var queue;
    var url;
    var now;
    var exit;
    var node;
    // Detect whether this is an image.
    if (character === $30c1f0114b4bfd47$var$exclamationMark) {
        isImage = true;
        subvalue = character;
        character = value.charAt(++index);
    }
    // Eat the opening.
    if (character !== $30c1f0114b4bfd47$var$leftSquareBracket) return;
    // Exit when this is a link and we’re already inside a link.
    if (!isImage && self.inLink) return;
    subvalue += character;
    queue = "";
    index++;
    // Eat the content.
    length = value.length;
    now = eat.now();
    depth = 0;
    now.column += index;
    now.offset += index;
    while(index < length){
        character = value.charAt(index);
        subqueue = character;
        if (character === $30c1f0114b4bfd47$var$graveAccent) {
            // Inline-code in link content.
            count = 1;
            while(value.charAt(index + 1) === $30c1f0114b4bfd47$var$graveAccent){
                subqueue += character;
                index++;
                count++;
            }
            if (!opening) opening = count;
            else if (count >= opening) opening = 0;
        } else if (character === $30c1f0114b4bfd47$var$backslash) {
            // Allow brackets to be escaped.
            index++;
            subqueue += value.charAt(index);
        } else if ((!opening || gfm) && character === $30c1f0114b4bfd47$var$leftSquareBracket) // In GFM mode, brackets in code still count.  In all other modes,
        // they don’t.
        depth++;
        else if ((!opening || gfm) && character === $30c1f0114b4bfd47$var$rightSquareBracket) {
            if (depth) depth--;
            else {
                // Allow white-space between content and url in GFM mode.
                if (!pedantic) while(index < length){
                    character = value.charAt(index + 1);
                    if (!$kZNgz(character)) break;
                    subqueue += character;
                    index++;
                }
                if (value.charAt(index + 1) !== $30c1f0114b4bfd47$var$leftParenthesis) return;
                subqueue += $30c1f0114b4bfd47$var$leftParenthesis;
                closed = true;
                index++;
                break;
            }
        }
        queue += subqueue;
        subqueue = "";
        index++;
    }
    // Eat the content closing.
    if (!closed) return;
    content = queue;
    subvalue += queue + subqueue;
    index++;
    // Eat white-space.
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        subvalue += character;
        index++;
    }
    // Eat the URL.
    character = value.charAt(index);
    queue = "";
    beforeURL = subvalue;
    if (character === $30c1f0114b4bfd47$var$lessThan) {
        index++;
        beforeURL += $30c1f0114b4bfd47$var$lessThan;
        while(index < length){
            character = value.charAt(index);
            if (character === $30c1f0114b4bfd47$var$greaterThan) break;
            if (commonmark && character === $30c1f0114b4bfd47$var$lineFeed) return;
            queue += character;
            index++;
        }
        if (value.charAt(index) !== $30c1f0114b4bfd47$var$greaterThan) return;
        subvalue += $30c1f0114b4bfd47$var$lessThan + queue + $30c1f0114b4bfd47$var$greaterThan;
        url = queue;
        index++;
    } else {
        character = null;
        subqueue = "";
        while(index < length){
            character = value.charAt(index);
            if (subqueue && (character === $30c1f0114b4bfd47$var$quotationMark || character === $30c1f0114b4bfd47$var$apostrophe || commonmark && character === $30c1f0114b4bfd47$var$leftParenthesis)) break;
            if ($kZNgz(character)) {
                if (!pedantic) break;
                subqueue += character;
            } else {
                if (character === $30c1f0114b4bfd47$var$leftParenthesis) depth++;
                else if (character === $30c1f0114b4bfd47$var$rightParenthesis) {
                    if (depth === 0) break;
                    depth--;
                }
                queue += subqueue;
                subqueue = "";
                if (character === $30c1f0114b4bfd47$var$backslash) {
                    queue += $30c1f0114b4bfd47$var$backslash;
                    character = value.charAt(++index);
                }
                queue += character;
            }
            index++;
        }
        subvalue += queue;
        url = queue;
        index = subvalue.length;
    }
    // Eat white-space.
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    subvalue += queue;
    // Eat the title.
    if (queue && (character === $30c1f0114b4bfd47$var$quotationMark || character === $30c1f0114b4bfd47$var$apostrophe || commonmark && character === $30c1f0114b4bfd47$var$leftParenthesis)) {
        index++;
        subvalue += character;
        queue = "";
        marker = character === $30c1f0114b4bfd47$var$leftParenthesis ? $30c1f0114b4bfd47$var$rightParenthesis : character;
        beforeTitle = subvalue;
        // In commonmark-mode, things are pretty easy: the marker cannot occur
        // inside the title.  Non-commonmark does, however, support nested
        // delimiters.
        if (commonmark) {
            while(index < length){
                character = value.charAt(index);
                if (character === marker) break;
                if (character === $30c1f0114b4bfd47$var$backslash) {
                    queue += $30c1f0114b4bfd47$var$backslash;
                    character = value.charAt(++index);
                }
                index++;
                queue += character;
            }
            character = value.charAt(index);
            if (character !== marker) return;
            title = queue;
            subvalue += queue + character;
            index++;
            while(index < length){
                character = value.charAt(index);
                if (!$kZNgz(character)) break;
                subvalue += character;
                index++;
            }
        } else {
            subqueue = "";
            while(index < length){
                character = value.charAt(index);
                if (character === marker) {
                    if (hasMarker) {
                        queue += marker + subqueue;
                        subqueue = "";
                    }
                    hasMarker = true;
                } else if (!hasMarker) queue += character;
                else if (character === $30c1f0114b4bfd47$var$rightParenthesis) {
                    subvalue += queue + marker + subqueue;
                    title = queue;
                    break;
                } else if ($kZNgz(character)) subqueue += character;
                else {
                    queue += marker + subqueue + character;
                    subqueue = "";
                    hasMarker = false;
                }
                index++;
            }
        }
    }
    if (value.charAt(index) !== $30c1f0114b4bfd47$var$rightParenthesis) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    subvalue += $30c1f0114b4bfd47$var$rightParenthesis;
    url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {
        nonTerminated: false
    });
    if (title) {
        beforeTitle = eat(beforeTitle).test().end;
        title = self.decode.raw(self.unescape(title), beforeTitle);
    }
    node = {
        type: isImage ? "image" : "link",
        title: title || null,
        url: url
    };
    if (isImage) node.alt = self.decode.raw(self.unescape(content), now) || null;
    else {
        exit = self.enterLink();
        node.children = self.tokenizeInline(content, now);
        exit();
    }
    return eat(subvalue)(node);
}

});
parcelRegister("79FXg", function(module, exports) {
"use strict";
module.exports = $5359eb03c713b709$var$locate;
function $5359eb03c713b709$var$locate(value, fromIndex) {
    var link = value.indexOf("[", fromIndex);
    var image = value.indexOf("![", fromIndex);
    if (image === -1) return link;
    // Link can never be `-1` if an image is found, so we don’t need to check
    // for that :)
    return link < image ? link : image;
}

});


parcelRegister("7Wiug", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $79FXg = parcelRequire("79FXg");

var $jmqbX = parcelRequire("jmqbX");
module.exports = $5c7c4a516443d04f$var$reference;
$5c7c4a516443d04f$var$reference.locator = $79FXg;
var $5c7c4a516443d04f$var$link = "link";
var $5c7c4a516443d04f$var$image = "image";
var $5c7c4a516443d04f$var$footnote = "footnote";
var $5c7c4a516443d04f$var$shortcut = "shortcut";
var $5c7c4a516443d04f$var$collapsed = "collapsed";
var $5c7c4a516443d04f$var$full = "full";
var $5c7c4a516443d04f$var$space = " ";
var $5c7c4a516443d04f$var$exclamationMark = "!";
var $5c7c4a516443d04f$var$leftSquareBracket = "[";
var $5c7c4a516443d04f$var$backslash = "\\";
var $5c7c4a516443d04f$var$rightSquareBracket = "]";
var $5c7c4a516443d04f$var$caret = "^";
function $5c7c4a516443d04f$var$reference(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var footnotes = self.options.footnotes;
    var character = value.charAt(0);
    var index = 0;
    var length = value.length;
    var subvalue = "";
    var intro = "";
    var type = $5c7c4a516443d04f$var$link;
    var referenceType = $5c7c4a516443d04f$var$shortcut;
    var content;
    var identifier;
    var now;
    var node;
    var exit;
    var queue;
    var bracketed;
    var depth;
    // Check whether we’re eating an image.
    if (character === $5c7c4a516443d04f$var$exclamationMark) {
        type = $5c7c4a516443d04f$var$image;
        intro = character;
        character = value.charAt(++index);
    }
    if (character !== $5c7c4a516443d04f$var$leftSquareBracket) return;
    index++;
    intro += character;
    queue = "";
    // Check whether we’re eating a footnote.
    if (footnotes && value.charAt(index) === $5c7c4a516443d04f$var$caret) {
        // Exit if `![^` is found, so the `!` will be seen as text after this,
        // and we’ll enter this function again when `[^` is found.
        if (type === $5c7c4a516443d04f$var$image) return;
        intro += $5c7c4a516443d04f$var$caret;
        index++;
        type = $5c7c4a516443d04f$var$footnote;
    }
    // Eat the text.
    depth = 0;
    while(index < length){
        character = value.charAt(index);
        if (character === $5c7c4a516443d04f$var$leftSquareBracket) {
            bracketed = true;
            depth++;
        } else if (character === $5c7c4a516443d04f$var$rightSquareBracket) {
            if (!depth) break;
            depth--;
        }
        if (character === $5c7c4a516443d04f$var$backslash) {
            queue += $5c7c4a516443d04f$var$backslash;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
    subvalue = queue;
    content = queue;
    character = value.charAt(index);
    if (character !== $5c7c4a516443d04f$var$rightSquareBracket) return;
    index++;
    subvalue += character;
    queue = "";
    if (!commonmark) // The original markdown syntax definition explicitly allows for whitespace
    // between the link text and link label; commonmark departs from this, in
    // part to improve support for shortcut reference links
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    // Inline footnotes cannot have a label.
    // If footnotes are enabled, link labels cannot start with a caret.
    if (type !== $5c7c4a516443d04f$var$footnote && character === $5c7c4a516443d04f$var$leftSquareBracket && (!footnotes || value.charAt(index + 1) !== $5c7c4a516443d04f$var$caret)) {
        identifier = "";
        queue += character;
        index++;
        while(index < length){
            character = value.charAt(index);
            if (character === $5c7c4a516443d04f$var$leftSquareBracket || character === $5c7c4a516443d04f$var$rightSquareBracket) break;
            if (character === $5c7c4a516443d04f$var$backslash) {
                identifier += $5c7c4a516443d04f$var$backslash;
                character = value.charAt(++index);
            }
            identifier += character;
            index++;
        }
        character = value.charAt(index);
        if (character === $5c7c4a516443d04f$var$rightSquareBracket) {
            referenceType = identifier ? $5c7c4a516443d04f$var$full : $5c7c4a516443d04f$var$collapsed;
            queue += identifier + character;
            index++;
        } else identifier = "";
        subvalue += queue;
        queue = "";
    } else {
        if (!content) return;
        identifier = content;
    }
    // Brackets cannot be inside the identifier.
    if (referenceType !== $5c7c4a516443d04f$var$full && bracketed) return;
    subvalue = intro + subvalue;
    if (type === $5c7c4a516443d04f$var$link && self.inLink) return null;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    if (type === $5c7c4a516443d04f$var$footnote && content.indexOf($5c7c4a516443d04f$var$space) !== -1) return eat(subvalue)({
        type: $5c7c4a516443d04f$var$footnote,
        children: this.tokenizeInline(content, eat.now())
    });
    now = eat.now();
    now.column += intro.length;
    now.offset += intro.length;
    identifier = referenceType === $5c7c4a516443d04f$var$full ? identifier : content;
    node = {
        type: type + "Reference",
        identifier: $jmqbX(identifier),
        label: identifier
    };
    if (type === $5c7c4a516443d04f$var$link || type === $5c7c4a516443d04f$var$image) node.referenceType = referenceType;
    if (type === $5c7c4a516443d04f$var$link) {
        exit = self.enterLink();
        node.children = self.tokenizeInline(content, now);
        exit();
    } else if (type === $5c7c4a516443d04f$var$image) node.alt = self.decode.raw(self.unescape(content), now) || null;
    return eat(subvalue)(node);
}

});

parcelRegister("fmNrr", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $kZNgz = parcelRequire("kZNgz");

var $iaMhL = parcelRequire("iaMhL");
module.exports = $b2ff4328a7e106a4$var$strong;
$b2ff4328a7e106a4$var$strong.locator = $iaMhL;
var $b2ff4328a7e106a4$var$backslash = "\\";
var $b2ff4328a7e106a4$var$asterisk = "*";
var $b2ff4328a7e106a4$var$underscore = "_";
function $b2ff4328a7e106a4$var$strong(eat, value, silent) {
    var self = this;
    var index = 0;
    var character = value.charAt(index);
    var now;
    var pedantic;
    var marker;
    var queue;
    var subvalue;
    var length;
    var prev;
    if (character !== $b2ff4328a7e106a4$var$asterisk && character !== $b2ff4328a7e106a4$var$underscore || value.charAt(++index) !== character) return;
    pedantic = self.options.pedantic;
    marker = character;
    subvalue = marker + marker;
    length = value.length;
    index++;
    queue = "";
    character = "";
    if (pedantic && $kZNgz(value.charAt(index))) return;
    while(index < length){
        prev = character;
        character = value.charAt(index);
        if (character === marker && value.charAt(index + 1) === marker && (!pedantic || !$kZNgz(prev))) {
            character = value.charAt(index + 2);
            if (character !== marker) {
                if (!$2Lc6r(queue)) return;
                /* istanbul ignore if - never used (yet) */ if (silent) return true;
                now = eat.now();
                now.column += 2;
                now.offset += 2;
                return eat(subvalue + queue + subvalue)({
                    type: "strong",
                    children: self.tokenizeInline(queue, now)
                });
            }
        }
        if (!pedantic && character === $b2ff4328a7e106a4$var$backslash) {
            queue += character;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
}

});
parcelRegister("iaMhL", function(module, exports) {
"use strict";
module.exports = $d3ae9daaee50c876$var$locate;
function $d3ae9daaee50c876$var$locate(value, fromIndex) {
    var asterisk = value.indexOf("**", fromIndex);
    var underscore = value.indexOf("__", fromIndex);
    if (underscore === -1) return asterisk;
    if (asterisk === -1) return underscore;
    return underscore < asterisk ? underscore : asterisk;
}

});


parcelRegister("7yt0a", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $keUlj = parcelRequire("keUlj");

var $kZNgz = parcelRequire("kZNgz");

var $6P8CC = parcelRequire("6P8CC");
module.exports = $5802347f338abf37$var$emphasis;
$5802347f338abf37$var$emphasis.locator = $6P8CC;
var $5802347f338abf37$var$asterisk = "*";
var $5802347f338abf37$var$underscore = "_";
var $5802347f338abf37$var$backslash = "\\";
function $5802347f338abf37$var$emphasis(eat, value, silent) {
    var self = this;
    var index = 0;
    var character = value.charAt(index);
    var now;
    var pedantic;
    var marker;
    var queue;
    var subvalue;
    var length;
    var prev;
    if (character !== $5802347f338abf37$var$asterisk && character !== $5802347f338abf37$var$underscore) return;
    pedantic = self.options.pedantic;
    subvalue = character;
    marker = character;
    length = value.length;
    index++;
    queue = "";
    character = "";
    if (pedantic && $kZNgz(value.charAt(index))) return;
    while(index < length){
        prev = character;
        character = value.charAt(index);
        if (character === marker && (!pedantic || !$kZNgz(prev))) {
            character = value.charAt(++index);
            if (character !== marker) {
                if (!$2Lc6r(queue) || prev === marker) return;
                if (!pedantic && marker === $5802347f338abf37$var$underscore && $keUlj(character)) {
                    queue += marker;
                    continue;
                }
                /* istanbul ignore if - never used (yet) */ if (silent) return true;
                now = eat.now();
                now.column++;
                now.offset++;
                return eat(subvalue + queue + marker)({
                    type: "emphasis",
                    children: self.tokenizeInline(queue, now)
                });
            }
            queue += marker;
        }
        if (!pedantic && character === $5802347f338abf37$var$backslash) {
            queue += character;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
}

});
parcelRegister("keUlj", function(module, exports) {
"use strict";
module.exports = $ebc0d1ed13224092$var$wordCharacter;
var $ebc0d1ed13224092$var$fromCode = String.fromCharCode;
var $ebc0d1ed13224092$var$re = /\w/;
// Check if the given character code, or the character code at the first
// character, is a word character.
function $ebc0d1ed13224092$var$wordCharacter(character) {
    return $ebc0d1ed13224092$var$re.test(typeof character === "number" ? $ebc0d1ed13224092$var$fromCode(character) : character.charAt(0));
}

});

parcelRegister("6P8CC", function(module, exports) {
"use strict";
module.exports = $4f7e31a392f18c4c$var$locate;
function $4f7e31a392f18c4c$var$locate(value, fromIndex) {
    var asterisk = value.indexOf("*", fromIndex);
    var underscore = value.indexOf("_", fromIndex);
    if (underscore === -1) return asterisk;
    if (asterisk === -1) return underscore;
    return underscore < asterisk ? underscore : asterisk;
}

});


parcelRegister("8NqmE", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $ivEZI = parcelRequire("ivEZI");
module.exports = $667759b94575a5d7$var$strikethrough;
$667759b94575a5d7$var$strikethrough.locator = $ivEZI;
var $667759b94575a5d7$var$tilde = "~";
var $667759b94575a5d7$var$fence = "~~";
function $667759b94575a5d7$var$strikethrough(eat, value, silent) {
    var self = this;
    var character = "";
    var previous = "";
    var preceding = "";
    var subvalue = "";
    var index;
    var length;
    var now;
    if (!self.options.gfm || value.charAt(0) !== $667759b94575a5d7$var$tilde || value.charAt(1) !== $667759b94575a5d7$var$tilde || $kZNgz(value.charAt(2))) return;
    index = 1;
    length = value.length;
    now = eat.now();
    now.column += 2;
    now.offset += 2;
    while(++index < length){
        character = value.charAt(index);
        if (character === $667759b94575a5d7$var$tilde && previous === $667759b94575a5d7$var$tilde && (!preceding || !$kZNgz(preceding))) {
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            return eat($667759b94575a5d7$var$fence + subvalue + $667759b94575a5d7$var$fence)({
                type: "delete",
                children: self.tokenizeInline(subvalue, now)
            });
        }
        subvalue += previous;
        preceding = previous;
        previous = character;
    }
}

});
parcelRegister("ivEZI", function(module, exports) {
"use strict";
module.exports = $d79aebe61bd873bb$var$locate;
function $d79aebe61bd873bb$var$locate(value, fromIndex) {
    return value.indexOf("~~", fromIndex);
}

});


parcelRegister("kcJCs", function(module, exports) {
"use strict";

var $1WKa9 = parcelRequire("1WKa9");
module.exports = $eb5850b0ca110fa9$var$inlineCode;
$eb5850b0ca110fa9$var$inlineCode.locator = $1WKa9;
var $eb5850b0ca110fa9$var$lineFeed = 10 //  '\n'
;
var $eb5850b0ca110fa9$var$space = 32 // ' '
;
var $eb5850b0ca110fa9$var$graveAccent = 96 //  '`'
;
function $eb5850b0ca110fa9$var$inlineCode(eat, value, silent) {
    var length = value.length;
    var index = 0;
    var openingFenceEnd;
    var closingFenceStart;
    var closingFenceEnd;
    var code;
    var next;
    var found;
    while(index < length){
        if (value.charCodeAt(index) !== $eb5850b0ca110fa9$var$graveAccent) break;
        index++;
    }
    if (index === 0 || index === length) return;
    openingFenceEnd = index;
    next = value.charCodeAt(index);
    while(index < length){
        code = next;
        next = value.charCodeAt(index + 1);
        if (code === $eb5850b0ca110fa9$var$graveAccent) {
            if (closingFenceStart === undefined) closingFenceStart = index;
            closingFenceEnd = index + 1;
            if (next !== $eb5850b0ca110fa9$var$graveAccent && closingFenceEnd - closingFenceStart === openingFenceEnd) {
                found = true;
                break;
            }
        } else if (closingFenceStart !== undefined) {
            closingFenceStart = undefined;
            closingFenceEnd = undefined;
        }
        index++;
    }
    if (!found) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    // Remove the initial and final space (or line feed), iff they exist and there
    // are non-space characters in the content.
    index = openingFenceEnd;
    length = closingFenceStart;
    code = value.charCodeAt(index);
    next = value.charCodeAt(length - 1);
    found = false;
    if (length - index > 2 && (code === $eb5850b0ca110fa9$var$space || code === $eb5850b0ca110fa9$var$lineFeed) && (next === $eb5850b0ca110fa9$var$space || next === $eb5850b0ca110fa9$var$lineFeed)) {
        index++;
        length--;
        while(index < length){
            code = value.charCodeAt(index);
            if (code !== $eb5850b0ca110fa9$var$space && code !== $eb5850b0ca110fa9$var$lineFeed) {
                found = true;
                break;
            }
            index++;
        }
        if (found === true) {
            openingFenceEnd++;
            closingFenceStart--;
        }
    }
    return eat(value.slice(0, closingFenceEnd))({
        type: "inlineCode",
        value: value.slice(openingFenceEnd, closingFenceStart)
    });
}

});
parcelRegister("1WKa9", function(module, exports) {
"use strict";
module.exports = $16af042dd6844d9d$var$locate;
function $16af042dd6844d9d$var$locate(value, fromIndex) {
    return value.indexOf("`", fromIndex);
}

});


parcelRegister("5HxXI", function(module, exports) {
"use strict";

var $jHUst = parcelRequire("jHUst");
module.exports = $426b5015cf8848a8$var$hardBreak;
$426b5015cf8848a8$var$hardBreak.locator = $jHUst;
var $426b5015cf8848a8$var$space = " ";
var $426b5015cf8848a8$var$lineFeed = "\n";
var $426b5015cf8848a8$var$minBreakLength = 2;
function $426b5015cf8848a8$var$hardBreak(eat, value, silent) {
    var length = value.length;
    var index = -1;
    var queue = "";
    var character;
    while(++index < length){
        character = value.charAt(index);
        if (character === $426b5015cf8848a8$var$lineFeed) {
            if (index < $426b5015cf8848a8$var$minBreakLength) return;
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            queue += character;
            return eat(queue)({
                type: "break"
            });
        }
        if (character !== $426b5015cf8848a8$var$space) return;
        queue += character;
    }
}

});
parcelRegister("jHUst", function(module, exports) {
"use strict";
module.exports = $e58dd3ec31e2aede$var$locate;
function $e58dd3ec31e2aede$var$locate(value, fromIndex) {
    var index = value.indexOf("\n", fromIndex);
    while(index > fromIndex){
        if (value.charAt(index - 1) !== " ") break;
        index--;
    }
    return index;
}

});


parcelRegister("6Wwq4", function(module, exports) {
"use strict";
module.exports = $50e14eb3180c3348$var$text;
function $50e14eb3180c3348$var$text(eat, value, silent) {
    var self = this;
    var methods;
    var tokenizers;
    var index;
    var length;
    var subvalue;
    var position;
    var tokenizer;
    var name;
    var min;
    var now;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    methods = self.inlineMethods;
    length = methods.length;
    tokenizers = self.inlineTokenizers;
    index = -1;
    min = value.length;
    while(++index < length){
        name = methods[index];
        if (name === "text" || !tokenizers[name]) continue;
        tokenizer = tokenizers[name].locator;
        if (!tokenizer) eat.file.fail("Missing locator: `" + name + "`");
        position = tokenizer.call(self, value, 1);
        if (position !== -1 && position < min) min = position;
    }
    subvalue = value.slice(0, min);
    now = eat.now();
    self.decode(subvalue, now, handler);
    function handler(content, position, source) {
        eat(source || content)({
            type: "text",
            value: content
        });
    }
}

});



parcelRegister("h6gi9", function(module, exports) {
"use strict";

var $4HYGy = parcelRequire("4HYGy");

var $36bRz = parcelRequire("36bRz");

var $1oqsf = parcelRequire("1oqsf");
module.exports = $c72fa26a3391e042$var$stringify;
$c72fa26a3391e042$var$stringify.Compiler = $1oqsf;
function $c72fa26a3391e042$var$stringify(options) {
    var Local = $4HYGy($1oqsf);
    Local.prototype.options = $36bRz(Local.prototype.options, this.data("settings"), options);
    this.Compiler = Local;
}

});
parcelRegister("1oqsf", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $2Na8b = parcelRequire("2Na8b");
module.exports = $103c8da766b39025$var$Compiler;
// Construct a new compiler.
function $103c8da766b39025$var$Compiler(tree, file) {
    this.inLink = false;
    this.inTable = false;
    this.tree = tree;
    this.file = file;
    this.options = $36bRz(this.options);
    this.setOptions({});
}
var $103c8da766b39025$var$proto = $103c8da766b39025$var$Compiler.prototype;
// Enter and exit helpers. */
$103c8da766b39025$var$proto.enterLink = $2Na8b("inLink", false);
$103c8da766b39025$var$proto.enterTable = $2Na8b("inTable", false);

$103c8da766b39025$var$proto.enterLinkReference = (parcelRequire("eiJud"));

// Configuration.
$103c8da766b39025$var$proto.options = (parcelRequire("4jg49"));

$103c8da766b39025$var$proto.setOptions = (parcelRequire("1qewb"));

$103c8da766b39025$var$proto.compile = (parcelRequire("hUe0Z"));

$103c8da766b39025$var$proto.visit = (parcelRequire("7lWhm"));

$103c8da766b39025$var$proto.all = (parcelRequire("kazMB"));

$103c8da766b39025$var$proto.block = (parcelRequire("lMErl"));

$103c8da766b39025$var$proto.visitOrderedItems = (parcelRequire("2oLUO"));

$103c8da766b39025$var$proto.visitUnorderedItems = (parcelRequire("gCbn3"));

























// Expose visitors.
$103c8da766b39025$var$proto.visitors = {
    root: (parcelRequire("iuJSU")),
    text: (parcelRequire("bHTi6")),
    heading: (parcelRequire("6mcjt")),
    paragraph: (parcelRequire("ktk10")),
    blockquote: (parcelRequire("hstik")),
    list: (parcelRequire("9epcP")),
    listItem: (parcelRequire("9dTPf")),
    inlineCode: (parcelRequire("6EXE0")),
    code: (parcelRequire("h8uBH")),
    html: (parcelRequire("aIhig")),
    thematicBreak: (parcelRequire("k9U2B")),
    strong: (parcelRequire("59ZkP")),
    emphasis: (parcelRequire("6BoPl")),
    break: (parcelRequire("gWhdU")),
    delete: (parcelRequire("1AvTQ")),
    link: (parcelRequire("jErZN")),
    linkReference: (parcelRequire("cAGMu")),
    imageReference: (parcelRequire("jVyJf")),
    definition: (parcelRequire("2sZJo")),
    image: (parcelRequire("2nkQi")),
    footnote: (parcelRequire("ka6AX")),
    footnoteReference: (parcelRequire("4SeIk")),
    footnoteDefinition: (parcelRequire("2qmXc")),
    table: (parcelRequire("fMO6H")),
    tableCell: (parcelRequire("hLNrB"))
};

});
parcelRegister("eiJud", function(module, exports) {
"use strict";

var $1J8rd = parcelRequire("1J8rd");
module.exports = $a69607c9b51a3c1a$var$enter;
// Shortcut and collapsed link references need no escaping and encoding during
// the processing of child nodes (it must be implied from identifier).
//
// This toggler turns encoding and escaping off for shortcut and collapsed
// references.
//
// Implies `enterLink`.
function $a69607c9b51a3c1a$var$enter(compiler, node) {
    var encode = compiler.encode;
    var escape = compiler.escape;
    var exitLink = compiler.enterLink();
    if (node.referenceType !== "shortcut" && node.referenceType !== "collapsed") return exitLink;
    compiler.escape = $1J8rd;
    compiler.encode = $1J8rd;
    return exit;
    function exit() {
        compiler.encode = encode;
        compiler.escape = escape;
        exitLink();
    }
}

});
parcelRegister("1J8rd", function(module, exports) {
"use strict";
module.exports = $14208a0176175815$var$identity;
function $14208a0176175815$var$identity(value) {
    return value;
}

});


parcelRegister("4jg49", function(module, exports) {
"use strict";
module.exports = {
    gfm: true,
    commonmark: false,
    pedantic: false,
    entities: "false",
    setext: false,
    closeAtx: false,
    looseTable: false,
    spacedTable: true,
    paddedTable: true,
    stringLength: $3235661e56601a06$var$stringLength,
    incrementListMarker: true,
    fences: false,
    fence: "`",
    bullet: "-",
    listItemIndent: "tab",
    rule: "*",
    ruleSpaces: true,
    ruleRepetition: 3,
    strong: "*",
    emphasis: "_"
};
function $3235661e56601a06$var$stringLength(value) {
    return value.length;
}

});

parcelRegister("1qewb", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $cRpzI = parcelRequire("cRpzI");

var $4jg49 = parcelRequire("4jg49");

var $2broZ = parcelRequire("2broZ");

var $1J8rd = parcelRequire("1J8rd");
module.exports = $10937b28ca4da452$var$setOptions;
// Map of applicable enums.
var $10937b28ca4da452$var$maps = {
    entities: {
        true: true,
        false: true,
        numbers: true,
        escape: true
    },
    bullet: {
        "*": true,
        "-": true,
        "+": true
    },
    rule: {
        "-": true,
        _: true,
        "*": true
    },
    listItemIndent: {
        tab: true,
        mixed: true,
        1: true
    },
    emphasis: {
        _: true,
        "*": true
    },
    strong: {
        _: true,
        "*": true
    },
    fence: {
        "`": true,
        "~": true
    }
};
// Expose `validate`.
var $10937b28ca4da452$var$validate = {
    boolean: $10937b28ca4da452$var$validateBoolean,
    string: $10937b28ca4da452$var$validateString,
    number: $10937b28ca4da452$var$validateNumber,
    function: $10937b28ca4da452$var$validateFunction
};
// Set options.  Does not overwrite previously set options.
function $10937b28ca4da452$var$setOptions(options) {
    var self = this;
    var current = self.options;
    var ruleRepetition;
    var key;
    if (options == null) options = {};
    else if (typeof options === "object") options = $36bRz(options);
    else throw new Error("Invalid value `" + options + "` for setting `options`");
    for(key in $4jg49)$10937b28ca4da452$var$validate[typeof $4jg49[key]](options, key, current[key], $10937b28ca4da452$var$maps[key]);
    ruleRepetition = options.ruleRepetition;
    if (ruleRepetition && ruleRepetition < 3) $10937b28ca4da452$var$raise(ruleRepetition, "options.ruleRepetition");
    self.encode = $10937b28ca4da452$var$encodeFactory(String(options.entities));
    self.escape = $2broZ(options);
    self.options = options;
    return self;
}
// Validate a value to be boolean. Defaults to `def`.  Raises an exception with
// `context[name]` when not a boolean.
function $10937b28ca4da452$var$validateBoolean(context, name, def) {
    var value = context[name];
    if (value == null) value = def;
    if (typeof value !== "boolean") $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Validate a value to be boolean. Defaults to `def`.  Raises an exception with
// `context[name]` when not a boolean.
function $10937b28ca4da452$var$validateNumber(context, name, def) {
    var value = context[name];
    if (value == null) value = def;
    if (isNaN(value)) $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Validate a value to be in `map`. Defaults to `def`.  Raises an exception
// with `context[name]` when not in `map`.
function $10937b28ca4da452$var$validateString(context, name, def, map) {
    var value = context[name];
    if (value == null) value = def;
    value = String(value);
    if (!(value in map)) $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Validate a value to be function. Defaults to `def`.  Raises an exception
// with `context[name]` when not a function.
function $10937b28ca4da452$var$validateFunction(context, name, def) {
    var value = context[name];
    if (value == null) value = def;
    if (typeof value !== "function") $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Factory to encode HTML entities.  Creates a no-operation function when
// `type` is `'false'`, a function which encodes using named references when
// `type` is `'true'`, and a function which encodes using numbered references
// when `type` is `'numbers'`.
function $10937b28ca4da452$var$encodeFactory(type) {
    var options = {};
    if (type === "false") return $1J8rd;
    if (type === "true") options.useNamedReferences = true;
    if (type === "escape") {
        options.escapeOnly = true;
        options.useNamedReferences = true;
    }
    return wrapped;
    // Encode HTML entities using the bound options.
    function wrapped(value) {
        return $cRpzI(value, options);
    }
}
// Throw an exception with in its `message` `value` and `name`.
function $10937b28ca4da452$var$raise(value, name) {
    throw new Error("Invalid value `" + value + "` for setting `" + name + "`");
}

});
parcelRegister("cRpzI", function(module, exports) {
"use strict";

var $hZyIS = parcelRequire("hZyIS");

var $9PlhL = parcelRequire("9PlhL");

var $6lhfp = parcelRequire("6lhfp");

var $35IlD = parcelRequire("35IlD");

var $a278X = parcelRequire("a278X");

var $8A1I1 = parcelRequire("8A1I1");
module.exports = $95ce45f8ed6c82e0$var$encode;
$95ce45f8ed6c82e0$var$encode.escape = $95ce45f8ed6c82e0$var$escape;
var $95ce45f8ed6c82e0$var$own = {}.hasOwnProperty;
// List of enforced escapes.
var $95ce45f8ed6c82e0$var$escapes = [
    '"',
    "'",
    "<",
    ">",
    "&",
    "`"
];
// Map of characters to names.
var $95ce45f8ed6c82e0$var$characters = $95ce45f8ed6c82e0$var$construct();
// Default escapes.
var $95ce45f8ed6c82e0$var$defaultEscapes = $95ce45f8ed6c82e0$var$toExpression($95ce45f8ed6c82e0$var$escapes);
// Surrogate pairs.
var $95ce45f8ed6c82e0$var$surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
// Non-ASCII characters.
// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
var $95ce45f8ed6c82e0$var$bmp = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
// Encode special characters in `value`.
function $95ce45f8ed6c82e0$var$encode(value, options) {
    var settings = options || {};
    var subset = settings.subset;
    var set = subset ? $95ce45f8ed6c82e0$var$toExpression(subset) : $95ce45f8ed6c82e0$var$defaultEscapes;
    var escapeOnly = settings.escapeOnly;
    var omit = settings.omitOptionalSemicolons;
    value = value.replace(set, replace);
    if (subset || escapeOnly) return value;
    return value.replace($95ce45f8ed6c82e0$var$surrogatePair, replaceSurrogatePair).replace($95ce45f8ed6c82e0$var$bmp, replace);
    function replaceSurrogatePair(pair, pos, val) {
        return $95ce45f8ed6c82e0$var$toHexReference((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, val.charAt(pos + 2), omit);
    }
    function replace(char, pos, val) {
        return $95ce45f8ed6c82e0$var$one(char, val.charAt(pos + 1), settings);
    }
}
// Shortcut to escape special characters in HTML.
function $95ce45f8ed6c82e0$var$escape(value) {
    return $95ce45f8ed6c82e0$var$encode(value, {
        escapeOnly: true,
        useNamedReferences: true
    });
}
// Encode `char` according to `options`.
function $95ce45f8ed6c82e0$var$one(char, next, options) {
    var shortest = options.useShortestReferences;
    var omit = options.omitOptionalSemicolons;
    var named;
    var code;
    var numeric;
    var decimal;
    if ((shortest || options.useNamedReferences) && $95ce45f8ed6c82e0$var$own.call($95ce45f8ed6c82e0$var$characters, char)) named = $95ce45f8ed6c82e0$var$toNamed($95ce45f8ed6c82e0$var$characters[char], next, omit, options.attribute);
    if (shortest || !named) {
        code = char.charCodeAt(0);
        numeric = $95ce45f8ed6c82e0$var$toHexReference(code, next, omit);
        // Use the shortest numeric reference when requested.
        // A simple algorithm would use decimal for all code points under 100, as
        // those are shorter than hexadecimal:
        //
        // * `&#99;` vs `&#x63;` (decimal shorter)
        // * `&#100;` vs `&#x64;` (equal)
        //
        // However, because we take `next` into consideration when `omit` is used,
        // And it would be possible that decimals are shorter on bigger values as
        // well if `next` is hexadecimal but not decimal, we instead compare both.
        if (shortest) {
            decimal = $95ce45f8ed6c82e0$var$toDecimalReference(code, next, omit);
            if (decimal.length < numeric.length) numeric = decimal;
        }
    }
    if (named && (!shortest || named.length < numeric.length)) return named;
    return numeric;
}
// Transform `code` into an entity.
function $95ce45f8ed6c82e0$var$toNamed(name, next, omit, attribute) {
    var value = "&" + name;
    if (omit && $95ce45f8ed6c82e0$var$own.call($9PlhL, name) && $8A1I1.indexOf(name) === -1 && (!attribute || next && next !== "=" && !$a278X(next))) return value;
    return value + ";";
}
// Transform `code` into a hexadecimal character reference.
function $95ce45f8ed6c82e0$var$toHexReference(code, next, omit) {
    var value = "&#x" + code.toString(16).toUpperCase();
    return omit && next && !$6lhfp(next) ? value : value + ";";
}
// Transform `code` into a decimal character reference.
function $95ce45f8ed6c82e0$var$toDecimalReference(code, next, omit) {
    var value = "&#" + String(code);
    return omit && next && !$35IlD(next) ? value : value + ";";
}
// Create an expression for `characters`.
function $95ce45f8ed6c82e0$var$toExpression(characters) {
    return new RegExp("[" + characters.join("") + "]", "g");
}
// Construct the map.
function $95ce45f8ed6c82e0$var$construct() {
    var chars = {};
    var name;
    for(name in $hZyIS)chars[$hZyIS[name]] = name;
    return chars;
}

});
parcelRegister("hZyIS", function(module, exports) {
module.exports = JSON.parse('{"nbsp":"\xa0","iexcl":"\xa1","cent":"\xa2","pound":"\xa3","curren":"\xa4","yen":"\xa5","brvbar":"\xa6","sect":"\xa7","uml":"\xa8","copy":"\xa9","ordf":"\xaa","laquo":"\xab","not":"\xac","shy":"\xad","reg":"\xae","macr":"\xaf","deg":"\xb0","plusmn":"\xb1","sup2":"\xb2","sup3":"\xb3","acute":"\xb4","micro":"\xb5","para":"\xb6","middot":"\xb7","cedil":"\xb8","sup1":"\xb9","ordm":"\xba","raquo":"\xbb","frac14":"\xbc","frac12":"\xbd","frac34":"\xbe","iquest":"\xbf","Agrave":"\xc0","Aacute":"\xc1","Acirc":"\xc2","Atilde":"\xc3","Auml":"\xc4","Aring":"\xc5","AElig":"\xc6","Ccedil":"\xc7","Egrave":"\xc8","Eacute":"\xc9","Ecirc":"\xca","Euml":"\xcb","Igrave":"\xcc","Iacute":"\xcd","Icirc":"\xce","Iuml":"\xcf","ETH":"\xd0","Ntilde":"\xd1","Ograve":"\xd2","Oacute":"\xd3","Ocirc":"\xd4","Otilde":"\xd5","Ouml":"\xd6","times":"\xd7","Oslash":"\xd8","Ugrave":"\xd9","Uacute":"\xda","Ucirc":"\xdb","Uuml":"\xdc","Yacute":"\xdd","THORN":"\xde","szlig":"\xdf","agrave":"\xe0","aacute":"\xe1","acirc":"\xe2","atilde":"\xe3","auml":"\xe4","aring":"\xe5","aelig":"\xe6","ccedil":"\xe7","egrave":"\xe8","eacute":"\xe9","ecirc":"\xea","euml":"\xeb","igrave":"\xec","iacute":"\xed","icirc":"\xee","iuml":"\xef","eth":"\xf0","ntilde":"\xf1","ograve":"\xf2","oacute":"\xf3","ocirc":"\xf4","otilde":"\xf5","ouml":"\xf6","divide":"\xf7","oslash":"\xf8","ugrave":"\xf9","uacute":"\xfa","ucirc":"\xfb","uuml":"\xfc","yacute":"\xfd","thorn":"\xfe","yuml":"\xff","fnof":"\u0192","Alpha":"\u0391","Beta":"\u0392","Gamma":"\u0393","Delta":"\u0394","Epsilon":"\u0395","Zeta":"\u0396","Eta":"\u0397","Theta":"\u0398","Iota":"\u0399","Kappa":"\u039A","Lambda":"\u039B","Mu":"\u039C","Nu":"\u039D","Xi":"\u039E","Omicron":"\u039F","Pi":"\u03A0","Rho":"\u03A1","Sigma":"\u03A3","Tau":"\u03A4","Upsilon":"\u03A5","Phi":"\u03A6","Chi":"\u03A7","Psi":"\u03A8","Omega":"\u03A9","alpha":"\u03B1","beta":"\u03B2","gamma":"\u03B3","delta":"\u03B4","epsilon":"\u03B5","zeta":"\u03B6","eta":"\u03B7","theta":"\u03B8","iota":"\u03B9","kappa":"\u03BA","lambda":"\u03BB","mu":"\u03BC","nu":"\u03BD","xi":"\u03BE","omicron":"\u03BF","pi":"\u03C0","rho":"\u03C1","sigmaf":"\u03C2","sigma":"\u03C3","tau":"\u03C4","upsilon":"\u03C5","phi":"\u03C6","chi":"\u03C7","psi":"\u03C8","omega":"\u03C9","thetasym":"\u03D1","upsih":"\u03D2","piv":"\u03D6","bull":"\u2022","hellip":"\u2026","prime":"\u2032","Prime":"\u2033","oline":"\u203E","frasl":"\u2044","weierp":"\u2118","image":"\u2111","real":"\u211C","trade":"\u2122","alefsym":"\u2135","larr":"\u2190","uarr":"\u2191","rarr":"\u2192","darr":"\u2193","harr":"\u2194","crarr":"\u21B5","lArr":"\u21D0","uArr":"\u21D1","rArr":"\u21D2","dArr":"\u21D3","hArr":"\u21D4","forall":"\u2200","part":"\u2202","exist":"\u2203","empty":"\u2205","nabla":"\u2207","isin":"\u2208","notin":"\u2209","ni":"\u220B","prod":"\u220F","sum":"\u2211","minus":"\u2212","lowast":"\u2217","radic":"\u221A","prop":"\u221D","infin":"\u221E","ang":"\u2220","and":"\u2227","or":"\u2228","cap":"\u2229","cup":"\u222A","int":"\u222B","there4":"\u2234","sim":"\u223C","cong":"\u2245","asymp":"\u2248","ne":"\u2260","equiv":"\u2261","le":"\u2264","ge":"\u2265","sub":"\u2282","sup":"\u2283","nsub":"\u2284","sube":"\u2286","supe":"\u2287","oplus":"\u2295","otimes":"\u2297","perp":"\u22A5","sdot":"\u22C5","lceil":"\u2308","rceil":"\u2309","lfloor":"\u230A","rfloor":"\u230B","lang":"\u2329","rang":"\u232A","loz":"\u25CA","spades":"\u2660","clubs":"\u2663","hearts":"\u2665","diams":"\u2666","quot":"\\"","amp":"&","lt":"<","gt":">","OElig":"\u0152","oelig":"\u0153","Scaron":"\u0160","scaron":"\u0161","Yuml":"\u0178","circ":"\u02C6","tilde":"\u02DC","ensp":"\u2002","emsp":"\u2003","thinsp":"\u2009","zwnj":"\u200C","zwj":"\u200D","lrm":"\u200E","rlm":"\u200F","ndash":"\u2013","mdash":"\u2014","lsquo":"\u2018","rsquo":"\u2019","sbquo":"\u201A","ldquo":"\u201C","rdquo":"\u201D","bdquo":"\u201E","dagger":"\u2020","Dagger":"\u2021","permil":"\u2030","lsaquo":"\u2039","rsaquo":"\u203A","euro":"\u20AC"}');

});

parcelRegister("8A1I1", function(module, exports) {
module.exports = JSON.parse('["cent","copy","divide","gt","lt","not","para","times"]');

});


parcelRegister("2broZ", function(module, exports) {
"use strict";

var $35IlD = parcelRequire("35IlD");

var $3ADVd = parcelRequire("3ADVd");

var $kZNgz = parcelRequire("kZNgz");

var $6lv3b = parcelRequire("6lv3b");

var $hHbQw = parcelRequire("hHbQw");
module.exports = $1971dd560461b20f$var$factory;
var $1971dd560461b20f$var$tab = "	";
var $1971dd560461b20f$var$lineFeed = "\n";
var $1971dd560461b20f$var$space = " ";
var $1971dd560461b20f$var$numberSign = "#";
var $1971dd560461b20f$var$ampersand = "&";
var $1971dd560461b20f$var$leftParenthesis = "(";
var $1971dd560461b20f$var$rightParenthesis = ")";
var $1971dd560461b20f$var$asterisk = "*";
var $1971dd560461b20f$var$plusSign = "+";
var $1971dd560461b20f$var$dash = "-";
var $1971dd560461b20f$var$dot = ".";
var $1971dd560461b20f$var$colon = ":";
var $1971dd560461b20f$var$lessThan = "<";
var $1971dd560461b20f$var$greaterThan = ">";
var $1971dd560461b20f$var$leftSquareBracket = "[";
var $1971dd560461b20f$var$backslash = "\\";
var $1971dd560461b20f$var$rightSquareBracket = "]";
var $1971dd560461b20f$var$underscore = "_";
var $1971dd560461b20f$var$graveAccent = "`";
var $1971dd560461b20f$var$verticalBar = "|";
var $1971dd560461b20f$var$tilde = "~";
var $1971dd560461b20f$var$exclamationMark = "!";
var $1971dd560461b20f$var$entities = {
    "<": "&lt;",
    ":": "&#x3A;",
    "&": "&amp;",
    "|": "&#x7C;",
    "~": "&#x7E;"
};
var $1971dd560461b20f$var$shortcut = "shortcut";
var $1971dd560461b20f$var$mailto = "mailto";
var $1971dd560461b20f$var$https = "https";
var $1971dd560461b20f$var$http = "http";
var $1971dd560461b20f$var$blankExpression = /\n\s*$/;
// Factory to escape characters.
function $1971dd560461b20f$var$factory(options) {
    return escape;
    // Escape punctuation characters in a node’s value.
    function escape(value, node, parent) {
        var self = this;
        var gfm = options.gfm;
        var commonmark = options.commonmark;
        var pedantic = options.pedantic;
        var markers = commonmark ? [
            $1971dd560461b20f$var$dot,
            $1971dd560461b20f$var$rightParenthesis
        ] : [
            $1971dd560461b20f$var$dot
        ];
        var siblings = parent && parent.children;
        var index = siblings && siblings.indexOf(node);
        var prev = siblings && siblings[index - 1];
        var next = siblings && siblings[index + 1];
        var length = value.length;
        var escapable = $6lv3b(options);
        var position = -1;
        var queue = [];
        var escaped = queue;
        var afterNewLine;
        var character;
        var wordCharBefore;
        var wordCharAfter;
        var offset;
        var replace;
        if (prev) afterNewLine = $1971dd560461b20f$var$text(prev) && $1971dd560461b20f$var$blankExpression.test(prev.value);
        else afterNewLine = !parent || parent.type === "root" || parent.type === "paragraph";
        while(++position < length){
            character = value.charAt(position);
            replace = false;
            if (character === "\n") afterNewLine = true;
            else if (character === $1971dd560461b20f$var$backslash || character === $1971dd560461b20f$var$graveAccent || character === $1971dd560461b20f$var$asterisk || character === $1971dd560461b20f$var$leftSquareBracket || character === $1971dd560461b20f$var$lessThan || character === $1971dd560461b20f$var$ampersand && $hHbQw(value.slice(position)) > 0 || character === $1971dd560461b20f$var$rightSquareBracket && self.inLink || gfm && character === $1971dd560461b20f$var$tilde && value.charAt(position + 1) === $1971dd560461b20f$var$tilde || gfm && character === $1971dd560461b20f$var$verticalBar && (self.inTable || $1971dd560461b20f$var$alignment(value, position)) || character === $1971dd560461b20f$var$underscore && // Delegate leading/trailing underscores to the multinode version below.
            position > 0 && position < length - 1 && (pedantic || !$3ADVd(value.charAt(position - 1)) || !$3ADVd(value.charAt(position + 1))) || gfm && !self.inLink && character === $1971dd560461b20f$var$colon && $1971dd560461b20f$var$protocol(queue.join(""))) replace = true;
            else if (afterNewLine) {
                if (character === $1971dd560461b20f$var$greaterThan || character === $1971dd560461b20f$var$numberSign || character === $1971dd560461b20f$var$asterisk || character === $1971dd560461b20f$var$dash || character === $1971dd560461b20f$var$plusSign) replace = true;
                else if ($35IlD(character)) {
                    offset = position + 1;
                    while(offset < length){
                        if (!$35IlD(value.charAt(offset))) break;
                        offset++;
                    }
                    if (markers.indexOf(value.charAt(offset)) !== -1) {
                        next = value.charAt(offset + 1);
                        if (!next || next === $1971dd560461b20f$var$space || next === $1971dd560461b20f$var$tab || next === $1971dd560461b20f$var$lineFeed) {
                            queue.push(value.slice(position, offset));
                            position = offset;
                            character = value.charAt(position);
                            replace = true;
                        }
                    }
                }
            }
            if (afterNewLine && !$kZNgz(character)) afterNewLine = false;
            queue.push(replace ? one(character) : character);
        }
        // Multi-node versions.
        if (siblings && $1971dd560461b20f$var$text(node)) {
            // Check for an opening parentheses after a link-reference (which can be
            // joined by white-space).
            if (prev && prev.referenceType === $1971dd560461b20f$var$shortcut) {
                position = -1;
                length = escaped.length;
                while(++position < length){
                    character = escaped[position];
                    if (character === $1971dd560461b20f$var$space || character === $1971dd560461b20f$var$tab) continue;
                    if (character === $1971dd560461b20f$var$leftParenthesis || character === $1971dd560461b20f$var$colon) escaped[position] = one(character);
                    break;
                }
                // If the current node is all spaces / tabs, preceded by a shortcut,
                // and followed by a text starting with `(`, escape it.
                if ($1971dd560461b20f$var$text(next) && position === length && next.value.charAt(0) === $1971dd560461b20f$var$leftParenthesis) escaped.push($1971dd560461b20f$var$backslash);
            }
            // Ensure non-auto-links are not seen as links.  This pattern needs to
            // check the preceding nodes too.
            if (gfm && !self.inLink && $1971dd560461b20f$var$text(prev) && value.charAt(0) === $1971dd560461b20f$var$colon && $1971dd560461b20f$var$protocol(prev.value.slice(-6))) escaped[0] = one($1971dd560461b20f$var$colon);
            // Escape ampersand if it would otherwise start an entity.
            if ($1971dd560461b20f$var$text(next) && value.charAt(length - 1) === $1971dd560461b20f$var$ampersand && $hHbQw($1971dd560461b20f$var$ampersand + next.value) !== 0) escaped[escaped.length - 1] = one($1971dd560461b20f$var$ampersand);
            // Escape exclamation marks immediately followed by links.
            if (next && next.type === "link" && value.charAt(length - 1) === $1971dd560461b20f$var$exclamationMark) escaped[escaped.length - 1] = one($1971dd560461b20f$var$exclamationMark);
            // Escape double tildes in GFM.
            if (gfm && $1971dd560461b20f$var$text(next) && value.charAt(length - 1) === $1971dd560461b20f$var$tilde && next.value.charAt(0) === $1971dd560461b20f$var$tilde) escaped.splice(escaped.length - 1, 0, $1971dd560461b20f$var$backslash);
            // Escape underscores, but not mid-word (unless in pedantic mode).
            wordCharBefore = $1971dd560461b20f$var$text(prev) && $3ADVd(prev.value.slice(-1));
            wordCharAfter = $1971dd560461b20f$var$text(next) && $3ADVd(next.value.charAt(0));
            if (length === 1) {
                if (value === $1971dd560461b20f$var$underscore && (pedantic || !wordCharBefore || !wordCharAfter)) escaped.unshift($1971dd560461b20f$var$backslash);
            } else {
                if (value.charAt(0) === $1971dd560461b20f$var$underscore && (pedantic || !wordCharBefore || !$3ADVd(value.charAt(1)))) escaped.unshift($1971dd560461b20f$var$backslash);
                if (value.charAt(length - 1) === $1971dd560461b20f$var$underscore && (pedantic || !wordCharAfter || !$3ADVd(value.charAt(length - 2)))) escaped.splice(escaped.length - 1, 0, $1971dd560461b20f$var$backslash);
            }
        }
        return escaped.join("");
        function one(character) {
            return escapable.indexOf(character) === -1 ? $1971dd560461b20f$var$entities[character] : $1971dd560461b20f$var$backslash + character;
        }
    }
}
// Check if `index` in `value` is inside an alignment row.
function $1971dd560461b20f$var$alignment(value, index) {
    var start = value.lastIndexOf($1971dd560461b20f$var$lineFeed, index);
    var end = value.indexOf($1971dd560461b20f$var$lineFeed, index);
    var char;
    end = end === -1 ? value.length : end;
    while(++start < end){
        char = value.charAt(start);
        if (char !== $1971dd560461b20f$var$colon && char !== $1971dd560461b20f$var$dash && char !== $1971dd560461b20f$var$space && char !== $1971dd560461b20f$var$verticalBar) return false;
    }
    return true;
}
// Check if `node` is a text node.
function $1971dd560461b20f$var$text(node) {
    return node && node.type === "text";
}
// Check if `value` ends in a protocol.
function $1971dd560461b20f$var$protocol(value) {
    var val = value.slice(-6).toLowerCase();
    return val === $1971dd560461b20f$var$mailto || val.slice(-5) === $1971dd560461b20f$var$https || val.slice(-4) === $1971dd560461b20f$var$http;
}

});
parcelRegister("3ADVd", function(module, exports) {
"use strict";
module.exports = function(str) {
    if (typeof str !== "string") throw new TypeError("Expected a string");
    return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
};

});

parcelRegister("hHbQw", function(module, exports) {
"use strict";

var $eUIxU = parcelRequire("eUIxU");
module.exports = $ce1fa43116c2eefa$var$length;
var $ce1fa43116c2eefa$var$ampersand = "&";
// Returns the length of HTML entity that is a prefix of the given string
// (excluding the ampersand), 0 if it does not start with an entity.
function $ce1fa43116c2eefa$var$length(value) {
    var prefix;
    /* istanbul ignore if - Currently also tested for at implemention, but we
   * keep it here because that’s proper. */ if (value.charAt(0) !== $ce1fa43116c2eefa$var$ampersand) return 0;
    prefix = value.split($ce1fa43116c2eefa$var$ampersand, 2).join($ce1fa43116c2eefa$var$ampersand);
    return prefix.length - $eUIxU(prefix).length;
}

});



parcelRegister("hUe0Z", function(module, exports) {
"use strict";

var $2m6yc = parcelRequire("2m6yc");
module.exports = $d09289b1ba255a6d$var$compile;
// Stringify the given tree.
function $d09289b1ba255a6d$var$compile() {
    return this.visit($2m6yc(this.tree, this.options.commonmark));
}

});
parcelRegister("2m6yc", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
module.exports = $1b72b7a679216ff8$var$compact;
// Make an mdast tree compact by merging adjacent text nodes.
function $1b72b7a679216ff8$var$compact(tree, commonmark) {
    $KDBsL(tree, visitor);
    return tree;
    function visitor(child, index, parent) {
        var siblings = parent ? parent.children : [];
        var prev = index && siblings[index - 1];
        if (prev && child.type === prev.type && $1b72b7a679216ff8$var$mergeable(prev, commonmark) && $1b72b7a679216ff8$var$mergeable(child, commonmark)) {
            if (child.value) prev.value += child.value;
            if (child.children) prev.children = prev.children.concat(child.children);
            siblings.splice(index, 1);
            if (prev.position && child.position) prev.position.end = child.position.end;
            return index;
        }
    }
}
function $1b72b7a679216ff8$var$mergeable(node, commonmark) {
    var start;
    var end;
    if (node.type === "text") {
        if (!node.position) return true;
        start = node.position.start;
        end = node.position.end;
        // Only merge nodes which occupy the same size as their `value`.
        return start.line !== end.line || end.column - start.column === node.value.length;
    }
    return commonmark && node.type === "blockquote";
}

});


parcelRegister("7lWhm", function(module, exports) {
"use strict";
module.exports = $55a7b38d389b3e43$var$one;
function $55a7b38d389b3e43$var$one(node, parent) {
    var self = this;
    var visitors = self.visitors;
    // Fail on unknown nodes.
    if (typeof visitors[node.type] !== "function") self.file.fail(new Error("Missing compiler for node of type `" + node.type + "`: `" + node + "`"), node);
    return visitors[node.type].call(self, node, parent);
}

});

parcelRegister("kazMB", function(module, exports) {
"use strict";
module.exports = $eaf07f9409457532$var$all;
// Visit all children of `parent`.
function $eaf07f9409457532$var$all(parent) {
    var self = this;
    var children = parent.children;
    var length = children.length;
    var results = [];
    var index = -1;
    while(++index < length)results[index] = self.visit(children[index], parent);
    return results;
}

});

parcelRegister("lMErl", function(module, exports) {
"use strict";
module.exports = $fdbd73325f2576de$var$block;
var $fdbd73325f2576de$var$lineFeed = "\n";
var $fdbd73325f2576de$var$blank = $fdbd73325f2576de$var$lineFeed + $fdbd73325f2576de$var$lineFeed;
var $fdbd73325f2576de$var$triple = $fdbd73325f2576de$var$blank + $fdbd73325f2576de$var$lineFeed;
var $fdbd73325f2576de$var$comment = $fdbd73325f2576de$var$blank + "<!---->" + $fdbd73325f2576de$var$blank;
// Stringify a block node with block children (e.g., `root` or `blockquote`).
// Knows about code following a list, or adjacent lists with similar bullets,
// and places an extra line feed between them.
function $fdbd73325f2576de$var$block(node) {
    var self = this;
    var options = self.options;
    var fences = options.fences;
    var gap = options.commonmark ? $fdbd73325f2576de$var$comment : $fdbd73325f2576de$var$triple;
    var values = [];
    var children = node.children;
    var length = children.length;
    var index = -1;
    var prev;
    var child;
    while(++index < length){
        prev = child;
        child = children[index];
        if (prev) {
            // A list preceding another list that are equally ordered, or a
            // list preceding an indented code block, need a gap between them,
            // so as not to see them as one list, or content of the list,
            // respectively.
            //
            // In commonmark, only something that breaks both up can do that,
            // so we opt for an empty, invisible comment.  In other flavours,
            // two blank lines are fine.
            if (prev.type === "list" && (child.type === "list" && prev.ordered === child.ordered || child.type === "code" && !child.lang && !fences)) values.push(gap);
            else values.push($fdbd73325f2576de$var$blank);
        }
        values.push(self.visit(child, node));
    }
    return values.join("");
}

});

parcelRegister("2oLUO", function(module, exports) {
"use strict";
module.exports = $1bf2fda37ffa6cbc$var$orderedItems;
var $1bf2fda37ffa6cbc$var$lineFeed = "\n";
var $1bf2fda37ffa6cbc$var$dot = ".";
var $1bf2fda37ffa6cbc$var$blank = $1bf2fda37ffa6cbc$var$lineFeed + $1bf2fda37ffa6cbc$var$lineFeed;
// Visit ordered list items.
//
// Starts the list with
// `node.start` and increments each following list item
// bullet by one:
//
//     2. foo
//     3. bar
//
// In `incrementListMarker: false` mode, does not increment
// each marker and stays on `node.start`:
//
//     1. foo
//     1. bar
function $1bf2fda37ffa6cbc$var$orderedItems(node) {
    var self = this;
    var fn = self.visitors.listItem;
    var increment = self.options.incrementListMarker;
    var values = [];
    var start = node.start;
    var children = node.children;
    var length = children.length;
    var index = -1;
    var bullet;
    start = start == null ? 1 : start;
    while(++index < length){
        bullet = (increment ? start + index : start) + $1bf2fda37ffa6cbc$var$dot;
        values[index] = fn.call(self, children[index], node, index, bullet);
    }
    return values.join(node.spread ? $1bf2fda37ffa6cbc$var$blank : $1bf2fda37ffa6cbc$var$lineFeed);
}

});

parcelRegister("gCbn3", function(module, exports) {
"use strict";
module.exports = $c18903f8fd9d96da$var$unorderedItems;
var $c18903f8fd9d96da$var$lineFeed = "\n";
var $c18903f8fd9d96da$var$blank = $c18903f8fd9d96da$var$lineFeed + $c18903f8fd9d96da$var$lineFeed;
// Visit unordered list items.  Uses `options.bullet` as each item’s bullet.
function $c18903f8fd9d96da$var$unorderedItems(node) {
    var self = this;
    var bullet = self.options.bullet;
    var fn = self.visitors.listItem;
    var children = node.children;
    var length = children.length;
    var index = -1;
    var values = [];
    while(++index < length)values[index] = fn.call(self, children[index], node, index, bullet);
    return values.join(node.spread ? $c18903f8fd9d96da$var$blank : $c18903f8fd9d96da$var$lineFeed);
}

});

parcelRegister("iuJSU", function(module, exports) {
"use strict";
module.exports = $d76e9f0e1880392d$var$root;
var $d76e9f0e1880392d$var$lineFeed = "\n";
// Stringify a root.
// Adds a final newline to ensure valid POSIX files. */
function $d76e9f0e1880392d$var$root(node) {
    var doc = this.block(node);
    if (doc.charAt(doc.length - 1) !== $d76e9f0e1880392d$var$lineFeed) doc += $d76e9f0e1880392d$var$lineFeed;
    return doc;
}

});

parcelRegister("bHTi6", function(module, exports) {
"use strict";
module.exports = $885e997bf5f33a48$var$text;
// Stringify text.
// Supports named entities in `settings.encode: true` mode:
//
// ```markdown
// AT&amp;T
// ```
//
// Supports numbered entities in `settings.encode: numbers` mode:
//
// ```markdown
// AT&#x26;T
// ```
function $885e997bf5f33a48$var$text(node, parent) {
    return this.encode(this.escape(node.value, node, parent), node);
}

});

parcelRegister("6mcjt", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $4a0e593fd7bfb44f$var$heading;
var $4a0e593fd7bfb44f$var$lineFeed = "\n";
var $4a0e593fd7bfb44f$var$space = " ";
var $4a0e593fd7bfb44f$var$numberSign = "#";
var $4a0e593fd7bfb44f$var$dash = "-";
var $4a0e593fd7bfb44f$var$equalsTo = "=";
// Stringify a heading.
//
// In `setext: true` mode and when `depth` is smaller than three, creates a
// setext header:
//
// ```markdown
// Foo
// ===
// ```
//
// Otherwise, an ATX header is generated:
//
// ```markdown
// ### Foo
// ```
//
// In `closeAtx: true` mode, the header is closed with hashes:
//
// ```markdown
// ### Foo ###
// ```
function $4a0e593fd7bfb44f$var$heading(node) {
    var self = this;
    var depth = node.depth;
    var setext = self.options.setext;
    var closeAtx = self.options.closeAtx;
    var content = self.all(node).join("");
    var prefix;
    if (setext && depth < 3) return content + $4a0e593fd7bfb44f$var$lineFeed + $j6axH(depth === 1 ? $4a0e593fd7bfb44f$var$equalsTo : $4a0e593fd7bfb44f$var$dash, content.length);
    prefix = $j6axH($4a0e593fd7bfb44f$var$numberSign, node.depth);
    return prefix + $4a0e593fd7bfb44f$var$space + content + (closeAtx ? $4a0e593fd7bfb44f$var$space + prefix : "");
}

});

parcelRegister("ktk10", function(module, exports) {
"use strict";
module.exports = $ee760ab3715ceac3$var$paragraph;
function $ee760ab3715ceac3$var$paragraph(node) {
    return this.all(node).join("");
}

});

parcelRegister("hstik", function(module, exports) {
"use strict";
module.exports = $cb5bc67872618751$var$blockquote;
var $cb5bc67872618751$var$lineFeed = "\n";
var $cb5bc67872618751$var$space = " ";
var $cb5bc67872618751$var$greaterThan = ">";
function $cb5bc67872618751$var$blockquote(node) {
    var values = this.block(node).split($cb5bc67872618751$var$lineFeed);
    var result = [];
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        result[index] = (value ? $cb5bc67872618751$var$space : "") + value;
    }
    return $cb5bc67872618751$var$greaterThan + result.join($cb5bc67872618751$var$lineFeed + $cb5bc67872618751$var$greaterThan);
}

});

parcelRegister("9epcP", function(module, exports) {
"use strict";
module.exports = $6b88f93b11ad4cf6$var$list;
function $6b88f93b11ad4cf6$var$list(node) {
    var fn = node.ordered ? this.visitOrderedItems : this.visitUnorderedItems;
    return fn.call(this, node);
}

});

parcelRegister("9dTPf", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");

var $76VEg = parcelRequire("76VEg");
module.exports = $6b70a1c64b9e2d0b$var$listItem;
var $6b70a1c64b9e2d0b$var$lineFeed = "\n";
var $6b70a1c64b9e2d0b$var$space = " ";
var $6b70a1c64b9e2d0b$var$leftSquareBracket = "[";
var $6b70a1c64b9e2d0b$var$rightSquareBracket = "]";
var $6b70a1c64b9e2d0b$var$lowercaseX = "x";
var $6b70a1c64b9e2d0b$var$ceil = Math.ceil;
var $6b70a1c64b9e2d0b$var$blank = $6b70a1c64b9e2d0b$var$lineFeed + $6b70a1c64b9e2d0b$var$lineFeed;
var $6b70a1c64b9e2d0b$var$tabSize = 4;
// Stringify a list item.
//
// Prefixes the content with a checked checkbox when `checked: true`:
//
// ```markdown
// [x] foo
// ```
//
// Prefixes the content with an unchecked checkbox when `checked: false`:
//
// ```markdown
// [ ] foo
// ```
function $6b70a1c64b9e2d0b$var$listItem(node, parent, position, bullet) {
    var self = this;
    var style = self.options.listItemIndent;
    var marker = bullet || self.options.bullet;
    var spread = node.spread == null ? true : node.spread;
    var checked = node.checked;
    var children = node.children;
    var length = children.length;
    var values = [];
    var index = -1;
    var value;
    var indent;
    var spacing;
    while(++index < length)values[index] = self.visit(children[index], node);
    value = values.join(spread ? $6b70a1c64b9e2d0b$var$blank : $6b70a1c64b9e2d0b$var$lineFeed);
    if (typeof checked === "boolean") // Note: I’d like to be able to only add the space between the check and
    // the value, but unfortunately github does not support empty list-items
    // with a checkbox :(
    value = $6b70a1c64b9e2d0b$var$leftSquareBracket + (checked ? $6b70a1c64b9e2d0b$var$lowercaseX : $6b70a1c64b9e2d0b$var$space) + $6b70a1c64b9e2d0b$var$rightSquareBracket + $6b70a1c64b9e2d0b$var$space + value;
    if (style === "1" || style === "mixed" && value.indexOf($6b70a1c64b9e2d0b$var$lineFeed) === -1) {
        indent = marker.length + 1;
        spacing = $6b70a1c64b9e2d0b$var$space;
    } else {
        indent = $6b70a1c64b9e2d0b$var$ceil((marker.length + 1) / $6b70a1c64b9e2d0b$var$tabSize) * $6b70a1c64b9e2d0b$var$tabSize;
        spacing = $j6axH($6b70a1c64b9e2d0b$var$space, indent - marker.length);
    }
    return value ? marker + spacing + $76VEg(value, indent / $6b70a1c64b9e2d0b$var$tabSize).slice(indent) : marker;
}

});
parcelRegister("76VEg", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $52d5cfb9a3a7225e$var$pad;
var $52d5cfb9a3a7225e$var$lineFeed = "\n";
var $52d5cfb9a3a7225e$var$space = " ";
var $52d5cfb9a3a7225e$var$tabSize = 4;
// Pad `value` with `level * tabSize` spaces.  Respects lines.  Ignores empty
// lines.
function $52d5cfb9a3a7225e$var$pad(value, level) {
    var values = value.split($52d5cfb9a3a7225e$var$lineFeed);
    var index = values.length;
    var padding = $j6axH($52d5cfb9a3a7225e$var$space, level * $52d5cfb9a3a7225e$var$tabSize);
    while(index--)if (values[index].length !== 0) values[index] = padding + values[index];
    return values.join($52d5cfb9a3a7225e$var$lineFeed);
}

});


parcelRegister("6EXE0", function(module, exports) {
"use strict";

var $2BG1N = parcelRequire("2BG1N");

var $j6axH = parcelRequire("j6axH");
module.exports = $4d94be9fb538b0f7$var$inlineCode;
var $4d94be9fb538b0f7$var$graveAccentChar = "`";
var $4d94be9fb538b0f7$var$lineFeed = 10 //  '\n'
;
var $4d94be9fb538b0f7$var$space = 32 // ' '
;
var $4d94be9fb538b0f7$var$graveAccent = 96 //  '`'
;
// Stringify inline code.
//
// Knows about internal ticks (`\``), and ensures one more tick is used to
// enclose the inline code:
//
// ````markdown
// ```foo ``bar`` baz```
// ````
//
// Even knows about inital and final ticks:
//
// ``markdown
// `` `foo ``
// `` foo` ``
// ```
function $4d94be9fb538b0f7$var$inlineCode(node) {
    var value = node.value;
    var ticks = $j6axH($4d94be9fb538b0f7$var$graveAccentChar, $2BG1N(value, $4d94be9fb538b0f7$var$graveAccentChar) + 1);
    var start = ticks;
    var end = ticks;
    var head = value.charCodeAt(0);
    var tail = value.charCodeAt(value.length - 1);
    var wrap = false;
    var index;
    var length;
    if (head === $4d94be9fb538b0f7$var$graveAccent || tail === $4d94be9fb538b0f7$var$graveAccent) wrap = true;
    else if (value.length > 2 && $4d94be9fb538b0f7$var$ws(head) && $4d94be9fb538b0f7$var$ws(tail)) {
        index = 1;
        length = value.length - 1;
        while(++index < length)if (!$4d94be9fb538b0f7$var$ws(value.charCodeAt(index))) {
            wrap = true;
            break;
        }
    }
    if (wrap) {
        start += " ";
        end = " " + end;
    }
    return start + value + end;
}
function $4d94be9fb538b0f7$var$ws(code) {
    return code === $4d94be9fb538b0f7$var$lineFeed || code === $4d94be9fb538b0f7$var$space;
}

});
parcelRegister("2BG1N", function(module, exports) {
"use strict";
module.exports = $1e5fa35dbdacaf71$var$longestStreak;
// Get the count of the longest repeating streak of `character` in `value`.
function $1e5fa35dbdacaf71$var$longestStreak(value, character) {
    var count = 0;
    var maximum = 0;
    var expected;
    var index;
    if (typeof character !== "string" || character.length !== 1) throw new Error("Expected character");
    value = String(value);
    index = value.indexOf(character);
    expected = index;
    while(index !== -1){
        count++;
        if (index === expected) {
            if (count > maximum) maximum = count;
        } else count = 1;
        expected = index + 1;
        index = value.indexOf(character, expected);
    }
    return maximum;
}

});


parcelRegister("h8uBH", function(module, exports) {
"use strict";

var $2BG1N = parcelRequire("2BG1N");

var $j6axH = parcelRequire("j6axH");

var $76VEg = parcelRequire("76VEg");
module.exports = $c79aecee8034dfd0$var$code;
var $c79aecee8034dfd0$var$lineFeed = "\n";
var $c79aecee8034dfd0$var$space = " ";
var $c79aecee8034dfd0$var$tilde = "~";
var $c79aecee8034dfd0$var$graveAccent = "`";
// Stringify code.
// Creates indented code when:
//
// - No language tag exists
// - Not in `fences: true` mode
// - A non-empty value exists
//
// Otherwise, GFM fenced code is created:
//
// ````markdown
// ```js
// foo();
// ```
// ````
//
// When in ``fence: `~` `` mode, uses tildes as fences:
//
// ```markdown
// ~~~js
// foo();
// ~~~
// ```
//
// Knows about internal fences:
//
// `````markdown
// ````markdown
// ```javascript
// foo();
// ```
// ````
// `````
function $c79aecee8034dfd0$var$code(node, parent) {
    var self = this;
    var value = node.value;
    var options = self.options;
    var marker = options.fence;
    var info = node.lang || "";
    var fence;
    if (info && node.meta) info += $c79aecee8034dfd0$var$space + node.meta;
    info = self.encode(self.escape(info, node));
    // Without (needed) fences.
    if (!info && !options.fences && value && value.charAt(0) !== $c79aecee8034dfd0$var$lineFeed && value.charAt(value.length - 1) !== $c79aecee8034dfd0$var$lineFeed) {
        // Throw when pedantic, in a list item which isn’t compiled using a tab.
        if (parent && parent.type === "listItem" && options.listItemIndent !== "tab" && options.pedantic) self.file.fail("Cannot indent code properly. See https://git.io/fxKR8", node.position);
        return $76VEg(value, 1);
    }
    // Backticks in the info string don’t work with backtick fenced code.
    // Backticks (and tildes) are fine in tilde fenced code.
    if (marker === $c79aecee8034dfd0$var$graveAccent && info.indexOf($c79aecee8034dfd0$var$graveAccent) !== -1) marker = $c79aecee8034dfd0$var$tilde;
    fence = $j6axH(marker, Math.max($2BG1N(value, marker) + 1, 3));
    return fence + info + $c79aecee8034dfd0$var$lineFeed + value + $c79aecee8034dfd0$var$lineFeed + fence;
}

});

parcelRegister("aIhig", function(module, exports) {
"use strict";
module.exports = $7ccb6d94089a221e$var$html;
function $7ccb6d94089a221e$var$html(node) {
    return node.value;
}

});

parcelRegister("k9U2B", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $ead01e7d07399c23$var$thematic;
var $ead01e7d07399c23$var$space = " ";
// Stringify a `thematic-break`.
// The character used is configurable through `rule`: (`'_'`):
//
// ```markdown
// ___
// ```
//
// The number of repititions is defined through `ruleRepetition` (`6`):
//
// ```markdown
// ******
// ```
//
// Whether spaces delimit each character, is configured through `ruleSpaces`
// (`true`):
// ```markdown
// * * *
// ```
function $ead01e7d07399c23$var$thematic() {
    var options = this.options;
    var rule = $j6axH(options.rule, options.ruleRepetition);
    return options.ruleSpaces ? rule.split("").join($ead01e7d07399c23$var$space) : rule;
}

});

parcelRegister("59ZkP", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $3c1d5ed671948a47$var$strong;
// Stringify a `strong`.
//
// The marker used is configurable by `strong`, which defaults to an asterisk
// (`'*'`) but also accepts an underscore (`'_'`):
//
// ```markdown
// __foo__
// ```
function $3c1d5ed671948a47$var$strong(node) {
    var marker = $j6axH(this.options.strong, 2);
    return marker + this.all(node).join("") + marker;
}

});

parcelRegister("6BoPl", function(module, exports) {
"use strict";
module.exports = $4ce974f1fdcaa67e$var$emphasis;
var $4ce974f1fdcaa67e$var$underscore = "_";
var $4ce974f1fdcaa67e$var$asterisk = "*";
// Stringify an `emphasis`.
//
// The marker used is configurable through `emphasis`, which defaults to an
// underscore (`'_'`) but also accepts an asterisk (`'*'`):
//
// ```markdown
// *foo*
// ```
//
// In `pedantic` mode, text which itself contains an underscore will cause the
// marker to default to an asterisk instead:
//
// ```markdown
// *foo_bar*
// ```
function $4ce974f1fdcaa67e$var$emphasis(node) {
    var marker = this.options.emphasis;
    var content = this.all(node).join("");
    // When in pedantic mode, prevent using underscore as the marker when there
    // are underscores in the content.
    if (this.options.pedantic && marker === $4ce974f1fdcaa67e$var$underscore && content.indexOf(marker) !== -1) marker = $4ce974f1fdcaa67e$var$asterisk;
    return marker + content + marker;
}

});

parcelRegister("gWhdU", function(module, exports) {
"use strict";
module.exports = $c54f6c4c454c4b38$var$lineBreak;
var $c54f6c4c454c4b38$var$backslash = "\\";
var $c54f6c4c454c4b38$var$lineFeed = "\n";
var $c54f6c4c454c4b38$var$space = " ";
var $c54f6c4c454c4b38$var$commonmark = $c54f6c4c454c4b38$var$backslash + $c54f6c4c454c4b38$var$lineFeed;
var $c54f6c4c454c4b38$var$normal = $c54f6c4c454c4b38$var$space + $c54f6c4c454c4b38$var$space + $c54f6c4c454c4b38$var$lineFeed;
function $c54f6c4c454c4b38$var$lineBreak() {
    return this.options.commonmark ? $c54f6c4c454c4b38$var$commonmark : $c54f6c4c454c4b38$var$normal;
}

});

parcelRegister("1AvTQ", function(module, exports) {
"use strict";
module.exports = $1281e5e0c3f7617f$var$strikethrough;
var $1281e5e0c3f7617f$var$tilde = "~";
var $1281e5e0c3f7617f$var$fence = $1281e5e0c3f7617f$var$tilde + $1281e5e0c3f7617f$var$tilde;
function $1281e5e0c3f7617f$var$strikethrough(node) {
    return $1281e5e0c3f7617f$var$fence + this.all(node).join("") + $1281e5e0c3f7617f$var$fence;
}

});

parcelRegister("jErZN", function(module, exports) {
"use strict";

var $1RMhw = parcelRequire("1RMhw");

var $gUBoX = parcelRequire("gUBoX");
module.exports = $e4e7781a32f5dc7b$var$link;
var $e4e7781a32f5dc7b$var$space = " ";
var $e4e7781a32f5dc7b$var$leftSquareBracket = "[";
var $e4e7781a32f5dc7b$var$rightSquareBracket = "]";
var $e4e7781a32f5dc7b$var$leftParenthesis = "(";
var $e4e7781a32f5dc7b$var$rightParenthesis = ")";
// Expression for a protocol:
// See <https://en.wikipedia.org/wiki/Uniform_Resource_Identifier#Generic_syntax>.
var $e4e7781a32f5dc7b$var$protocol = /^[a-z][a-z+.-]+:\/?/i;
// Stringify a link.
//
// When no title exists, the compiled `children` equal `url`, and `url` starts
// with a protocol, an auto link is created:
//
// ```markdown
// <http://example.com>
// ```
//
// Otherwise, is smart about enclosing `url` (see `encloseURI()`) and `title`
// (see `encloseTitle()`).
// ```
//
// ```markdown
// [foo](<foo at bar dot com> 'An "example" e-mail')
// ```
//
// Supports named entities in the `url` and `title` when in `settings.encode`
// mode.
function $e4e7781a32f5dc7b$var$link(node) {
    var self = this;
    var content = self.encode(node.url || "", node);
    var exit = self.enterLink();
    var escaped = self.encode(self.escape(node.url || "", node));
    var value = self.all(node).join("");
    exit();
    if (node.title == null && $e4e7781a32f5dc7b$var$protocol.test(content) && escaped === value) // Backslash escapes do not work in autolinks, so we do not escape.
    return $1RMhw(self.encode(node.url), true);
    content = $1RMhw(content);
    if (node.title) content += $e4e7781a32f5dc7b$var$space + $gUBoX(self.encode(self.escape(node.title, node), node));
    return $e4e7781a32f5dc7b$var$leftSquareBracket + value + $e4e7781a32f5dc7b$var$rightSquareBracket + $e4e7781a32f5dc7b$var$leftParenthesis + content + $e4e7781a32f5dc7b$var$rightParenthesis;
}

});
parcelRegister("1RMhw", function(module, exports) {
"use strict";

var $ggJb9 = parcelRequire("ggJb9");
module.exports = $15c03168be7e3636$var$enclose;
var $15c03168be7e3636$var$leftParenthesis = "(";
var $15c03168be7e3636$var$rightParenthesis = ")";
var $15c03168be7e3636$var$lessThan = "<";
var $15c03168be7e3636$var$greaterThan = ">";
var $15c03168be7e3636$var$expression = /\s/;
// Wrap `url` in angle brackets when needed, or when
// forced.
// In links, images, and definitions, the URL part needs
// to be enclosed when it:
//
// - has a length of `0`
// - contains white-space
// - has more or less opening than closing parentheses
function $15c03168be7e3636$var$enclose(uri, always) {
    if (always || uri.length === 0 || $15c03168be7e3636$var$expression.test(uri) || $ggJb9(uri, $15c03168be7e3636$var$leftParenthesis) !== $ggJb9(uri, $15c03168be7e3636$var$rightParenthesis)) return $15c03168be7e3636$var$lessThan + uri + $15c03168be7e3636$var$greaterThan;
    return uri;
}

});
parcelRegister("ggJb9", function(module, exports) {
"use strict";
module.exports = $bd812f917a96fba8$var$ccount;
function $bd812f917a96fba8$var$ccount(value, character) {
    var val = String(value);
    var count = 0;
    var index;
    if (typeof character !== "string" || character.length !== 1) throw new Error("Expected character");
    index = val.indexOf(character);
    while(index !== -1){
        count++;
        index = val.indexOf(character, index + 1);
    }
    return count;
}

});


parcelRegister("gUBoX", function(module, exports) {
"use strict";
module.exports = $c4fee37c91a6bb2d$var$enclose;
var $c4fee37c91a6bb2d$var$quotationMark = '"';
var $c4fee37c91a6bb2d$var$apostrophe = "'";
// There is currently no way to support nested delimiters across Markdown.pl,
// CommonMark, and GitHub (RedCarpet).  The following code supports Markdown.pl
// and GitHub.
// CommonMark is not supported when mixing double- and single quotes inside a
// title.
function $c4fee37c91a6bb2d$var$enclose(title) {
    var delimiter = title.indexOf($c4fee37c91a6bb2d$var$quotationMark) === -1 ? $c4fee37c91a6bb2d$var$quotationMark : $c4fee37c91a6bb2d$var$apostrophe;
    return delimiter + title + delimiter;
}

});


parcelRegister("cAGMu", function(module, exports) {
"use strict";

var $8vDWa = parcelRequire("8vDWa");

var $copSG = parcelRequire("copSG");
module.exports = $92aa0847c0f26e6b$var$linkReference;
var $92aa0847c0f26e6b$var$leftSquareBracket = "[";
var $92aa0847c0f26e6b$var$rightSquareBracket = "]";
var $92aa0847c0f26e6b$var$shortcut = "shortcut";
var $92aa0847c0f26e6b$var$collapsed = "collapsed";
function $92aa0847c0f26e6b$var$linkReference(node) {
    var self = this;
    var type = node.referenceType;
    var exit = self.enterLinkReference(self, node);
    var value = self.all(node).join("");
    exit();
    if (type === $92aa0847c0f26e6b$var$shortcut || type === $92aa0847c0f26e6b$var$collapsed) value = $8vDWa(value, node.label || node.identifier);
    return $92aa0847c0f26e6b$var$leftSquareBracket + value + $92aa0847c0f26e6b$var$rightSquareBracket + $copSG(node);
}

});
parcelRegister("8vDWa", function(module, exports) {
"use strict";

var $hHbQw = parcelRequire("hHbQw");
module.exports = $632032abf37cfa7b$var$copy;
var $632032abf37cfa7b$var$ampersand = "&";
var $632032abf37cfa7b$var$punctuationExppresion = /[-!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~_]/;
// For shortcut and collapsed reference links, the contents is also an
// identifier, so we need to restore the original encoding and escaping
// that were present in the source string.
//
// This function takes the unescaped & unencoded value from shortcut’s
// child nodes and the identifier and encodes the former according to
// the latter.
function $632032abf37cfa7b$var$copy(value, identifier) {
    var length = value.length;
    var count = identifier.length;
    var result = [];
    var position = 0;
    var index = 0;
    var start;
    while(index < length){
        // Take next non-punctuation characters from `value`.
        start = index;
        while(index < length && !$632032abf37cfa7b$var$punctuationExppresion.test(value.charAt(index)))index += 1;
        result.push(value.slice(start, index));
        // Advance `position` to the next punctuation character.
        while(position < count && !$632032abf37cfa7b$var$punctuationExppresion.test(identifier.charAt(position)))position += 1;
        // Take next punctuation characters from `identifier`.
        start = position;
        while(position < count && $632032abf37cfa7b$var$punctuationExppresion.test(identifier.charAt(position))){
            if (identifier.charAt(position) === $632032abf37cfa7b$var$ampersand) position += $hHbQw(identifier.slice(position));
            position += 1;
        }
        result.push(identifier.slice(start, position));
        // Advance `index` to the next non-punctuation character.
        while(index < length && $632032abf37cfa7b$var$punctuationExppresion.test(value.charAt(index)))index += 1;
    }
    return result.join("");
}

});

parcelRegister("copSG", function(module, exports) {
"use strict";
module.exports = $905bcd5e95700a8a$var$label;
var $905bcd5e95700a8a$var$leftSquareBracket = "[";
var $905bcd5e95700a8a$var$rightSquareBracket = "]";
var $905bcd5e95700a8a$var$shortcut = "shortcut";
var $905bcd5e95700a8a$var$collapsed = "collapsed";
// Stringify a reference label.
// Because link references are easily, mistakingly, created (for example,
// `[foo]`), reference nodes have an extra property depicting how it looked in
// the original document, so stringification can cause minimal changes.
function $905bcd5e95700a8a$var$label(node) {
    var type = node.referenceType;
    if (type === $905bcd5e95700a8a$var$shortcut) return "";
    return $905bcd5e95700a8a$var$leftSquareBracket + (type === $905bcd5e95700a8a$var$collapsed ? "" : node.label || node.identifier) + $905bcd5e95700a8a$var$rightSquareBracket;
}

});


parcelRegister("jVyJf", function(module, exports) {
"use strict";

var $copSG = parcelRequire("copSG");
module.exports = $e81e479779c3b958$var$imageReference;
var $e81e479779c3b958$var$leftSquareBracket = "[";
var $e81e479779c3b958$var$rightSquareBracket = "]";
var $e81e479779c3b958$var$exclamationMark = "!";
function $e81e479779c3b958$var$imageReference(node) {
    return $e81e479779c3b958$var$exclamationMark + $e81e479779c3b958$var$leftSquareBracket + (this.encode(node.alt, node) || "") + $e81e479779c3b958$var$rightSquareBracket + $copSG(node);
}

});

parcelRegister("2sZJo", function(module, exports) {
"use strict";

var $1RMhw = parcelRequire("1RMhw");

var $gUBoX = parcelRequire("gUBoX");
module.exports = $1cbe14d533bad5a8$var$definition;
var $1cbe14d533bad5a8$var$space = " ";
var $1cbe14d533bad5a8$var$colon = ":";
var $1cbe14d533bad5a8$var$leftSquareBracket = "[";
var $1cbe14d533bad5a8$var$rightSquareBracket = "]";
// Stringify an URL definition.
//
// Is smart about enclosing `url` (see `encloseURI()`) and `title` (see
// `encloseTitle()`).
//
// ```markdown
// [foo]: <foo at bar dot com> 'An "example" e-mail'
// ```
function $1cbe14d533bad5a8$var$definition(node) {
    var content = $1RMhw(node.url);
    if (node.title) content += $1cbe14d533bad5a8$var$space + $gUBoX(node.title);
    return $1cbe14d533bad5a8$var$leftSquareBracket + (node.label || node.identifier) + $1cbe14d533bad5a8$var$rightSquareBracket + $1cbe14d533bad5a8$var$colon + $1cbe14d533bad5a8$var$space + content;
}

});

parcelRegister("2nkQi", function(module, exports) {
"use strict";

var $1RMhw = parcelRequire("1RMhw");

var $gUBoX = parcelRequire("gUBoX");
module.exports = $1bade5a2cf9acf3e$var$image;
var $1bade5a2cf9acf3e$var$space = " ";
var $1bade5a2cf9acf3e$var$leftParenthesis = "(";
var $1bade5a2cf9acf3e$var$rightParenthesis = ")";
var $1bade5a2cf9acf3e$var$leftSquareBracket = "[";
var $1bade5a2cf9acf3e$var$rightSquareBracket = "]";
var $1bade5a2cf9acf3e$var$exclamationMark = "!";
// Stringify an image.
//
// Is smart about enclosing `url` (see `encloseURI()`) and `title` (see
// `encloseTitle()`).
//
// ```markdown
// ![foo](</fav icon.png> 'My "favourite" icon')
// ```
//
// Supports named entities in `url`, `alt`, and `title` when in
// `settings.encode` mode.
function $1bade5a2cf9acf3e$var$image(node) {
    var self = this;
    var content = $1RMhw(self.encode(node.url || "", node));
    var exit = self.enterLink();
    var alt = self.encode(self.escape(node.alt || "", node));
    exit();
    if (node.title) content += $1bade5a2cf9acf3e$var$space + $gUBoX(self.encode(node.title, node));
    return $1bade5a2cf9acf3e$var$exclamationMark + $1bade5a2cf9acf3e$var$leftSquareBracket + alt + $1bade5a2cf9acf3e$var$rightSquareBracket + $1bade5a2cf9acf3e$var$leftParenthesis + content + $1bade5a2cf9acf3e$var$rightParenthesis;
}

});

parcelRegister("ka6AX", function(module, exports) {
"use strict";
module.exports = $ead9db7d8d64f80d$var$footnote;
var $ead9db7d8d64f80d$var$leftSquareBracket = "[";
var $ead9db7d8d64f80d$var$rightSquareBracket = "]";
var $ead9db7d8d64f80d$var$caret = "^";
function $ead9db7d8d64f80d$var$footnote(node) {
    return $ead9db7d8d64f80d$var$leftSquareBracket + $ead9db7d8d64f80d$var$caret + this.all(node).join("") + $ead9db7d8d64f80d$var$rightSquareBracket;
}

});

parcelRegister("4SeIk", function(module, exports) {
"use strict";
module.exports = $38c79e7955686b20$var$footnoteReference;
var $38c79e7955686b20$var$leftSquareBracket = "[";
var $38c79e7955686b20$var$rightSquareBracket = "]";
var $38c79e7955686b20$var$caret = "^";
function $38c79e7955686b20$var$footnoteReference(node) {
    return $38c79e7955686b20$var$leftSquareBracket + $38c79e7955686b20$var$caret + (node.label || node.identifier) + $38c79e7955686b20$var$rightSquareBracket;
}

});

parcelRegister("2qmXc", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
var $1c3fd0a1995aea1d$var$lineFeed = "\n";
var $1c3fd0a1995aea1d$var$space = " ";
var $1c3fd0a1995aea1d$var$colon = ":";
var $1c3fd0a1995aea1d$var$leftSquareBracket = "[";
var $1c3fd0a1995aea1d$var$rightSquareBracket = "]";
var $1c3fd0a1995aea1d$var$caret = "^";
var $1c3fd0a1995aea1d$var$tabSize = 4;
var $1c3fd0a1995aea1d$var$blank = $1c3fd0a1995aea1d$var$lineFeed + $1c3fd0a1995aea1d$var$lineFeed;
var $1c3fd0a1995aea1d$var$indent = $j6axH($1c3fd0a1995aea1d$var$space, $1c3fd0a1995aea1d$var$tabSize);
module.exports = $1c3fd0a1995aea1d$var$footnoteDefinition;
function $1c3fd0a1995aea1d$var$footnoteDefinition(node) {
    var content = this.all(node).join($1c3fd0a1995aea1d$var$blank + $1c3fd0a1995aea1d$var$indent);
    return $1c3fd0a1995aea1d$var$leftSquareBracket + $1c3fd0a1995aea1d$var$caret + (node.label || node.identifier) + $1c3fd0a1995aea1d$var$rightSquareBracket + $1c3fd0a1995aea1d$var$colon + $1c3fd0a1995aea1d$var$space + content;
}

});

parcelRegister("fMO6H", function(module, exports) {
"use strict";

var $7E0li = parcelRequire("7E0li");
module.exports = $b7e234ecd59a74b5$var$table;
var $b7e234ecd59a74b5$var$space = " ";
var $b7e234ecd59a74b5$var$verticalBar = "|";
// Stringify table.
//
// Creates a fenced table by default, but not in `looseTable: true` mode:
//
// ```markdown
//  Foo | Bar
// :-: | ---
// Baz | Qux
//
// NOTE: Be careful with `looseTable: true` mode, as a loose table inside an
// indented code block on GitHub renders as an actual table!
//
// Creates a spaced table by default, but not in `spacedTable: false`:
//
// ```markdown
// |Foo|Bar|
// |:-:|---|
// |Baz|Qux|
// ```
function $b7e234ecd59a74b5$var$table(node) {
    var self = this;
    var options = self.options;
    var loose = options.looseTable;
    var spaced = options.spacedTable;
    var pad = options.paddedTable;
    var stringLength = options.stringLength;
    var rows = node.children;
    var index = rows.length;
    var exit = self.enterTable();
    var result = [];
    var start;
    var end;
    while(index--)result[index] = self.all(rows[index]);
    exit();
    if (loose) {
        start = "";
        end = "";
    } else if (spaced) {
        start = $b7e234ecd59a74b5$var$verticalBar + $b7e234ecd59a74b5$var$space;
        end = $b7e234ecd59a74b5$var$space + $b7e234ecd59a74b5$var$verticalBar;
    } else {
        start = $b7e234ecd59a74b5$var$verticalBar;
        end = $b7e234ecd59a74b5$var$verticalBar;
    }
    return $7E0li(result, {
        align: node.align,
        pad: pad,
        start: start,
        end: end,
        stringLength: stringLength,
        delimiter: spaced ? $b7e234ecd59a74b5$var$space + $b7e234ecd59a74b5$var$verticalBar + $b7e234ecd59a74b5$var$space : $b7e234ecd59a74b5$var$verticalBar
    });
}

});
parcelRegister("7E0li", function(module, exports) {
"use strict";
module.exports = $590c88d877a7d17f$var$markdownTable;
var $590c88d877a7d17f$var$dotRe = /\./;
var $590c88d877a7d17f$var$lastDotRe = /\.[^.]*$/;
// Characters.
var $590c88d877a7d17f$var$space = " ";
var $590c88d877a7d17f$var$lineFeed = "\n";
var $590c88d877a7d17f$var$dash = "-";
var $590c88d877a7d17f$var$dot = ".";
var $590c88d877a7d17f$var$colon = ":";
var $590c88d877a7d17f$var$lowercaseC = "c";
var $590c88d877a7d17f$var$lowercaseL = "l";
var $590c88d877a7d17f$var$lowercaseR = "r";
var $590c88d877a7d17f$var$verticalBar = "|";
var $590c88d877a7d17f$var$minCellSize = 3;
// Create a table from a matrix of strings.
function $590c88d877a7d17f$var$markdownTable(table, options) {
    var settings = options || {};
    var delimiter = settings.delimiter;
    var start = settings.start;
    var end = settings.end;
    var alignment = settings.align;
    var calculateStringLength = settings.stringLength || $590c88d877a7d17f$var$lengthNoop;
    var cellCount = 0;
    var rowIndex = -1;
    var rowLength = table.length;
    var sizes = [];
    var align;
    var rule;
    var rows;
    var row;
    var cells;
    var index;
    var position;
    var size;
    var value;
    var spacing;
    var before;
    var after;
    alignment = alignment ? alignment.concat() : [];
    if (delimiter === null || delimiter === undefined) delimiter = $590c88d877a7d17f$var$space + $590c88d877a7d17f$var$verticalBar + $590c88d877a7d17f$var$space;
    if (start === null || start === undefined) start = $590c88d877a7d17f$var$verticalBar + $590c88d877a7d17f$var$space;
    if (end === null || end === undefined) end = $590c88d877a7d17f$var$space + $590c88d877a7d17f$var$verticalBar;
    while(++rowIndex < rowLength){
        row = table[rowIndex];
        index = -1;
        if (row.length > cellCount) cellCount = row.length;
        while(++index < cellCount){
            position = row[index] ? $590c88d877a7d17f$var$dotindex(row[index]) : null;
            if (!sizes[index]) sizes[index] = $590c88d877a7d17f$var$minCellSize;
            if (position > sizes[index]) sizes[index] = position;
        }
    }
    if (typeof alignment === "string") alignment = $590c88d877a7d17f$var$pad(cellCount, alignment).split("");
    // Make sure only valid alignments are used.
    index = -1;
    while(++index < cellCount){
        align = alignment[index];
        if (typeof align === "string") align = align.charAt(0).toLowerCase();
        if (align !== $590c88d877a7d17f$var$lowercaseL && align !== $590c88d877a7d17f$var$lowercaseR && align !== $590c88d877a7d17f$var$lowercaseC && align !== $590c88d877a7d17f$var$dot) align = "";
        alignment[index] = align;
    }
    rowIndex = -1;
    rows = [];
    while(++rowIndex < rowLength){
        row = table[rowIndex];
        index = -1;
        cells = [];
        while(++index < cellCount){
            value = row[index];
            value = $590c88d877a7d17f$var$stringify(value);
            if (alignment[index] === $590c88d877a7d17f$var$dot) {
                position = $590c88d877a7d17f$var$dotindex(value);
                size = sizes[index] + ($590c88d877a7d17f$var$dotRe.test(value) ? 0 : 1) - (calculateStringLength(value) - position);
                cells[index] = value + $590c88d877a7d17f$var$pad(size - 1);
            } else cells[index] = value;
        }
        rows[rowIndex] = cells;
    }
    sizes = [];
    rowIndex = -1;
    while(++rowIndex < rowLength){
        cells = rows[rowIndex];
        index = -1;
        while(++index < cellCount){
            value = cells[index];
            if (!sizes[index]) sizes[index] = $590c88d877a7d17f$var$minCellSize;
            size = calculateStringLength(value);
            if (size > sizes[index]) sizes[index] = size;
        }
    }
    rowIndex = -1;
    while(++rowIndex < rowLength){
        cells = rows[rowIndex];
        index = -1;
        if (settings.pad !== false) while(++index < cellCount){
            value = cells[index];
            position = sizes[index] - (calculateStringLength(value) || 0);
            spacing = $590c88d877a7d17f$var$pad(position);
            if (alignment[index] === $590c88d877a7d17f$var$lowercaseR || alignment[index] === $590c88d877a7d17f$var$dot) value = spacing + value;
            else if (alignment[index] === $590c88d877a7d17f$var$lowercaseC) {
                position /= 2;
                if (position % 1 === 0) {
                    before = position;
                    after = position;
                } else {
                    before = position + 0.5;
                    after = position - 0.5;
                }
                value = $590c88d877a7d17f$var$pad(before) + value + $590c88d877a7d17f$var$pad(after);
            } else value += spacing;
            cells[index] = value;
        }
        rows[rowIndex] = cells.join(delimiter);
    }
    if (settings.rule !== false) {
        index = -1;
        rule = [];
        while(++index < cellCount){
            // When `pad` is false, make the rule the same size as the first row.
            if (settings.pad === false) {
                value = table[0][index];
                spacing = calculateStringLength($590c88d877a7d17f$var$stringify(value));
                spacing = spacing > $590c88d877a7d17f$var$minCellSize ? spacing : $590c88d877a7d17f$var$minCellSize;
            } else spacing = sizes[index];
            align = alignment[index];
            // When `align` is left, don't add colons.
            value = align === $590c88d877a7d17f$var$lowercaseR || align === "" ? $590c88d877a7d17f$var$dash : $590c88d877a7d17f$var$colon;
            value += $590c88d877a7d17f$var$pad(spacing - 2, $590c88d877a7d17f$var$dash);
            value += align !== $590c88d877a7d17f$var$lowercaseL && align !== "" ? $590c88d877a7d17f$var$colon : $590c88d877a7d17f$var$dash;
            rule[index] = value;
        }
        rows.splice(1, 0, rule.join(delimiter));
    }
    return start + rows.join(end + $590c88d877a7d17f$var$lineFeed + start) + end;
}
function $590c88d877a7d17f$var$stringify(value) {
    return value === null || value === undefined ? "" : String(value);
}
// Get the length of `value`.
function $590c88d877a7d17f$var$lengthNoop(value) {
    return String(value).length;
}
// Get a string consisting of `length` `character`s.
function $590c88d877a7d17f$var$pad(length, character) {
    return new Array(length + 1).join(character || $590c88d877a7d17f$var$space);
}
// Get the position of the last dot in `value`.
function $590c88d877a7d17f$var$dotindex(value) {
    var match = $590c88d877a7d17f$var$lastDotRe.exec(value);
    return match ? match.index + 1 : value.length;
}

});


parcelRegister("hLNrB", function(module, exports) {
"use strict";
module.exports = $cefd2e0c5b7fade6$var$tableCell;
var $cefd2e0c5b7fade6$var$lineFeed = /\r?\n/g;
function $cefd2e0c5b7fade6$var$tableCell(node) {
    return this.all(node).join("").replace($cefd2e0c5b7fade6$var$lineFeed, " ");
}

});




parcelRegister("bv9EC", function(module, exports) {
"use strict";
module.exports = $85fa1417fdc98180$var$react;

var $cPqzE = parcelRequire("cPqzE");

var $6qkoA = parcelRequire("6qkoA");

var $1gsXp = parcelRequire("1gsXp");

var $6GMPt = parcelRequire("6GMPt");
var $85fa1417fdc98180$var$globalReact;
var $85fa1417fdc98180$var$globalCreateElement;
var $85fa1417fdc98180$var$globalFragment;

/* istanbul ignore next - Hard to test */ try {
    $85fa1417fdc98180$var$globalReact = (parcelRequire("cQNHH"));
    $85fa1417fdc98180$var$globalCreateElement = $85fa1417fdc98180$var$globalReact.createElement;
    $85fa1417fdc98180$var$globalFragment = $85fa1417fdc98180$var$globalReact.Fragment;
} catch (error) {}
var $85fa1417fdc98180$var$own = {}.hasOwnProperty;
var $85fa1417fdc98180$var$tableElements = [
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
];
function $85fa1417fdc98180$var$react(options) {
    var settings = options || {};
    var createElement = settings.createElement || $85fa1417fdc98180$var$globalCreateElement;
    var Fragment = settings.fragment || $85fa1417fdc98180$var$globalFragment;
    var clean = settings.sanitize !== false;
    var scheme = clean && typeof settings.sanitize !== "boolean" ? settings.sanitize : null;
    var toHastOptions = settings.toHast || {};
    var components = settings.remarkReactComponents || {};
    this.Compiler = compile;
    // Wrapper around `createElement` to pass components in.
    function h(name, props, children) {
        // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we remove the pretty lines for now.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        if (children && $85fa1417fdc98180$var$tableElements.indexOf(name) !== -1) children = children.filter(function(child) {
            return child !== "\n";
        });
        return createElement($85fa1417fdc98180$var$own.call(components, name) ? components[name] : name, props, children);
    }
    // Compile mdast to React.
    function compile(node) {
        var tree = $cPqzE(node, toHastOptions);
        var root;
        if (clean) tree = $6qkoA(tree, scheme);
        root = $1gsXp(h, $6GMPt(tree), settings.prefix);
        // If this compiled to a `<div>`, but fragment are possible, use those.
        if (root.type === "div" && Fragment) root = createElement(Fragment, {}, root.props.children);
        return root;
    }
}

});
parcelRegister("cPqzE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnwOf"));

});
parcelRegister("dnwOf", function(module, exports) {
"use strict";
module.exports = $9bd6dfa2f24ac709$var$toHast;

var $36bRz = parcelRequire("36bRz");

var $iliNM = parcelRequire("iliNM");

var $KDBsL = parcelRequire("KDBsL");

var $i1zwa = parcelRequire("i1zwa");

var $2EMTP = parcelRequire("2EMTP");

var $lBwlE = parcelRequire("lBwlE");

var $3ZT5R = parcelRequire("3ZT5R");

var $57ODx = parcelRequire("57ODx");

var $8d6xV = parcelRequire("8d6xV");
var $9bd6dfa2f24ac709$var$own = {}.hasOwnProperty;
// Factory to transform.
function $9bd6dfa2f24ac709$var$factory(tree, options) {
    var settings = options || {};
    var dangerous = settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = $lBwlE(tree, settings);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = $36bRz($8d6xV, settings.handlers || {});
    $KDBsL(tree, "footnoteDefinition", onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left) {
            data = left.data;
            if (right.type === "element" && data.hName) right.tagName = data.hName;
            if (right.type === "element" && data.hProperties) right.properties = $36bRz(right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!$2EMTP(ctx)) right.position = {
            start: $i1zwa.start(ctx),
            end: $i1zwa.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === "object" && "length" in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8d48e57/index.js#L26>.
        if (!$9bd6dfa2f24ac709$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function $9bd6dfa2f24ac709$var$toHast(tree, options) {
    var h = $9bd6dfa2f24ac709$var$factory(tree, options);
    var node = $3ZT5R(h, tree);
    var foot = $57ODx(h);
    if (foot) node.children = node.children.concat($iliNM("text", "\n"), foot);
    return node;
}

});
parcelRegister("iliNM", function(module, exports) {
"use strict";

var $bDppX = parcelRequire("bDppX");
module.exports = $d5a8c5d1ffc9b864$var$u;
function $d5a8c5d1ffc9b864$var$u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== "object" || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = $bDppX({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

});

parcelRegister("i1zwa", function(module, exports) {
"use strict";
var $d1f3df11cf77dc6e$var$start = $d1f3df11cf77dc6e$var$factory("start");
var $d1f3df11cf77dc6e$var$end = $d1f3df11cf77dc6e$var$factory("end");
module.exports = $d1f3df11cf77dc6e$var$position;
$d1f3df11cf77dc6e$var$position.start = $d1f3df11cf77dc6e$var$start;
$d1f3df11cf77dc6e$var$position.end = $d1f3df11cf77dc6e$var$end;
function $d1f3df11cf77dc6e$var$position(node) {
    return {
        start: $d1f3df11cf77dc6e$var$start(node),
        end: $d1f3df11cf77dc6e$var$end(node)
    };
}
function $d1f3df11cf77dc6e$var$factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

});

parcelRegister("2EMTP", function(module, exports) {
"use strict";
module.exports = $1ef53fa30fd5e7dc$var$generated;
function $1ef53fa30fd5e7dc$var$generated(node) {
    var position = $1ef53fa30fd5e7dc$var$optional($1ef53fa30fd5e7dc$var$optional(node).position);
    var start = $1ef53fa30fd5e7dc$var$optional(position.start);
    var end = $1ef53fa30fd5e7dc$var$optional(position.end);
    return !start.line || !start.column || !end.line || !end.column;
}
function $1ef53fa30fd5e7dc$var$optional(value) {
    return value && typeof value === "object" ? value : {};
}

});

parcelRegister("lBwlE", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
module.exports = $fba62559b2947c6e$var$getDefinitionFactory;
var $fba62559b2947c6e$var$own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function $fba62559b2947c6e$var$getDefinitionFactory(node, options) {
    return $fba62559b2947c6e$var$getterFactory($fba62559b2947c6e$var$gather(node, options));
}
// Gather all definitions in `node`
function $fba62559b2947c6e$var$gather(node, options) {
    var cache = {};
    if (!node || !node.type) throw new Error("mdast-util-definitions expected node");
    $KDBsL(node, "definition", options && options.commonmark ? commonmark : normal);
    return cache;
    function commonmark(definition) {
        var id = $fba62559b2947c6e$var$normalise(definition.identifier);
        if (!$fba62559b2947c6e$var$own.call(cache, id)) cache[id] = definition;
    }
    function normal(definition) {
        cache[$fba62559b2947c6e$var$normalise(definition.identifier)] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function $fba62559b2947c6e$var$getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && $fba62559b2947c6e$var$normalise(identifier);
        return id && $fba62559b2947c6e$var$own.call(cache, id) ? cache[id] : null;
    }
}
function $fba62559b2947c6e$var$normalise(identifier) {
    return identifier.toUpperCase();
}

});

parcelRegister("3ZT5R", function(module, exports) {
"use strict";
module.exports = $2e91ce06fb183c5e$var$one;

var $iliNM = parcelRequire("iliNM");

var $a3nRR = parcelRequire("a3nRR");
var $2e91ce06fb183c5e$var$own = {}.hasOwnProperty;
// Transform an unknown node.
function $2e91ce06fb183c5e$var$unknown(h, node) {
    if ($2e91ce06fb183c5e$var$text(node)) return h.augment(node, $iliNM("text", node.value));
    return h(node, "div", $a3nRR(h, node));
}
// Visit a node.
function $2e91ce06fb183c5e$var$one(h, node, parent) {
    var type = node && node.type;
    var fn = $2e91ce06fb183c5e$var$own.call(h.handlers, type) ? h.handlers[type] : null;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    return (typeof fn === "function" ? fn : $2e91ce06fb183c5e$var$unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function $2e91ce06fb183c5e$var$text(node) {
    var data = node.data || {};
    if ($2e91ce06fb183c5e$var$own.call(data, "hName") || $2e91ce06fb183c5e$var$own.call(data, "hProperties") || $2e91ce06fb183c5e$var$own.call(data, "hChildren")) return false;
    return "value" in node;
}

});
parcelRegister("a3nRR", function(module, exports) {
"use strict";
module.exports = $751cb2d759c7ebc8$var$all;

var $2Lc6r = parcelRequire("2Lc6r");

var $3ZT5R = parcelRequire("3ZT5R");
function $751cb2d759c7ebc8$var$all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = $3ZT5R(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === "break") {
                if (result.value) result.value = $2Lc6r.left(result.value);
                head = result.children && result.children[0];
                if (head && head.value) head.value = $2Lc6r.left(head.value);
            }
            values = values.concat(result);
        }
    }
    return values;
}

});


parcelRegister("57ODx", function(module, exports) {
"use strict";
module.exports = $3bb4e2980a9f3e75$var$generateFootnotes;

var $jYimF = parcelRequire("jYimF");

var $bRwBF = parcelRequire("bRwBF");

var $8W6At = parcelRequire("8W6At");
function $3bb4e2980a9f3e75$var$generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: "link",
            url: "#fnref-" + def.identifier,
            data: {
                hProperties: {
                    className: [
                        "footnote-backref"
                    ]
                }
            },
            children: [
                {
                    type: "text",
                    value: "\u21A9"
                }
            ]
        };
        if (!tail || tail.type !== "paragraph") {
            tail = {
                type: "paragraph",
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: "listItem",
            data: {
                hProperties: {
                    id: "fn-" + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, "div", {
        className: [
            "footnotes"
        ]
    }, $8W6At([
        $jYimF(h),
        $bRwBF(h, {
            type: "list",
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRegister("jYimF", function(module, exports) {
"use strict";
module.exports = $e8a1ddc0e56354ce$var$thematicBreak;
function $e8a1ddc0e56354ce$var$thematicBreak(h, node) {
    return h(node, "hr");
}

});

parcelRegister("bRwBF", function(module, exports) {
"use strict";
module.exports = $8a2deff15c2dea79$var$list;

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $8a2deff15c2dea79$var$list(h, node) {
    var props = {};
    var name = node.ordered ? "ol" : "ul";
    var items;
    var index = -1;
    var length;
    if (typeof node.start === "number" && node.start !== 1) props.start = node.start;
    items = $a3nRR(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf("task-list-item") !== -1) {
        props.className = [
            "contains-task-list"
        ];
        break;
    }
    return h(node, name, props, $8W6At(items, true));
}

});
parcelRegister("8W6At", function(module, exports) {
"use strict";
module.exports = $6818d99a9c9efdfb$var$wrap;

var $iliNM = parcelRequire("iliNM");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function $6818d99a9c9efdfb$var$wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push($iliNM("text", "\n"));
    while(++index < length){
        if (index) result.push($iliNM("text", "\n"));
        result.push(nodes[index]);
    }
    if (loose && nodes.length !== 0) result.push($iliNM("text", "\n"));
    return result;
}

});



parcelRegister("8d6xV", function(module, exports) {
"use strict";






















module.exports = {
    blockquote: (parcelRequire("ePoGc")),
    break: (parcelRequire("9Zqab")),
    code: (parcelRequire("c4HiZ")),
    delete: (parcelRequire("and8S")),
    emphasis: (parcelRequire("1otWW")),
    footnoteReference: (parcelRequire("79UvT")),
    footnote: (parcelRequire("0warK")),
    heading: (parcelRequire("iKrST")),
    html: (parcelRequire("kZQ0f")),
    imageReference: (parcelRequire("bHi1A")),
    image: (parcelRequire("wIsZY")),
    inlineCode: (parcelRequire("gT8Qg")),
    linkReference: (parcelRequire("6o8rq")),
    link: (parcelRequire("giPxz")),
    listItem: (parcelRequire("4Cw3I")),
    list: (parcelRequire("bRwBF")),
    paragraph: (parcelRequire("bv3yS")),
    root: (parcelRequire("8smh5")),
    strong: (parcelRequire("7SWrt")),
    table: (parcelRequire("8QBhZ")),
    text: (parcelRequire("1oKFc")),
    thematicBreak: (parcelRequire("jYimF")),
    toml: $5fa49d8f19a44066$var$ignore,
    yaml: $5fa49d8f19a44066$var$ignore,
    definition: $5fa49d8f19a44066$var$ignore,
    footnoteDefinition: $5fa49d8f19a44066$var$ignore
};
// Return nothing for nodes that are ignored.
function $5fa49d8f19a44066$var$ignore() {
    return null;
}

});
parcelRegister("ePoGc", function(module, exports) {
"use strict";
module.exports = $acb8f8f29cb01c01$var$blockquote;

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $acb8f8f29cb01c01$var$blockquote(h, node) {
    return h(node, "blockquote", $8W6At($a3nRR(h, node), true));
}

});

parcelRegister("9Zqab", function(module, exports) {
"use strict";
module.exports = $745e1b0f3119219e$var$hardBreak;

var $iliNM = parcelRequire("iliNM");
function $745e1b0f3119219e$var$hardBreak(h, node) {
    return [
        h(node, "br"),
        $iliNM("text", "\n")
    ];
}

});

parcelRegister("c4HiZ", function(module, exports) {
"use strict";
module.exports = $8ca7734b07b99517$var$code;

var $lMy0e = parcelRequire("lMy0e");

var $iliNM = parcelRequire("iliNM");
function $8ca7734b07b99517$var$code(h, node) {
    var value = node.value ? $lMy0e(node.value + "\n") : "";
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    if (lang) props.className = [
        "language-" + lang
    ];
    return h(node.position, "pre", [
        h(node, "code", props, [
            $iliNM("text", value)
        ])
    ]);
}

});
parcelRegister("lMy0e", function(module, exports) {
"use strict";
module.exports = $fdb874e8b5fd731e$var$detab;

var $j6axH = parcelRequire("j6axH");
var $fdb874e8b5fd731e$var$tab = 0x09;
var $fdb874e8b5fd731e$var$lineFeed = 0x0a;
var $fdb874e8b5fd731e$var$carriageReturn = 0x0d;
// Replace tabs with spaces, being smart about which column the tab is at and
// which size should be used.
function $fdb874e8b5fd731e$var$detab(value, size) {
    var string = typeof value === "string";
    var length = string && value.length;
    var start = 0;
    var index = -1;
    var column = -1;
    var tabSize = size || 4;
    var results = [];
    var code;
    var add;
    if (!string) throw new Error("detab expected string");
    while(++index < length){
        code = value.charCodeAt(index);
        if (code === $fdb874e8b5fd731e$var$tab) {
            add = tabSize - (column + 1) % tabSize;
            column += add;
            results.push(value.slice(start, index) + $j6axH(" ", add));
            start = index + 1;
        } else if (code === $fdb874e8b5fd731e$var$lineFeed || code === $fdb874e8b5fd731e$var$carriageReturn) column = -1;
        else column++;
    }
    results.push(value.slice(start));
    return results.join("");
}

});


parcelRegister("and8S", function(module, exports) {
"use strict";
module.exports = $78d63f1f549b1766$var$strikethrough;

var $a3nRR = parcelRequire("a3nRR");
function $78d63f1f549b1766$var$strikethrough(h, node) {
    return h(node, "del", $a3nRR(h, node));
}

});

parcelRegister("1otWW", function(module, exports) {
"use strict";
module.exports = $103f43bb41337f98$var$emphasis;

var $a3nRR = parcelRequire("a3nRR");
function $103f43bb41337f98$var$emphasis(h, node) {
    return h(node, "em", $a3nRR(h, node));
}

});

parcelRegister("79UvT", function(module, exports) {
"use strict";
module.exports = $5365360aa73b58ac$var$footnoteReference;

var $iliNM = parcelRequire("iliNM");
function $5365360aa73b58ac$var$footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, "sup", {
        id: "fnref-" + identifier
    }, [
        h(node, "a", {
            href: "#fn-" + identifier,
            className: [
                "footnote-ref"
            ]
        }, [
            $iliNM("text", node.label || identifier)
        ])
    ]);
}

});

parcelRegister("0warK", function(module, exports) {
"use strict";
module.exports = $0018f3fed8c9a22a$var$footnote;

var $79UvT = parcelRequire("79UvT");
function $0018f3fed8c9a22a$var$footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return $79UvT(h, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("iKrST", function(module, exports) {
"use strict";
module.exports = $da622725bb586ac6$var$heading;

var $a3nRR = parcelRequire("a3nRR");
function $da622725bb586ac6$var$heading(h, node) {
    return h(node, "h" + node.depth, $a3nRR(h, node));
}

});

parcelRegister("kZQ0f", function(module, exports) {
"use strict";
module.exports = $f491d7dd6da6a2ae$var$html;

var $iliNM = parcelRequire("iliNM");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function $f491d7dd6da6a2ae$var$html(h, node) {
    return h.dangerous ? h.augment(node, $iliNM("raw", node.value)) : null;
}

});

parcelRegister("bHi1A", function(module, exports) {
"use strict";
module.exports = $8841b12b75664b81$var$imageReference;

var $fgOwe = parcelRequire("fgOwe");

var $fpvQ7 = parcelRequire("fpvQ7");
function $8841b12b75664b81$var$imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $fpvQ7(h, node);
    props = {
        src: $fgOwe(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "img", props);
}

});
parcelRegister("fgOwe", function(module, exports) {
"use strict";
var $b1df89a559ade814$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $b1df89a559ade814$var$getEncodeCache(exclude) {
    var i, ch, cache = $b1df89a559ade814$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $b1df89a559ade814$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $b1df89a559ade814$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $b1df89a559ade814$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $b1df89a559ade814$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$b1df89a559ade814$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$b1df89a559ade814$var$encode.componentChars = "-_.!~*'()";
module.exports = $b1df89a559ade814$var$encode;

});

parcelRegister("fpvQ7", function(module, exports) {
"use strict";
module.exports = $b381e37f8b3f7cb8$var$revert;

var $iliNM = parcelRequire("iliNM");

var $a3nRR = parcelRequire("a3nRR");
// Return the content of a reference without definition as Markdown.
function $b381e37f8b3f7cb8$var$revert(h, node) {
    var subtype = node.referenceType;
    var suffix = "]";
    var contents;
    var head;
    var tail;
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return $iliNM("text", "![" + node.alt + suffix);
    contents = $a3nRR(h, node);
    head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift($iliNM("text", "["));
    tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push($iliNM("text", suffix));
    return contents;
}

});


parcelRegister("wIsZY", function(module, exports) {
"use strict";

var $fgOwe = parcelRequire("fgOwe");
module.exports = $06257b6ffc6725d9$var$image;
function $06257b6ffc6725d9$var$image(h, node) {
    var props = {
        src: $fgOwe(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "img", props);
}

});

parcelRegister("gT8Qg", function(module, exports) {
"use strict";
module.exports = $c4b8a434bfabab2a$var$inlineCode;

var $lcAVc = parcelRequire("lcAVc");

var $iliNM = parcelRequire("iliNM");
function $c4b8a434bfabab2a$var$inlineCode(h, node) {
    return h(node, "code", [
        $iliNM("text", $lcAVc(node.value))
    ]);
}

});

parcelRegister("6o8rq", function(module, exports) {
"use strict";
module.exports = $4a6b8839d3897a9d$var$linkReference;

var $fgOwe = parcelRequire("fgOwe");

var $fpvQ7 = parcelRequire("fpvQ7");

var $a3nRR = parcelRequire("a3nRR");
function $4a6b8839d3897a9d$var$linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $fpvQ7(h, node);
    props = {
        href: $fgOwe(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "a", props, $a3nRR(h, node));
}

});

parcelRegister("giPxz", function(module, exports) {
"use strict";

var $fgOwe = parcelRequire("fgOwe");

var $a3nRR = parcelRequire("a3nRR");
module.exports = $bde64ea9a906a15d$var$link;
function $bde64ea9a906a15d$var$link(h, node) {
    var props = {
        href: $fgOwe(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "a", props, $a3nRR(h, node));
}

});

parcelRegister("4Cw3I", function(module, exports) {
"use strict";
module.exports = $35d39440511cc9a4$var$listItem;

var $iliNM = parcelRequire("iliNM");

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $35d39440511cc9a4$var$listItem(h, node, parent) {
    var children = node.children;
    var head = children[0];
    var raw = $a3nRR(h, node);
    var loose = parent ? $35d39440511cc9a4$var$listLoose(parent) : $35d39440511cc9a4$var$listItemLoose(node);
    var props = {};
    var result;
    var container;
    var index;
    var length;
    var child;
    // Tight lists should not render `paragraph` nodes as `p` elements.
    if (loose) result = raw;
    else {
        result = [];
        length = raw.length;
        index = -1;
        while(++index < length){
            child = raw[index];
            if (child.tagName === "p") result = result.concat(child.children);
            else result.push(child);
        }
    }
    if (typeof node.checked === "boolean") {
        if (loose && (!head || head.type !== "paragraph")) result.unshift(h(null, "p", []));
        container = loose ? result[0].children : result;
        if (container.length !== 0) container.unshift($iliNM("text", " "));
        container.unshift(h(null, "input", {
            type: "checkbox",
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            "task-list-item"
        ];
    }
    if (loose && result.length !== 0) result = $8W6At(result, true);
    return h(node, "li", props, result);
}
function $35d39440511cc9a4$var$listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = $35d39440511cc9a4$var$listItemLoose(children[index]);
    return loose;
}
function $35d39440511cc9a4$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("bv3yS", function(module, exports) {
"use strict";
module.exports = $85f55a2f0191e3a2$var$paragraph;

var $a3nRR = parcelRequire("a3nRR");
function $85f55a2f0191e3a2$var$paragraph(h, node) {
    return h(node, "p", $a3nRR(h, node));
}

});

parcelRegister("8smh5", function(module, exports) {
"use strict";
module.exports = $62823780429ed901$var$root;

var $iliNM = parcelRequire("iliNM");

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $62823780429ed901$var$root(h, node) {
    return h.augment(node, $iliNM("root", $8W6At($a3nRR(h, node))));
}

});

parcelRegister("7SWrt", function(module, exports) {
"use strict";
module.exports = $5bdae8f59f38b55f$var$strong;

var $a3nRR = parcelRequire("a3nRR");
function $5bdae8f59f38b55f$var$strong(h, node) {
    return h(node, "strong", $a3nRR(h, node));
}

});

parcelRegister("8QBhZ", function(module, exports) {
"use strict";
module.exports = $67101ae5d3955a13$var$table;

var $i1zwa = parcelRequire("i1zwa");

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $67101ae5d3955a13$var$table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align;
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? "th" : "td";
        pos = alignLength;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? $a3nRR(h, cell) : []);
        }
        result[index] = h(rows[index], "tr", $8W6At(out, true));
    }
    return h(node, "table", $8W6At([
        h(result[0].position, "thead", $8W6At([
            result[0]
        ], true)),
        h({
            start: $i1zwa.start(result[1]),
            end: $i1zwa.end(result[result.length - 1])
        }, "tbody", $8W6At(result.slice(1), true))
    ], true));
}

});

parcelRegister("1oKFc", function(module, exports) {
"use strict";
module.exports = $104c3abbfb5fc142$var$text;

var $iliNM = parcelRequire("iliNM");

var $jE3YM = parcelRequire("jE3YM");
function $104c3abbfb5fc142$var$text(h, node) {
    return h.augment(node, $iliNM("text", $jE3YM(node.value)));
}

});
parcelRegister("jE3YM", function(module, exports) {
"use strict";
module.exports = $e4d4d6f72706816a$var$trimLines;
var $e4d4d6f72706816a$var$ws = /[ \t]*\n+[ \t]*/g;
var $e4d4d6f72706816a$var$newline = "\n";
function $e4d4d6f72706816a$var$trimLines(value) {
    return String(value).replace($e4d4d6f72706816a$var$ws, $e4d4d6f72706816a$var$newline);
}

});





parcelRegister("6qkoA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7MUP2"));

});
parcelRegister("7MUP2", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $gOAtn = parcelRequire("gOAtn");
module.exports = $5ab917c89cbe7984$var$wrapper;
var $5ab917c89cbe7984$var$own = {}.hasOwnProperty;
var $5ab917c89cbe7984$var$allData = "data*";
var $5ab917c89cbe7984$var$commentEnd = "-->";
var $5ab917c89cbe7984$var$nodeSchema = {
    root: {
        children: $5ab917c89cbe7984$var$all
    },
    doctype: $5ab917c89cbe7984$var$handleDoctype,
    comment: $5ab917c89cbe7984$var$handleComment,
    element: {
        tagName: $5ab917c89cbe7984$var$handleTagName,
        properties: $5ab917c89cbe7984$var$handleProperties,
        children: $5ab917c89cbe7984$var$all
    },
    text: {
        value: $5ab917c89cbe7984$var$handleValue
    },
    "*": {
        data: $5ab917c89cbe7984$var$allow,
        position: $5ab917c89cbe7984$var$allow
    }
};
// Sanitize `node`, according to `schema`.
function $5ab917c89cbe7984$var$wrapper(node, schema) {
    var ctx = {
        type: "root",
        children: []
    };
    var replace;
    if (!node || typeof node !== "object" || !node.type) return ctx;
    replace = $5ab917c89cbe7984$var$one($36bRz($gOAtn, schema || {}), node, []);
    if (!replace) return ctx;
    if ("length" in replace) {
        if (replace.length === 1) return replace[0];
        ctx.children = replace;
        return ctx;
    }
    return replace;
}
// Sanitize `node`.
function $5ab917c89cbe7984$var$one(schema, node, stack) {
    var type = node && node.type;
    var replacement = {
        type: node.type
    };
    var replace = true;
    var definition;
    var allowed;
    var result;
    var key;
    if (!$5ab917c89cbe7984$var$own.call($5ab917c89cbe7984$var$nodeSchema, type)) replace = false;
    else {
        definition = $5ab917c89cbe7984$var$nodeSchema[type];
        if (typeof definition === "function") definition = definition(schema, node);
        if (!definition) replace = false;
        else {
            allowed = $36bRz(definition, $5ab917c89cbe7984$var$nodeSchema["*"]);
            for(key in allowed){
                result = allowed[key](schema, node[key], node, stack);
                if (result === false) {
                    replace = false;
                    // Set the non-safe value.
                    replacement[key] = node[key];
                } else if (result !== null && result !== undefined) replacement[key] = result;
            }
        }
    }
    if (!replace) {
        if (!replacement.children || replacement.children.length === 0 || schema.strip.indexOf(replacement.tagName) !== -1) return null;
        return replacement.children;
    }
    return replacement;
}
// Sanitize `children`.
function $5ab917c89cbe7984$var$all(schema, children, node, stack) {
    var nodes = children || [];
    var length = nodes.length || 0;
    var results = [];
    var index = -1;
    var result;
    stack = stack.concat(node.tagName);
    while(++index < length){
        result = $5ab917c89cbe7984$var$one(schema, nodes[index], stack);
        if (result) {
            if ("length" in result) results = results.concat(result);
            else results.push(result);
        }
    }
    return results;
}
// Sanitize `properties`.
function $5ab917c89cbe7984$var$handleProperties(schema, properties, node, stack) {
    var name = $5ab917c89cbe7984$var$handleTagName(schema, node.tagName, node, stack);
    var attrs = schema.attributes;
    var reqs = schema.required || /* istanbul ignore next */ {};
    var props = properties || {};
    var result = {};
    var allowed;
    var required;
    var definition;
    var prop;
    var value;
    allowed = $36bRz($5ab917c89cbe7984$var$toPropertyValueMap(attrs["*"]), $5ab917c89cbe7984$var$toPropertyValueMap($5ab917c89cbe7984$var$own.call(attrs, name) ? attrs[name] : []));
    for(prop in props){
        value = props[prop];
        if ($5ab917c89cbe7984$var$own.call(allowed, prop)) definition = allowed[prop];
        else if ($5ab917c89cbe7984$var$data(prop) && $5ab917c89cbe7984$var$own.call(allowed, $5ab917c89cbe7984$var$allData)) definition = allowed[$5ab917c89cbe7984$var$allData];
        else continue;
        if (value && typeof value === "object" && "length" in value) value = $5ab917c89cbe7984$var$handlePropertyValues(schema, value, prop, definition);
        else value = $5ab917c89cbe7984$var$handlePropertyValue(schema, value, prop, definition);
        if (value !== null && value !== undefined) result[prop] = value;
    }
    required = $5ab917c89cbe7984$var$own.call(reqs, name) ? reqs[name] : {};
    for(prop in required)if (!$5ab917c89cbe7984$var$own.call(result, prop)) result[prop] = required[prop];
    return result;
}
// Sanitize a property value which is a list.
function $5ab917c89cbe7984$var$handlePropertyValues(schema, values, prop, definition) {
    var length = values.length;
    var result = [];
    var index = -1;
    var value;
    while(++index < length){
        value = $5ab917c89cbe7984$var$handlePropertyValue(schema, values[index], prop, definition);
        if (value !== null && value !== undefined) result.push(value);
    }
    return result;
}
// Sanitize a property value.
function $5ab917c89cbe7984$var$handlePropertyValue(schema, value, prop, definition) {
    if (typeof value !== "boolean" && typeof value !== "number" && typeof value !== "string") return null;
    if (!$5ab917c89cbe7984$var$handleProtocol(schema, value, prop)) return null;
    if (definition.length !== 0 && definition.indexOf(value) === -1) return null;
    if (schema.clobber.indexOf(prop) !== -1) value = schema.clobberPrefix + value;
    return value;
}
// Check whether `value` is a safe URL.
function $5ab917c89cbe7984$var$handleProtocol(schema, value, prop) {
    var protocols = schema.protocols;
    var protocol;
    var first;
    var colon;
    var length;
    var index;
    protocols = $5ab917c89cbe7984$var$own.call(protocols, prop) ? protocols[prop].concat() : [];
    if (protocols.length === 0) return true;
    value = String(value);
    first = value.charAt(0);
    if (first === "#" || first === "/") return true;
    colon = value.indexOf(":");
    if (colon === -1) return true;
    length = protocols.length;
    index = -1;
    while(++index < length){
        protocol = protocols[index];
        if (colon === protocol.length && value.slice(0, protocol.length) === protocol) return true;
    }
    index = value.indexOf("?");
    if (index !== -1 && colon > index) return true;
    index = value.indexOf("#");
    if (index !== -1 && colon > index) return true;
    return false;
}
// Always return a valid HTML5 doctype.
function $5ab917c89cbe7984$var$handleDoctypeName() {
    return "html";
}
// Sanitize `tagName`.
function $5ab917c89cbe7984$var$handleTagName(schema, tagName, node, stack) {
    var name = typeof tagName === "string" ? tagName : null;
    var ancestors = schema.ancestors;
    var length;
    var index;
    if (!name || name === "*" || schema.tagNames.indexOf(name) === -1) return false;
    ancestors = $5ab917c89cbe7984$var$own.call(ancestors, name) ? ancestors[name] : [];
    // Some nodes can break out of their context if they don’t have a certain
    // ancestor.
    if (ancestors.length !== 0) {
        length = ancestors.length + 1;
        index = -1;
        while(++index < length){
            if (!ancestors[index]) return false;
            if (stack.indexOf(ancestors[index]) !== -1) break;
        }
    }
    return name;
}
function $5ab917c89cbe7984$var$handleDoctype(schema) {
    return schema.allowDoctypes ? {
        name: $5ab917c89cbe7984$var$handleDoctypeName
    } : null;
}
function $5ab917c89cbe7984$var$handleComment(schema) {
    return schema.allowComments ? {
        value: $5ab917c89cbe7984$var$handleCommentValue
    } : null;
}
// See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
function $5ab917c89cbe7984$var$handleCommentValue(schema, value) {
    var result = typeof value === "string" ? value : "";
    var index = result.indexOf($5ab917c89cbe7984$var$commentEnd);
    return index === -1 ? result : result.slice(0, index);
}
// Sanitize `value`.
function $5ab917c89cbe7984$var$handleValue(schema, value) {
    return typeof value === "string" ? value : "";
}
// Create a map from a list of props or a list of properties and values.
function $5ab917c89cbe7984$var$toPropertyValueMap(values) {
    var result = {};
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        if (value && typeof value === "object" && "length" in value) result[value[0]] = value.slice(1);
        else result[value] = [];
    }
    return result;
}
// Allow `value`.
function $5ab917c89cbe7984$var$allow(schema, value) {
    return value;
}
// Check if `prop` is a data property.
function $5ab917c89cbe7984$var$data(prop) {
    return prop.length > 4 && prop.slice(0, 4).toLowerCase() === "data";
}

});
parcelRegister("gOAtn", function(module, exports) {
module.exports = JSON.parse('{"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto","xmpp","irc","ircs"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details","caption","figure","figcaption","abbr","bdo","cite","dfn","mark","small","span","time","wbr","input"],"attributes":{"a":["href"],"img":["src","longDesc"],"input":[["type","checkbox"],["disabled",true]],"li":[["className","task-list-item"]],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","ariaDescribedBy","ariaHidden","ariaLabel","ariaLabelledBy","axis","border","cellPadding","cellSpacing","char","charOff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hSpace","isMap","id","label","lang","maxLength","media","method","multiple","name","noHref","noShade","noWrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","vAlign","value","vSpace","width","itemProp"]},"required":{"input":{"type":"checkbox","disabled":true}}}');

});



parcelRegister("1gsXp", function(module, exports) {
"use strict";

var $9ovh3 = parcelRequire("9ovh3");

var $gSyAZ = parcelRequire("gSyAZ");

var $ffG6I = parcelRequire("ffG6I");

var $6pKpX = parcelRequire("6pKpX");

var $dxv4b = parcelRequire("dxv4b");

var $ll02G = parcelRequire("ll02G");

var $b9hO3 = parcelRequire("b9hO3");

var $aM3Le = parcelRequire("aM3Le");

var $3AImh = parcelRequire("3AImh");
var $0ebdbf6245b5a3b9$var$root = $3AImh("root");
var $0ebdbf6245b5a3b9$var$element = $3AImh("element");
var $0ebdbf6245b5a3b9$var$text = $3AImh("text");
var $0ebdbf6245b5a3b9$var$dashes = /-([a-z])/g;
module.exports = $0ebdbf6245b5a3b9$var$wrapper;
function $0ebdbf6245b5a3b9$var$wrapper(h, node, options) {
    var settings = options || {};
    var prefix;
    var r;
    var v;
    var vd;
    if (typeof h !== "function") throw new Error("h is not a function");
    if (typeof settings === "string" || typeof settings === "boolean") {
        prefix = settings;
        settings = {};
    } else prefix = settings.prefix;
    r = $0ebdbf6245b5a3b9$var$react(h);
    v = $0ebdbf6245b5a3b9$var$vue(h);
    vd = $0ebdbf6245b5a3b9$var$vdom(h);
    if (prefix === null || prefix === undefined) prefix = r === true || v === true || vd === true ? "h-" : false;
    if ($0ebdbf6245b5a3b9$var$root(node)) {
        if (node.children.length === 1 && $0ebdbf6245b5a3b9$var$element(node.children[0])) node = node.children[0];
        else node = {
            type: "element",
            tagName: "div",
            properties: {},
            children: node.children
        };
    } else if (!$0ebdbf6245b5a3b9$var$element(node)) throw new Error("Expected root or element, not `" + (node && node.type || node) + "`");
    return $0ebdbf6245b5a3b9$var$toH(h, node, {
        schema: settings.space === "svg" ? $gSyAZ : $9ovh3,
        prefix: prefix,
        key: 0,
        react: r,
        vue: v,
        vdom: vd,
        hyperscript: $0ebdbf6245b5a3b9$var$hyperscript(h)
    });
}
// Transform a hast node through a hyperscript interface to *anything*!
function $0ebdbf6245b5a3b9$var$toH(h, node, ctx) {
    var parentSchema = ctx.schema;
    var schema = parentSchema;
    var name = node.tagName;
    var properties;
    var attributes;
    var children;
    var property;
    var elements;
    var length;
    var index;
    var value;
    var result;
    if (parentSchema.space === "html" && name.toLowerCase() === "svg") {
        schema = $gSyAZ;
        ctx.schema = schema;
    }
    if (ctx.vdom === true && schema.space === "html") name = name.toUpperCase();
    properties = node.properties;
    attributes = {};
    for(property in properties)$0ebdbf6245b5a3b9$var$addAttribute(attributes, property, properties[property], ctx);
    if (typeof attributes.style === "string" && (ctx.vdom === true || ctx.vue === true || ctx.react === true)) // VDOM, Vue, and React accept `style` as object.
    attributes.style = $0ebdbf6245b5a3b9$var$parseStyle(attributes.style, name);
    if (ctx.prefix) {
        ctx.key++;
        attributes.key = ctx.prefix + ctx.key;
    }
    if (ctx.vdom && schema.space !== "html") attributes.namespace = $aM3Le[schema.space];
    elements = [];
    children = node.children;
    length = children ? children.length : 0;
    index = -1;
    while(++index < length){
        value = children[index];
        if ($0ebdbf6245b5a3b9$var$element(value)) elements.push($0ebdbf6245b5a3b9$var$toH(h, value, ctx));
        else if ($0ebdbf6245b5a3b9$var$text(value)) elements.push(value.value);
    }
    // Ensure no React warnings are triggered for void elements having children
    // passed in.
    result = elements.length === 0 ? h(name, attributes) : h(name, attributes, elements);
    // Restore parent schema.
    ctx.schema = parentSchema;
    return result;
}
function $0ebdbf6245b5a3b9$var$addAttribute(props, prop, value, ctx) {
    var hyperlike = ctx.hyperscript || ctx.vdom || ctx.vue;
    var schema = ctx.schema;
    var info = $ffG6I(schema, prop);
    var subprop;
    // Ignore nully and `NaN` values.
    // Ignore `false` and falsey known booleans for hyperlike DSLs.
    if (value === null || value === undefined || value !== value || hyperlike && value === false || hyperlike && info.boolean && !value) return;
    if (value !== null && typeof value === "object" && "length" in value) // Accept `array`.
    // Most props are space-separated.
    value = (info.commaSeparated ? $ll02G : $dxv4b).stringify(value);
    // Treat `true` and truthy known booleans.
    if (info.boolean && ctx.hyperscript === true) value = "";
    if (ctx.vue) {
        if (prop !== "style") subprop = "attrs";
    } else if (!info.mustUseProperty) {
        if (ctx.vdom === true) subprop = "attributes";
        else if (ctx.hyperscript === true) subprop = "attrs";
    }
    if (subprop) {
        if (props[subprop] === undefined) props[subprop] = {};
        props[subprop][info.attribute] = value;
    } else if (ctx.react && info.space) props[$6pKpX[info.property] || info.property] = value;
    else props[info.attribute] = value;
}
// Check if `h` is `react.createElement`.
function $0ebdbf6245b5a3b9$var$react(h) {
    var node = h && h("div");
    return Boolean(node && ("_owner" in node || "_store" in node) && node.key === null);
}
// Check if `h` is `hyperscript`.
function $0ebdbf6245b5a3b9$var$hyperscript(h) {
    return Boolean(h && h.context && h.cleanup);
}
// Check if `h` is `virtual-dom/h`.
function $0ebdbf6245b5a3b9$var$vdom(h) {
    return h && h("div").type === "VirtualNode";
}
function $0ebdbf6245b5a3b9$var$vue(h) {
    var node = h && h("div");
    return Boolean(node && node.context && node.context._isVue);
}
function $0ebdbf6245b5a3b9$var$parseStyle(value, tagName) {
    var result = {};
    try {
        $b9hO3(value, iterator);
    } catch (error) {
        error.message = tagName + "[style]" + error.message.slice(9);
        throw error;
    }
    return result;
    function iterator(name, value) {
        result[$0ebdbf6245b5a3b9$var$styleCase(name)] = value;
    }
}
function $0ebdbf6245b5a3b9$var$styleCase(val) {
    if (val.slice(0, 4) === "-ms-") val = "ms-" + val.slice(4);
    return val.replace($0ebdbf6245b5a3b9$var$dashes, $0ebdbf6245b5a3b9$var$styleReplacer);
}
function $0ebdbf6245b5a3b9$var$styleReplacer($0, $1) {
    return $1.toUpperCase();
}

});
parcelRegister("9ovh3", function(module, exports) {
"use strict";

var $5B5Uy = parcelRequire("5B5Uy");

var $fOaV0 = parcelRequire("fOaV0");

var $66rZX = parcelRequire("66rZX");

var $5vUqY = parcelRequire("5vUqY");

var $7PmIb = parcelRequire("7PmIb");

var $hjKxW = parcelRequire("hjKxW");
module.exports = $5B5Uy([
    $66rZX,
    $fOaV0,
    $5vUqY,
    $7PmIb,
    $hjKxW
]);

});
parcelRegister("5B5Uy", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $g2TdU = parcelRequire("g2TdU");
module.exports = $4134fe45309c0213$var$merge;
function $4134fe45309c0213$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $g2TdU($36bRz.apply(null, property), $36bRz.apply(null, normal), space);
}

});
parcelRegister("g2TdU", function(module, exports) {
"use strict";
module.exports = $bae7ab714200f9b4$var$Schema;
var $bae7ab714200f9b4$var$proto = $bae7ab714200f9b4$var$Schema.prototype;
$bae7ab714200f9b4$var$proto.space = null;
$bae7ab714200f9b4$var$proto.normal = {};
$bae7ab714200f9b4$var$proto.property = {};
function $bae7ab714200f9b4$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}

});


parcelRegister("fOaV0", function(module, exports) {
"use strict";

var $ieLB3 = parcelRequire("ieLB3");
module.exports = $ieLB3({
    space: "xlink",
    transform: $b823feb1374d23bd$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $b823feb1374d23bd$var$xlinkTransform(_, prop) {
    return "xlink:" + prop.slice(5).toLowerCase();
}

});
parcelRegister("ieLB3", function(module, exports) {
"use strict";

var $1j0Kh = parcelRequire("1j0Kh");

var $g2TdU = parcelRequire("g2TdU");

var $6rS13 = parcelRequire("6rS13");
module.exports = $d46e747ab4f2b22e$var$create;
function $d46e747ab4f2b22e$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $6rS13(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$1j0Kh(prop)] = prop;
        normal[$1j0Kh(info.attribute)] = prop;
    }
    return new $g2TdU(property, normal, space);
}

});
parcelRegister("1j0Kh", function(module, exports) {
"use strict";
module.exports = $0f3824cd0a6551b1$var$normalize;
function $0f3824cd0a6551b1$var$normalize(value) {
    return value.toLowerCase();
}

});

parcelRegister("6rS13", function(module, exports) {
"use strict";

var $3W6gM = parcelRequire("3W6gM");

var $8cx7u = parcelRequire("8cx7u");
module.exports = $4b1f2a1f219d5ad5$var$DefinedInfo;
$4b1f2a1f219d5ad5$var$DefinedInfo.prototype = new $3W6gM();
$4b1f2a1f219d5ad5$var$DefinedInfo.prototype.defined = true;
var $4b1f2a1f219d5ad5$var$checks = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
];
var $4b1f2a1f219d5ad5$var$checksLength = $4b1f2a1f219d5ad5$var$checks.length;
function $4b1f2a1f219d5ad5$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $4b1f2a1f219d5ad5$var$mark(this, "space", space);
    $3W6gM.call(this, property, attribute);
    while(++index < $4b1f2a1f219d5ad5$var$checksLength){
        check = $4b1f2a1f219d5ad5$var$checks[index];
        $4b1f2a1f219d5ad5$var$mark(this, check, (mask & $8cx7u[check]) === $8cx7u[check]);
    }
}
function $4b1f2a1f219d5ad5$var$mark(values, key, value) {
    if (value) values[key] = value;
}

});
parcelRegister("3W6gM", function(module, exports) {
"use strict";
module.exports = $2ddba6e5ecc0780e$var$Info;
var $2ddba6e5ecc0780e$var$proto = $2ddba6e5ecc0780e$var$Info.prototype;
$2ddba6e5ecc0780e$var$proto.space = null;
$2ddba6e5ecc0780e$var$proto.attribute = null;
$2ddba6e5ecc0780e$var$proto.property = null;
$2ddba6e5ecc0780e$var$proto.boolean = false;
$2ddba6e5ecc0780e$var$proto.booleanish = false;
$2ddba6e5ecc0780e$var$proto.overloadedBoolean = false;
$2ddba6e5ecc0780e$var$proto.number = false;
$2ddba6e5ecc0780e$var$proto.commaSeparated = false;
$2ddba6e5ecc0780e$var$proto.spaceSeparated = false;
$2ddba6e5ecc0780e$var$proto.commaOrSpaceSeparated = false;
$2ddba6e5ecc0780e$var$proto.mustUseProperty = false;
$2ddba6e5ecc0780e$var$proto.defined = false;
function $2ddba6e5ecc0780e$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}

});

parcelRegister("8cx7u", function(module, exports) {

$parcel$export(module.exports, "boolean", function () { return $5f8922a1b1e2a2b3$export$4a21f16c33752377; }, function (v) { return $5f8922a1b1e2a2b3$export$4a21f16c33752377 = v; });
$parcel$export(module.exports, "booleanish", function () { return $5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f; }, function (v) { return $5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f = v; });
$parcel$export(module.exports, "overloadedBoolean", function () { return $5f8922a1b1e2a2b3$export$242ac3d3042558aa; }, function (v) { return $5f8922a1b1e2a2b3$export$242ac3d3042558aa = v; });
$parcel$export(module.exports, "number", function () { return $5f8922a1b1e2a2b3$export$98e628dec113755e; }, function (v) { return $5f8922a1b1e2a2b3$export$98e628dec113755e = v; });
$parcel$export(module.exports, "spaceSeparated", function () { return $5f8922a1b1e2a2b3$export$ab8645c862eb5a3e; }, function (v) { return $5f8922a1b1e2a2b3$export$ab8645c862eb5a3e = v; });
$parcel$export(module.exports, "commaSeparated", function () { return $5f8922a1b1e2a2b3$export$9c8d678629b3d3; }, function (v) { return $5f8922a1b1e2a2b3$export$9c8d678629b3d3 = v; });
$parcel$export(module.exports, "commaOrSpaceSeparated", function () { return $5f8922a1b1e2a2b3$export$2ad25cfebf36cacd; }, function (v) { return $5f8922a1b1e2a2b3$export$2ad25cfebf36cacd = v; });
var $5f8922a1b1e2a2b3$export$4a21f16c33752377;
var $5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f;
var $5f8922a1b1e2a2b3$export$242ac3d3042558aa;
var $5f8922a1b1e2a2b3$export$98e628dec113755e;
var $5f8922a1b1e2a2b3$export$ab8645c862eb5a3e;
var $5f8922a1b1e2a2b3$export$9c8d678629b3d3;
var $5f8922a1b1e2a2b3$export$2ad25cfebf36cacd;
"use strict";
var $5f8922a1b1e2a2b3$var$powers = 0;
$5f8922a1b1e2a2b3$export$4a21f16c33752377 = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$242ac3d3042558aa = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$98e628dec113755e = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$ab8645c862eb5a3e = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$9c8d678629b3d3 = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$2ad25cfebf36cacd = $5f8922a1b1e2a2b3$var$increment();
function $5f8922a1b1e2a2b3$var$increment() {
    return Math.pow(2, ++$5f8922a1b1e2a2b3$var$powers);
}

});




parcelRegister("66rZX", function(module, exports) {
"use strict";

var $ieLB3 = parcelRequire("ieLB3");
module.exports = $ieLB3({
    space: "xml",
    transform: $4719057e6e3f18c1$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $4719057e6e3f18c1$var$xmlTransform(_, prop) {
    return "xml:" + prop.slice(3).toLowerCase();
}

});

parcelRegister("5vUqY", function(module, exports) {
"use strict";

var $ieLB3 = parcelRequire("ieLB3");

var $hLCV5 = parcelRequire("hLCV5");
module.exports = $ieLB3({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: $hLCV5,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("hLCV5", function(module, exports) {
"use strict";

var $5ktOm = parcelRequire("5ktOm");
module.exports = $cef504212d1ed016$var$caseInsensitiveTransform;
function $cef504212d1ed016$var$caseInsensitiveTransform(attributes, property) {
    return $5ktOm(attributes, property.toLowerCase());
}

});
parcelRegister("5ktOm", function(module, exports) {
"use strict";
module.exports = $3e15f1ecea332a93$var$caseSensitiveTransform;
function $3e15f1ecea332a93$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("7PmIb", function(module, exports) {
"use strict";

var $8cx7u = parcelRequire("8cx7u");

var $ieLB3 = parcelRequire("ieLB3");
var $5b2ee9ddc12efb82$var$booleanish = $8cx7u.booleanish;
var $5b2ee9ddc12efb82$var$number = $8cx7u.number;
var $5b2ee9ddc12efb82$var$spaceSeparated = $8cx7u.spaceSeparated;
module.exports = $ieLB3({
    transform: $5b2ee9ddc12efb82$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $5b2ee9ddc12efb82$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $5b2ee9ddc12efb82$var$booleanish,
        ariaChecked: $5b2ee9ddc12efb82$var$booleanish,
        ariaColCount: $5b2ee9ddc12efb82$var$number,
        ariaColIndex: $5b2ee9ddc12efb82$var$number,
        ariaColSpan: $5b2ee9ddc12efb82$var$number,
        ariaControls: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $5b2ee9ddc12efb82$var$booleanish,
        ariaDropEffect: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $5b2ee9ddc12efb82$var$booleanish,
        ariaFlowTo: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaGrabbed: $5b2ee9ddc12efb82$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $5b2ee9ddc12efb82$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaLevel: $5b2ee9ddc12efb82$var$number,
        ariaLive: null,
        ariaModal: $5b2ee9ddc12efb82$var$booleanish,
        ariaMultiLine: $5b2ee9ddc12efb82$var$booleanish,
        ariaMultiSelectable: $5b2ee9ddc12efb82$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $5b2ee9ddc12efb82$var$number,
        ariaPressed: $5b2ee9ddc12efb82$var$booleanish,
        ariaReadOnly: $5b2ee9ddc12efb82$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $5b2ee9ddc12efb82$var$booleanish,
        ariaRoleDescription: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaRowCount: $5b2ee9ddc12efb82$var$number,
        ariaRowIndex: $5b2ee9ddc12efb82$var$number,
        ariaRowSpan: $5b2ee9ddc12efb82$var$number,
        ariaSelected: $5b2ee9ddc12efb82$var$booleanish,
        ariaSetSize: $5b2ee9ddc12efb82$var$number,
        ariaSort: null,
        ariaValueMax: $5b2ee9ddc12efb82$var$number,
        ariaValueMin: $5b2ee9ddc12efb82$var$number,
        ariaValueNow: $5b2ee9ddc12efb82$var$number,
        ariaValueText: null,
        role: null
    }
});
function $5b2ee9ddc12efb82$var$ariaTransform(_, prop) {
    return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
}

});

parcelRegister("hjKxW", function(module, exports) {
"use strict";

var $8cx7u = parcelRequire("8cx7u");

var $ieLB3 = parcelRequire("ieLB3");

var $hLCV5 = parcelRequire("hLCV5");
var $c9b8512c43c3ea70$var$boolean = $8cx7u.boolean;
var $c9b8512c43c3ea70$var$overloadedBoolean = $8cx7u.overloadedBoolean;
var $c9b8512c43c3ea70$var$booleanish = $8cx7u.booleanish;
var $c9b8512c43c3ea70$var$number = $8cx7u.number;
var $c9b8512c43c3ea70$var$spaceSeparated = $8cx7u.spaceSeparated;
var $c9b8512c43c3ea70$var$commaSeparated = $8cx7u.commaSeparated;
module.exports = $ieLB3({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: $hLCV5,
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $c9b8512c43c3ea70$var$commaSeparated,
        acceptCharset: $c9b8512c43c3ea70$var$spaceSeparated,
        accessKey: $c9b8512c43c3ea70$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $c9b8512c43c3ea70$var$boolean,
        allowPaymentRequest: $c9b8512c43c3ea70$var$boolean,
        allowUserMedia: $c9b8512c43c3ea70$var$boolean,
        alt: null,
        as: null,
        async: $c9b8512c43c3ea70$var$boolean,
        autoCapitalize: null,
        autoComplete: $c9b8512c43c3ea70$var$spaceSeparated,
        autoFocus: $c9b8512c43c3ea70$var$boolean,
        autoPlay: $c9b8512c43c3ea70$var$boolean,
        capture: $c9b8512c43c3ea70$var$boolean,
        charSet: null,
        checked: $c9b8512c43c3ea70$var$boolean,
        cite: null,
        className: $c9b8512c43c3ea70$var$spaceSeparated,
        cols: $c9b8512c43c3ea70$var$number,
        colSpan: null,
        content: null,
        contentEditable: $c9b8512c43c3ea70$var$booleanish,
        controls: $c9b8512c43c3ea70$var$boolean,
        controlsList: $c9b8512c43c3ea70$var$spaceSeparated,
        coords: $c9b8512c43c3ea70$var$number | $c9b8512c43c3ea70$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $c9b8512c43c3ea70$var$boolean,
        defer: $c9b8512c43c3ea70$var$boolean,
        dir: null,
        dirName: null,
        disabled: $c9b8512c43c3ea70$var$boolean,
        download: $c9b8512c43c3ea70$var$overloadedBoolean,
        draggable: $c9b8512c43c3ea70$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $c9b8512c43c3ea70$var$boolean,
        formTarget: null,
        headers: $c9b8512c43c3ea70$var$spaceSeparated,
        height: $c9b8512c43c3ea70$var$number,
        hidden: $c9b8512c43c3ea70$var$boolean,
        high: $c9b8512c43c3ea70$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $c9b8512c43c3ea70$var$spaceSeparated,
        httpEquiv: $c9b8512c43c3ea70$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $c9b8512c43c3ea70$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $c9b8512c43c3ea70$var$boolean,
        itemId: null,
        itemProp: $c9b8512c43c3ea70$var$spaceSeparated,
        itemRef: $c9b8512c43c3ea70$var$spaceSeparated,
        itemScope: $c9b8512c43c3ea70$var$boolean,
        itemType: $c9b8512c43c3ea70$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loop: $c9b8512c43c3ea70$var$boolean,
        low: $c9b8512c43c3ea70$var$number,
        manifest: null,
        max: null,
        maxLength: $c9b8512c43c3ea70$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $c9b8512c43c3ea70$var$number,
        multiple: $c9b8512c43c3ea70$var$boolean,
        muted: $c9b8512c43c3ea70$var$boolean,
        name: null,
        nonce: null,
        noModule: $c9b8512c43c3ea70$var$boolean,
        noValidate: $c9b8512c43c3ea70$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $c9b8512c43c3ea70$var$boolean,
        optimum: $c9b8512c43c3ea70$var$number,
        pattern: null,
        ping: $c9b8512c43c3ea70$var$spaceSeparated,
        placeholder: null,
        playsInline: $c9b8512c43c3ea70$var$boolean,
        poster: null,
        preload: null,
        readOnly: $c9b8512c43c3ea70$var$boolean,
        referrerPolicy: null,
        rel: $c9b8512c43c3ea70$var$spaceSeparated,
        required: $c9b8512c43c3ea70$var$boolean,
        reversed: $c9b8512c43c3ea70$var$boolean,
        rows: $c9b8512c43c3ea70$var$number,
        rowSpan: $c9b8512c43c3ea70$var$number,
        sandbox: $c9b8512c43c3ea70$var$spaceSeparated,
        scope: null,
        scoped: $c9b8512c43c3ea70$var$boolean,
        seamless: $c9b8512c43c3ea70$var$boolean,
        selected: $c9b8512c43c3ea70$var$boolean,
        shape: null,
        size: $c9b8512c43c3ea70$var$number,
        sizes: null,
        slot: null,
        span: $c9b8512c43c3ea70$var$number,
        spellCheck: $c9b8512c43c3ea70$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $c9b8512c43c3ea70$var$commaSeparated,
        start: $c9b8512c43c3ea70$var$number,
        step: null,
        style: null,
        tabIndex: $c9b8512c43c3ea70$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $c9b8512c43c3ea70$var$boolean,
        useMap: null,
        value: $c9b8512c43c3ea70$var$booleanish,
        width: $c9b8512c43c3ea70$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $c9b8512c43c3ea70$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $c9b8512c43c3ea70$var$number,
        borderColor: null,
        bottomMargin: $c9b8512c43c3ea70$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $c9b8512c43c3ea70$var$boolean,
        declare: $c9b8512c43c3ea70$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $c9b8512c43c3ea70$var$number,
        leftMargin: $c9b8512c43c3ea70$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $c9b8512c43c3ea70$var$number,
        marginWidth: $c9b8512c43c3ea70$var$number,
        noResize: $c9b8512c43c3ea70$var$boolean,
        noHref: $c9b8512c43c3ea70$var$boolean,
        noShade: $c9b8512c43c3ea70$var$boolean,
        noWrap: $c9b8512c43c3ea70$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $c9b8512c43c3ea70$var$number,
        rules: null,
        scheme: null,
        scrolling: $c9b8512c43c3ea70$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $c9b8512c43c3ea70$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $c9b8512c43c3ea70$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $c9b8512c43c3ea70$var$boolean,
        disableRemotePlayback: $c9b8512c43c3ea70$var$boolean,
        prefix: null,
        property: null,
        results: $c9b8512c43c3ea70$var$number,
        security: null,
        unselectable: null
    }
});

});


parcelRegister("gSyAZ", function(module, exports) {
"use strict";

var $5B5Uy = parcelRequire("5B5Uy");

var $fOaV0 = parcelRequire("fOaV0");

var $66rZX = parcelRequire("66rZX");

var $5vUqY = parcelRequire("5vUqY");

var $7PmIb = parcelRequire("7PmIb");

var $hzJz8 = parcelRequire("hzJz8");
module.exports = $5B5Uy([
    $66rZX,
    $fOaV0,
    $5vUqY,
    $7PmIb,
    $hzJz8
]);

});
parcelRegister("hzJz8", function(module, exports) {
"use strict";

var $8cx7u = parcelRequire("8cx7u");

var $ieLB3 = parcelRequire("ieLB3");

var $5ktOm = parcelRequire("5ktOm");
var $ccb90cf397990efb$var$boolean = $8cx7u.boolean;
var $ccb90cf397990efb$var$number = $8cx7u.number;
var $ccb90cf397990efb$var$spaceSeparated = $8cx7u.spaceSeparated;
var $ccb90cf397990efb$var$commaSeparated = $8cx7u.commaSeparated;
var $ccb90cf397990efb$var$commaOrSpaceSeparated = $8cx7u.commaOrSpaceSeparated;
module.exports = $ieLB3({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: $5ktOm,
    properties: {
        about: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        accentHeight: $ccb90cf397990efb$var$number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $ccb90cf397990efb$var$number,
        amplitude: $ccb90cf397990efb$var$number,
        arabicForm: null,
        ascent: $ccb90cf397990efb$var$number,
        attributeName: null,
        attributeType: null,
        azimuth: $ccb90cf397990efb$var$number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $ccb90cf397990efb$var$number,
        by: null,
        calcMode: null,
        capHeight: $ccb90cf397990efb$var$number,
        className: $ccb90cf397990efb$var$spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $ccb90cf397990efb$var$number,
        diffuseConstant: $ccb90cf397990efb$var$number,
        direction: null,
        display: null,
        dur: null,
        divisor: $ccb90cf397990efb$var$number,
        dominantBaseline: null,
        download: $ccb90cf397990efb$var$boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $ccb90cf397990efb$var$number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $ccb90cf397990efb$var$number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $ccb90cf397990efb$var$number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $ccb90cf397990efb$var$commaSeparated,
        g2: $ccb90cf397990efb$var$commaSeparated,
        glyphName: $ccb90cf397990efb$var$commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $ccb90cf397990efb$var$number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $ccb90cf397990efb$var$number,
        horizOriginX: $ccb90cf397990efb$var$number,
        horizOriginY: $ccb90cf397990efb$var$number,
        id: null,
        ideographic: $ccb90cf397990efb$var$number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $ccb90cf397990efb$var$number,
        k: $ccb90cf397990efb$var$number,
        k1: $ccb90cf397990efb$var$number,
        k2: $ccb90cf397990efb$var$number,
        k3: $ccb90cf397990efb$var$number,
        k4: $ccb90cf397990efb$var$number,
        kernelMatrix: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $ccb90cf397990efb$var$number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $ccb90cf397990efb$var$number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $ccb90cf397990efb$var$number,
        overlineThickness: $ccb90cf397990efb$var$number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $ccb90cf397990efb$var$number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $ccb90cf397990efb$var$spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $ccb90cf397990efb$var$number,
        pointsAtY: $ccb90cf397990efb$var$number,
        pointsAtZ: $ccb90cf397990efb$var$number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        rev: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        requiredFeatures: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        requiredFonts: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        requiredFormats: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $ccb90cf397990efb$var$number,
        specularExponent: $ccb90cf397990efb$var$number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $ccb90cf397990efb$var$number,
        strikethroughThickness: $ccb90cf397990efb$var$number,
        string: null,
        stroke: null,
        strokeDashArray: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $ccb90cf397990efb$var$number,
        strokeOpacity: $ccb90cf397990efb$var$number,
        strokeWidth: null,
        style: null,
        surfaceScale: $ccb90cf397990efb$var$number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        tabIndex: $ccb90cf397990efb$var$number,
        tableValues: null,
        target: null,
        targetX: $ccb90cf397990efb$var$number,
        targetY: $ccb90cf397990efb$var$number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $ccb90cf397990efb$var$number,
        underlineThickness: $ccb90cf397990efb$var$number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $ccb90cf397990efb$var$number,
        values: null,
        vAlphabetic: $ccb90cf397990efb$var$number,
        vMathematical: $ccb90cf397990efb$var$number,
        vectorEffect: null,
        vHanging: $ccb90cf397990efb$var$number,
        vIdeographic: $ccb90cf397990efb$var$number,
        version: null,
        vertAdvY: $ccb90cf397990efb$var$number,
        vertOriginX: $ccb90cf397990efb$var$number,
        vertOriginY: $ccb90cf397990efb$var$number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $ccb90cf397990efb$var$number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});

});


parcelRegister("ffG6I", function(module, exports) {
"use strict";

var $1j0Kh = parcelRequire("1j0Kh");

var $6rS13 = parcelRequire("6rS13");

var $3W6gM = parcelRequire("3W6gM");
var $b1a8eb5e87daf454$var$data = "data";
module.exports = $b1a8eb5e87daf454$var$find;
var $b1a8eb5e87daf454$var$valid = /^data[-\w.:]+$/i;
var $b1a8eb5e87daf454$var$dash = /-[a-z]/g;
var $b1a8eb5e87daf454$var$cap = /[A-Z]/g;
function $b1a8eb5e87daf454$var$find(schema, value) {
    var normal = $1j0Kh(value);
    var prop = value;
    var Type = $3W6gM;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $b1a8eb5e87daf454$var$data && $b1a8eb5e87daf454$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") prop = $b1a8eb5e87daf454$var$datasetToProperty(value);
        else value = $b1a8eb5e87daf454$var$datasetToAttribute(value);
        Type = $6rS13;
    }
    return new Type(prop, value);
}
function $b1a8eb5e87daf454$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($b1a8eb5e87daf454$var$dash, $b1a8eb5e87daf454$var$camelcase);
    return $b1a8eb5e87daf454$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $b1a8eb5e87daf454$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($b1a8eb5e87daf454$var$dash.test(value)) return property;
    value = value.replace($b1a8eb5e87daf454$var$cap, $b1a8eb5e87daf454$var$kebab);
    if (value.charAt(0) !== "-") value = "-" + value;
    return $b1a8eb5e87daf454$var$data + value;
}
function $b1a8eb5e87daf454$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
function $b1a8eb5e87daf454$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("6pKpX", function(module, exports) {
module.exports = JSON.parse('{"classId":"classID","dataType":"datatype","itemId":"itemID","strokeDashArray":"strokeDasharray","strokeDashOffset":"strokeDashoffset","strokeLineCap":"strokeLinecap","strokeLineJoin":"strokeLinejoin","strokeMiterLimit":"strokeMiterlimit","typeOf":"typeof","xLinkActuate":"xlinkActuate","xLinkArcRole":"xlinkArcrole","xLinkHref":"xlinkHref","xLinkRole":"xlinkRole","xLinkShow":"xlinkShow","xLinkTitle":"xlinkTitle","xLinkType":"xlinkType","xmlnsXLink":"xmlnsXlink"}');

});

parcelRegister("dxv4b", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $9db6749ae4e98b85$export$98e6a39c04603d36; }, function (v) { return $9db6749ae4e98b85$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $9db6749ae4e98b85$export$fac44ee5b035f737; }, function (v) { return $9db6749ae4e98b85$export$fac44ee5b035f737 = v; });
var $9db6749ae4e98b85$export$98e6a39c04603d36;
var $9db6749ae4e98b85$export$fac44ee5b035f737;
"use strict";
$9db6749ae4e98b85$export$98e6a39c04603d36 = $9db6749ae4e98b85$var$parse;
$9db6749ae4e98b85$export$fac44ee5b035f737 = $9db6749ae4e98b85$var$stringify;
var $9db6749ae4e98b85$var$empty = "";
var $9db6749ae4e98b85$var$space = " ";
var $9db6749ae4e98b85$var$whiteSpace = /[ \t\n\r\f]+/g;
function $9db6749ae4e98b85$var$parse(value) {
    var input = String(value || $9db6749ae4e98b85$var$empty).trim();
    return input === $9db6749ae4e98b85$var$empty ? [] : input.split($9db6749ae4e98b85$var$whiteSpace);
}
function $9db6749ae4e98b85$var$stringify(values) {
    return values.join($9db6749ae4e98b85$var$space).trim();
}

});

parcelRegister("ll02G", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $f88b978602bb666f$export$98e6a39c04603d36; }, function (v) { return $f88b978602bb666f$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $f88b978602bb666f$export$fac44ee5b035f737; }, function (v) { return $f88b978602bb666f$export$fac44ee5b035f737 = v; });
var $f88b978602bb666f$export$98e6a39c04603d36;
var $f88b978602bb666f$export$fac44ee5b035f737;
"use strict";
$f88b978602bb666f$export$98e6a39c04603d36 = $f88b978602bb666f$var$parse;
$f88b978602bb666f$export$fac44ee5b035f737 = $f88b978602bb666f$var$stringify;
var $f88b978602bb666f$var$comma = ",";
var $f88b978602bb666f$var$space = " ";
var $f88b978602bb666f$var$empty = "";
// Parse comma-separated tokens to an array.
function $f88b978602bb666f$var$parse(value) {
    var values = [];
    var input = String(value || $f88b978602bb666f$var$empty);
    var index = input.indexOf($f88b978602bb666f$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($f88b978602bb666f$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $f88b978602bb666f$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $f88b978602bb666f$var$empty : $f88b978602bb666f$var$space;
    var right = settings.padRight ? $f88b978602bb666f$var$space : $f88b978602bb666f$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $f88b978602bb666f$var$empty) values = values.concat($f88b978602bb666f$var$empty);
    return values.join(right + $f88b978602bb666f$var$comma + left).trim();
}

});

parcelRegister("b9hO3", function(module, exports) {

var $kXXGL = parcelRequire("kXXGL");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $81de58eebb75200f$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $kXXGL(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $81de58eebb75200f$var$StyleToObject;

});
parcelRegister("kXXGL", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $f4379e4a25d88a25$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $f4379e4a25d88a25$var$NEWLINE_REGEX = /\n/g;
var $f4379e4a25d88a25$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $f4379e4a25d88a25$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $f4379e4a25d88a25$var$COLON_REGEX = /^:\s*/;
var $f4379e4a25d88a25$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $f4379e4a25d88a25$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $f4379e4a25d88a25$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $f4379e4a25d88a25$var$NEWLINE = "\n";
var $f4379e4a25d88a25$var$FORWARD_SLASH = "/";
var $f4379e4a25d88a25$var$ASTERISK = "*";
var $f4379e4a25d88a25$var$EMPTY_STRING = "";
// types
var $f4379e4a25d88a25$var$TYPE_COMMENT = "comment";
var $f4379e4a25d88a25$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($f4379e4a25d88a25$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($f4379e4a25d88a25$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($f4379e4a25d88a25$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($f4379e4a25d88a25$var$FORWARD_SLASH != style.charAt(0) || $f4379e4a25d88a25$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($f4379e4a25d88a25$var$EMPTY_STRING != style.charAt(i) && ($f4379e4a25d88a25$var$ASTERISK != style.charAt(i) || $f4379e4a25d88a25$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($f4379e4a25d88a25$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $f4379e4a25d88a25$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($f4379e4a25d88a25$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($f4379e4a25d88a25$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($f4379e4a25d88a25$var$VALUE_REGEX);
        var ret = pos({
            type: $f4379e4a25d88a25$var$TYPE_DECLARATION,
            property: $f4379e4a25d88a25$var$trim(prop[0].replace($f4379e4a25d88a25$var$COMMENT_REGEX, $f4379e4a25d88a25$var$EMPTY_STRING)),
            value: val ? $f4379e4a25d88a25$var$trim(val[0].replace($f4379e4a25d88a25$var$COMMENT_REGEX, $f4379e4a25d88a25$var$EMPTY_STRING)) : $f4379e4a25d88a25$var$EMPTY_STRING
        });
        // ;
        match($f4379e4a25d88a25$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $f4379e4a25d88a25$var$trim(str) {
    return str ? str.replace($f4379e4a25d88a25$var$TRIM_REGEX, $f4379e4a25d88a25$var$EMPTY_STRING) : $f4379e4a25d88a25$var$EMPTY_STRING;
}

});


parcelRegister("aM3Le", function(module, exports) {
module.exports = JSON.parse('{"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}');

});


parcelRegister("6GMPt", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
var $4dec8acf1bacf0c4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4dec8acf1bacf0c4$var$hastCssPropertyMap = {
    align: "text-align",
    valign: "vertical-align",
    height: "height",
    width: "width"
};
module.exports = function tableCellStyle(node) {
    $KDBsL(node, "element", $4dec8acf1bacf0c4$var$visitor);
    return node;
};
function $4dec8acf1bacf0c4$var$visitor(node) {
    if (node.tagName !== "tr" && node.tagName !== "td" && node.tagName !== "th") return;
    var hastName;
    var cssName;
    for(hastName in $4dec8acf1bacf0c4$var$hastCssPropertyMap){
        if (!$4dec8acf1bacf0c4$var$hasOwnProperty.call($4dec8acf1bacf0c4$var$hastCssPropertyMap, hastName) || node.properties[hastName] === undefined) continue;
        cssName = $4dec8acf1bacf0c4$var$hastCssPropertyMap[hastName];
        $4dec8acf1bacf0c4$var$appendStyle(node, cssName, node.properties[hastName]);
        delete node.properties[hastName];
    }
}
function $4dec8acf1bacf0c4$var$appendStyle(node, property, value) {
    var prevStyle = (node.properties.style || "").trim();
    if (prevStyle && !/;\s*/.test(prevStyle)) prevStyle += ";";
    if (prevStyle) prevStyle += " ";
    var nextStyle = prevStyle + property + ": " + value + ";";
    node.properties.style = nextStyle;
}

});


parcelRegister("1irrc", function(module, exports) {
var $0f1cc16d68d0414a$var$cache = {};
function $0f1cc16d68d0414a$var$escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
/**
 * Replaces variable placeholders inside a string with any given data. Each key
 * in `data` corresponds to a variable placeholder name in `str`.
 *
 * Usage:
 * {{{
 * template('My name is ${name} and I am ${age} years old.', { name: 'Bob', age: '65' });
 * }}}
 *
 * @param  String str     A string containing variable place-holders.
 * @param  Object data    A key, value array where each key stands for a place-holder variable
 *                        name to be replaced with value.
 * @param  Object options Available options are:
 *                        - `'before'`: The character or string in front of the name of the variable
 *                          place-holder (defaults to `'${'`).
 *                        - `'after'`: The character or string after the name of the variable
 *                          place-holder (defaults to `}`).
 *                        - `'escape'`: The character or string used to escape the before character or string
 *                          (defaults to `'\\'`).
 *                        - `'clean'`: A boolean or array with instructions for cleaning.
 * @return String
 */ function $0f1cc16d68d0414a$var$template(str, data, options) {
    var data = data || {};
    var options = options || {};
    var keys = Array.isArray(data) ? Array.apply(null, {
        length: data.length
    }).map(Number.call, Number) : Object.keys(data);
    var len = keys.length;
    if (!len) return str;
    var before = options.before !== undefined ? options.before : "${";
    var after = options.after !== undefined ? options.after : "}";
    var escape = options.escape !== undefined ? options.escape : "\\";
    var clean = options.clean !== undefined ? options.clean : false;
    $0f1cc16d68d0414a$var$cache[escape] = $0f1cc16d68d0414a$var$cache[escape] || $0f1cc16d68d0414a$var$escapeRegExp(escape);
    $0f1cc16d68d0414a$var$cache[before] = $0f1cc16d68d0414a$var$cache[before] || $0f1cc16d68d0414a$var$escapeRegExp(before);
    $0f1cc16d68d0414a$var$cache[after] = $0f1cc16d68d0414a$var$cache[after] || $0f1cc16d68d0414a$var$escapeRegExp(after);
    var begin = escape ? "(" + $0f1cc16d68d0414a$var$cache[escape] + ")?" + $0f1cc16d68d0414a$var$cache[before] : $0f1cc16d68d0414a$var$cache[before];
    var end = $0f1cc16d68d0414a$var$cache[after];
    for(var i = 0; i < len; i++)str = str.replace(new RegExp(begin + String(keys[i]) + end, "g"), function(match, behind) {
        return behind ? match : String(data[keys[i]]);
    });
    if (escape) str = str.replace(new RegExp($0f1cc16d68d0414a$var$escapeRegExp(escape) + $0f1cc16d68d0414a$var$escapeRegExp(before), "g"), before);
    return clean ? $0f1cc16d68d0414a$var$template.clean(str, options) : str;
}
/**
 * Cleans up a formatted string with given `options` depending
 * on the `'clean'` option. The goal of this function is to replace all whitespace
 * and unneeded mark-up around place-holders that did not get replaced by `Text::insert()`.
 *
 * @param  String str     The string to clean.
 * @param  Object options Available options are:
 *                        - `'before'`: characters marking the start of targeted substring.
 *                        - `'after'`: characters marking the end of targeted substring.
 *                        - `'escape'`: The character or string used to escape the before character or string
 *                          (defaults to `'\\'`).
 *                        - `'gap'`: Regular expression matching gaps.
 *                        - `'word'`: Regular expression matching words.
 *                        - `'replacement'`: String to use for cleaned substrings (defaults to `''`).
 * @return String         The cleaned string.
 */ $0f1cc16d68d0414a$var$template.clean = function(str, options) {
    var options = options || {};
    var before = options.before !== undefined ? options.before : "${";
    var after = options.after !== undefined ? options.after : "}";
    var escape = options.escape !== undefined ? options.escape : "\\";
    var word = options.word !== undefined ? options.word : "[\\w,.]+";
    var gap = options.gap !== undefined ? options.gap : "(\\s*(?:(?:and|or|,)\\s*)?)";
    var replacement = options.replacement !== undefined ? options.replacement : "";
    $0f1cc16d68d0414a$var$cache[escape] = $0f1cc16d68d0414a$var$cache[escape] || $0f1cc16d68d0414a$var$escapeRegExp(escape);
    $0f1cc16d68d0414a$var$cache[before] = $0f1cc16d68d0414a$var$cache[before] || $0f1cc16d68d0414a$var$escapeRegExp(before);
    $0f1cc16d68d0414a$var$cache[after] = $0f1cc16d68d0414a$var$cache[after] || $0f1cc16d68d0414a$var$escapeRegExp(after);
    var begin = escape ? "(" + $0f1cc16d68d0414a$var$cache[escape] + ")?" + $0f1cc16d68d0414a$var$cache[before] : $0f1cc16d68d0414a$var$cache[before];
    var end = $0f1cc16d68d0414a$var$cache[after];
    str = str.replace(new RegExp(gap + begin + word + end + gap, "g"), function(match, before, behind, after) {
        if (behind) return match;
        if (before && after && before.trim() === after.trim()) {
            if (before.trim() || before && after) return before + replacement;
        }
        return replacement;
    });
    if (escape) str = str.replace(new RegExp($0f1cc16d68d0414a$var$escapeRegExp(escape) + $0f1cc16d68d0414a$var$escapeRegExp(before)), before);
    return str;
};
module.exports = $0f1cc16d68d0414a$var$template;

});

parcelRegister("kvHhM", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $eee84788f0a161e2$export$f99233281efd08a0; });
$parcel$export(module.exports, "MainHeading", function () { return $eee84788f0a161e2$export$b8da7edf2c95385a; });
$parcel$export(module.exports, "MainHeadingSmaller", function () { return $eee84788f0a161e2$export$63f51c2867992028; });
$parcel$export(module.exports, "SectionHeading", function () { return $eee84788f0a161e2$export$72d7ca7a5d1d4807; });
$parcel$export(module.exports, "NormalText", function () { return $eee84788f0a161e2$export$c68ad5affd687b01; });
$parcel$export(module.exports, "SubtleText", function () { return $eee84788f0a161e2$export$474d9b539a9b2a24; });
/* eslint-disable react/jsx-props-no-spreading */ 
var $co7DE = parcelRequire("co7DE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
function $eee84788f0a161e2$export$f99233281efd08a0(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "h1"
    });
}
function $eee84788f0a161e2$export$b8da7edf2c95385a({ noUnderline: noUnderline, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        underline: noUnderline ? "false" : "true",
        variant: "h2"
    });
}
$eee84788f0a161e2$export$b8da7edf2c95385a.defaultProps = {
    noUnderline: false
};
const $eee84788f0a161e2$var$useHeadingSmallerStyles = (0, $7b1Lp.default)({
    root: {
        fontWeight: 600,
        fontSize: 16,
        marginBottom: 20,
        marginTop: 20,
        lineHeight: "22px"
    }
});
function $eee84788f0a161e2$export$63f51c2867992028({ align: align = "left", ...props }) {
    const classes = $eee84788f0a161e2$var$useHeadingSmallerStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        classes: classes,
        align: align,
        variant: "h2"
    });
}
function $eee84788f0a161e2$export$72d7ca7a5d1d4807(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "h3"
    });
}
function $eee84788f0a161e2$export$c68ad5affd687b01(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "body1"
    });
}
function $eee84788f0a161e2$export$474d9b539a9b2a24(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "body2"
    });
}

});



parcelRegister("8p3P7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e39fd0ab6b61a2$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");

var $8mLXY = parcelRequire("8mLXY");
function $61e39fd0ab6b61a2$var$LazyLoading({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $cQNHH.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8mLXY.default), {
            dark: true
        })
    }, children);
}
var $61e39fd0ab6b61a2$export$2e2bcd8739ae039 = $61e39fd0ab6b61a2$var$LazyLoading;

});

parcelRegister("aJjY6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cfd98a9e1965a4c$export$2e2bcd8739ae039; });

var $fsWgf = parcelRequire("fsWgf");

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");


var $7cfd98a9e1965a4c$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $7cfd98a9e1965a4c$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $7cfd98a9e1965a4c$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $7cfd98a9e1965a4c$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: "100%"
            };
            return;
        }
        if (size === "auto") {
            styles[key] = {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none"
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === "xs") (0, $gtn2B.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $7cfd98a9e1965a4c$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function $7cfd98a9e1965a4c$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $7cfd98a9e1965a4c$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($7cfd98a9e1965a4c$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($7cfd98a9e1965a4c$var$getOffset(themeSpacing), ")"),
            "& > $item": {
                padding: $7cfd98a9e1965a4c$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $7cfd98a9e1965a4c$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $gtn2B.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: "border-box",
            margin: "0" // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ "direction-xs-column": {
            flexDirection: "column"
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ "direction-xs-column-reverse": {
            flexDirection: "column-reverse"
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ "direction-xs-row-reverse": {
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ "wrap-xs-nowrap": {
            flexWrap: "nowrap"
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ "wrap-xs-wrap-reverse": {
            flexWrap: "wrap-reverse"
        },
        /* Styles applied to the root element if `alignItems="center"`. */ "align-items-xs-center": {
            alignItems: "center"
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ "align-items-xs-flex-start": {
            alignItems: "flex-start"
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ "align-items-xs-flex-end": {
            alignItems: "flex-end"
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ "align-items-xs-baseline": {
            alignItems: "baseline"
        },
        /* Styles applied to the root element if `alignContent="center"`. */ "align-content-xs-center": {
            alignContent: "center"
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ "align-content-xs-flex-start": {
            alignContent: "flex-start"
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ "align-content-xs-flex-end": {
            alignContent: "flex-end"
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ "align-content-xs-space-between": {
            alignContent: "space-between"
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ "align-content-xs-space-around": {
            alignContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ "justify-content-xs-center": {
            justifyContent: "center"
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ "justify-content-xs-flex-end": {
            justifyContent: "flex-end"
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ "justify-content-xs-space-between": {
            justifyContent: "space-between"
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ "justify-content-xs-space-around": {
            justifyContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ "justify-content-xs-space-evenly": {
            justifyContent: "space-evenly"
        }
    }, $7cfd98a9e1965a4c$var$generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $7cfd98a9e1965a4c$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $7cfd98a9e1965a4c$var$Grid = /*#__PURE__*/ $cQNHH.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $fsWgf.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $bKF6r.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $cQNHH.createElement(Component, (0, $gtn2B.default)({
        className: className,
        ref: ref
    }, other));
});
var $7cfd98a9e1965a4c$var$StyledGrid = (0, $eyd6T.default)($7cfd98a9e1965a4c$export$9dd6ff9ea0189349, {
    name: "MuiGrid"
})($7cfd98a9e1965a4c$var$Grid);
var $7cfd98a9e1965a4c$var$requireProp;
var $7cfd98a9e1965a4c$export$2e2bcd8739ae039 = $7cfd98a9e1965a4c$var$StyledGrid;

});

parcelRegister("bIgYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8870f9ed15d7c62a$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");


var $eyd6T = parcelRequire("eyd6T");

var $80wVS = parcelRequire("80wVS");

var $6apHB = parcelRequire("6apHB");

var $5beWR = parcelRequire("5beWR");
var $8870f9ed15d7c62a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $8870f9ed15d7c62a$var$IconButton = /*#__PURE__*/ $cQNHH.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $fsWgf.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $cQNHH.createElement((0, $6apHB.default), (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, color !== "default" && classes["color".concat((0, $5beWR.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $5beWR.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $cQNHH.createElement("span", {
        className: classes.label
    }, children));
});
var $8870f9ed15d7c62a$export$2e2bcd8739ae039 = (0, $eyd6T.default)($8870f9ed15d7c62a$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($8870f9ed15d7c62a$var$IconButton);

});

parcelRegister("97AH2", function(module, exports) {
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a413afb14e941e1$var$React = $8jEx7((parcelRequire("cQNHH")));

var $6a413afb14e941e1$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $6a413afb14e941e1$var$_default = (0, $6a413afb14e941e1$var$_createSvgIcon.default)(/*#__PURE__*/ $6a413afb14e941e1$var$React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
module.exports.default = $6a413afb14e941e1$var$_default;

});
parcelRegister("kFrsj", function(module, exports) {
function $f0bcef155f16a61d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $f0bcef155f16a61d$var$_interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("8jEx7", function(module, exports) {

var $dvB3a = parcelRequire("dvB3a");
var $60df8a21ceea9678$var$_typeof = $dvB3a.default;
function $60df8a21ceea9678$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($60df8a21ceea9678$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $60df8a21ceea9678$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $60df8a21ceea9678$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $60df8a21ceea9678$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
module.exports = $60df8a21ceea9678$var$_interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("dvB3a", function(module, exports) {
function $9d5ae8f6bd5defcb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = $9d5ae8f6bd5defcb$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $9d5ae8f6bd5defcb$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $9d5ae8f6bd5defcb$var$_typeof(obj);
}
module.exports = $9d5ae8f6bd5defcb$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("bXzXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $c1Uiz.default;
    }
});

var $c1Uiz = parcelRequire("c1Uiz");

});
parcelRegister("c1Uiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c213fc20d89d4f3$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");

var $g03v7 = parcelRequire("g03v7");
function $8c213fc20d89d4f3$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $g03v7.default), (0, $gtn2B.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $g03v7.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(Component));
}

});
parcelRegister("g03v7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba5f5ca4c3950e3f$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");


var $eyd6T = parcelRequire("eyd6T");

var $5beWR = parcelRequire("5beWR");
var $ba5f5ca4c3950e3f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $ba5f5ca4c3950e3f$var$SvgIcon = /*#__PURE__*/ $cQNHH.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $fsWgf.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $cQNHH.createElement(Component, (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $5beWR.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $5beWR.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $cQNHH.createElement("title", null, titleAccess) : null);
});
$ba5f5ca4c3950e3f$var$SvgIcon.muiName = "SvgIcon";
var $ba5f5ca4c3950e3f$export$2e2bcd8739ae039 = (0, $eyd6T.default)($ba5f5ca4c3950e3f$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($ba5f5ca4c3950e3f$var$SvgIcon);

});




parcelRegister("c4XSV", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $8cb44fa200269a5f$export$1adfeb024f5185b; });
$parcel$export(module.exports, "FormattedDate", function () { return $8cb44fa200269a5f$export$40ae3194919d16b; });

var $1DZj1 = parcelRequire("1DZj1");

var $szrnD = parcelRequire("szrnD");

var $4uhmr = parcelRequire("4uhmr");

var $IPPAR = parcelRequire("IPPAR");



var $kV13H = parcelRequire("kV13H");


function $8cb44fa200269a5f$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $8cb44fa200269a5f$export$747d244ee58120dd(msg) {
    return msg;
}
var $8cb44fa200269a5f$export$40ae3194919d16b = (0, $1DZj1.createFormattedComponent)("formatDate");
var $8cb44fa200269a5f$export$5b390a54f8a846f7 = (0, $1DZj1.createFormattedComponent)("formatTime");
var $8cb44fa200269a5f$export$db80edc1e6b2f63d = (0, $1DZj1.createFormattedComponent)("formatNumber");
var $8cb44fa200269a5f$export$f52b44e459e6e71d = (0, $1DZj1.createFormattedComponent)("formatList");
var $8cb44fa200269a5f$export$c2336ea5aaab92fa = (0, $1DZj1.createFormattedComponent)("formatDisplayName");
var $8cb44fa200269a5f$export$7fdc7d2c91ce149b = (0, $1DZj1.createFormattedDateTimePartsComponent)("formatDate");
var $8cb44fa200269a5f$export$ec35873761676c2a = (0, $1DZj1.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("1DZj1", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $1328fd0886f23ed9$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $1328fd0886f23ed9$export$b37e14176d001dec; });

var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $4uhmr = parcelRequire("4uhmr");
var $1328fd0886f23ed9$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($1328fd0886f23ed9$var$DisplayName || ($1328fd0886f23ed9$var$DisplayName = {}));
var $1328fd0886f23ed9$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($1328fd0886f23ed9$var$DisplayNameParts || ($1328fd0886f23ed9$var$DisplayNameParts = {}));
var $1328fd0886f23ed9$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $4uhmr.default)();
    var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$1328fd0886f23ed9$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $1328fd0886f23ed9$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $4uhmr.default)();
    var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$1328fd0886f23ed9$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $1328fd0886f23ed9$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $4uhmr.default)();
        var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $1328fd0886f23ed9$var$DisplayNameParts[name];
    return ComponentParts;
}
function $1328fd0886f23ed9$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $4uhmr.default)();
        var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $cQNHH.Fragment;
        return $cQNHH.createElement(Text, null, formattedValue);
    };
    Component.displayName = $1328fd0886f23ed9$var$DisplayName[name];
    return Component;
}

});

parcelRegister("IPPAR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $086c50c3452d74d7$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $gb4K1 = parcelRequire("gb4K1");

var $c5cmP = parcelRequire("c5cmP");
var $5VJfG = parcelRequire("5VJfG");
var $aKj9Z = parcelRequire("aKj9Z");

var $cQNHH = parcelRequire("cQNHH");

var $2KDk6 = parcelRequire("2KDk6");

var $szrnD = parcelRequire("szrnD");

var $9FMnG = parcelRequire("9FMnG");
function $086c50c3452d74d7$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $086c50c3452d74d7$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $9FMnG.isFormatXMLElementFn)(v) ? (0, $2KDk6.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $086c50c3452d74d7$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $086c50c3452d74d7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $aKj9Z.formatMessage).apply(void 0, (0, $gb4K1.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $cQNHH.Children.toArray(chunks);
    return chunks;
};
var $086c50c3452d74d7$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $gb4K1.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $086c50c3452d74d7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $c5cmP.createIntl)((0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, (0, $2KDk6.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, coreIntl), {
        formatMessage: $086c50c3452d74d7$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $086c50c3452d74d7$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $086c50c3452d74d7$var$IntlProvider = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $5VJfG.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $086c50c3452d74d7$export$7e4cbedfdd7b4c0d($086c50c3452d74d7$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $086c50c3452d74d7$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $086c50c3452d74d7$var$processIntlConfig(props);
        if (!(0, $2KDk6.shallowEqual)(prevConfig, config)) return {
            intl: $086c50c3452d74d7$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $2KDk6.invariantIntlContext)(this.state.intl);
        return $cQNHH.createElement((0, $szrnD.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $2KDk6.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($cQNHH.PureComponent);
var $086c50c3452d74d7$export$2e2bcd8739ae039 = $086c50c3452d74d7$var$IntlProvider;

});
parcelRegister("c5cmP", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $8cbf8b8978d1b273$export$7e4cbedfdd7b4c0d; });

var $gb4K1 = parcelRequire("gb4K1");

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");

var $bEHO0 = parcelRequire("bEHO0");

var $4I0Ba = parcelRequire("4I0Ba");

var $4xOmy = parcelRequire("4xOmy");

var $fWzDy = parcelRequire("fWzDy");

var $aKj9Z = parcelRequire("aKj9Z");

var $7Huld = parcelRequire("7Huld");

var $1mQHj = parcelRequire("1mQHj");
function $8cbf8b8978d1b273$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $8cbf8b8978d1b273$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $8cbf8b8978d1b273$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $8cbf8b8978d1b273$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $5VJfG.createFormatters)(cache);
    var resolvedConfig = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, (0, $5VJfG.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $dCg2n.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $dCg2n.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $dCg2n.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $8cbf8b8978d1b273$var$verifyConfigMessages(resolvedConfig);
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $bEHO0.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $bEHO0.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $4I0Ba.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $4xOmy.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $4xOmy.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $4xOmy.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $4xOmy.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $4xOmy.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $fWzDy.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $aKj9Z.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $aKj9Z.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $7Huld.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $7Huld.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $1mQHj.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("bEHO0", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $87c568fc21c9ea21$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $87c568fc21c9ea21$export$6871080848f10b2f; });

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");
var $87c568fc21c9ea21$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $87c568fc21c9ea21$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $5VJfG.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $5VJfG.filterProps)(options, $87c568fc21c9ea21$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $87c568fc21c9ea21$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $87c568fc21c9ea21$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $87c568fc21c9ea21$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $87c568fc21c9ea21$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

});

parcelRegister("4I0Ba", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $36dbbc55570f9232$export$b4ea3b48dcf921f6; });

var $5VJfG = parcelRequire("5VJfG");

var $8RUL4 = parcelRequire("8RUL4");

var $dCg2n = parcelRequire("dCg2n");
var $36dbbc55570f9232$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $36dbbc55570f9232$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $5VJfG.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $5VJfG.filterProps)(options, $36dbbc55570f9232$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $36dbbc55570f9232$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $8RUL4.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    try {
        return $36dbbc55570f9232$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("4xOmy", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $34f14f7f43e8af49$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $34f14f7f43e8af49$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $34f14f7f43e8af49$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $34f14f7f43e8af49$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $34f14f7f43e8af49$export$af6e5d7a5c73edeb; });

var $gb4K1 = parcelRequire("gb4K1");

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");
var $34f14f7f43e8af49$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $34f14f7f43e8af49$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $5VJfG.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $34f14f7f43e8af49$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $34f14f7f43e8af49$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $34f14f7f43e8af49$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $34f14f7f43e8af49$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $5VJfG.filterProps)(options, $34f14f7f43e8af49$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $34f14f7f43e8af49$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $34f14f7f43e8af49$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

});

parcelRegister("fWzDy", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $b9b7ea8e1febf9cf$export$bbbd05c900f3568d; });

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");

var $8RUL4 = parcelRequire("8RUL4");
var $b9b7ea8e1febf9cf$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $b9b7ea8e1febf9cf$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $8RUL4.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $b9b7ea8e1febf9cf$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("aKj9Z", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $7d2d1014377ab8c5$export$25868d1e8e76735f; });

var $gb4K1 = parcelRequire("gb4K1");

var $gvCUa = parcelRequire("gvCUa");
parcelRequire("iTKsw");
var $4kwTT = parcelRequire("4kwTT");

var $dCg2n = parcelRequire("dCg2n");
parcelRequire("b4svv");
var $a5i87 = parcelRequire("a5i87");
function $7d2d1014377ab8c5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $gb4K1.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $7d2d1014377ab8c5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $7d2d1014377ab8c5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $4kwTT.IntlMessageFormat).formats;
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, mfFormats), f1), {
        date: $7d2d1014377ab8c5$var$deepMergeOptions($7d2d1014377ab8c5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $7d2d1014377ab8c5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $7d2d1014377ab8c5$var$deepMergeOptions($7d2d1014377ab8c5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $7d2d1014377ab8c5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $7d2d1014377ab8c5$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $gvCUa.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $a5i87.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, defaultRichTextElements), values || {});
    formats = $7d2d1014377ab8c5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $7d2d1014377ab8c5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $dCg2n.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $dCg2n.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $gb4K1.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $dCg2n.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $dCg2n.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

});

parcelRegister("7Huld", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $59b415acb7c7c3b5$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $59b415acb7c7c3b5$export$6f284aad1934db69; });

var $gb4K1 = parcelRequire("gb4K1");

var $5VJfG = parcelRequire("5VJfG");

var $8RUL4 = parcelRequire("8RUL4");

var $dCg2n = parcelRequire("dCg2n");
var $59b415acb7c7c3b5$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $59b415acb7c7c3b5$var$now = Date.now();
function $59b415acb7c7c3b5$var$generateToken(i) {
    return "".concat($59b415acb7c7c3b5$var$now, "_").concat(i, "_").concat($59b415acb7c7c3b5$var$now);
}
function $59b415acb7c7c3b5$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $59b415acb7c7c3b5$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $59b415acb7c7c3b5$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $8RUL4.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $59b415acb7c7c3b5$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $59b415acb7c7c3b5$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("1mQHj", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $0ff0b927fde01746$export$62fe1a4d9e891fa2; });

var $5VJfG = parcelRequire("5VJfG");

var $8RUL4 = parcelRequire("8RUL4");

var $dCg2n = parcelRequire("dCg2n");
var $0ff0b927fde01746$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $0ff0b927fde01746$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $8RUL4.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $0ff0b927fde01746$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

});




parcelRegister("53xQg", function(module, exports) {

$parcel$export(module.exports, "SUPPORT_EMAIL", function () { return $3ae77be0b9196b9a$export$fc5cbb021d0697ad; });
/* eslint-disable import/prefer-default-export */ const $3ae77be0b9196b9a$export$fc5cbb021d0697ad = "support@trialbee.com";

});

parcelRegister("2Hhgv", function(module, exports) {

$parcel$export(module.exports, "subscribeMetrics", function () { return $1f6cfd70a6026f23$export$67af0da6a41789e4; });
$parcel$export(module.exports, "unsubscribeMetrics", function () { return $1f6cfd70a6026f23$export$32e6bda1c181c045; });
$parcel$export(module.exports, "submitMetric", function () { return $1f6cfd70a6026f23$export$fc3d95e08c10def0; });
$parcel$export(module.exports, "metricsDataFromState", function () { return $1f6cfd70a6026f23$export$f4930abe3d1aecb1; });
const $1f6cfd70a6026f23$var$subscribers = [];
function $1f6cfd70a6026f23$export$67af0da6a41789e4(callback) {
    $1f6cfd70a6026f23$var$subscribers.push(callback);
}
function $1f6cfd70a6026f23$export$32e6bda1c181c045(callback) {
    $1f6cfd70a6026f23$var$subscribers.splice($1f6cfd70a6026f23$var$subscribers.findIndex((c)=>c === callback), 1);
}
function $1f6cfd70a6026f23$export$fc3d95e08c10def0(action) {
    $1f6cfd70a6026f23$var$subscribers.forEach((subscriber)=>subscriber(action));
}
function $1f6cfd70a6026f23$export$f4930abe3d1aecb1({ pageName: pageName, ...state }) {
    const metricsData = {
        currentPage: pageName,
        subPage: state[pageName].subPage || null
    };
    if (state.questionnaire && state.sessionInfo.questions) metricsData.questionnaire = {
        questionsAnswered: Object.keys(state.questionnaire.answers || {}).map((id)=>{
            const [question, index] = state.sessionInfo.questions.map((value, i)=>[
                    value,
                    i + 1
                ]).find(([{ id: questionId }])=>questionId === id);
            return {
                index: index,
                key: question.key
            };
        })
    };
    if (state.clinicForm) metricsData.clinicForm = {
        siteIsSelected: Boolean(state.clinicForm.selectedSite)
    };
    if (state.contactDetails) metricsData.contactDetailsForm = {
        enteredFields: Object.entries(state.contactDetails.fieldValues || {}).filter((entry)=>entry[1].value).map(([key])=>key),
        fieldsWithErrors: Object.entries(state.contactDetails.fieldValues || {}).filter((entry)=>entry[1].errors && entry[1].errors.length).map(([key])=>key),
        hasConsented: state.contactDetails.consented
    };
    return metricsData;
}

});

parcelRegister("aeuny", function(module, exports) {

$parcel$export(module.exports, "CloseConfirmationProvider", function () { return $7732c6caa7a63e8d$export$9efa4137e8c31f94; });
$parcel$export(module.exports, "useCloseConfirmation", function () { return $7732c6caa7a63e8d$export$3feac60ccf59e145; });
$parcel$export(module.exports, "useIsLocked", function () { return $7732c6caa7a63e8d$export$2ae0e5727802c39e; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $7732c6caa7a63e8d$var$CloseConfirmationContext = /*#__PURE__*/ (0, $cQNHH.createContext)();
function $7732c6caa7a63e8d$export$9efa4137e8c31f94({ children: children }) {
    const [{ lockCount: lockCount }, dispatch] = (0, $cQNHH.useReducer)((state, action)=>{
        if (action.type === "add") return {
            lockCount: state.lockCount + 1
        };
        else if (action.type === "remove") return {
            lockCount: state.lockCount - 1
        };
        return state;
    }, {
        lockCount: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($7732c6caa7a63e8d$var$CloseConfirmationContext.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            lockCount: lockCount,
            dispatch: dispatch
        }
    }, children);
}
function $7732c6caa7a63e8d$export$3feac60ccf59e145(enable = true) {
    const { dispatch: dispatch } = (0, $cQNHH.useContext)($7732c6caa7a63e8d$var$CloseConfirmationContext);
    (0, $cQNHH.useEffect)(()=>{
        if (enable) {
            dispatch({
                type: "add"
            });
            return ()=>dispatch({
                    type: "remove"
                });
        }
        return ()=>{};
    }, [
        enable
    ]);
}
function $7732c6caa7a63e8d$export$2ae0e5727802c39e() {
    const { lockCount: lockCount } = (0, $cQNHH.useContext)($7732c6caa7a63e8d$var$CloseConfirmationContext);
    return lockCount > 0;
}

});

parcelRegister("hgf0k", function(module, exports) {

$parcel$export(module.exports, "GlobalStateProvider", function () { return $c90f91d60b9576d3$export$262181a5dfabf1e3; });
$parcel$export(module.exports, "useGlobalScope", function () { return $c90f91d60b9576d3$export$d2cda2dad07d1c1; });
$parcel$export(module.exports, "useFullGlobalState", function () { return $c90f91d60b9576d3$export$a1ece1599f2c55ec; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
function $c90f91d60b9576d3$var$set(obj, path, value) {
    const paths = path.split(".");
    let current = obj;
    for(let i = 0; i < paths.length - 1; i += 1){
        current[paths[i]] = current[paths[i]] || {};
        current = current[paths[i]];
    }
    current[paths[paths.length - 1]] = value;
}
const $c90f91d60b9576d3$var$StateContext = /*#__PURE__*/ (0, $cQNHH.createContext)();
function $c90f91d60b9576d3$export$262181a5dfabf1e3({ initialKeys: initialKeys, children: children }) {
    // Used to force rerender
    const [b, setB] = (0, $cQNHH.useState)(0);
    const initialState = (0, $cQNHH.useMemo)(()=>initialKeys.reduce((acc, key)=>({
                ...acc,
                [key]: {}
            }), {}));
    const state = (0, $cQNHH.useRef)(initialState);
    const setQueue = (0, $cQNHH.useRef)([]);
    const setState = (path, value, skipRerender)=>{
        if (!skipRerender) {
            setQueue.current.push([
                path,
                value
            ]);
            while(setQueue.current.length > 0){
                const [queuedPath, queuedValue] = setQueue.current.shift();
                $c90f91d60b9576d3$var$set(state.current, queuedPath, queuedValue);
            }
            setB(b + 1); // Forces a rerender
        } else $c90f91d60b9576d3$var$set(state.current, path, value);
    };
    return(// eslint-disable-next-line react/jsx-no-constructed-context-values
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($c90f91d60b9576d3$var$StateContext.Provider, {
        value: {
            state: state.current,
            setState: setState
        }
    }, children));
}
$c90f91d60b9576d3$export$262181a5dfabf1e3.defaultProps = {
    initialKeys: []
};
function $c90f91d60b9576d3$export$d2cda2dad07d1c1(scope) {
    const { state: state, setState: setState } = (0, $cQNHH.useContext)($c90f91d60b9576d3$var$StateContext);
    const localState = state[scope] || {};
    // Works almost exactly the same as useState.
    // Returns [value, setter, propertySetter]
    // The `propertySetter` can be used to set nested properties. `propertySetter('foo.bar', 'baz');`
    // would result in `scope.property.foo.bar` being equal to baz.
    const useGlobalState = (property, defaultValue)=>{
        let value = localState[property];
        if (!Object.prototype.hasOwnProperty.call(localState, property)) {
            if (typeof defaultValue === "function") value = defaultValue();
            else value = defaultValue || null;
            setState(`${scope}.${property}`, value, true);
        }
        return [
            value,
            (newValue)=>setState(`${scope}.${property}`, newValue),
            (path, newValue)=>setState(`${scope}.${property}.${path}`, newValue)
        ];
    };
    return useGlobalState;
}
function $c90f91d60b9576d3$export$a1ece1599f2c55ec() {
    const { state: state, setState: setState } = (0, $cQNHH.useContext)($c90f91d60b9576d3$var$StateContext);
    return [
        state,
        setState
    ];
}

});

parcelRegister("7lOcN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a170522605d2d5$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
let $55a170522605d2d5$var$counter = 0;
function $55a170522605d2d5$export$2e2bcd8739ae039(prefix = "tb") {
    const hasRun = (0, $cQNHH.useRef)(false);
    const value = (0, $cQNHH.useRef)($55a170522605d2d5$var$counter);
    if (!hasRun.current) {
        hasRun.current = true;
        $55a170522605d2d5$var$counter += 1;
    }
    return `${prefix}-${value.current}`;
}

});

parcelRegister("iTDkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1be00365ac69a7$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");

var $i2fgf = parcelRequire("i2fgf");

var $iN8hK = parcelRequire("iN8hK");

var $dHJvE = parcelRequire("dHJvE");
function $dc1be00365ac69a7$var$EligibilityPage({ title: title, text: text, buttonText: buttonText, onButtonClick: onButtonClick, isEligible: isEligible, showButton: showButton, subText: subText, noIcon: noIcon, customPage: customPage }) {
    let icon = null;
    if (!noIcon) icon = isEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $iN8hK.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $i2fgf.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $dHJvE.default), {
        buttonText: buttonText,
        customPage: customPage,
        icon: icon,
        onButtonClick: onButtonClick,
        showButton: showButton,
        subText: subText,
        text: text,
        title: title
    });
}
$dc1be00365ac69a7$var$EligibilityPage.defaultProps = {
    buttonText: undefined,
    customPage: {},
    isEligible: false,
    noIcon: false,
    onButtonClick: undefined,
    showButton: false,
    subText: undefined,
    text: undefined,
    title: undefined
};
var $dc1be00365ac69a7$export$2e2bcd8739ae039 = $dc1be00365ac69a7$var$EligibilityPage;

});
parcelRegister("i2fgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2144070faf4ef3a$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
function $d2144070faf4ef3a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        viewBox: "0 0 258 158",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z",
        id: "a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z",
        id: "c"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M4.623 1.56l-.343-.343-1.36 1.36-1.36-1.36-.343.343 1.36 1.36-1.36 1.36.343.343 1.36-1.36 1.36 1.36.343-.343-1.36-1.36z",
        id: "e"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z",
        id: "g"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M17.032 2.839c-7.835 0-14.193 6.358-14.193 14.193 0 7.834 6.358 14.193 14.193 14.193 7.834 0 14.193-6.359 14.193-14.193 0-7.835-6.359-14.193-14.193-14.193zm1.419 21.29h-2.839v-2.84h2.839v2.84zm0-5.678h-2.839V9.935h2.839v8.516z",
        id: "i"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "129.197",
        cy: "149.222",
        fill: "#F0F1F1",
        rx: "59.124",
        ry: "8.778"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#BABFC0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "rotate(-180 98.175 34.014)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "38.037",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M13.148 0h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM11.685 35.111h8.023v5.852h-8.023a2.926 2.926 0 1 1 0-5.852z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(0 27.065)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "2.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "64.964",
        cy: "64.37",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "43.796",
        cy: "20.481",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M20.444 0h61.308v5.852H20.444a2.926 2.926 0 1 1 0-5.852zM75.192 26.333h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM73.729 61.444h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852zM58.394 35.111h23.358v17.556H58.394a8.76 8.76 0 0 1-8.759-8.76v-.037a8.76 8.76 0 0 1 8.76-8.759z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(81.752)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#BABFC0",
        height: "122.889",
        rx: "5.839",
        width: "94.891"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#FFF",
        height: "111.185",
        rx: "2.92",
        width: "83.212",
        x: "5.839",
        y: "5.852"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 99.481h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 99.481)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#005B86",
        mask: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 87.777h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 87.778)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#c"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#c"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#005B86",
        mask: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 76.074h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 76.074)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#e"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#193159",
        fillRule: "nonzero",
        xlinkHref: "#e"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#FA6428",
        mask: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 64.37h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 64.37)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#g"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#g"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#005B86",
        mask: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(29.927 17.556)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h34.063v34.063H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "j"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#i"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#FFF",
        fillRule: "nonzero",
        transform: "matrix(1 0 0 -1 0 34.063)",
        xlinkHref: "#i"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#FA6428",
        mask: "url(#j)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h34.009v34.035H0z"
    }))))));
}

});

parcelRegister("iN8hK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae33adfe9479f38$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
function $dae33adfe9479f38$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        viewBox: "0 0 258 158",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M47.032 47.302l-2.058-1.873c-7.31-6.629-12.135-11-12.135-16.365 0-4.371 3.434-7.806 7.806-7.806 2.47 0 4.84 1.15 6.387 2.966 1.547-1.816 3.917-2.966 6.386-2.966 4.372 0 7.807 3.435 7.807 7.806 0 5.365-4.826 9.736-12.135 16.379l-2.058 1.86z",
        id: "a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "129.197",
        cy: "148.278",
        fill: "#F0F1F1",
        rx: "59.124",
        ry: "8.722"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#BABFC0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "rotate(-180 98.175 33.799)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "37.796",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M13.12 0h6.588v8.722H13.12a4.361 4.361 0 1 1 0-8.722zM11.667 34.889h8.041v5.815h-8.041a2.907 2.907 0 1 1 0-5.815z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(0 26.894)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "2.907",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "64.964",
        cy: "63.963",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "43.796",
        cy: "20.352",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M20.426 0h61.326v5.815H20.426a2.907 2.907 0 1 1 0-5.815zM75.164 26.167h6.588v8.722h-6.588a4.361 4.361 0 0 1 0-8.722zM73.71 61.056h8.042v5.814H73.71a2.907 2.907 0 1 1 0-5.815z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M58.357 34.889h23.395v17.444H58.357a8.722 8.722 0 0 1 0-17.444z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(81.752)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#BABFC0",
        height: "122.111",
        rx: "5.839",
        width: "94.891"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#FFF",
        height: "110.481",
        rx: "2.92",
        width: "83.212",
        x: "5.839",
        y: "5.815"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#F0F1F1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M23.358 98.852h48.175v5.815H23.358zM23.358 87.222h48.175v5.815H23.358zM23.358 75.593h48.175v5.815H23.358zM23.358 63.963h48.175v5.815H23.358z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M30 17h34.063v34.063H30z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#DC143C",
        fillRule: "nonzero",
        xlinkHref: "#a"
    }))));
}

});

parcelRegister("dHJvE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa297bbb7a7eb1a$export$2e2bcd8739ae039; });

var $7YYXE = parcelRequire("7YYXE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");

var $1YSJM = parcelRequire("1YSJM");

var $h5HRh = parcelRequire("h5HRh");

var $kvHhM = parcelRequire("kvHhM");
const $9fa297bbb7a7eb1a$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            display: "flex",
            flexGrow: 1,
            overflow: "auto"
        },
        container: {
            flexGrow: 1,
            width: "100%",
            maxWidth: 750,
            margin: "auto",
            textAlign: "center",
            padding: "0 30px",
            [theme.breakpoints.down("sm")]: {
                padding: "20px 10px"
            },
            "& > *": {
                marginBottom: 28,
                "&:first-child": {
                    marginTop: 56,
                    [theme.breakpoints.down("xs")]: {
                        marginTop: 28
                    }
                },
                "&:last-child": {
                    marginBottom: 56
                }
            }
        },
        iconContainer: {
            maxWidth: "100%",
            maxHeight: 200,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,
            [theme.breakpoints.down("sm")]: {
                height: 100
            },
            "& svg": {
                height: "100%"
            }
        }
    }));
function $9fa297bbb7a7eb1a$var$Md(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        ...props,
        overrideComponents: {
            p: (elProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", elProps)
        }
    });
}
function $9fa297bbb7a7eb1a$var$MessagePage({ icon: icon, title: title, text: text, showButton: showButton, buttonText: buttonText, onButtonClick: onButtonClick, subText: subText, customPage: customPage }) {
    const aria = (0, $1YSJM.default)();
    const classes = $9fa297bbb7a7eb1a$var$useStyles();
    const _text = customPage.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($9fa297bbb7a7eb1a$var$Md, {
        tags: customPage.tags
    }, customPage.text) : text;
    const _subText = customPage.subText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($9fa297bbb7a7eb1a$var$Md, {
        tags: customPage.tags
    }, customPage.subText) : subText;
    const buttonClickHandler = ()=>onButtonClick(customPage.buttonAction);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root,
        ...aria
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.container
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-hidden": "true",
        className: classes.iconContainer
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), {
        noUnderline: !_text && !_subText
    }, customPage.title || title), _text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), null, _text), _subText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.SubtleText), {
        variant: "subtitle1"
    }, _subText), showButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        color: "primary",
        onClick: buttonClickHandler,
        variant: "contained"
    }, customPage.buttonText || buttonText)));
}
$9fa297bbb7a7eb1a$var$MessagePage.defaultProps = {
    buttonText: undefined,
    customPage: {},
    icon: null,
    onButtonClick: undefined,
    showButton: false,
    subText: undefined,
    text: undefined
};
var $9fa297bbb7a7eb1a$export$2e2bcd8739ae039 = $9fa297bbb7a7eb1a$var$MessagePage;

});


parcelRegister("ki4tF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec58f63519aad129$export$2e2bcd8739ae039; });

var $6WDy5 = parcelRequire("6WDy5");
parcelRequire("cQNHH");

var $8dv03 = parcelRequire("8dv03");
function $ec58f63519aad129$export$2e2bcd8739ae039() {
    var theme = (0, $6WDy5.default)() || (0, $8dv03.default);
    return theme;
}

});

parcelRegister("fpN3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38f3e2033a8b759$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");

var $jB5O2 = parcelRequire("jB5O2");
var $6WDy5 = parcelRequire("6WDy5");
function $b38f3e2033a8b759$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $6WDy5.default)();
    var props = (0, $jB5O2.default)({
        theme: theme,
        name: "MuiUseMediaQuery",
        props: {}
    });
    var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    var _props$options = (0, $gtn2B.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $cQNHH.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $cQNHH.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
}

});

parcelRegister("ioHzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d64c4587dc185195$export$2e2bcd8739ae039; });

var $7YYXE = parcelRequire("7YYXE");

var $gqYIj = parcelRequire("gqYIj");

var $fG0QW = parcelRequire("fG0QW");

var $7b1Lp = parcelRequire("7b1Lp");
var $6WDy5 = parcelRequire("6WDy5");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $d64c4587dc185195$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            maxWidth: 290,
            width: "100%",
            textTransform: "none",
            [theme.breakpoints.down("xs")]: {
                maxWidth: "100%"
            },
            "& > span > :not(:last-child)": {
                marginRight: theme.direction === "ltr" && "10px",
                marginLeft: theme.direction === "rtl" && "10px"
            }
        },
        filler: {
            flex: "0 1 24px",
            display: "block"
        },
        childContainer: {
            flexGrow: 1
        },
        arrowLeft: {
            left: 5
        },
        arrowRight: {
            right: 5
        }
    }));
function $d64c4587dc185195$var$ButtonWithArrow({ children: children, arrowSide: arrowSide, compact: compact, hideText: hideText, ...buttonProps }) {
    const classes = $d64c4587dc185195$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        className: classes.root,
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d64c4587dc185195$var$ArrowSide, {
        arrowSide: arrowSide,
        compact: compact,
        hideText: hideText
    }, children));
}
function $d64c4587dc185195$var$ArrowSide({ arrowSide: arrowSide, compact: compact, hideText: hideText, children: children }) {
    const classes = $d64c4587dc185195$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, arrowSide === "left" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d64c4587dc185195$var$ArrowSideLeft, null) : !compact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: classes.filler
    }), !hideText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.childContainer
    }, children), arrowSide === "right" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d64c4587dc185195$var$ArrowSideRight, null) : !compact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: classes.filler
    }));
}
function $d64c4587dc185195$var$ArrowSideLeft() {
    const classes = $d64c4587dc185195$var$useStyles();
    const theme = (0, $6WDy5.default)();
    return theme.direction === "rtl" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fG0QW))), {
        className: classes.arrowRight
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gqYIj))), {
        className: classes.arrowLeft
    });
}
function $d64c4587dc185195$var$ArrowSideRight() {
    const classes = $d64c4587dc185195$var$useStyles();
    const theme = (0, $6WDy5.default)();
    return theme.direction === "rtl" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gqYIj))), {
        className: classes.arrowLeft
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fG0QW))), {
        className: classes.arrowRight
    });
}
$d64c4587dc185195$var$ArrowSide.defaultProps = {
    arrowSide: "right",
    compact: false,
    hideText: false
};
$d64c4587dc185195$var$ButtonWithArrow.defaultProps = {
    arrowSide: "right",
    color: "inherit",
    compact: false,
    hideText: false
};
var $d64c4587dc185195$export$2e2bcd8739ae039 = $d64c4587dc185195$var$ButtonWithArrow;

});
parcelRegister("gqYIj", function(module, exports) {
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf6e2b8988242713$var$React = $8jEx7((parcelRequire("cQNHH")));

var $bf6e2b8988242713$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $bf6e2b8988242713$var$_default = (0, $bf6e2b8988242713$var$_createSvgIcon.default)(/*#__PURE__*/ $bf6e2b8988242713$var$React.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");
module.exports.default = $bf6e2b8988242713$var$_default;

});

parcelRegister("fG0QW", function(module, exports) {
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b69b70a505936db5$var$React = $8jEx7((parcelRequire("cQNHH")));

var $b69b70a505936db5$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $b69b70a505936db5$var$_default = (0, $b69b70a505936db5$var$_createSvgIcon.default)(/*#__PURE__*/ $b69b70a505936db5$var$React.createElement("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
module.exports.default = $b69b70a505936db5$var$_default;

});


parcelRegister("k4Dr6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9d2c58d5a97a323$export$2e2bcd8739ae039; });

var $lHE6I = parcelRequire("lHE6I");

var $ki4tF = parcelRequire("ki4tF");

var $fpN3t = parcelRequire("fpN3t");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
parcelRequire("8u8eZ");

var $jge0r = parcelRequire("jge0r");

var $ioHzT = parcelRequire("ioHzT");
const $e9d2c58d5a97a323$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            width: "100%",
            backgroundColor: "white",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
            zIndex: 100,
            display: "flex",
            flex: "0 0 auto",
            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
                justifyContent: "space-around"
            },
            "@media print": {
                display: "none"
            }
        },
        children: {
            flexGrow: 1,
            padding: "7px 16px",
            display: "flex",
            alignItems: "center"
        },
        buttons: {
            display: "flex",
            flexGrow: 1,
            "& > *": {
                padding: "7px 16px",
                display: "flex",
                alignItems: "center"
            }
        },
        spacer: {
            flexGrow: 1,
            padding: 0
        },
        backButton: {
            color: theme.palette.grey[600],
            "& > *": {
                minWidth: 0
            },
            [theme.breakpoints.down("xs")]: {
                minWidth: "48px",
                paddingRight: 0
            }
        },
        warningButton: {
            paddingRight: 0,
            color: theme.palette.warning.main
        },
        continueButton: {
            minWidth: 200,
            "& > *": {
                width: "100%"
            },
            [theme.breakpoints.down("xs")]: {
                width: "100%"
            }
        }
    }));
function $e9d2c58d5a97a323$var$Footer({ children: children, formIsComplete: formIsComplete, onBackClick: onBackClick, onContinueClick: onContinueClick, footerText: footerText, loading: loading, liveRegionId: liveRegionId, warning: warning, nextPageName: nextPageName, prevPageName: prevPageName }) {
    const theme = (0, $ki4tF.default)();
    const small = (0, $fpN3t.default)(theme.breakpoints.down("xs"));
    const classes = $e9d2c58d5a97a323$var$useStyles();
    const isSubmitPage = nextPageName === "completed";
    const nextBtnText = footerText || (isSubmitPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Submit",
        id: "Footer.submit"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Next",
        id: "Footer.next"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("footer", {
        className: classes.root
    }, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.children
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.buttons
    }, onBackClick && prevPageName && prevPageName !== "questionnaire" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.backButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ioHzT.default), {
        "data-testid": "back-button",
        "aria-controls": liveRegionId,
        arrowSide: "left",
        compact: true,
        hideText: small,
        onClick: onBackClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Back",
        id: "Footer.back"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: classes.spacer
    }), warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.warningButton
    }, warning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.continueButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ioHzT.default), {
        "data-testid": "continue-button",
        "aria-controls": liveRegionId,
        color: "primary",
        compact: true,
        disabled: !formIsComplete || loading,
        onClick: ()=>{
            if (isSubmitPage && formIsComplete) (0, $jge0r.userMetrics).track("Submit button pressed");
            onContinueClick();
        },
        variant: "contained"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $lHE6I.default), {
        size: 28
    }) : nextBtnText))));
}
$e9d2c58d5a97a323$var$Footer.defaultProps = {
    children: undefined,
    loading: false,
    nextPageName: undefined,
    onBackClick: undefined,
    prevPageName: undefined,
    warning: undefined
};
var $e9d2c58d5a97a323$export$2e2bcd8739ae039 = $e9d2c58d5a97a323$var$Footer;

});

parcelRegister("lAtLk", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = Promise.all([
    $iWqN5("ikSDi"),
    $iWqN5("4Ks7K")
]).then(()=>parcelRequire("7kKfH"));

});
parcelRegister("iWqN5", function(module, exports) {
"use strict";

function $dca26cdb128fd356$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("c5HCY")).resolve(id));
}
module.exports = $dca26cdb128fd356$var$load;

});


parcelRegister("XF2by", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = Promise.all([
    $iWqN5("hUWfe"),
    $iWqN5("7ADK3")
]).then(()=>parcelRequire("fSdGL"));

});

parcelRegister("kYYQv", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = Promise.all([
    $iWqN5("hUWfe"),
    $iWqN5("ikSDi"),
    $iWqN5("dJ5dO")
]).then(()=>parcelRequire("hvptt"));

});

parcelRegister("7VhxQ", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = $iWqN5("fRSG6").then(()=>parcelRequire("dhDqy"));

});

parcelRegister("1rrDX", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("lCfIL", function(module, exports) {

$parcel$export(module.exports, "useRequest", function () { return $fbc95774681ad017$export$7fba1a658e28476a; });
$parcel$export(module.exports, "useAPI", function () { return $fbc95774681ad017$export$67a65489846e51f3; });
$parcel$export(module.exports, "initSession", function () { return $fbc95774681ad017$export$403ed9a23f6abb2d; });

var $cQNHH = parcelRequire("cQNHH");

var $5dlN6 = parcelRequire("5dlN6");
/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */ function $fbc95774681ad017$var$checkStatus(response) {
    if (response.status >= 200 && response.status < 300) return response;
    // TODO: ensure backend renders 404 when studyId/locale is missing
    // https://app.bugsnag.com/trialbee/self-assessment/errors/6475360bfecaf70008d4989f?event_id=65a50b4600d0018894110000&i=wh&m=nw
    const error = new Error(response.statusText || `Status: ${response.status}`);
    error.response = response;
    throw error;
}
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */ function $fbc95774681ad017$var$parseJSON(response) {
    if (response.status === 204 || response.status === 205) return null;
    return response.json();
}
async function $fbc95774681ad017$var$makeRequest({ config: config, method: method, url: url, body: body, sessionToken: sessionToken }) {
    let receivedToken = sessionToken;
    try {
        const headers = {
            "Content-Type": "application/json"
        };
        if (sessionToken) headers["TB-Session-Token"] = sessionToken;
        const res = await fetch(`${config.baseURI}${url}`, {
            method: method,
            credentials: "include",
            mode: "cors",
            body: body ? JSON.stringify(body) : undefined,
            headers: new Headers(headers)
        });
        $fbc95774681ad017$var$checkStatus(res);
        const json = await $fbc95774681ad017$var$parseJSON(res);
        /**
     * HACK: This is stored mainly because of Safari handling cookies in an iframe poorly. See more in
     * the `osa` rest endpoint in external-api-service.
     */ if (res.headers.has("TB-Session-Token")) receivedToken = res.headers.get("TB-Session-Token");
        return [
            json,
            receivedToken
        ];
    } catch (error) {
        (0, $5dlN6.notifyError)({
            error: error,
            body: body
        });
        let errorCode = "unknownError";
        if (error instanceof Error) errorCode = error;
        else if (error instanceof Object) ({ errorCode: errorCode } = error);
        return [
            null,
            receivedToken,
            errorCode
        ];
    }
}
function $fbc95774681ad017$export$7fba1a658e28476a(request, ...params) {
    const [result, setResult] = (0, $cQNHH.useState)(null);
    (0, $cQNHH.useEffect)(()=>{
        request(...params).then((res)=>setResult(res));
    }, [
        ...params
    ]);
    return [
        result === null,
        result
    ];
}
function $fbc95774681ad017$export$67a65489846e51f3(config, sessionToken) {
    const [error, setError] = (0, $cQNHH.useState)(null);
    const api = (0, $cQNHH.useMemo)(()=>{
        async function _makeRequest(method, url, body) {
            const [json, _, errorCode] = await $fbc95774681ad017$var$makeRequest({
                config: config,
                method: method,
                url: url,
                body: body,
                sessionToken: sessionToken
            });
            setError(errorCode);
            return json;
        }
        return {
            submitQuestion (id, answer) {
                return _makeRequest("PUT", `/question/${id}`, {
                    answer: answer
                });
            },
            getQuestionnaireResults () {
                return _makeRequest("GET", "/questionnaireResults");
            },
            submitSite ({ id: id, studyId: studyId }) {
                return _makeRequest("PUT", "/site", {
                    siteId: id,
                    studyId: studyId
                });
            },
            submitContactDetails (contactDetails) {
                return _makeRequest("PUT", "/contactDetails", contactDetails);
            },
            dropoutCandidate () {
                return _makeRequest("PUT", "/dropout");
            },
            finalizeSession () {
                return _makeRequest("POST", "/finalize");
            }
        };
    }, [
        config.baseURI,
        config.studyId,
        config.locale,
        sessionToken
    ]);
    return [
        api,
        error
    ];
}
async function $fbc95774681ad017$export$403ed9a23f6abb2d(config) {
    const { studyId: studyId, ...body } = config;
    const [json, receivedToken, errorCode] = await $fbc95774681ad017$var$makeRequest({
        config: config,
        method: "POST",
        url: `/init/${studyId}`,
        body: body
    });
    if (errorCode) throw String(errorCode);
    return [
        json,
        receivedToken
    ];
}

});
parcelRegister("5dlN6", function(module, exports) {

$parcel$export(module.exports, "startBugSnag", function () { return $3cbf11e213b2f990$export$7cb39e07eacf6673; });
$parcel$export(module.exports, "notifyError", function () { return $3cbf11e213b2f990$export$740944ffd2f8d33e; });
$parcel$export(module.exports, "ErrorBoundary", function () { return $3cbf11e213b2f990$export$e926676385687eaf; });

var $d1bFm = parcelRequire("d1bFm");

var $7xuSA = parcelRequire("7xuSA");

var $cQNHH = parcelRequire("cQNHH");

var $4ScnI = parcelRequire("4ScnI");
const $3cbf11e213b2f990$var$getEnvironment = (url)=>{
    try {
        if (url.includes("app.trialbee.com")) return "preview";
        else if (url.includes("trialbee.com")) return "production";
        else if (url.includes("stage.trialbee.xyz")) return "stage";
        else if (url.includes("dev.trialbee.xyz")) return "dev";
        else if (url.includes("local.trialbee.xyz")) return "local";
    } catch (_) {}
    return "unknown";
};
const $3cbf11e213b2f990$export$7cb39e07eacf6673 = (config)=>{
    const { studyId: studyId, locale: locale, baseURI: baseURI, landingPage: landingPage } = config;
    (0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))).start({
        apiKey: "2da0f97bc911d81177881caf1438a7e0",
        plugins: [
            new (0, (/*@__PURE__*/$parcel$interopDefault($7xuSA)))()
        ],
        releaseStage: $3cbf11e213b2f990$var$getEnvironment(window.location.hostname),
        enabledReleaseStages: [
            "production",
            "stage",
            "dev",
            "unknown",
            "preview"
        ],
        appType: "react",
        appVersion: (0, $4ScnI.version) || "unknown",
        metadata: {
            baseURI: baseURI,
            studyId: studyId,
            locale: locale,
            landingPage: landingPage,
            version: $4ScnI.version
        }
    });
};
const $3cbf11e213b2f990$export$740944ffd2f8d33e = ({ error: error, body: body })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))).notify(error, {
        request: body
    });
};
function $3cbf11e213b2f990$export$e926676385687eaf(props) {
    const ReactErrorBoundary = (0, $cQNHH.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))).getPlugin("react").createErrorBoundary((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH)))), [
        (0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH)))
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(ReactErrorBoundary, props);
}

});
parcelRegister("d1bFm", function(module, exports) {

module.exports = (parcelRequire("iUAyZ"));

});

parcelRegister("7xuSA", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$src_1 = {};
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    _$src_1 = /*#__PURE__*/ function() {
        function BugsnagPluginReact() {
            // Fetch React from the window object, if it exists
            var globalReact = typeof window !== "undefined" && window.React;
            this.name = "react";
            this.lazy = arguments.length === 0 && !globalReact;
            if (!this.lazy) {
                this.React = (arguments.length <= 0 ? undefined : arguments[0]) || globalReact;
                if (!this.React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
            }
        }
        var _proto = BugsnagPluginReact.prototype;
        _proto.load = function load(client) {
            if (!this.lazy) {
                var ErrorBoundary = createClass(this.React, client);
                ErrorBoundary.createErrorBoundary = function() {
                    return ErrorBoundary;
                };
                return ErrorBoundary;
            }
            var BugsnagPluginReactLazyInitializer = function() {
                throw new Error("@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:\nPass React to the plugin constructor\n\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })`\nand then call `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()`\n\nOr if React is not available until after Bugsnag has started,\nconstruct the plugin with no arguments\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact()] })`,\nthen pass in React when available to construct your error boundary\n  `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)`");
            };
            BugsnagPluginReactLazyInitializer.createErrorBoundary = function(React) {
                if (!React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
                return createClass(React, client);
            };
            return BugsnagPluginReactLazyInitializer;
        };
        return BugsnagPluginReact;
    }();
    var formatComponentStack = function(str) {
        var lines = str.split(/\s*\n\s*/g);
        var ret = "";
        for(var line = 0, len = lines.length; line < len; line++)if (lines[line].length) ret += "" + (ret.length ? "\n" : "") + lines[line];
        return ret;
    };
    var createClass = function(React, client) {
        return /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    error: null,
                    info: null
                };
                _this.handleClearError = _this.handleClearError.bind(_assertThisInitialized(_this));
                return _this;
            }
            var _proto2 = ErrorBoundary.prototype;
            _proto2.handleClearError = function handleClearError() {
                this.setState({
                    error: null,
                    info: null
                });
            };
            _proto2.componentDidCatch = function componentDidCatch(error, info) {
                var onError = this.props.onError;
                var handledState = {
                    severity: "error",
                    unhandled: true,
                    severityReason: {
                        type: "unhandledException"
                    }
                };
                var event = client.Event.create(error, true, handledState, 1);
                if (info && info.componentStack) info.componentStack = formatComponentStack(info.componentStack);
                event.addMetadata("react", info);
                client._notify(event, onError);
                this.setState({
                    error: error,
                    info: info
                });
            };
            _proto2.render = function render() {
                var error = this.state.error;
                if (error) {
                    var FallbackComponent = this.props.FallbackComponent;
                    if (FallbackComponent) return React.createElement(FallbackComponent, _extends({}, this.state, {
                        clearError: this.handleClearError
                    }));
                    return null;
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React.Component);
    };
    _$src_1.formatComponentStack = formatComponentStack;
    _$src_1["default"] = _$src_1;
    return _$src_1;
});

});

parcelRegister("4ScnI", function(module, exports) {
module.exports = JSON.parse('{"name":"trialbee-self-assessment","version":"1.30.2","private":true,"api":"dist/prescreener.js","targets":{"api":{"source":"src/prescreener/prescreener.js","distDir":"./dist","engines":{"browsers":"> 0.25%, not dead"}},"app":{"source":"src/prescreener/selfAssessment.html","distDir":"./dist","engines":{"browsers":"> 0.25%, not dead"}}},"engines":{"node":">=18.17.1"},"scripts":{"dev":"echo \'\uD83D\uDEA8 Please use super-honey instead - `dev-frontend up widget`\'","dev:docker":"npm-run-all -p dev:docker:*","dev:docker:parcel":"parcel --host 0.0.0.0 --no-cache --hmr-port 1236 --hmr-host 127.0.0.1  --no-hmr","dev:docker:caddy":"caddy run --watch --config /code/Caddyfile","build":"parcel build --no-cache","clean":"rm -rf dist/ .parcel-cache","start":"node dist/server.js","build_local":"npm-run-all -p build_local:replace:*","lint":"eslint src","test":"echo Disabled jest","test:size":"SIZE_LIMIT_CONFIG=\\"prescreener\\" size-limit --no-running-time","test:watch":"jest --watch","translations:pull":"mkdir -p ./dist/locale; npx poeditor-ci pull","translations:expand":"babel-node --experimental-modules ./common/scripts/expandLanguages.mjs","translations:clean":"babel-node ./common/scripts/cleanLanguages.js"},"dependencies":{"@babel/polyfill":"^7.12.1","@babel/runtime":"^7.22.3","@bugsnag/browser":"^7.20.0","@bugsnag/js":"^7.20.0","@bugsnag/plugin-react":"^7.19.0","@formatjs/intl-pluralrules":"^1.5.2","@formatjs/intl-relativetimeformat":"^4.5.9","@material-ui/core":"^4.12.3","@material-ui/icons":"^4.11.2","@material-ui/styles":"^4.11.4","@trialbee/eligibility-validator":"0.1.6","body-scroll-lock":"^2.6.4","classnames":"^2.2.6","color":"^3.1.2","core-js":"^3.6.4","cors":"^2.8.5","debounce":"^1.2.0","express":"^4.17.1","gherkin-lint":"^4.2.4","google-map-react":"^1.1.6","jexl":"^2.2.2","jss":"^10.8.2","jss-rtl":"^0.3.0","libphonenumber-js":"^1.7.40","lodash.get":"^4.4.2","lodash.merge":"^4.6.2","lodash.mergewith":"^4.6.2","mixpanel-browser":"^2.45.0","path":"^0.12.7","prop-types":"^15.7.2","react":"^16.12.0","react-dom":"^16.12.0","react-intl":"^6.5.5","react-phone-input-2":"^2.11.0","remark":"^11.0.2","remark-react":"^6.0.0","smoothscroll-polyfill":"^0.4.4","string-placeholder":"^1.0.2","validate.js":"^0.13.1"},"devDependencies":{"@babel/cli":"^7.23.4","@babel/core":"^7.23.7","@babel/eslint-parser":"^7.23.3","@babel/node":"^7.22.19","@babel/plugin-proposal-class-properties":"^7.18.6","@babel/plugin-syntax-dynamic-import":"^7.8.3","@babel/plugin-syntax-jsx":"^7.23.3","@babel/plugin-transform-runtime":"^7.23.7","@babel/preset-env":"^7.23.8","@babel/preset-react":"^7.23.3","babel-eslint":"^10.1.0","babel-plugin-add-module-exports":"^1.0.2","babel-plugin-react-intl":"^7.5.18","babel-plugin-transform-react-remove-prop-types":"^0.4.24","bugsnag-sourcemaps":"^1.3.0","eslint":"^8.56.0","eslint-config-airbnb":"^19.0.4","eslint-config-prettier":"^9.1.0","eslint-plugin-import":"^2.29.1","eslint-plugin-jest":"^27.6.3","eslint-plugin-json":"^3.1.0","eslint-plugin-jsx-a11y":"^6.8.0","eslint-plugin-prettier":"^5.1.3","eslint-plugin-react":"^7.33.2","eslint-plugin-react-hooks":"^4.6.0","events":"^3.1.0","get-port":"^5.1.1","jest":"^24","nodemon":"^3.0.3","npm-run-all":"^4.1.5","parcel":"^2.11.0","path-browserify":"^1.0.1","prettier":"3.1.1","size-limit":"^11.0.2"},"eslintConfig":{"extends":"react-app"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}');

});




var $815Xb = parcelRequire("815Xb");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("1xEYC");


var $2FoLs = parcelRequire("2FoLs");

var $6WDy5 = parcelRequire("6WDy5");

var $49sgH = parcelRequire("49sgH");
function $2bb9b1e646170ca5$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $815Xb.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $2bb9b1e646170ca5$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $6WDy5.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $2bb9b1e646170ca5$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $49sgH.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2FoLs.default).Provider, {
        value: theme
    }, children);
}
var $2bb9b1e646170ca5$export$2e2bcd8739ae039 = $2bb9b1e646170ca5$var$ThemeProvider;



var $cQNHH = parcelRequire("cQNHH");

var $dLwnG = parcelRequire("dLwnG");
var $649299cff7f987fa$exports = {};
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    $649299cff7f987fa$exports = {
        polyfill: polyfill
    };
})();



var $5dlN6 = parcelRequire("5dlN6");
function $134249fea87571b9$export$a587e606f93a3767(userAgent) {
    return userAgent.match(/(?:MSIE|Trident)/);
}
function $134249fea87571b9$export$f357a97864275ebe(callback) {
    const el = document.createElement("div");
    // Styling
    el.style.position = "fixed";
    el.style.top = "0";
    el.style.right = "0";
    el.style.bottom = "0";
    el.style.left = "0";
    el.style.backgroundColor = "#000000";
    el.style.width = "100%";
    el.style.height = "100%";
    // Click to close
    el.onclick = ()=>{
        el.parentNode.removeChild(el);
        callback();
    };
    // Content
    const content = document.createElement("span");
    content.style.color = "#fff";
    content.style.textAlign = "center";
    content.style.width = "100%";
    content.style.display = "block";
    content.style.padding = "20%";
    content.style.boxSizing = "border-box";
    content.innerHTML = "Your web browser is out of date. Please switch to another browser to continue with signing up for the study. Click anywhere on this page to close this warning.";
    el.appendChild(content);
    return el;
}



var $hFJEF = parcelRequire("hFJEF");
// Default config for both self-assessment
const $0ed8d10c3555ce9e$var$DEFAULT_CONFIG = {
    locale: "en_US",
    colorMain: "#005B86",
    fontFamily: "Poppins, sans-serif",
    fontInclude: "https://fonts.googleapis.com/css?family=Poppins:400,600&display=swap",
    autoScroll: false
};
function $0ed8d10c3555ce9e$var$customizer(objValue, srcValue, key) {
    if (!srcValue) return objValue;
    if (key === "contactForm" || key === "steps") return srcValue;
    return undefined;
}
function $0ed8d10c3555ce9e$var$mergeConfigs(...configs) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hFJEF)))({}, $0ed8d10c3555ce9e$var$DEFAULT_CONFIG, ...configs, $0ed8d10c3555ce9e$var$customizer);
}
var $0ed8d10c3555ce9e$export$2e2bcd8739ae039 = $0ed8d10c3555ce9e$var$mergeConfigs;



var $elwbS = parcelRequire("elwbS");
var $366d7e75857fe306$exports = {};
"use strict";
var $c49a0977e70d9aa3$exports = {};
/* MIT license */ var $0716198b0a558eb3$exports = {};
"use strict";
$0716198b0a558eb3$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $0a96f3f09beefc56$exports = {};
"use strict";
var $162f7e076b4294b5$exports = {};
$162f7e076b4294b5$exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};


var $0a96f3f09beefc56$var$concat = Array.prototype.concat;
var $0a96f3f09beefc56$var$slice = Array.prototype.slice;
var $0a96f3f09beefc56$var$swizzle = $0a96f3f09beefc56$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($162f7e076b4294b5$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $0a96f3f09beefc56$var$concat.call(results, $0a96f3f09beefc56$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$0a96f3f09beefc56$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($0a96f3f09beefc56$var$swizzle(arguments));
    };
};


var $c49a0977e70d9aa3$var$reverseNames = {};
// create a list of reverse color names
for(var $c49a0977e70d9aa3$var$name in $0716198b0a558eb3$exports)if ($0716198b0a558eb3$exports.hasOwnProperty($c49a0977e70d9aa3$var$name)) $c49a0977e70d9aa3$var$reverseNames[$0716198b0a558eb3$exports[$c49a0977e70d9aa3$var$name]] = $c49a0977e70d9aa3$var$name;
var $c49a0977e70d9aa3$var$cs = $c49a0977e70d9aa3$exports = {
    to: {},
    get: {}
};
$c49a0977e70d9aa3$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $c49a0977e70d9aa3$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $c49a0977e70d9aa3$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $c49a0977e70d9aa3$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$c49a0977e70d9aa3$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var keyword = /(\D+)/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) rgb[3] = parseFloat(match[4]);
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) rgb[3] = parseFloat(match[4]);
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        rgb = $0716198b0a558eb3$exports[match[1]];
        if (!rgb) return null;
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $c49a0977e70d9aa3$var$clamp(rgb[i], 0, 255);
    rgb[3] = $c49a0977e70d9aa3$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$c49a0977e70d9aa3$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) + 360) % 360;
        var s = $c49a0977e70d9aa3$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $c49a0977e70d9aa3$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $c49a0977e70d9aa3$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$c49a0977e70d9aa3$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $c49a0977e70d9aa3$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $c49a0977e70d9aa3$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $c49a0977e70d9aa3$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$c49a0977e70d9aa3$var$cs.to.hex = function() {
    var rgba = $0a96f3f09beefc56$exports(arguments);
    return "#" + $c49a0977e70d9aa3$var$hexDouble(rgba[0]) + $c49a0977e70d9aa3$var$hexDouble(rgba[1]) + $c49a0977e70d9aa3$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $c49a0977e70d9aa3$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$c49a0977e70d9aa3$var$cs.to.rgb = function() {
    var rgba = $0a96f3f09beefc56$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$c49a0977e70d9aa3$var$cs.to.rgb.percent = function() {
    var rgba = $0a96f3f09beefc56$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$c49a0977e70d9aa3$var$cs.to.hsl = function() {
    var hsla = $0a96f3f09beefc56$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$c49a0977e70d9aa3$var$cs.to.hwb = function() {
    var hwba = $0a96f3f09beefc56$exports(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$c49a0977e70d9aa3$var$cs.to.keyword = function(rgb) {
    return $c49a0977e70d9aa3$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $c49a0977e70d9aa3$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $c49a0977e70d9aa3$var$hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}


var $0f497461630e3c95$exports = {};
var $d472b51d48917ca4$exports = {};
/* MIT license */ var $7c9a8b0cdbbe0cb5$exports = {};
"use strict";
$7c9a8b0cdbbe0cb5$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var $d472b51d48917ca4$var$reverseKeywords = {};
for(var $d472b51d48917ca4$var$key in $7c9a8b0cdbbe0cb5$exports)if ($7c9a8b0cdbbe0cb5$exports.hasOwnProperty($d472b51d48917ca4$var$key)) $d472b51d48917ca4$var$reverseKeywords[$7c9a8b0cdbbe0cb5$exports[$d472b51d48917ca4$var$key]] = $d472b51d48917ca4$var$key;
var $d472b51d48917ca4$var$convert = $d472b51d48917ca4$exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
// hide .channels and .labels properties
for(var $d472b51d48917ca4$var$model in $d472b51d48917ca4$var$convert)if ($d472b51d48917ca4$var$convert.hasOwnProperty($d472b51d48917ca4$var$model)) {
    if (!("channels" in $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model])) throw new Error("missing channels property: " + $d472b51d48917ca4$var$model);
    if (!("labels" in $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model])) throw new Error("missing channel labels property: " + $d472b51d48917ca4$var$model);
    if ($d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].labels.length !== $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].channels) throw new Error("channel and label counts mismatch: " + $d472b51d48917ca4$var$model);
    var $d472b51d48917ca4$var$channels = $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].channels;
    var $d472b51d48917ca4$var$labels = $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].labels;
    delete $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].channels;
    delete $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].labels;
    Object.defineProperty($d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model], "channels", {
        value: $d472b51d48917ca4$var$channels
    });
    Object.defineProperty($d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model], "labels", {
        value: $d472b51d48917ca4$var$labels
    });
}
$d472b51d48917ca4$var$convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = $d472b51d48917ca4$var$convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function $d472b51d48917ca4$var$comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
$d472b51d48917ca4$var$convert.rgb.keyword = function(rgb) {
    var reversed = $d472b51d48917ca4$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in $7c9a8b0cdbbe0cb5$exports)if ($7c9a8b0cdbbe0cb5$exports.hasOwnProperty(keyword)) {
        var value = $7c9a8b0cdbbe0cb5$exports[keyword];
        // Compute comparative distance
        var distance = $d472b51d48917ca4$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$d472b51d48917ca4$var$convert.keyword.rgb = function(keyword) {
    return $7c9a8b0cdbbe0cb5$exports[keyword];
};
$d472b51d48917ca4$var$convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.lab = function(rgb) {
    var xyz = $d472b51d48917ca4$var$convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$d472b51d48917ca4$var$convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$d472b51d48917ca4$var$convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$d472b51d48917ca4$var$convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$d472b51d48917ca4$var$convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$d472b51d48917ca4$var$convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$d472b51d48917ca4$var$convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$d472b51d48917ca4$var$convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$d472b51d48917ca4$var$convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$d472b51d48917ca4$var$convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$d472b51d48917ca4$var$convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$d472b51d48917ca4$var$convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$d472b51d48917ca4$var$convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : $d472b51d48917ca4$var$convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$d472b51d48917ca4$var$convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return $d472b51d48917ca4$var$convert.rgb.ansi16($d472b51d48917ca4$var$convert.hsv.rgb(args), args[2]);
};
$d472b51d48917ca4$var$convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$d472b51d48917ca4$var$convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$d472b51d48917ca4$var$convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$d472b51d48917ca4$var$convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$d472b51d48917ca4$var$convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
        return char + char;
    }).join("");
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$d472b51d48917ca4$var$convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$d472b51d48917ca4$var$convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$d472b51d48917ca4$var$convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$d472b51d48917ca4$var$convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$d472b51d48917ca4$var$convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$d472b51d48917ca4$var$convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$d472b51d48917ca4$var$convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$d472b51d48917ca4$var$convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$d472b51d48917ca4$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$d472b51d48917ca4$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$d472b51d48917ca4$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$d472b51d48917ca4$var$convert.gray.hsl = $d472b51d48917ca4$var$convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$d472b51d48917ca4$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$d472b51d48917ca4$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$d472b51d48917ca4$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$d472b51d48917ca4$var$convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$d472b51d48917ca4$var$convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $a29b8262ef492f6d$exports = {};

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $a29b8262ef492f6d$var$buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys($d472b51d48917ca4$exports);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $a29b8262ef492f6d$var$deriveBFS(fromModel) {
    var graph = $a29b8262ef492f6d$var$buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys($d472b51d48917ca4$exports[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $a29b8262ef492f6d$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $a29b8262ef492f6d$var$wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = $d472b51d48917ca4$exports[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $a29b8262ef492f6d$var$link($d472b51d48917ca4$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$a29b8262ef492f6d$exports = function(fromModel) {
    var graph = $a29b8262ef492f6d$var$deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $a29b8262ef492f6d$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


var $0f497461630e3c95$var$convert = {};
var $0f497461630e3c95$var$models = Object.keys($d472b51d48917ca4$exports);
function $0f497461630e3c95$var$wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $0f497461630e3c95$var$wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$0f497461630e3c95$var$models.forEach(function(fromModel) {
    $0f497461630e3c95$var$convert[fromModel] = {};
    Object.defineProperty($0f497461630e3c95$var$convert[fromModel], "channels", {
        value: $d472b51d48917ca4$exports[fromModel].channels
    });
    Object.defineProperty($0f497461630e3c95$var$convert[fromModel], "labels", {
        value: $d472b51d48917ca4$exports[fromModel].labels
    });
    var routes = $a29b8262ef492f6d$exports(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        $0f497461630e3c95$var$convert[fromModel][toModel] = $0f497461630e3c95$var$wrapRounded(fn);
        $0f497461630e3c95$var$convert[fromModel][toModel].raw = $0f497461630e3c95$var$wrapRaw(fn);
    });
});
$0f497461630e3c95$exports = $0f497461630e3c95$var$convert;


var $366d7e75857fe306$var$_slice = [].slice;
var $366d7e75857fe306$var$skippedModels = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // gray conflicts with some method names, and has its own method defined.
    "gray",
    // shouldn't really be in color-convert either...
    "hex"
];
var $366d7e75857fe306$var$hashedModelKeys = {};
Object.keys($0f497461630e3c95$exports).forEach(function(model) {
    $366d7e75857fe306$var$hashedModelKeys[$366d7e75857fe306$var$_slice.call($0f497461630e3c95$exports[model].labels).sort().join("")] = model;
});
var $366d7e75857fe306$var$limiters = {};
function $366d7e75857fe306$var$Color(obj, model) {
    if (!(this instanceof $366d7e75857fe306$var$Color)) return new $366d7e75857fe306$var$Color(obj, model);
    if (model && model in $366d7e75857fe306$var$skippedModels) model = null;
    if (model && !(model in $0f497461630e3c95$exports)) throw new Error("Unknown model: " + model);
    var i;
    var channels;
    if (obj == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof $366d7e75857fe306$var$Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === "string") {
        var result = $c49a0977e70d9aa3$exports.get(obj);
        if (result === null) throw new Error("Unable to parse color from string: " + obj);
        this.model = result.model;
        channels = $0f497461630e3c95$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || "rgb";
        channels = $0f497461630e3c95$exports[this.model].channels;
        var newArr = $366d7e75857fe306$var$_slice.call(obj, 0, channels);
        this.color = $366d7e75857fe306$var$zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === "number" ? obj[channels] : 1;
    } else if (typeof obj === "number") {
        // this is always RGB - can be converted later on.
        obj &= 0xFFFFFF;
        this.model = "rgb";
        this.color = [
            obj >> 16 & 0xFF,
            obj >> 8 & 0xFF,
            obj & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ("alpha" in obj) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof obj.alpha === "number" ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $366d7e75857fe306$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(obj));
        this.model = $366d7e75857fe306$var$hashedModelKeys[hashedKeys];
        var labels = $0f497461630e3c95$exports[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(obj[labels[i]]);
        this.color = $366d7e75857fe306$var$zeroArray(color);
    }
    // perform limitations (clamping, etc.)
    if ($366d7e75857fe306$var$limiters[this.model]) {
        channels = $0f497461630e3c95$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = $366d7e75857fe306$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$366d7e75857fe306$var$Color.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(places) {
        var self = this.model in $c49a0977e70d9aa3$exports.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $c49a0977e70d9aa3$exports.to[self.model](args);
    },
    percentString: function(places) {
        var self = this.rgb().round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $c49a0977e70d9aa3$exports.to.rgb.percent(args);
    },
    array: function() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        var result = {};
        var channels = $0f497461630e3c95$exports[this.model].channels;
        var labels = $0f497461630e3c95$exports[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function(places) {
        places = Math.max(places || 0, 0);
        return new $366d7e75857fe306$var$Color(this.color.map($366d7e75857fe306$var$roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function(val) {
        if (arguments.length) return new $366d7e75857fe306$var$Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        return this.valpha;
    },
    // rgb
    red: $366d7e75857fe306$var$getset("rgb", 0, $366d7e75857fe306$var$maxfn(255)),
    green: $366d7e75857fe306$var$getset("rgb", 1, $366d7e75857fe306$var$maxfn(255)),
    blue: $366d7e75857fe306$var$getset("rgb", 2, $366d7e75857fe306$var$maxfn(255)),
    hue: $366d7e75857fe306$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, function(val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: $366d7e75857fe306$var$getset("hsl", 1, $366d7e75857fe306$var$maxfn(100)),
    lightness: $366d7e75857fe306$var$getset("hsl", 2, $366d7e75857fe306$var$maxfn(100)),
    saturationv: $366d7e75857fe306$var$getset("hsv", 1, $366d7e75857fe306$var$maxfn(100)),
    value: $366d7e75857fe306$var$getset("hsv", 2, $366d7e75857fe306$var$maxfn(100)),
    chroma: $366d7e75857fe306$var$getset("hcg", 1, $366d7e75857fe306$var$maxfn(100)),
    gray: $366d7e75857fe306$var$getset("hcg", 2, $366d7e75857fe306$var$maxfn(100)),
    white: $366d7e75857fe306$var$getset("hwb", 1, $366d7e75857fe306$var$maxfn(100)),
    wblack: $366d7e75857fe306$var$getset("hwb", 2, $366d7e75857fe306$var$maxfn(100)),
    cyan: $366d7e75857fe306$var$getset("cmyk", 0, $366d7e75857fe306$var$maxfn(100)),
    magenta: $366d7e75857fe306$var$getset("cmyk", 1, $366d7e75857fe306$var$maxfn(100)),
    yellow: $366d7e75857fe306$var$getset("cmyk", 2, $366d7e75857fe306$var$maxfn(100)),
    black: $366d7e75857fe306$var$getset("cmyk", 3, $366d7e75857fe306$var$maxfn(100)),
    x: $366d7e75857fe306$var$getset("xyz", 0, $366d7e75857fe306$var$maxfn(100)),
    y: $366d7e75857fe306$var$getset("xyz", 1, $366d7e75857fe306$var$maxfn(100)),
    z: $366d7e75857fe306$var$getset("xyz", 2, $366d7e75857fe306$var$maxfn(100)),
    l: $366d7e75857fe306$var$getset("lab", 0, $366d7e75857fe306$var$maxfn(100)),
    a: $366d7e75857fe306$var$getset("lab", 1),
    b: $366d7e75857fe306$var$getset("lab", 2),
    keyword: function(val) {
        if (arguments.length) return new $366d7e75857fe306$var$Color(val);
        return $0f497461630e3c95$exports[this.model].keyword(this.color);
    },
    hex: function(val) {
        if (arguments.length) return new $366d7e75857fe306$var$Color(val);
        return $c49a0977e70d9aa3$exports.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $366d7e75857fe306$var$Color.rgb(val, val, val);
    },
    fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function(mixinColor, weight) {
        // ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return $366d7e75857fe306$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// model conversion methods and static constructors
Object.keys($0f497461630e3c95$exports).forEach(function(model) {
    if ($366d7e75857fe306$var$skippedModels.indexOf(model) !== -1) return;
    var channels = $0f497461630e3c95$exports[model].channels;
    // conversion methods
    $366d7e75857fe306$var$Color.prototype[model] = function() {
        if (this.model === model) return new $366d7e75857fe306$var$Color(this);
        if (arguments.length) return new $366d7e75857fe306$var$Color(arguments, model);
        var newAlpha = typeof arguments[channels] === "number" ? channels : this.valpha;
        return new $366d7e75857fe306$var$Color($366d7e75857fe306$var$assertArray($0f497461630e3c95$exports[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    // 'static' construction methods
    $366d7e75857fe306$var$Color[model] = function(color) {
        if (typeof color === "number") color = $366d7e75857fe306$var$zeroArray($366d7e75857fe306$var$_slice.call(arguments), channels);
        return new $366d7e75857fe306$var$Color(color, model);
    };
});
function $366d7e75857fe306$var$roundTo(num, places) {
    return Number(num.toFixed(places));
}
function $366d7e75857fe306$var$roundToPlace(places) {
    return function(num) {
        return $366d7e75857fe306$var$roundTo(num, places);
    };
}
function $366d7e75857fe306$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    model.forEach(function(m) {
        ($366d7e75857fe306$var$limiters[m] || ($366d7e75857fe306$var$limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function(val) {
        var result;
        if (arguments.length) {
            if (modifier) val = modifier(val);
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $366d7e75857fe306$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $366d7e75857fe306$var$assertArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $366d7e75857fe306$var$zeroArray(arr, length) {
    for(var i = 0; i < length; i++)if (typeof arr[i] !== "number") arr[i] = 0;
    return arr;
}
$366d7e75857fe306$exports = $366d7e75857fe306$var$Color;


function $03fa2a80882ee47c$export$2e2bcd8739ae039({ colorMain: colorMain, colorLight: colorLight, fontFamily: fontFamily, textDirection: textDirection }) {
    const greyscale = {
        50: "#FAFAFA",
        100: "#F7F7F7",
        200: "#EEEEEE",
        300: "#DFDFDF",
        350: "#BABFC0",
        400: "#939393",
        500: "#7F7F7F",
        600: "#6B6B6B",
        700: "#525252",
        800: "#393939",
        900: "#1C1C1C"
    };
    const clearSky = {
        main: "#00A8EE"
    };
    const autumn = {
        main: "#FF4E4E"
    };
    const summer = {
        main: "#FEBE36",
        extraLight: "#FFF8E8"
    };
    const spring = {
        main: "#6FC922"
    };
    const primaryColor = (0, (/*@__PURE__*/$parcel$interopDefault($366d7e75857fe306$exports)))(colorMain).hex();
    const primaryColorLight = colorLight ? (0, (/*@__PURE__*/$parcel$interopDefault($366d7e75857fe306$exports)))(colorLight).hex() : (0, (/*@__PURE__*/$parcel$interopDefault($366d7e75857fe306$exports)))(primaryColor).lighten(2.6).desaturate(0.3).hex();
    const primaryPalette = {
        main: primaryColor,
        extraLight: primaryColorLight
    };
    return (0, $elwbS.default)({
        direction: textDirection,
        palette: {
            white: "#ffffff",
            grey: greyscale,
            primary: {
                main: primaryPalette.main,
                extraLight: primaryPalette.extraLight
            },
            secondary: clearSky,
            error: autumn,
            success: spring,
            warning: summer
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 930,
                xl: 1280
            }
        },
        spacing: 10,
        typography: {
            fontFamily: fontFamily,
            h1: {
                fontWeight: 600,
                fontSize: 16,
                color: greyscale[700],
                lineHeight: "22px"
            },
            h2: {
                color: greyscale[700],
                fontWeight: 600,
                fontSize: 26,
                lineHeight: "36px",
                marginBottom: 28,
                position: "relative",
                textAlign: "center",
                '&[underline="true"]': {
                    paddingBottom: 28,
                    "&:after": {
                        display: "block",
                        content: '""',
                        position: "absolute",
                        width: 96,
                        height: 4,
                        borderRadius: 2,
                        backgroundColor: primaryPalette.main,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        margin: "0 auto"
                    }
                }
            },
            h3: {
                fontWeight: 400,
                fontSize: 16,
                color: greyscale[800],
                lineHeight: 1.8
            },
            h4: {
                fontWeight: 500,
                fontSize: 16,
                marginBottom: 50,
                color: greyscale[800],
                lineHeight: 1.6
            },
            h5: {
                fontWeight: 400,
                fontSize: 16,
                color: greyscale[700],
                lineHeight: "16px"
            },
            body1: {
                fontSize: 16,
                marginBottom: 20
            },
            body2: {
                fontWeight: 500,
                fontSize: 13,
                color: greyscale[600],
                lineHeight: 1.6
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    fontSize: 16,
                    margin: "5px 0",
                    minHeight: "48px",
                    minWidth: "100px",
                    borderRadius: "4px",
                    textTransform: "none",
                    "&$disabled": {
                        borderColor: "#eee",
                        backgroundColor: "#eee",
                        color: greyscale[400]
                    },
                    "&:hover": {
                        "background-color": primaryPalette.extraLight
                    }
                },
                text: {
                    color: primaryPalette.main,
                    backgroundColor: "transparent",
                    "&:focus": {
                        backgroundColor: primaryPalette.extraLight
                    }
                },
                outlined: {
                    border: `1px solid ${primaryPalette.main}`,
                    backgroundColor: "transparent"
                },
                contained: {
                    backgroundColor: "white",
                    color: greyscale[600],
                    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.24)"
                },
                containedPrimary: {
                    color: "white",
                    backgroundColor: primaryPalette.main,
                    "@media (hover: none)": {
                        "&:hover": {
                            backgroundColor: "inherit"
                        }
                    }
                },
                sizeSmall: {
                    padding: "8px 12px",
                    fontWeight: 600,
                    margin: 0,
                    minHeight: 0,
                    "& svg": {
                        fontSize: "20px"
                    }
                },
                disabled: {}
            },
            MuiLinearProgress: {
                root: {
                    width: "100%",
                    backgroundColor: primaryPalette.extraLight,
                    "border-radius": "5px",
                    "box-shadow": "inset 0px 2px 0px rgba(0,0,0,0.1)",
                    height: "10px"
                },
                bar: {
                    backgroundColor: primaryPalette.main,
                    "border-radius": "5px"
                }
            },
            MuiListItem: {
                root: {
                    backgroundColor: "#fff"
                },
                divider: {
                    borderBottom: "1px solid rgb(223, 222, 222)"
                },
                button: {
                    "&:hover": {
                        backgroundColor: greyscale[100]
                    }
                }
            },
            MuiInput: {
                root: {
                    "&:after, &:before": {
                        display: "none"
                    }
                }
            },
            MuiInputBase: {
                root: {
                    lineHeight: "24px",
                    "&$disabled": {
                        boxShadow: "none !important"
                    },
                    "&$error": {
                        borderColor: `${autumn.main} !important`
                    }
                },
                input: {
                    boxSizing: "border-box"
                }
            },
            MuiSelect: {
                root: {
                    height: "100%"
                },
                selectMenu: {
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: 16
                },
                select: {
                    width: "100%",
                    height: "100%",
                    paddingLeft: 16
                }
            },
            MuiRadio: {
                colorSecondary: {
                    color: primaryPalette.main,
                    "&.Mui-checked": {
                        color: primaryPalette.main
                    }
                }
            },
            MuiCheckbox: {
                colorSecondary: {
                    color: primaryPalette.main,
                    "&.Mui-checked": {
                        color: primaryPalette.main
                    }
                }
            },
            MuiFormControl: {
                root: {
                    width: "100%",
                    "& > div:not(label)": {
                        // This is essentially just the input component inside the `FromControl`.
                        marginTop: "24px",
                        border: `1px solid ${greyscale[350]}`,
                        borderRadius: 4,
                        height: 48,
                        overflow: "hidden",
                        "& > input": {
                            width: "100%",
                            height: "100%",
                            padding: "0 16px",
                            border: "none",
                            background: "transparent",
                            "&:focus": {
                                background: "rgba(0, 0, 0, 0.05)"
                            }
                        }
                    },
                    "& > label": {
                        color: `${greyscale[700]} !important`,
                        width: "130%"
                    }
                }
            },
            MuiFormHelperText: {
                root: {
                    color: autumn.main,
                    marginTop: -15
                }
            },
            MuiTypography: {
                gutterBottom: {
                    marginBottom: "1em"
                }
            }
        }
    });
}



var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $IPPAR = parcelRequire("IPPAR");
/* eslint-disable react/prop-types */ 
var $iCH0W = parcelRequire("iCH0W");
var $1krVc = parcelRequire("1krVc");

var $ipwm3 = parcelRequire("ipwm3");
var $cbcf587276a09605$exports = {};
"use strict";
Object.defineProperty($cbcf587276a09605$exports, "__esModule", {
    value: true
});
var $5633fe0b92143340$exports = {};

$parcel$defineInteropFlag($5633fe0b92143340$exports);

$parcel$export($5633fe0b92143340$exports, "default", function () { return $5633fe0b92143340$export$2e2bcd8739ae039; });
/**
 * Takes an array of [keyValue1, keyValue2] pairs and creates an object of {keyValue1: keyValue2, keyValue2: keyValue1}
 * @param {Array} array the array of pairs
 * @return {Object} the {key, value} pair object
 */ function $1a7d5cdda8bc4e95$export$2d1720544b23b823(array) {
    return array.reduce(function(obj, _ref) {
        var prop1 = _ref[0], prop2 = _ref[1];
        obj[prop1] = prop2;
        obj[prop2] = prop1;
        return obj;
    }, {});
}
function $1a7d5cdda8bc4e95$export$953cecd6e717a553(val) {
    return typeof val === "boolean";
}
function $1a7d5cdda8bc4e95$export$7ccc53e8f1e7dfc5(val) {
    return typeof val === "function";
}
function $1a7d5cdda8bc4e95$export$9e5f44173e64f162(val) {
    return typeof val === "number";
}
function $1a7d5cdda8bc4e95$export$ae1af26003f05816(val) {
    return val === null || typeof val === "undefined";
}
function $1a7d5cdda8bc4e95$export$43caf9889c228507(val) {
    return val && typeof val === "object";
}
function $1a7d5cdda8bc4e95$export$2408f22a0fab9ae5(val) {
    return typeof val === "string";
}
function $1a7d5cdda8bc4e95$export$882b5998b3b9117c(inclusive, inclusee) {
    return inclusive.indexOf(inclusee) !== -1;
}
/**
 * Flip the sign of a CSS value, possibly with a unit.
 *
 * We can't just negate the value with unary minus due to the units.
 *
 * @private
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example -77%)
 */ function $1a7d5cdda8bc4e95$export$35e795649ee09318(value) {
    if (parseFloat(value) === 0) // Don't mangle zeroes
    return value;
    if (value[0] === "-") return value.slice(1);
    return "-" + value;
}
function $1a7d5cdda8bc4e95$export$23f2a1d2818174ef(match, prefix, offset, suffix) {
    return prefix + $1a7d5cdda8bc4e95$export$35e795649ee09318(offset) + suffix;
}
/**
 * Takes a percentage for background position and inverts it.
 * This was copied and modified from CSSJanus:
 * https://github.com/cssjanus/cssjanus/blob/4245f834365f6cfb0239191a151432fb85abab23/src/cssjanus.js#L152-L175
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example 23%)
 */ function $1a7d5cdda8bc4e95$export$dda1d9f60106f0e9(value) {
    var idx = value.indexOf(".");
    if (idx === -1) value = 100 - parseFloat(value) + "%";
    else {
        // Two off, one for the "%" at the end, one for the dot itself
        var len = value.length - idx - 2;
        value = 100 - parseFloat(value);
        value = value.toFixed(len) + "%";
    }
    return value;
}
/**
 * This takes a list of CSS values and converts it to an array
 * @param {String} value - something like `1px`, `1px 2em`, or `3pt rgb(150, 230, 550) 40px calc(100% - 5px)`
 * @return {Array} the split values (for example: `['3pt', 'rgb(150, 230, 550)', '40px', 'calc(100% - 5px)']`)
 */ function $1a7d5cdda8bc4e95$export$625550452a3fa3ec(value) {
    return value.replace(/ +/g, " ") // remove all extraneous spaces
    .split(" ").map(function(i) {
        return i.trim();
    }) // get rid of extra space before/after each item
    .filter(Boolean) // get rid of empty strings
    // join items which are within parenthese
    // luckily `calc (100% - 5px)` is invalid syntax and it must be `calc(100% - 5px)`, otherwise this would be even more complex
    .reduce(function(_ref2, item) {
        var list = _ref2.list, state = _ref2.state;
        var openParansCount = (item.match(/\(/g) || []).length;
        var closedParansCount = (item.match(/\)/g) || []).length;
        if (state.parensDepth > 0) list[list.length - 1] = list[list.length - 1] + " " + item;
        else list.push(item);
        state.parensDepth += openParansCount - closedParansCount;
        return {
            list: list,
            state: state
        };
    }, {
        list: [],
        state: {
            parensDepth: 0
        }
    }).list;
}
/**
 * This is intended for properties that are `top right bottom left` and will switch them to `top left bottom right`
 * @param {String} value - `1px 2px 3px 4px` for example, but also handles cases where there are too few/too many and
 * simply returns the value in those cases (which is the correct behavior)
 * @return {String} the result - `1px 4px 3px 2px` for example.
 */ function $1a7d5cdda8bc4e95$export$342063e11d6c3cad(value) {
    var splitValues = $1a7d5cdda8bc4e95$export$625550452a3fa3ec(value);
    if (splitValues.length <= 3 || splitValues.length > 4) return value;
    var top = splitValues[0], right = splitValues[1], bottom = splitValues[2], left = splitValues[3];
    return [
        top,
        left,
        bottom,
        right
    ].join(" ");
}
var $1a7d5cdda8bc4e95$export$ffb5f4729a158638 = {
    padding: function padding(_ref) {
        var value = _ref.value;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
        return $1a7d5cdda8bc4e95$export$342063e11d6c3cad(value);
    },
    textShadow: function textShadow(_ref2) {
        var value = _ref2.value;
        // intentionally leaving off the `g` flag here because we only want to change the first number (which is the offset-x)
        return value.replace(/(-*)([.|\d]+)/, function(match, negative, number) {
            if (number === "0") return match;
            var doubleNegative = negative === "" ? "-" : "";
            return "" + doubleNegative + number;
        });
    },
    borderColor: function borderColor(_ref3) {
        var value = _ref3.value;
        return $1a7d5cdda8bc4e95$export$342063e11d6c3cad(value);
    },
    borderRadius: function borderRadius(_ref4) {
        var value = _ref4.value;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
        if ($1a7d5cdda8bc4e95$export$882b5998b3b9117c(value, "/")) {
            var _value$split = value.split("/"), radius1 = _value$split[0], radius2 = _value$split[1];
            var convertedRadius1 = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderRadius({
                value: radius1.trim()
            });
            var convertedRadius2 = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderRadius({
                value: radius2.trim()
            });
            return convertedRadius1 + " / " + convertedRadius2;
        }
        var splitValues = $1a7d5cdda8bc4e95$export$625550452a3fa3ec(value);
        switch(splitValues.length){
            case 2:
                return splitValues.reverse().join(" ");
            case 4:
                var topLeft = splitValues[0], topRight = splitValues[1], bottomRight = splitValues[2], bottomLeft = splitValues[3];
                return [
                    topRight,
                    topLeft,
                    bottomLeft,
                    bottomRight
                ].join(" ");
            default:
                return value;
        }
    },
    background: function background(_ref5) {
        var value = _ref5.value, valuesToConvert = _ref5.valuesToConvert, isRtl = _ref5.isRtl, bgImgDirectionRegex = _ref5.bgImgDirectionRegex, bgPosDirectionRegex = _ref5.bgPosDirectionRegex;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
         // Yeah, this is in need of a refactor 🙃...
        // but this property is a tough cookie 🍪
        // get the backgroundPosition out of the string by removing everything that couldn't be the backgroundPosition value
        var backgroundPositionValue = value.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g, "").trim(); // replace that backgroundPosition value with the converted version
        value = value.replace(backgroundPositionValue, $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition({
            value: backgroundPositionValue,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        })); // do the backgroundImage value replacing on the whole value (because why not?)
        return $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundImage({
            value: value,
            valuesToConvert: valuesToConvert,
            bgImgDirectionRegex: bgImgDirectionRegex
        });
    },
    backgroundImage: function backgroundImage(_ref6) {
        var value = _ref6.value, valuesToConvert = _ref6.valuesToConvert, bgImgDirectionRegex = _ref6.bgImgDirectionRegex;
        if (!$1a7d5cdda8bc4e95$export$882b5998b3b9117c(value, "url(") && !$1a7d5cdda8bc4e95$export$882b5998b3b9117c(value, "linear-gradient(")) return value;
        return value.replace(bgImgDirectionRegex, function(match, g1, group2) {
            return match.replace(group2, valuesToConvert[group2]);
        });
    },
    backgroundPosition: function backgroundPosition(_ref7) {
        var value = _ref7.value, valuesToConvert = _ref7.valuesToConvert, isRtl = _ref7.isRtl, bgPosDirectionRegex = _ref7.bgPosDirectionRegex;
        return value // intentionally only grabbing the first instance of this because that represents `left`
        .replace(isRtl ? /^((-|\d|\.)+%)/ : null, function(match, group) {
            return $1a7d5cdda8bc4e95$export$dda1d9f60106f0e9(group);
        }).replace(bgPosDirectionRegex, function(match) {
            return valuesToConvert[match];
        });
    },
    backgroundPositionX: function backgroundPositionX(_ref8) {
        var value = _ref8.value, valuesToConvert = _ref8.valuesToConvert, isRtl = _ref8.isRtl, bgPosDirectionRegex = _ref8.bgPosDirectionRegex;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
        return $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition({
            value: value,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        });
    },
    transition: function transition(_ref9) {
        var value = _ref9.value, propertiesToConvert = _ref9.propertiesToConvert;
        return value.split(/,\s*/g).map(function(transition) {
            var values = transition.split(" "); // Property is always defined first
            values[0] = propertiesToConvert[values[0]] || values[0];
            return values.join(" ");
        }).join(", ");
    },
    transitionProperty: function transitionProperty(_ref10) {
        var value = _ref10.value, propertiesToConvert = _ref10.propertiesToConvert;
        return value.split(/,\s*/g).map(function(prop) {
            return propertiesToConvert[prop] || prop;
        }).join(", ");
    },
    transform: function transform(_ref11) {
        var value = _ref11.value;
        // This was copied and modified from CSSJanus:
        // https://github.com/cssjanus/cssjanus/blob/4a40f001b1ba35567112d8b8e1d9d95eda4234c3/src/cssjanus.js#L152-L153
        var nonAsciiPattern = "[^\\u0020-\\u007e]";
        var escapePattern = "(?:(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)|\\\\[^\\r\\n\\f0-9a-f])";
        var signedQuantPattern = "((?:-?" + ("(?:[0-9]*\\.[0-9]+|[0-9]+)(?:\\s*(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)|" + ("-?" + ("(?:[_a-z]|" + nonAsciiPattern + "|" + escapePattern + ")") + ("(?:[_a-z0-9-]|" + nonAsciiPattern + "|" + escapePattern + ")") + "*") + ")?") + ")|(?:inherit|auto))";
        var translateXRegExp = new RegExp("(translateX\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", "gi");
        var translateRegExp = new RegExp("(translate\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,1}\\s*\\))", "gi");
        var translate3dRegExp = new RegExp("(translate3d\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,2}\\s*\\))", "gi");
        var rotateRegExp = new RegExp("(rotate[ZY]?\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", "gi");
        return value.replace(translateXRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef).replace(translateRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef).replace(translate3dRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef).replace(rotateRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef);
    }
};
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.objectPosition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.margin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.padding;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderWidth = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.padding;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderStyle = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderColor;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty; // kebab-case versions
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["text-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-color"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderColor;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-radius"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderRadius;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["background-image"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundImage;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["background-position"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["background-position-x"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPositionX;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["object-position"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.objectPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-width"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.padding;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["box-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-box-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-box-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-style"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderColor;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transform"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transform"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["transform-origin"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transform-origin"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transform-origin"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transition"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transition"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["transition-property"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transition-property"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transition-property"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
var $1a7d5cdda8bc4e95$export$407448d2b89b1813 = $1a7d5cdda8bc4e95$export$2d1720544b23b823([
    [
        "paddingLeft",
        "paddingRight"
    ],
    [
        "marginLeft",
        "marginRight"
    ],
    [
        "left",
        "right"
    ],
    [
        "borderLeft",
        "borderRight"
    ],
    [
        "borderLeftColor",
        "borderRightColor"
    ],
    [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    [
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ],
    [
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ],
    [
        "padding-left",
        "padding-right"
    ],
    [
        "margin-left",
        "margin-right"
    ],
    [
        "border-left",
        "border-right"
    ],
    [
        "border-left-color",
        "border-right-color"
    ],
    [
        "border-left-style",
        "border-right-style"
    ],
    [
        "border-left-width",
        "border-right-width"
    ],
    [
        "border-top-left-radius",
        "border-top-right-radius"
    ],
    [
        "border-bottom-left-radius",
        "border-bottom-right-radius"
    ]
]);
var $1a7d5cdda8bc4e95$export$8b22cf2602fb60ce = [
    "content"
]; // this is the same as the propertiesToConvert except for values
var $1a7d5cdda8bc4e95$export$90a7f3efeed30595 = $1a7d5cdda8bc4e95$export$2d1720544b23b823([
    [
        "ltr",
        "rtl"
    ],
    [
        "left",
        "right"
    ],
    [
        "w-resize",
        "e-resize"
    ],
    [
        "sw-resize",
        "se-resize"
    ],
    [
        "nw-resize",
        "ne-resize"
    ]
]); // Sorry for the regex 😞, but basically thisis used to replace _every_ instance of
// `ltr`, `rtl`, `right`, and `left` in `backgroundimage` with the corresponding opposite.
// A situation we're accepting here:
// url('/left/right/rtl/ltr.png') will be changed to url('/right/left/ltr/rtl.png')
// Definite trade-offs here, but I think it's a good call.
var $1a7d5cdda8bc4e95$var$bgImgDirectionRegex = new RegExp("(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)", "g");
var $1a7d5cdda8bc4e95$var$bgPosDirectionRegex = new RegExp("(left)|(right)");
/**
 * converts properties and values in the CSS in JS object to their corresponding RTL values
 * @param {Object} object the CSS in JS object
 * @return {Object} the RTL converted object
 */ function $1a7d5cdda8bc4e95$export$db3b6bfb95261072(object) {
    return Object.keys(object).reduce(function(newObj, originalKey) {
        var originalValue = object[originalKey];
        if ($1a7d5cdda8bc4e95$export$2408f22a0fab9ae5(originalValue)) // you're welcome to later code 😺
        originalValue = originalValue.trim();
         // Some properties should never be transformed
        if ($1a7d5cdda8bc4e95$export$882b5998b3b9117c($1a7d5cdda8bc4e95$export$8b22cf2602fb60ce, originalKey)) {
            newObj[originalKey] = originalValue;
            return newObj;
        }
        var _convertProperty = $1a7d5cdda8bc4e95$export$4368d992c4eafac0(originalKey, originalValue), key = _convertProperty.key, value = _convertProperty.value;
        newObj[key] = value;
        return newObj;
    }, Array.isArray(object) ? [] : {});
}
/**
 * Converts a property and its value to the corresponding RTL key and value
 * @param {String} originalKey the original property key
 * @param {Number|String|Object} originalValue the original css property value
 * @return {Object} the new {key, value} pair
 */ function $1a7d5cdda8bc4e95$export$4368d992c4eafac0(originalKey, originalValue) {
    var isNoFlip = /\/\*\s?@noflip\s?\*\//.test(originalValue);
    var key = isNoFlip ? originalKey : $1a7d5cdda8bc4e95$export$39b482c5e57630a8(originalKey);
    var value = isNoFlip ? originalValue : $1a7d5cdda8bc4e95$export$f1e1789686576879(key, originalValue);
    return {
        key: key,
        value: value
    };
}
/**
 * This gets the RTL version of the given property if it has a corresponding RTL property
 * @param {String} property the name of the property
 * @return {String} the name of the RTL property
 */ function $1a7d5cdda8bc4e95$export$39b482c5e57630a8(property) {
    return $1a7d5cdda8bc4e95$export$407448d2b89b1813[property] || property;
}
/**
 * This converts the given value to the RTL version of that value based on the key
 * @param {String} key this is the key (note: this should be the RTL version of the originalKey)
 * @param {String|Number|Object} originalValue the original css property value. If it's an object, then we'll convert that as well
 * @return {String|Number|Object} the converted value
 */ function $1a7d5cdda8bc4e95$export$f1e1789686576879(key, originalValue) {
    /* eslint complexity:[2, 10] */ // let's try to keep the complexity down... If we have to do this much more, let's break this up
    if ($1a7d5cdda8bc4e95$export$ae1af26003f05816(originalValue) || $1a7d5cdda8bc4e95$export$953cecd6e717a553(originalValue)) return originalValue;
    if ($1a7d5cdda8bc4e95$export$43caf9889c228507(originalValue)) return $1a7d5cdda8bc4e95$export$db3b6bfb95261072(originalValue); // recurssion 🌀
    var isNum = $1a7d5cdda8bc4e95$export$9e5f44173e64f162(originalValue);
    var isFunc = $1a7d5cdda8bc4e95$export$7ccc53e8f1e7dfc5(originalValue);
    var importantlessValue = isNum || isFunc ? originalValue : originalValue.replace(/ !important.*?$/, "");
    var isImportant = !isNum && importantlessValue.length !== originalValue.length;
    var valueConverter = $1a7d5cdda8bc4e95$export$ffb5f4729a158638[key];
    var newValue;
    if (valueConverter) newValue = valueConverter({
        value: importantlessValue,
        valuesToConvert: $1a7d5cdda8bc4e95$export$90a7f3efeed30595,
        propertiesToConvert: $1a7d5cdda8bc4e95$export$407448d2b89b1813,
        isRtl: true,
        bgImgDirectionRegex: $1a7d5cdda8bc4e95$var$bgImgDirectionRegex,
        bgPosDirectionRegex: $1a7d5cdda8bc4e95$var$bgPosDirectionRegex
    });
    else newValue = $1a7d5cdda8bc4e95$export$90a7f3efeed30595[importantlessValue] || importantlessValue;
    if (isImportant) return newValue + " !important";
    return newValue;
}


var $5633fe0b92143340$export$2e2bcd8739ae039 = (0, $1a7d5cdda8bc4e95$export$db3b6bfb95261072);


var $cbcf587276a09605$var$convert = $5633fe0b92143340$exports["default"] || $5633fe0b92143340$exports;
function $cbcf587276a09605$var$jssRTL(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enabled, enabled = _c === void 0 ? true : _c, _d = _b.opt, opt = _d === void 0 ? "out" : _d;
    return {
        onProcessStyle: function(style, rule, sheet) {
            if (rule.type === "font-face") return style;
            if (!enabled) {
                if (typeof style.flip === "boolean") delete style.flip;
                return style;
            }
            var flip = opt === "out"; // If it's set to opt-out, then it should flip by default
            if (typeof sheet.options.flip === "boolean") flip = sheet.options.flip;
            if (typeof style.flip === "boolean") {
                flip = style.flip;
                delete style.flip;
            }
            if (!flip) return style;
            return $cbcf587276a09605$var$convert(typeof rule.toJSON === "function" ? rule.toJSON() : style);
        }
    };
}
$cbcf587276a09605$exports.default = $cbcf587276a09605$var$jssRTL;



var $cQNHH = parcelRequire("cQNHH");
// Configure JSS
const $b93edc1652573c86$var$jss = (0, $ipwm3.create)({
    plugins: [
        ...(0, $iCH0W.default)().plugins,
        (0, (/*@__PURE__*/$parcel$interopDefault($cbcf587276a09605$exports)))()
    ]
});
function $b93edc1652573c86$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $1krVc.default), {
        jss: $b93edc1652573c86$var$jss
    }, children);
}


var $8be7ad1126c1e5b2$export$2e2bcd8739ae039 = (0, $b93edc1652573c86$export$2e2bcd8739ae039);



var $8mLXY = parcelRequire("8mLXY");

var $7b1Lp = parcelRequire("7b1Lp");
var $c9fdafd6c40a8204$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $c9fdafd6c40a8204$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $c9fdafd6c40a8204$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var $c9fdafd6c40a8204$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $c9fdafd6c40a8204$var$funcTag = "[object Function]", $c9fdafd6c40a8204$var$genTag = "[object GeneratorFunction]", $c9fdafd6c40a8204$var$symbolTag = "[object Symbol]";
/** Used to match property names within property paths. */ var $c9fdafd6c40a8204$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $c9fdafd6c40a8204$var$reIsPlainProp = /^\w*$/, $c9fdafd6c40a8204$var$reLeadingDot = /^\./, $c9fdafd6c40a8204$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c9fdafd6c40a8204$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $c9fdafd6c40a8204$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $c9fdafd6c40a8204$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $c9fdafd6c40a8204$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $c9fdafd6c40a8204$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c9fdafd6c40a8204$var$root = $c9fdafd6c40a8204$var$freeGlobal || $c9fdafd6c40a8204$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c9fdafd6c40a8204$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $c9fdafd6c40a8204$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $c9fdafd6c40a8204$var$arrayProto = Array.prototype, $c9fdafd6c40a8204$var$funcProto = Function.prototype, $c9fdafd6c40a8204$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $c9fdafd6c40a8204$var$coreJsData = $c9fdafd6c40a8204$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $c9fdafd6c40a8204$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($c9fdafd6c40a8204$var$coreJsData && $c9fdafd6c40a8204$var$coreJsData.keys && $c9fdafd6c40a8204$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $c9fdafd6c40a8204$var$funcToString = $c9fdafd6c40a8204$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c9fdafd6c40a8204$var$hasOwnProperty = $c9fdafd6c40a8204$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c9fdafd6c40a8204$var$objectToString = $c9fdafd6c40a8204$var$objectProto.toString;
/** Used to detect if a method is native. */ var $c9fdafd6c40a8204$var$reIsNative = RegExp("^" + $c9fdafd6c40a8204$var$funcToString.call($c9fdafd6c40a8204$var$hasOwnProperty).replace($c9fdafd6c40a8204$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $c9fdafd6c40a8204$var$Symbol = $c9fdafd6c40a8204$var$root.Symbol, $c9fdafd6c40a8204$var$splice = $c9fdafd6c40a8204$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $c9fdafd6c40a8204$var$Map = $c9fdafd6c40a8204$var$getNative($c9fdafd6c40a8204$var$root, "Map"), $c9fdafd6c40a8204$var$nativeCreate = $c9fdafd6c40a8204$var$getNative(Object, "create");
/** Used to convert symbols to primitives and strings. */ var $c9fdafd6c40a8204$var$symbolProto = $c9fdafd6c40a8204$var$Symbol ? $c9fdafd6c40a8204$var$Symbol.prototype : undefined, $c9fdafd6c40a8204$var$symbolToString = $c9fdafd6c40a8204$var$symbolProto ? $c9fdafd6c40a8204$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9fdafd6c40a8204$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c9fdafd6c40a8204$var$hashClear() {
    this.__data__ = $c9fdafd6c40a8204$var$nativeCreate ? $c9fdafd6c40a8204$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9fdafd6c40a8204$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9fdafd6c40a8204$var$hashGet(key) {
    var data = this.__data__;
    if ($c9fdafd6c40a8204$var$nativeCreate) {
        var result = data[key];
        return result === $c9fdafd6c40a8204$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c9fdafd6c40a8204$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9fdafd6c40a8204$var$hashHas(key) {
    var data = this.__data__;
    return $c9fdafd6c40a8204$var$nativeCreate ? data[key] !== undefined : $c9fdafd6c40a8204$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c9fdafd6c40a8204$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $c9fdafd6c40a8204$var$nativeCreate && value === undefined ? $c9fdafd6c40a8204$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$c9fdafd6c40a8204$var$Hash.prototype.clear = $c9fdafd6c40a8204$var$hashClear;
$c9fdafd6c40a8204$var$Hash.prototype["delete"] = $c9fdafd6c40a8204$var$hashDelete;
$c9fdafd6c40a8204$var$Hash.prototype.get = $c9fdafd6c40a8204$var$hashGet;
$c9fdafd6c40a8204$var$Hash.prototype.has = $c9fdafd6c40a8204$var$hashHas;
$c9fdafd6c40a8204$var$Hash.prototype.set = $c9fdafd6c40a8204$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9fdafd6c40a8204$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $c9fdafd6c40a8204$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9fdafd6c40a8204$var$listCacheDelete(key) {
    var data = this.__data__, index = $c9fdafd6c40a8204$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c9fdafd6c40a8204$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9fdafd6c40a8204$var$listCacheGet(key) {
    var data = this.__data__, index = $c9fdafd6c40a8204$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9fdafd6c40a8204$var$listCacheHas(key) {
    return $c9fdafd6c40a8204$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c9fdafd6c40a8204$var$listCacheSet(key, value) {
    var data = this.__data__, index = $c9fdafd6c40a8204$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$c9fdafd6c40a8204$var$ListCache.prototype.clear = $c9fdafd6c40a8204$var$listCacheClear;
$c9fdafd6c40a8204$var$ListCache.prototype["delete"] = $c9fdafd6c40a8204$var$listCacheDelete;
$c9fdafd6c40a8204$var$ListCache.prototype.get = $c9fdafd6c40a8204$var$listCacheGet;
$c9fdafd6c40a8204$var$ListCache.prototype.has = $c9fdafd6c40a8204$var$listCacheHas;
$c9fdafd6c40a8204$var$ListCache.prototype.set = $c9fdafd6c40a8204$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9fdafd6c40a8204$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c9fdafd6c40a8204$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $c9fdafd6c40a8204$var$Hash,
        "map": new ($c9fdafd6c40a8204$var$Map || $c9fdafd6c40a8204$var$ListCache),
        "string": new $c9fdafd6c40a8204$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9fdafd6c40a8204$var$mapCacheDelete(key) {
    return $c9fdafd6c40a8204$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9fdafd6c40a8204$var$mapCacheGet(key) {
    return $c9fdafd6c40a8204$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9fdafd6c40a8204$var$mapCacheHas(key) {
    return $c9fdafd6c40a8204$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c9fdafd6c40a8204$var$mapCacheSet(key, value) {
    $c9fdafd6c40a8204$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$c9fdafd6c40a8204$var$MapCache.prototype.clear = $c9fdafd6c40a8204$var$mapCacheClear;
$c9fdafd6c40a8204$var$MapCache.prototype["delete"] = $c9fdafd6c40a8204$var$mapCacheDelete;
$c9fdafd6c40a8204$var$MapCache.prototype.get = $c9fdafd6c40a8204$var$mapCacheGet;
$c9fdafd6c40a8204$var$MapCache.prototype.has = $c9fdafd6c40a8204$var$mapCacheHas;
$c9fdafd6c40a8204$var$MapCache.prototype.set = $c9fdafd6c40a8204$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c9fdafd6c40a8204$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($c9fdafd6c40a8204$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $c9fdafd6c40a8204$var$baseGet(object, path) {
    path = $c9fdafd6c40a8204$var$isKey(path, object) ? [
        path
    ] : $c9fdafd6c40a8204$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$c9fdafd6c40a8204$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c9fdafd6c40a8204$var$baseIsNative(value) {
    if (!$c9fdafd6c40a8204$var$isObject(value) || $c9fdafd6c40a8204$var$isMasked(value)) return false;
    var pattern = $c9fdafd6c40a8204$var$isFunction(value) || $c9fdafd6c40a8204$var$isHostObject(value) ? $c9fdafd6c40a8204$var$reIsNative : $c9fdafd6c40a8204$var$reIsHostCtor;
    return pattern.test($c9fdafd6c40a8204$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $c9fdafd6c40a8204$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($c9fdafd6c40a8204$var$isSymbol(value)) return $c9fdafd6c40a8204$var$symbolToString ? $c9fdafd6c40a8204$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$c9fdafd6c40a8204$var$INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $c9fdafd6c40a8204$var$castPath(value) {
    return $c9fdafd6c40a8204$var$isArray(value) ? value : $c9fdafd6c40a8204$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c9fdafd6c40a8204$var$getMapData(map, key) {
    var data = map.__data__;
    return $c9fdafd6c40a8204$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $c9fdafd6c40a8204$var$getNative(object, key) {
    var value = $c9fdafd6c40a8204$var$getValue(object, key);
    return $c9fdafd6c40a8204$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $c9fdafd6c40a8204$var$isKey(value, object) {
    if ($c9fdafd6c40a8204$var$isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $c9fdafd6c40a8204$var$isSymbol(value)) return true;
    return $c9fdafd6c40a8204$var$reIsPlainProp.test(value) || !$c9fdafd6c40a8204$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $c9fdafd6c40a8204$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c9fdafd6c40a8204$var$isMasked(func) {
    return !!$c9fdafd6c40a8204$var$maskSrcKey && $c9fdafd6c40a8204$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $c9fdafd6c40a8204$var$stringToPath = $c9fdafd6c40a8204$var$memoize(function(string) {
    string = $c9fdafd6c40a8204$var$toString(string);
    var result = [];
    if ($c9fdafd6c40a8204$var$reLeadingDot.test(string)) result.push("");
    string.replace($c9fdafd6c40a8204$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($c9fdafd6c40a8204$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c9fdafd6c40a8204$var$toKey(value) {
    if (typeof value == "string" || $c9fdafd6c40a8204$var$isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$c9fdafd6c40a8204$var$INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $c9fdafd6c40a8204$var$toSource(func) {
    if (func != null) {
        try {
            return $c9fdafd6c40a8204$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c9fdafd6c40a8204$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($c9fdafd6c40a8204$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($c9fdafd6c40a8204$var$memoize.Cache || $c9fdafd6c40a8204$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$c9fdafd6c40a8204$var$memoize.Cache = $c9fdafd6c40a8204$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c9fdafd6c40a8204$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c9fdafd6c40a8204$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $c9fdafd6c40a8204$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $c9fdafd6c40a8204$var$isObject(value) ? $c9fdafd6c40a8204$var$objectToString.call(value) : "";
    return tag == $c9fdafd6c40a8204$var$funcTag || tag == $c9fdafd6c40a8204$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $c9fdafd6c40a8204$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c9fdafd6c40a8204$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c9fdafd6c40a8204$var$isSymbol(value) {
    return typeof value == "symbol" || $c9fdafd6c40a8204$var$isObjectLike(value) && $c9fdafd6c40a8204$var$objectToString.call(value) == $c9fdafd6c40a8204$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c9fdafd6c40a8204$var$toString(value) {
    return value == null ? "" : $c9fdafd6c40a8204$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $c9fdafd6c40a8204$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c9fdafd6c40a8204$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
$c9fdafd6c40a8204$exports = $c9fdafd6c40a8204$var$get;



var $cQNHH = parcelRequire("cQNHH");

var $7YYXE = parcelRequire("7YYXE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
parcelRequire("8u8eZ");

var $1YSJM = parcelRequire("1YSJM");

var $jge0r = parcelRequire("jge0r");

var $h5HRh = parcelRequire("h5HRh");

var $kvHhM = parcelRequire("kvHhM");
const $9ba70814ad158a5d$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        content: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        closeText: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            margin: `0 ${theme.spacing(1)}px`,
            "& > *": {
                margin: `${theme.spacing(1)}px 0`
            }
        },
        closeButtons: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: theme.spacing(2),
            "& > *": {
                margin: `0 ${theme.spacing(1)}px`
            }
        }
    }));
function $9ba70814ad158a5d$var$ClosePrompt({ onCancel: onCancel, onClose: onClose, customPage: customPage }) {
    const aria = (0, $1YSJM.default)();
    const classes = $9ba70814ad158a5d$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.content,
        ...aria
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.closeText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), {
        variant: "h1"
    }, customPage.title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Are you sure you want to leave?",
        id: "Modal.closePrompt"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), null, customPage.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Any information you have entered will not be saved.",
        id: "Modal.closeDescription"
    })), customPage.subText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.SubtleText), {
        variant: "subtitle1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.subText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.closeButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        onClick: ()=>{
            (0, $jge0r.userMetrics).track("Leave button pressed");
            onClose(customPage.buttonAction);
        }
    }, customPage.buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Leave",
        id: "Modal.closeButton"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        color: "primary",
        onClick: onCancel,
        variant: "contained"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Go back",
        id: "Modal.closeCancel"
    }))));
}
$9ba70814ad158a5d$var$ClosePrompt.defaultProps = {
    customPage: {}
};
var $9ba70814ad158a5d$export$2e2bcd8739ae039 = $9ba70814ad158a5d$var$ClosePrompt;



var $8p3P7 = parcelRequire("8p3P7");

var $aJjY6 = parcelRequire("aJjY6");

var $bIgYU = parcelRequire("bIgYU");

var $97AH2 = parcelRequire("97AH2");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $c4XSV = parcelRequire("c4XSV");
var $kV13H = parcelRequire("kV13H");
var $szrnD = parcelRequire("szrnD");
parcelRequire("8u8eZ");

var $kvHhM = parcelRequire("kvHhM");

var $aJjY6 = parcelRequire("aJjY6");
var $b2b5f4d7507bba09$exports = {};
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty($b2b5f4d7507bba09$exports, "__esModule", {
    value: true
});
$b2b5f4d7507bba09$exports.default = void 0;

var $b2b5f4d7507bba09$var$React = $8jEx7((parcelRequire("cQNHH")));

var $b2b5f4d7507bba09$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $b2b5f4d7507bba09$var$_default = (0, $b2b5f4d7507bba09$var$_createSvgIcon.default)(/*#__PURE__*/ $b2b5f4d7507bba09$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
$b2b5f4d7507bba09$exports.default = $b2b5f4d7507bba09$var$_default;



var $7b1Lp = parcelRequire("7b1Lp");

var $1GRlU = parcelRequire("1GRlU");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $3be2f3118331ca5d$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            backgroundColor: "white",
            flex: "33.33%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "11px",
            color: theme.palette.grey[600],
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            lineHeight: "24px",
            fontFamily: theme.typography.fontFamily,
            "&:not(:last-of-type)": {
                borderRight: "1px solid #ccc"
            }
        },
        complete: {
            backgroundColor: theme.palette.primary.extraLight,
            color: theme.palette.primary.main,
            opacity: "0.5"
        },
        active: {
            backgroundColor: theme.palette.primary.main,
            color: "#fff",
            fontWeight: "bold"
        },
        default: {
            backgroundColor: "white"
        },
        icon: {
            marginLeft: 8,
            fontSize: 16,
            color: theme.palette.primary.main
        }
    }));
function $3be2f3118331ca5d$var$NavigationProgressItem({ item: item, progress: progress, index: index }) {
    const classes = $3be2f3118331ca5d$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aJjY6.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1GRlU)))(classes.root, {
            [classes.active]: progress === index
        }, {
            [classes.complete]: progress > index
        }, {
            [classes.default]: progress < index
        }),
        item: true
    }, item, progress > index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b2b5f4d7507bba09$exports))), {
        className: classes.icon
    }));
}
var $3be2f3118331ca5d$export$2e2bcd8739ae039 = $3be2f3118331ca5d$var$NavigationProgressItem;


const $01e80fff3c31a4e4$var$messages = (0, $c4XSV.defineMessages)({
    closeDialog: {
        "id": "Modal.CloseDialog",
        "defaultMessage": "Close dialog"
    }
});
const $01e80fff3c31a4e4$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            zIndex: 1000,
            backgroundColor: "white",
            "@media print": {
                display: "none"
            }
        },
        upper: {
            borderBottom: "1px solid #ccc",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            height: 72,
            [theme.breakpoints.down("xs")]: {
                height: 40
            }
        },
        closeButton: {
            position: "absolute",
            right: 16,
            color: "black",
            [theme.breakpoints.down("xs")]: {
                right: 0
            }
        },
        lower: {
            borderBottom: "1px solid #ccc"
        }
    }));
function $01e80fff3c31a4e4$var$NavigationProgress({ progress: progress, handleModalClose: handleModalClose, navItems: navItems, isHidden: isHidden, showCloseButton: showCloseButton, titleId: titleId, intl: { formatMessage: formatMessage } }) {
    const classes = $01e80fff3c31a4e4$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.upper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.Title), {
        id: titleId,
        variant: "h4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Sign up for study",
        id: "NavigationProgress.SignUp"
    })), showCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $bIgYU.default), {
        "aria-label": formatMessage($01e80fff3c31a4e4$var$messages.closeDialog),
        className: classes.closeButton,
        onClick: handleModalClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($97AH2))), null))), !isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-hidden": "true",
        className: classes.lower
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aJjY6.default), {
        container: true,
        direction: "row"
    }, navItems && navItems.map(({ label: label, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $3be2f3118331ca5d$export$2e2bcd8739ae039), {
            key: label.key,
            index: index,
            item: label,
            progress: progress
        })))));
}
$01e80fff3c31a4e4$var$NavigationProgress.defaultProps = {
    isHidden: false
};
var $01e80fff3c31a4e4$export$2e2bcd8739ae039 = (0, $szrnD.default)($01e80fff3c31a4e4$var$NavigationProgress);



var $53xQg = parcelRequire("53xQg");

var $2Hhgv = parcelRequire("2Hhgv");
parcelRequire("8u8eZ");
/* eslint-disable no-use-before-define */ 
var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
const $d2dddf4e60313517$var$getParams = window.location.search.substr(1).split("&").reduce((acc, keyValue)=>{
    const match = keyValue.match(/^(.+?)=(.+?)$/);
    if (!match) return acc;
    return {
        ...acc,
        [match[1]]: match[2]
    };
}, {});
function $d2dddf4e60313517$export$1cde898c5f939e7d(defaultValue, overrideName) {
    return defaultValue;
}


const $abbc1a8fae73e46a$export$302911c449e17ea4 = ({ steps: steps, sites: sites })=>{
    const [stepIndex, setStepIndex] = (0, $cQNHH.useState)((0, $d2dddf4e60313517$export$1cde898c5f939e7d)(0, "stepIndex"));
    const nextIndex = $abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, 1, steps, sites);
    const previousIndex = $abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, -1, steps, sites);
    const toNextPage = (updatedSites)=>{
        const actualSites = Array.isArray(updatedSites) ? updatedSites : sites;
        setStepIndex($abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, 1, steps, actualSites));
    };
    const toPreviousPage = (updatedSites)=>{
        const actualSites = Array.isArray(updatedSites) ? updatedSites : sites;
        setStepIndex($abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, -1, steps, actualSites));
    };
    const navItems = steps.map((step, index)=>{
        switch(step){
            case "questionnaire":
                return {
                    index: index,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                        key: "questions",
                        defaultMessage: "Questions",
                        id: "Modal.NavProgressStudyQuestions"
                    })
                };
            case "clinicForm":
                return {
                    index: index,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                        key: "location",
                        defaultMessage: "Location",
                        id: "Modal.LocationPreference"
                    })
                };
            case "contactDetails":
                return {
                    index: index,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                        key: "contact",
                        defaultMessage: "Contact",
                        id: "Modal.NavProgressContactDetails"
                    })
                };
            default:
                return null;
        }
    }).filter(Boolean);
    return {
        stepIndex: stepIndex,
        navItems: navItems,
        toNextPage: toNextPage,
        toPreviousPage: toPreviousPage,
        nextIndex: nextIndex,
        previousIndex: previousIndex,
        pageName: steps[stepIndex],
        hasNextPage: nextIndex < steps.length
    };
};
const $abbc1a8fae73e46a$export$55a8ee9f13137bb1 = (index, direction, steps, sites)=>{
    let newIndex = index + direction;
    const skippable = [
        "clinicForm",
        "questionnaire.eligible"
    ];
    while(skippable.includes(steps[newIndex])){
        if (steps[newIndex] === "clinicForm" && (sites === null || sites === void 0 ? void 0 : sites.length) <= 1) newIndex += direction;
        else if (steps[newIndex] === "questionnaire.eligible") newIndex += direction;
        else break;
    }
    return newIndex;
};



var $aeuny = parcelRequire("aeuny");

var $hgf0k = parcelRequire("hgf0k");

var $7lOcN = parcelRequire("7lOcN");

var $1YSJM = parcelRequire("1YSJM");

var $ikATC = parcelRequire("ikATC");

var $cQNHH = parcelRequire("cQNHH");

var $c4XSV = parcelRequire("c4XSV");
var $kV13H = parcelRequire("kV13H");

var $iTDkM = parcelRequire("iTDkM");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
parcelRequire("8u8eZ");

var $cQNHH = parcelRequire("cQNHH");
function $67fa45b3f289bd4d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        viewBox: "0 0 258 158",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M27.25 4.542c-12.535 0-22.708 10.173-22.708 22.709 0 12.535 10.173 22.708 22.709 22.708 12.535 0 22.708-10.173 22.708-22.708 0-12.536-10.173-22.71-22.708-22.71zm0 26.202l-7.86 7.861-3.494-3.494 7.86-7.86-7.86-7.861 3.494-3.494 7.86 7.86 7.861-7.86 3.494 3.494-7.86 7.86 7.86 7.861-3.494 3.494-7.86-7.86z",
        id: "a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "129.124",
        cy: "148.778",
        fill: "#F0F1F1",
        rx: "59.124",
        ry: "8.778"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#BABFC0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "rotate(-180 98.175 34.014)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "37.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M13.389 0h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM11.926 35h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(0 27.065)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "2.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "64.92",
        cy: "63.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "43.92",
        cy: "19.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M20.926 0h61.308v5.852H20.926a2.926 2.926 0 0 1 0-5.852zM75.389 26h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM73.926 61h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852zM58.76 35h23.357v17.556H58.759A8.76 8.76 0 0 1 50 43.796v-.037A8.76 8.76 0 0 1 58.76 35z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(81.752)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#BABFC0",
        height: "122.889",
        rx: "5.839",
        width: "94.891"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#FFF",
        height: "111.185",
        rx: "2.92",
        width: "83.212",
        x: "6",
        y: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(19 32)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h54.501v54.501H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#FFF",
        fillRule: "nonzero",
        transform: "matrix(1 0 0 -1 0 54.501)",
        xlinkHref: "#a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#FA6428",
        mask: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h55.015v55.057H0z"
    }))))));
}



var $dHJvE = parcelRequire("dHJvE");
function $aef71df54ffafd47$var$Error({ text: text, title: title, onButtonClick: onButtonClick }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $dHJvE.default), {
        buttonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Close",
            id: "Error.CloseModal"
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $67fa45b3f289bd4d$export$2e2bcd8739ae039), {
            height: "46",
            width: "46"
        }),
        onButtonClick: onButtonClick,
        showButton: Boolean(onButtonClick),
        text: text,
        title: title
    });
}
var $aef71df54ffafd47$export$2e2bcd8739ae039 = $aef71df54ffafd47$var$Error;



var $53xQg = parcelRequire("53xQg");
parcelRequire("8u8eZ");

var $jge0r = parcelRequire("jge0r");
function $1ffcf997f1a52a21$var$PleaseTryAgain() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Please try again later",
        id: "Error.PleaseTryAgain"
    });
}
function $1ffcf997f1a52a21$var$ErrorWrapper(props) {
    const { errorCode: errorCode, onButtonClick: onButtonClick } = props;
    (0, $cQNHH.useEffect)(()=>{
        (0, $jge0r.userMetrics).track("Error screen loaded");
    }, []);
    if (errorCode === "noToken") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Please contact support {email}",
            id: "Error.NoToken",
            values: {
                email: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
                    href: `mailto:${(0, $53xQg.SUPPORT_EMAIL)}`
                }, (0, $53xQg.SUPPORT_EMAIL))
            }
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Token is missing or invalid",
            id: "Error.NoTokenTitle"
        })
    });
    if (errorCode === "noSession") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "The signup process has ended due to inactivity. Please restart the sign-up process.",
            id: "Error.SessionTimedOut"
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Your session has expired",
            id: "Error.SessionTimedOutTitle"
        })
    });
    if (errorCode === "notActive") {
        const { createdAt: createdAt, status: status, startsIn: startsIn, endsIn: endsIn } = props;
        const subText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Should you have any questions or concerns, please email us at {email}.",
            id: "RegistrationComplete.ContactUs",
            values: {
                email: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ikATC.default), {
                    href: `mailto:${(0, $53xQg.SUPPORT_EMAIL)}`
                }, (0, $53xQg.SUPPORT_EMAIL))
            }
        });
        if (createdAt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $iTDkM.default), {
            isEligible: true,
            subText: subText,
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "This survey was already completed on {completedAt}",
                id: "SurveyComplete.AlreadyCompleted",
                values: {
                    completedAt: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c4XSV.FormattedDate), {
                        value: new Date(createdAt)
                    })
                }
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "Already completed",
                id: "SurveyComplete.AlreadyCompletedTitle"
            })
        });
        const time = new Date().getTime();
        let title = `${status}`;
        let text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "This survey is {status}",
            id: "SurveyInactive.Status",
            values: {
                status: status
            }
        });
        if (startsIn < 1) {
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "Survey not started",
                id: "SurveyInactive.NotStartedTitle"
            });
            text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "This survey will start on {date}",
                id: "SurveyInactive.NotStarted",
                values: {
                    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c4XSV.FormattedDate), {
                        value: new Date(time - startsIn * 60000)
                    })
                }
            });
        } else if (endsIn < 0) {
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "Survey closed",
                id: "SurveyInactive.EndedTitle"
            });
            text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "This survey ended on {date}",
                id: "SurveyInactive.Ended",
                values: {
                    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c4XSV.FormattedDate), {
                        value: new Date(time + endsIn * 60000)
                    })
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $iTDkM.default), {
            subText: subText,
            text: text,
            title: title
        });
    }
    if (errorCode === "offline" || errorCode === "disconnected") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($1ffcf997f1a52a21$var$PleaseTryAgain, null),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "No response from server",
            id: "Error.NoResponse"
        })
    });
    if (errorCode === "locale") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        title: "Language not supported"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($1ffcf997f1a52a21$var$PleaseTryAgain, null),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "An unknown error occurred",
            id: "Error.UnknownError"
        })
    });
}
$1ffcf997f1a52a21$var$ErrorWrapper.defaultProps = {
    createdAt: undefined,
    endsIn: undefined,
    errorCode: undefined,
    startsIn: undefined,
    status: undefined
};
var $1ffcf997f1a52a21$export$2e2bcd8739ae039 = $1ffcf997f1a52a21$var$ErrorWrapper;


/* eslint-disable react/jsx-props-no-spreading */ 
var $ki4tF = parcelRequire("ki4tF");

var $fpN3t = parcelRequire("fpN3t");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");

var $ioHzT = parcelRequire("ioHzT");

var $k4Dr6 = parcelRequire("k4Dr6");

var $h5HRh = parcelRequire("h5HRh");

var $kvHhM = parcelRequire("kvHhM");
parcelRequire("8u8eZ");

var $7lOcN = parcelRequire("7lOcN");

var $1YSJM = parcelRequire("1YSJM");
const $d0fa50b587ce357e$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            flexGrow: 1,
            overflowY: "auto"
        },
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        image: {
            width: "100%",
            height: 260,
            flexShrink: 0,
            backgroundSize: "cover",
            backgroundPosition: "center",
            clipPath: (props)=>`url(#${props.clipPathId})`,
            backgroundImage: `var(--welcome-image)`,
            [theme.breakpoints.down("xs")]: {
                height: 120
            }
        },
        content: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            width: 600,
            maxWidth: "90%",
            textAlign: "center",
            marginBottom: theme.spacing(2)
        },
        header: {
            marginTop: theme.spacing(3)
        },
        buttonContainer: {
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: theme.spacing(5),
            marginBottom: 0
        }
    }));
function $d0fa50b587ce357e$var$ParticipateText() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "I want to participate",
        id: "Welcome.Participate"
    });
}
function $d0fa50b587ce357e$var$Welcome({ navigateModal: navigateModal, closeModal: closeModal, welcomeImage: welcomeImage, contentId: contentId, customPages: { welcome: customPage = {} } }) {
    const clipPathId = (0, $7lOcN.default)();
    const aria = (0, $1YSJM.default)({
        noFocus: true
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        if (!welcomeImage) return;
        const root = document.documentElement;
        root.style.setProperty("--welcome-image", `url(${welcomeImage})`);
    }, [
        welcomeImage
    ]);
    const theme = (0, $ki4tF.default)();
    const footer = (0, $fpN3t.default)(theme.breakpoints.down("sm"));
    const classes = $d0fa50b587ce357e$var$useStyles({
        clipPathId: clipPathId
    });
    const buttonText = customPage.buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d0fa50b587ce357e$var$ParticipateText, null);
    const onClickHandler = ()=>customPage.buttonAction ? closeModal(customPage.buttonAction) : navigateModal({
            forward: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        height: "0",
        width: "0"
    }, "tagstags", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("clipPath", {
        clipPathUnits: "objectBoundingBox",
        id: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "m 0,-8e-8 v 0.9455507 C 0,0.94555062 0.22434471,1 0.50025839,1 0.77617207,1 1,0.94555062 1,0.94555062 V -8e-8 Z"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root,
        ...aria
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.image
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), {
        className: classes.header,
        underline: "true",
        variant: "h2"
    }, customPage.title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Find out if this study is a match for you",
        id: "Welcome.FindOutIfQualify"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), null, customPage.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "To sign up for this study, please answer a few questions and let us know which clinic you would like to visit during the study.",
        id: "Welcome.ToSignUp"
    })), customPage.subText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.SubtleText), {
        variant: "subtitle1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.subText)), !footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ioHzT.default), {
        "aria-controls": contentId,
        color: "primary",
        onClick: onClickHandler,
        variant: "contained"
    }, buttonText))))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $k4Dr6.default), {
        formIsComplete: true,
        footerText: buttonText,
        onContinueClick: onClickHandler
    }));
}
$d0fa50b587ce357e$var$Welcome.defaultProps = {
    customPages: {},
    welcomeImage: undefined
};
var $d0fa50b587ce357e$export$2e2bcd8739ae039 = $d0fa50b587ce357e$var$Welcome;



const $fe5ad4779f0e9155$var$questionnaireImport = (parcelRequire("lAtLk"));

const $fe5ad4779f0e9155$var$clinicFormImport = (parcelRequire("XF2by"));

const $fe5ad4779f0e9155$var$contactDetailsImport = (parcelRequire("kYYQv"));

const $fe5ad4779f0e9155$var$registrationCompletedImport = (parcelRequire("7VhxQ"));
const $fe5ad4779f0e9155$var$Questionnaire = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$questionnaireImport);
const $fe5ad4779f0e9155$var$ClinicForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$clinicFormImport);
const $fe5ad4779f0e9155$var$ContactDetails = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$contactDetailsImport);
const $fe5ad4779f0e9155$var$RegistrationCompleted = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$registrationCompletedImport);
const $fe5ad4779f0e9155$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            backgroundColor: "white",
            margin: "0 auto",
            borderRadius: "6px",
            overflow: "hidden",
            transition: "all .3s ease-in",
            position: "relative",
            width: "calc(100% - 20px)",
            height: "calc(100% - 20px)",
            zIndex: 9999,
            maxWidth: "930px",
            maxHeight: "720px",
            boxShadow: "0 0 24px 0 rgba(0, 0, 0, 0.36)",
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.down("sm")]: {
                maxWidth: "unset",
                maxHeight: "unset"
            },
            "@media print": {
                display: "block",
                boxShadow: "none",
                maxHeight: "unset",
                width: "100%",
                height: "auto"
            }
        },
        content: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            "@media print": {
                display: "block",
                overflow: "auto"
            }
        }
    }));
const $fe5ad4779f0e9155$var$defaultContactFields = [
    {
        name: "name",
        type: "name"
    },
    {
        name: "email",
        type: "email",
        confirm: true
    },
    {
        name: "phone",
        type: "phone"
    },
    {
        name: "preferredContactHours",
        type: "select",
        options: [
            "8-20",
            "8-12",
            "12-16",
            "16-20"
        ],
        defaultValue: "8-20"
    }
];
const $fe5ad4779f0e9155$var$pageToComponent = {
    welcome: (0, $d0fa50b587ce357e$export$2e2bcd8739ae039),
    questionnaire: $fe5ad4779f0e9155$var$Questionnaire,
    clinicForm: $fe5ad4779f0e9155$var$ClinicForm,
    contactDetails: $fe5ad4779f0e9155$var$ContactDetails,
    completed: $fe5ad4779f0e9155$var$RegistrationCompleted
};
const $fe5ad4779f0e9155$var$getCustomPages = ({ config: { customPages: customPages = {} } = {}, sessionInfo: { study: study } = {}, fullState: { clinicForm: clinicForm, contactDetails: contactDetails } = {} })=>{
    const tags = {
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(contactDetails, "fieldValues.name.value", ""),
        email: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(contactDetails, "fieldValues.email.value", ""),
        phone: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(contactDetails, "fieldValues.phone.value", ""),
        siteName: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(clinicForm, "selectedSite.name", ""),
        siteAddress: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(clinicForm, "selectedSite.address", ""),
        inboundProxyNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(clinicForm, "selectedSite.inboundProxyNumber", ""),
        publicStudyName: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(study, "publicStudyName", ""),
        supportEmail: `[${(0, $53xQg.SUPPORT_EMAIL)}](mailto:${(0, $53xQg.SUPPORT_EMAIL)})`
    };
    const customPagesWithTags = {
        ...customPages
    };
    Object.keys(customPages).forEach((key)=>{
        customPagesWithTags[key].tags = tags;
    });
    return customPagesWithTags;
};
function $fe5ad4779f0e9155$var$Modal({ onAction: onAction, sessionInfo: sessionInfo, config: config, api: api, errorCode: errorCode, onClose: onClose }) {
    const { defaultSiteId: defaultSiteId, questions: questions, googleApiKey: googleApiKey, consent: consent } = sessionInfo;
    const { steps: steps, contactForm: contactForm, ...otherConfig } = config;
    const titleId = (0, $7lOcN.default)();
    const contentId = (0, $7lOcN.default)();
    const aria = (0, $1YSJM.default)();
    const [sites, setSites] = (0, $cQNHH.useState)();
    const { navItems: navItems, pageName: pageName, hasNextPage: hasNextPage, toPreviousPage: toPreviousPage, toNextPage: toNextPage, nextIndex: nextIndex, previousIndex: previousIndex, stepIndex: stepIndex } = (0, $abbc1a8fae73e46a$export$302911c449e17ea4)({
        steps: steps,
        sites: sites
    });
    const [showClosePrompt, setShowClosePrompt] = (0, $cQNHH.useState)(false);
    const enableClosePrompt = (0, $aeuny.useIsLocked)();
    const [fullState, setGlobalState] = (0, $hgf0k.useFullGlobalState)();
    const actions = (0, $cQNHH.useRef)([]);
    const processActions = ()=>{
        while(actions.current.length){
            const action = actions.current.shift();
            const metrics = (0, $2Hhgv.metricsDataFromState)({
                ...fullState,
                sessionInfo: sessionInfo,
                pageName: pageName
            });
            onAction(action, metrics);
        }
    };
    processActions();
    (0, $cQNHH.useEffect)(()=>{
        const callback = (action)=>{
            actions.current.push(action);
            processActions();
        };
        (0, $2Hhgv.subscribeMetrics)(callback);
        return ()=>(0, $2Hhgv.unsubscribeMetrics)(callback);
    }, [
        fullState,
        sessionInfo,
        stepIndex
    ]);
    (0, $cQNHH.useEffect)(()=>(0, $2Hhgv.submitMetric)("pageOpened"), [
        stepIndex,
        fullState[pageName].subPage || null
    ]);
    (0, $cQNHH.useEffect)(()=>{
        if (defaultSiteId) setGlobalState("clinicForm.selectedSite", defaultSiteId);
    }, [
        defaultSiteId
    ]);
    const customPages = $fe5ad4779f0e9155$var$getCustomPages({
        config: config,
        sessionInfo: sessionInfo,
        fullState: fullState
    });
    const navigate = ({ forward: forward, sites: updatedSites })=>{
        if (forward && !hasNextPage) onClose(customPages[pageName] && customPages[pageName].buttonAction);
        else if (forward) toNextPage(updatedSites);
        else toPreviousPage(updatedSites);
    };
    const closeModal = (redirectUrl)=>{
        const close = ()=>{
            if (showClosePrompt) {
                (0, $2Hhgv.submitMetric)("dropout");
                api.dropoutCandidate();
            } else (0, $2Hhgv.submitMetric)("closed");
            onClose(redirectUrl);
        };
        if (enableClosePrompt && !showClosePrompt) setShowClosePrompt(redirectUrl || true);
        else close();
    };
    const getPageProps = ()=>{
        const nextPageName = nextIndex < steps.length ? steps[nextIndex] : null;
        const prevPageName = previousIndex >= 0 ? steps[previousIndex] : null;
        return {
            ...otherConfig,
            api: api,
            questions: questions,
            navigateModal: navigate,
            sites: sites,
            setSites: setSites,
            googleApiKey: googleApiKey,
            consent: consent,
            closeModal: closeModal,
            pageName: pageName,
            prevPageName: prevPageName,
            nextPageName: nextPageName,
            contentId: contentId,
            fields: contactForm || $fe5ad4779f0e9155$var$defaultContactFields,
            customPages: customPages,
            steps: steps
        };
    };
    const getStepContent = ()=>{
        const PageElement = $fe5ad4779f0e9155$var$pageToComponent[pageName];
        if (errorCode || !PageElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $1ffcf997f1a52a21$export$2e2bcd8739ae039), {
            errorCode: errorCode,
            onButtonClick: closeModal
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8p3P7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(PageElement, getPageProps()));
    };
    const getContent = ()=>{
        if (showClosePrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $9ba70814ad158a5d$export$2e2bcd8739ae039), {
            customPage: customPages.leave,
            onCancel: ()=>setShowClosePrompt(false),
            onClose: closeModal
        });
        return getStepContent();
    };
    const classes = $fe5ad4779f0e9155$var$useStyles();
    // TODO: Role on the root div?
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-labelledby": titleId,
        className: classes.root,
        ...aria
    }, !errorCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $01e80fff3c31a4e4$export$2e2bcd8739ae039), {
        handleModalClose: ()=>closeModal(),
        isHidden: pageName === "welcome",
        navItems: navItems,
        progress: stepIndex,
        showCloseButton: !showClosePrompt,
        titleId: titleId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-live": "polite",
        className: classes.content,
        id: contentId,
        name: "tb-sa-content"
    }, getContent()));
}
$fe5ad4779f0e9155$var$Modal.defaultProps = {
    errorCode: null,
    sessionInfo: {
        consent: [],
        googleApiKey: "",
        questionnaire: []
    }
};
var $fe5ad4779f0e9155$export$2e2bcd8739ae039 = $fe5ad4779f0e9155$var$Modal;
function $fe5ad4779f0e9155$export$23ec8986ee72eea6({ handleModalClose: handleModalClose }) {
    const classes = $fe5ad4779f0e9155$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $1ffcf997f1a52a21$export$2e2bcd8739ae039), {
        errorCode: "unknown",
        onButtonClick: handleModalClose
    })));
}


parcelRequire("8u8eZ");

var $aeuny = parcelRequire("aeuny");

var $hgf0k = parcelRequire("hgf0k");
/**
 * This file only exist to cover up for parcel not having the ability to do lazy importing based on
 * a glob. In the future, the big object could essentially be replaced with this:
 *
 * ```js
 * function getLanguage(locale) {
 *   const language = locale.match(/^(.+?)_.+?$/)[1];
 *
 *   return Promise.all([
 *     import(`react-intl/locale-data/${language}`),
 *     import(`./locales/${locale}.json`),
 *   ]);
 * }
 * ```
 *
 * The parcel issue in question can be found here:
 * https://github.com/parcel-bundler/parcel/issues/125
 */ 
var $1rrDX = parcelRequire("1rrDX");

var $cQNHH = parcelRequire("cQNHH");
var $f54519d442a89b55$exports = {};
$f54519d442a89b55$exports = JSON.parse('{"Terms.print":"Print","ClinicForm.mapsLookup":"Look up on Google maps","Modal.closePrompt":"Are you sure you want to leave?","Modal.closeDescription":"Any information you have entered will not be saved.","Modal.closeButton":"Leave","Modal.closeCancel":"Go back","Footer.back":"Back","Footer.next":"Next","Footer.submit":"Submit","phoneInput.countryOfOrigin":"Phone country of origin","ClinicForm.SelectedClinic":"Selected research centre","Error.CloseModal":"Close","Modal.CloseDialog":"Close dialog","NavigationProgress.SignUp":"See if you pre-qualify","Questionnaire.BMI.Height":"Height","Questionnaire.BMI.Weight":"Weight","Questionnaire.BMI.units.metric":"metric","Questionnaire.BMI.units.imperial":"imperial","Questionnaire.BMI.useStones":"Use stones","Questionnaire.BMI.centimeters":"Centimeters","Questionnaire.BMI.kilograms":"Kilograms","Questionnaire.BMI.feet":"Feet","Questionnaire.BMI.inches":"Inches","Questionnaire.BMI.pounds":"Pounds","Questionnaire.BMI.stone":"Stones","NavigationControls.Questionnaire.select.placeholder":"Select an answer","NavigationControls.NavigationControlsYes":"Yes","NavigationControls.NavigationControlsNo":"No","Questionnaire.QuestionTitle":"Question {number}. {questionText}","Survey.StartButton":"Start","Survey.ContinueButton":"Continue","Intro.caption":"Complete the survey before {date}","RegistrationComplete.ContactUs":"Should you have any questions or concerns, please email us at {email}.","SurveyComplete.ThankYou":"Thank you for taking the time to complete this survey.","SurveyComplete.CompletedTitle":"Survey completed","Terms.back":"Back","Terms.termsOfAgreement":"Terms of Agreement","Terms.recaptchaNotice":"This questionnaire is protected by reCAPTCHA and the Google {privacy} and {terms} apply.","Terms.recaptchaNoticePrivacy":"Privacy Policy","Terms.recaptchaNoticeTerms":"Terms of Service","ClinicForm.SelectClinic":"Select a preferred research centre you would like to visit if you were to take part in the study","ClinicForm.FindNearestClinic":"Find nearest research centre","Footer.FooterNoClinicSelected":"No research centre selected","ContactDetails.prompt":"Please enter your contact details and preferred time of contact so that the study medical team can reach you to discuss study participation.","ContactDetails.PromptNotice":"Submitting your contact details does not mean you have to join the study. That is your decision to make if you are fully eligible for the study.","ContactDetails.privacyDisclaimer":"Your personal information and your answers to the study questions are only used for the purposes of determining if the clinical study is suitable for you. You can at any time withdraw your consent and have your personal data removed.","Elegible.ChooseClinic":"Next","Elegible.SelectPreferedClinic":"In the next step you will select a research centre that you would like to visit during the study if you are eligible and would like to take part.","Elegible.EnterContactDetails":"In the next step you will enter your contact details so that the study medical team can reach you.","Elegible.YouAreElegible":"Based on your responses, you may be suitable for the study.","Error.PleaseTryAgain":"Please try again later","Error.NoToken":"Please contact support {email}","Error.NoTokenTitle":"Token is missing or invalid","Error.SessionTimedOut":"The signup process has ended due to inactivity. Please restart the sign-up process.","Error.SessionTimedOutTitle":"Your session has expired","SurveyComplete.AlreadyCompleted":"This survey was already completed on {completedAt}","SurveyComplete.AlreadyCompletedTitle":"Already completed","SurveyInactive.Status":"This survey is {status}","SurveyInactive.NotStartedTitle":"Survey not started","SurveyInactive.NotStarted":"This survey will start on {date}","SurveyInactive.EndedTitle":"Survey closed","SurveyInactive.Ended":"This survey ended on {date}","Error.NoResponse":"No response from server","Error.UnknownError":"An unknown error occurred","ContactDetails.name":"Name","ContactDetails.namePlaceholder":"Your name","ContactDetails.email":"Email address","ContactDetails.emailPlaceholder":"Your email address","ContactDetails.emailConfirm":"Confirm email address","ContactDetails.emailConfirmPlaceholder":"Confirm email address","ContactDetails.phone":"Phone number","ContactDetails.phonePlaceholder":"Your phone number","ContactDetails.phoneConfirm":"Confirm phone number","ContactDetails.phoneConfirmPlaceholder":"Confirm phone number","FormSelect.preferred_contact_way":"Preferred way to be contacted","ContactDetails.preferred_contact_wayPlaceholder":"Choose preferred method","FormSelect.availability_slots":"Preferred time to be contacted","ContactDetails.availability_slotsPlaceholder":"Choose time","Error.MinimumCharacters":"Please enter your whole name","Error.MaximumCharacters":"Please enter a shorter version of your name","Error.NotValidEmail":"Please enter a valid email","Error.NonEqualEmail":"The email addresses do not match","Error.PleaseSelectAvailabilitySlot":"Please select a timeslot for preferred contact","Error.PleaseSelectContactWay":"Please select a preferred way to be contacted","Error.NotValidPhoneNumber":"Please enter a valid phone number","Error.NotEqualPhoneNumber":"The phone numbers do not match","Error.YouMustConsent":"You cannot proceed without consenting. If you do not wish to consent, you can close the window in the upper right corner.","ContactTimes.8-20":"Anytime","ContactTimes.8-12":"8:00 am - 12:00 noon","ContactTimes.12-16":"12:00 noon - 4:00 pm","ContactTimes.16-20":"4:00 pm - 8:00 pm","Modal.NavProgressStudyQuestions":"Questions","Modal.LocationPreference":"Location","Modal.NavProgressContactDetails":"Contact","NotEligible.CloseButton":"Close","NotEligible.NotEligible":"Sorry, the study is not suitable for you at this time","Questionnaire.Progress":"{questionsAnswered} of {totalQuestions} answered","Warning.SkippedQuestions":"{count} questions skipped","Questionnaire.Prompt":"Please answer the following questions to find out if you are suitable for the study.","RegistrationComplete.Done":"Done","Registration.RegistrationNowFinished":"Thank you for your interest. An email has been sent to {email}. You will be contacted by the study medical team shortly to talk about the study.","Registration.RegistrationComplete":"Registration completed!","Welcome.Participate":"I want to participate","Welcome.FindOutIfQualify":"Find out if this study is a match for you","Welcome.ToSignUp":"Please answer a few questions to see if you may qualify for the study.","Countries.AF":"Afghanistan","Countries.AX":"\xc5land Islands","Countries.AL":"Albania","Countries.DZ":"Algeria","Countries.AS":"American Samoa","Countries.AD":"Andorra","Countries.AO":"Angola","Countries.AI":"Anguilla","Countries.AQ":"Antarctica","Countries.AG":"Antigua and Barbuda","Countries.AR":"Argentina","Countries.AM":"Armenia","Countries.AW":"Aruba","Countries.AU":"Australia","Countries.AT":"Austria","Countries.AZ":"Azerbaijan","Countries.BS":"Bahamas","Countries.BH":"Bahrain","Countries.BD":"Bangladesh","Countries.BB":"Barbados","Countries.BY":"Belarus","Countries.BE":"Belgium","Countries.BZ":"Belize","Countries.BJ":"Benin","Countries.BM":"Bermuda","Countries.BT":"Bhutan","Countries.BO":"Bolivia (Plurinational State of)","Countries.BQ":"Bonaire, Sint Eustatius and Saba","Countries.BA":"Bosnia and Herzegovina","Countries.BW":"Botswana","Countries.BV":"Bouvet Island","Countries.BR":"Brazil","Countries.IO":"British Indian Ocean Territory","Countries.UM":"United States Minor Outlying Islands","Countries.VG":"Virgin Islands (British)","Countries.VI":"Virgin Islands (U.S.)","Countries.BN":"Brunei Darussalam","Countries.BG":"Bulgaria","Countries.BF":"Burkina Faso","Countries.BI":"Burundi","Countries.KH":"Cambodia","Countries.CM":"Cameroon","Countries.CA":"Canada","Countries.CV":"Cabo Verde","Countries.KY":"Cayman Islands","Countries.CF":"Central African Republic","Countries.TD":"Chad","Countries.CL":"Chile","Countries.CN":"China","Countries.CX":"Christmas Island","Countries.CC":"Cocos (Keeling) Islands","Countries.CO":"Colombia","Countries.KM":"Comoros","Countries.CG":"Congo","Countries.CD":"Congo (Democratic Republic of the)","Countries.CK":"Cook Islands","Countries.CR":"Costa Rica","Countries.HR":"Croatia","Countries.CU":"Cuba","Countries.CW":"Cura\xe7ao","Countries.CY":"Cyprus","Countries.CZ":"Czech Republic","Countries.DK":"Denmark","Countries.DJ":"Djibouti","Countries.DM":"Dominica","Countries.DO":"Dominican Republic","Countries.EC":"Ecuador","Countries.EG":"Egypt","Countries.SV":"El Salvador","Countries.GQ":"Equatorial Guinea","Countries.ER":"Eritrea","Countries.EE":"Estonia","Countries.ET":"Ethiopia","Countries.FK":"Falkland Islands (Malvinas)","Countries.FO":"Faroe Islands","Countries.FJ":"Fiji","Countries.FI":"Finland","Countries.FR":"France","Countries.GF":"French Guiana","Countries.PF":"French Polynesia","Countries.TF":"French Southern Territories","Countries.GA":"Gabon","Countries.GM":"Gambia","Countries.GE":"Georgia","Countries.DE":"Germany","Countries.GH":"Ghana","Countries.GI":"Gibraltar","Countries.GR":"Greece","Countries.GL":"Greenland","Countries.GD":"Grenada","Countries.GP":"Guadeloupe","Countries.GU":"Guam","Countries.GT":"Guatemala","Countries.GG":"Guernsey","Countries.GN":"Guinea","Countries.GW":"Guinea-Bissau","Countries.GY":"Guyana","Countries.HT":"Haiti","Countries.HM":"Heard Island and McDonald Islands","Countries.VA":"Holy See","Countries.HN":"Honduras","Countries.HK":"Hong Kong","Countries.HU":"Hungary","Countries.IS":"Iceland","Countries.IN":"India","Countries.ID":"Indonesia","Countries.CI":"C\xf4te d\'Ivoire","Countries.IR":"Iran (Islamic Republic of)","Countries.IQ":"Iraq","Countries.IE":"Ireland","Countries.IM":"Isle of Man","Countries.IL":"Israel","Countries.IT":"Italy","Countries.JM":"Jamaica","Countries.JP":"Japan","Countries.JE":"Jersey","Countries.JO":"Jordan","Countries.KZ":"Kazakhstan","Countries.KE":"Kenya","Countries.KI":"Kiribati","Countries.KW":"Kuwait","Countries.KG":"Kyrgyzstan","Countries.LA":"Lao People\'s Democratic Republic","Countries.LV":"Latvia","Countries.LB":"Lebanon","Countries.LS":"Lesotho","Countries.LR":"Liberia","Countries.LY":"Libya","Countries.LI":"Liechtenstein","Countries.LT":"Lithuania","Countries.LU":"Luxembourg","Countries.MO":"Macao","Countries.MK":"Macedonia (the former Yugoslav Republic of)","Countries.MG":"Madagascar","Countries.MW":"Malawi","Countries.MY":"Malaysia","Countries.MV":"Maldives","Countries.ML":"Mali","Countries.MT":"Malta","Countries.MH":"Marshall Islands","Countries.MQ":"Martinique","Countries.MR":"Mauritania","Countries.MU":"Mauritius","Countries.YT":"Mayotte","Countries.MX":"Mexico","Countries.FM":"Micronesia (Federated States of)","Countries.MD":"Moldova (Republic of)","Countries.MC":"Monaco","Countries.MN":"Mongolia","Countries.ME":"Montenegro","Countries.MS":"Montserrat","Countries.MA":"Morocco","Countries.MZ":"Mozambique","Countries.MM":"Myanmar","Countries.NA":"Namibia","Countries.NR":"Nauru","Countries.NP":"Nepal","Countries.NL":"Netherlands","Countries.NC":"New Caledonia","Countries.NZ":"New Zealand","Countries.NI":"Nicaragua","Countries.NE":"Niger","Countries.NG":"Nigeria","Countries.NU":"Niue","Countries.NF":"Norfolk Island","Countries.KP":"Korea (Democratic People\'s Republic of)","Countries.MP":"Northern Mariana Islands","Countries.NO":"Norway","Countries.OM":"Oman","Countries.PK":"Pakistan","Countries.PW":"Palau","Countries.PS":"Palestine, State of","Countries.PA":"Panama","Countries.PG":"Papua New Guinea","Countries.PY":"Paraguay","Countries.PE":"Peru","Countries.PH":"Philippines","Countries.PN":"Pitcairn","Countries.PL":"Poland","Countries.PT":"Portugal","Countries.PR":"Puerto Rico","Countries.QA":"Qatar","Countries.XK":"Republic of Kosovo","Countries.RE":"R\xe9union","Countries.RO":"Romania","Countries.RU":"Russian Federation","Countries.RW":"Rwanda","Countries.BL":"Saint Barth\xe9lemy","Countries.SH":"Saint Helena, Ascension and Tristan da Cunha","Countries.KN":"Saint Kitts and Nevis","Countries.LC":"Saint Lucia","Countries.MF":"Saint Martin (French part)","Countries.PM":"Saint Pierre and Miquelon","Countries.VC":"Saint Vincent and the Grenadines","Countries.WS":"Samoa","Countries.SM":"San Marino","Countries.ST":"Sao Tome and Principe","Countries.SA":"Saudi Arabia","Countries.SN":"Senegal","Countries.RS":"Serbia","Countries.SC":"Seychelles","Countries.SL":"Sierra Leone","Countries.SG":"Singapore","Countries.SX":"Sint Maarten (Dutch part)","Countries.SK":"Slovakia","Countries.SI":"Slovenia","Countries.SB":"Solomon Islands","Countries.SO":"Somalia","Countries.ZA":"South Africa","Countries.GS":"South Georgia and the South Sandwich Islands","Countries.KR":"Korea (Republic of)","Countries.SS":"South Sudan","Countries.ES":"Spain","Countries.LK":"Sri Lanka","Countries.SD":"Sudan","Countries.SR":"Suriname","Countries.SJ":"Svalbard and Jan Mayen","Countries.SZ":"Swaziland","Countries.SE":"Sweden","Countries.CH":"Switzerland","Countries.SY":"Syrian Arab Republic","Countries.TW":"Taiwan","Countries.TJ":"Tajikistan","Countries.TZ":"Tanzania, United Republic of","Countries.TH":"Thailand","Countries.TL":"Timor-Leste","Countries.TG":"Togo","Countries.TK":"Tokelau","Countries.TO":"Tonga","Countries.TT":"Trinidad and Tobago","Countries.TN":"Tunisia","Countries.TR":"Turkey","Countries.TM":"Turkmenistan","Countries.TC":"Turks and Caicos Islands","Countries.TV":"Tuvalu","Countries.UG":"Uganda","Countries.UA":"Ukraine","Countries.AE":"United Arab Emirates","Countries.GB":"United Kingdom of Great Britain and Northern Ireland","Countries.US":"United States of America","Countries.UY":"Uruguay","Countries.UZ":"Uzbekistan","Countries.VU":"Vanuatu","Countries.VE":"Venezuela (Bolivarian Republic of)","Countries.VN":"Viet Nam","Countries.WF":"Wallis and Futuna","Countries.EH":"Western Sahara","Countries.YE":"Yemen","Countries.ZM":"Zambia","Countries.ZW":"Zimbabwe","ContactDetails.phone_option_placeholder":"Phone call","ContactDetails.sms_option_placeholder":"SMS","ContactDetails.email_option_placeholder":"Email","Consent.SeeFullVersionLink":"Full version","ContactDetails.PostalCode":"Postal code","ContactDetails.PostalCodePlaceholder":"Your postal code","Error.NotValidPostalCode":"Please enter a valid postal code"}');


/*
1. get language by locale (en-US.json)
2. if fail, extract first part of locale (en.json)
3. get language by language (en.json)
*/ async function $41cd20df18931d30$var$getLanguage(locale) {
    return fetch(`/locale/${locale}.json`).then((response)=>response.json()).catch((error)=>{
        throw error;
    });
}
/*
1. load prescreener
2. figure out the system language to use based on locale [94]
3. fetch system language from s3 (en-US.json, not en-US.213xzvb.js) [95]
3b. cache issues??
4. fetch languages from API, overlay the system languages from S3 [96]
*/ /**
 * Returns [loading, messages]
 */ function $41cd20df18931d30$var$useMessages(locale, customMessages) {
    const [messages, setMessages] = (0, $cQNHH.useState)(null);
    const [error, setError] = (0, $cQNHH.useState)(null);
    (0, $cQNHH.useEffect)(()=>{
        if (messages !== null) setMessages(null);
        try {
            $41cd20df18931d30$var$getLanguage(locale).then((translations)=>setMessages((0, (/*@__PURE__*/$parcel$interopDefault($1rrDX)))({}, translations, customMessages))).catch(()=>setMessages(customMessages));
            setError(null);
        } catch (err) {
            setError({
                errorCode: "locale",
                error: `Locale ${locale} not supported`
            });
        }
    }, [
        locale,
        customMessages
    ]);
    return {
        msg: messages,
        msgLoading: messages === null,
        msgErrorCode: error ? error.errorCode : false,
        msgError: error
    };
}
var $41cd20df18931d30$export$2e2bcd8739ae039 = $41cd20df18931d30$var$useMessages;



var $jge0r = parcelRequire("jge0r");

var $lCfIL = parcelRequire("lCfIL");
const $5ccd9f6f5dcc94a5$var$useStyles = (0, $7b1Lp.default)({
    root: {
        "& *": {
            boxSizing: "border-box",
            "-webkit-overflow-scrolling": "touch",
            "-webkit-text-size-adjust": "none",
            "-ms-text-size-adjust": "none",
            "text-size-adjust": "none"
        },
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        "@media print": {
            display: "block",
            position: "absolute",
            height: "auto",
            bottom: "auto"
        },
        "&:before": {
            content: '""',
            display: "block",
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "#1C1C1C",
            opacity: 0.42,
            zIndex: 0,
            "@media print": {
                display: "none"
            }
        }
    }
});
function $5ccd9f6f5dcc94a5$var$setDocumentTitle(msg) {
    if (msg) document.title = msg["NavigationProgress.SignUp"];
}
function $5ccd9f6f5dcc94a5$var$App(props) {
    const { loading: loading, errorCode: errorCode, sessionInfo: sessionInfo, sessionToken: sessionToken, config: config, onClose: onClose } = props;
    const { locale: locale, language: language, messages: messages, steps: steps, studyId: studyId } = config;
    (0, $cQNHH.useEffect)(()=>{
        (0, $jge0r.userMetrics).register({
            studyId: studyId,
            locale: locale
        });
        (0, $jge0r.userMetrics).track("Prescreener opened");
    }, []);
    const [api, apiErrorCode] = (0, $lCfIL.useAPI)(config, sessionToken);
    const { msg: msg, msgLoading: msgLoading, msgErrorCode: msgErrorCode } = (0, $41cd20df18931d30$export$2e2bcd8739ae039)(locale, messages);
    const classes = $5ccd9f6f5dcc94a5$var$useStyles();
    if (!apiErrorCode && !errorCode && !msgErrorCode && (loading || msgLoading)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8mLXY.default), null));
    $5ccd9f6f5dcc94a5$var$setDocumentTitle(msg);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $IPPAR.default), {
        locale: language === null || language === void 0 ? void 0 : language.substring(0, 3),
        messages: msg
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $hgf0k.GlobalStateProvider), {
        initialKeys: steps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aeuny.CloseConfirmationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8be7ad1126c1e5b2$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $fe5ad4779f0e9155$export$2e2bcd8739ae039), {
        ...props,
        api: api,
        errorCode: apiErrorCode || errorCode || msgErrorCode,
        handleModalClose: ()=>onClose(props),
        sessionInfo: sessionInfo
    }))))));
}
$5ccd9f6f5dcc94a5$var$App.defaultProps = {
    errorCode: undefined,
    sessionInfo: undefined,
    sessionToken: undefined
};
var $5ccd9f6f5dcc94a5$export$2e2bcd8739ae039 = $5ccd9f6f5dcc94a5$var$App;
function $5ccd9f6f5dcc94a5$export$a996741116394418({ config: { locale: locale, language: language, messages: messages }, onClose: onClose }) {
    const { msg: msg } = (0, $41cd20df18931d30$export$2e2bcd8739ae039)(locale, messages);
    const classes = $5ccd9f6f5dcc94a5$var$useStyles();
    const messagesWithFallback = {
        "Modal.UnknownError": "An unknown error occurred",
        "Error.PleaseTryAgain": "Please try again later",
        "Error.CloseModal": "Close",
        ...msg
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $IPPAR.default), {
        locale: language,
        messages: messagesWithFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $fe5ad4779f0e9155$export$23ec8986ee72eea6), {
        handleModalClose: ()=>onClose()
    })));
}



var $lCfIL = parcelRequire("lCfIL");
(0, (/*@__PURE__*/$parcel$interopDefault($649299cff7f987fa$exports))).polyfill();
// Used for verifying the parent API window origin.
let $263fb9b3900bc812$var$currentOrigin;
// Default config for self-assessment
const $263fb9b3900bc812$var$DEFAULT_CONFIG = {
    baseURI: new URL("/api/osa", window.location).href,
    locale: "en_US",
    steps: [
        "questionnaire",
        "clinicForm",
        "contactDetails",
        "completed"
    ]
};
const $263fb9b3900bc812$var$RTL_LANGUAGES = [
    "he",
    "ar",
    "dv",
    "fa",
    "ha",
    "ks",
    "ku",
    "ps",
    "ur",
    "yi"
];
// Used to send messages to the parent API. Remember to NEVER send sensitive data back as callbacks.
const $263fb9b3900bc812$var$postMessage = (type, options)=>{
    window.parent.postMessage(JSON.stringify({
        type: type,
        options: options
    }), $263fb9b3900bc812$var$currentOrigin);
};
const $263fb9b3900bc812$var$getRootElement = ()=>document.getElementById("root");
const $263fb9b3900bc812$var$onClose = (redirectUrl)=>{
    $263fb9b3900bc812$var$postMessage("close", {
        redirectUrl: redirectUrl
    });
    $263fb9b3900bc812$var$currentOrigin = undefined;
    (0, (/*@__PURE__*/$parcel$interopDefault($dLwnG))).unmountComponentAtNode($263fb9b3900bc812$var$getRootElement());
};
// Renders the self-assessment with the specified config.
const $263fb9b3900bc812$var$render = ({ config: config, loading: loading, errorCode: errorCode, sessionInfo: sessionInfo, sessionToken: sessionToken })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($dLwnG))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2bb9b1e646170ca5$export$2e2bcd8739ae039), {
        theme: (0, $03fa2a80882ee47c$export$2e2bcd8739ae039)(config)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5dlN6.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5ccd9f6f5dcc94a5$export$a996741116394418), {
                config: config,
                onClose: ()=>$263fb9b3900bc812$var$onClose(),
                root: $263fb9b3900bc812$var$getRootElement()
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5ccd9f6f5dcc94a5$export$2e2bcd8739ae039), {
        config: config,
        errorCode: errorCode,
        loading: loading,
        onAction: (action, metrics)=>{
            $263fb9b3900bc812$var$postMessage("action", {
                action: action,
                values: metrics
            });
        },
        onClose: (redirectUrl)=>$263fb9b3900bc812$var$onClose(redirectUrl),
        sessionInfo: sessionInfo,
        sessionToken: sessionToken
    }))), $263fb9b3900bc812$var$getRootElement());
};
function $263fb9b3900bc812$var$buildConfig({ baseURI: baseURI = $263fb9b3900bc812$var$DEFAULT_CONFIG.baseURI, locale: locale = $263fb9b3900bc812$var$DEFAULT_CONFIG.locale, ...restConfig } = {}) {
    const localeMatch = locale.match(/^([a-z]{2,})[_-]([A-Z]{2,})$/);
    if (!localeMatch) return [
        {},
        "Invalid locale format"
    ];
    const language = localeMatch[1].toLowerCase();
    const country = localeMatch[2].toLowerCase();
    const textDirection = $263fb9b3900bc812$var$RTL_LANGUAGES.includes(language) ? "rtl" : undefined;
    const uriMatch = baseURI.match(/^(https?:\/\/.+?)\/?$/);
    if (!uriMatch) return [
        {},
        "Invalid base URI format"
    ];
    return [
        {
            baseURI: `${uriMatch[1]}`,
            locale: locale,
            language: language,
            country: country,
            textDirection: textDirection,
            ...restConfig
        }
    ];
}
// All functions of the public API.
// Remember to add new functions to the functions array in `api.js`.
// All functions need to follow the signature of `f(callbackId, options)` and they need to post a message
// with either `error` or `done` together with the `callbackId`.
const $263fb9b3900bc812$var$api = {
    /**
   * Opens the self-assessment.
   *
   * @param {Object} config - The configuration to use when opening the self-assessment.
   * @param {string} config.locale - The locale code (`en_US`, `sv_SE`, ...).
   * @param {string} config.language - The ISO 639-1 language code (`en`, `sv`, ...).
   * @param {string} config.country - The country code (`us`, `se`, ...).
   * @param {string} config.studyId - The Trialbee Study ID.
   * @param {string} config.referrer - The URL that the candidate was referred from.
   * @param {string} config.referrerToken - The token as an open string eg: `Trialbee`.
   * @param {string} config.welcomeImage - The banner image to show on the introduction page.
   * @param {string} [config.baseURI] - The base URI for API calls.
   * @param {string} [config.googleApiKey] - A Google API key used for accessing the Google Maps API.
   * @param {string} [config.colorMain] - The theme color to use. Defaults to Trialbee blue.
   * @param {string} [config.colorLight] - The light theme color to use. Defaults to lightenand desaturated `colorMain`.
   * @param {string} [config.fontFamily] - The font to use.
   * @param {string} [config.fontInclude] - An url to CSS with `font-face` to be included.
   */ open (callbackId, partialConfig) {
        if ((0, $134249fea87571b9$export$a587e606f93a3767)(window.navigator.userAgent)) {
            const el = (0, $134249fea87571b9$export$f357a97864275ebe)(()=>{
                $263fb9b3900bc812$var$postMessage("close");
            });
            $263fb9b3900bc812$var$getRootElement().appendChild(el);
            $263fb9b3900bc812$var$postMessage("open");
            return undefined;
        }
        const sendError = (message)=>{
            $263fb9b3900bc812$var$postMessage("error", {
                fatal: true,
                message: message,
                callbackId: callbackId
            });
            $263fb9b3900bc812$var$currentOrigin = null;
        };
        const [config, error] = $263fb9b3900bc812$var$buildConfig(partialConfig);
        if (error) return sendError(error);
        (0, $5dlN6.startBugSnag)(config);
        $263fb9b3900bc812$var$render({
            config: config,
            loading: true
        });
        $263fb9b3900bc812$var$postMessage("open");
        return (0, $lCfIL.initSession)(config).then(([sessionInfo, sessionToken])=>{
            const merged = (0, $0ed8d10c3555ce9e$export$2e2bcd8739ae039)($263fb9b3900bc812$var$DEFAULT_CONFIG, sessionInfo.config, {
                textDirection: sessionInfo.textDirection
            }, config);
            // Apply custom fonts style
            if (merged.fontInclude) {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = merged.fontInclude;
                document.head.appendChild(link);
            }
            document.body.setAttribute("dir", merged.textDirection);
            document.documentElement.setAttribute("lang", merged.language);
            return $263fb9b3900bc812$var$render({
                sessionInfo: sessionInfo,
                sessionToken: sessionToken,
                config: merged
            });
        }).catch((errorCode)=>{
            const errorConfig = (0, $0ed8d10c3555ce9e$export$2e2bcd8739ae039)($263fb9b3900bc812$var$DEFAULT_CONFIG, config);
            $263fb9b3900bc812$var$render({
                config: errorConfig,
                errorCode: errorCode
            });
        }).finally(()=>$263fb9b3900bc812$var$postMessage("done", {
                callbackId: callbackId
            }));
    },
    getHeight (callbackId) {
        try {
            const content = document.getElementsByName("tb-sa-content")[0];
            content.style.display = "block";
            content.style.overflow = "scroll";
            $263fb9b3900bc812$var$postMessage("setHeight", {
                scrollHeight: content.scrollHeight,
                callbackId: callbackId
            });
            content.style.overflow = null;
            content.style.display = null;
        } catch (err) {
            $263fb9b3900bc812$var$postMessage("error", {
                message: `${err}`,
                callbackId: callbackId
            });
        }
    }
};
// Listens for messages from the parent API.
window.addEventListener("message", (e)=>{
    if (typeof e.data !== "string") return;
    if ($263fb9b3900bc812$var$currentOrigin && e.origin !== $263fb9b3900bc812$var$currentOrigin) return;
    try {
        const { f: f, callbackId: callbackId, options: options } = JSON.parse(e.data);
        if (f === "open") {
            // The dialog must already be opened so we ignore this event.
            if ($263fb9b3900bc812$var$currentOrigin) return;
            // We set the current origin here to verify the top level API later for callbacks and such.
            $263fb9b3900bc812$var$currentOrigin = e.origin;
        }
        $263fb9b3900bc812$var$api[f](callbackId, options);
    } catch (err) {
    // We don't really care about this error since it probably means some sort of attack is going on.
    }
});


//# sourceMappingURL=selfAssessment.118d9c43.js.map
